import { jsx as b, Fragment as tt, jsxs as B } from "react/jsx-runtime";
import * as A from "react";
import el, { useState as oe, useRef as ge, useEffect as De, useCallback as Ee, useMemo as Zt, createContext as sn, useContext as Ce, useId as wo, forwardRef as Pn, useLayoutEffect as Yr, useInsertionEffect as lh, Children as _1, isValidElement as z1, Fragment as uh, createElement as ch, Component as V1 } from "react";
import * as fh from "react-dom";
import $1 from "react-dom";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ha = function() {
  return Ha = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, Ha.apply(this, arguments);
}, Ga, j1 = function(e) {
  var t;
  e ? (function(n) {
    if (n) for (; n.lastChild; ) n.lastChild.remove();
  })(typeof e == "string" ? document.getElementById(e) : e) : (t = document.querySelector(".grecaptcha-badge")) && t.parentNode && document.body.removeChild(t.parentNode);
}, B1 = function(e, t) {
  j1(t), window.___grecaptcha_cfg = void 0;
  var n = document.querySelector("#" + e);
  n && n.remove(), (function() {
    var r = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
    r && r.remove();
  })();
}, W1 = function(e) {
  var t = e.render, n = e.onLoadCallbackName, r = e.language, i = e.onLoad, a = e.useRecaptchaNet, o = e.useEnterprise, s = e.scriptProps, l = s === void 0 ? {} : s, u = l.nonce, c = u === void 0 ? "" : u, f = l.defer, d = f !== void 0 && f, h = l.async, p = h !== void 0 && h, m = l.id, y = m === void 0 ? "" : m, g = l.appendTo, w = y || "google-recaptcha-v3";
  if ((function(x) {
    return !!document.querySelector("#" + x);
  })(w)) i();
  else {
    var v = (function(x) {
      return "https://www." + (x.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (x.useEnterprise ? "enterprise.js" : "api.js");
    })({ useEnterprise: o, useRecaptchaNet: a }), k = document.createElement("script");
    k.id = w, k.src = v + "?render=" + t + (t === "explicit" ? "&onload=" + n : "") + (r ? "&hl=" + r : ""), c && (k.nonce = c), k.defer = !!d, k.async = !!p, k.onload = i, (g === "body" ? document.body : document.getElementsByTagName("head")[0]).appendChild(k);
  }
}, _u = function(e) {
  typeof process < "u" && process.env && !1 || console.warn(e);
};
(function(e) {
  e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
})(Ga || (Ga = {}));
var tl = sn({ executeRecaptcha: function() {
  throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
} });
tl.Consumer;
function U1(e) {
  var t = e.reCaptchaKey, n = e.useEnterprise, r = n !== void 0 && n, i = e.useRecaptchaNet, a = i !== void 0 && i, o = e.scriptProps, s = e.language, l = e.container, u = e.children, c = oe(null), f = c[0], d = c[1], h = ge(t), p = JSON.stringify(o), m = JSON.stringify(l == null ? void 0 : l.parameters);
  De((function() {
    if (t) {
      var w = (o == null ? void 0 : o.id) || "google-recaptcha-v3", v = (o == null ? void 0 : o.onLoadCallbackName) || "onRecaptchaLoadCallback";
      return window[v] = function() {
        var k = r ? window.grecaptcha.enterprise : window.grecaptcha, x = Ha({ badge: "inline", size: "invisible", sitekey: t }, (l == null ? void 0 : l.parameters) || {});
        h.current = k.render(l == null ? void 0 : l.element, x);
      }, W1({ render: l != null && l.element ? "explicit" : t, onLoadCallbackName: v, useEnterprise: r, useRecaptchaNet: a, scriptProps: o, language: s, onLoad: function() {
        if (window && window.grecaptcha) {
          var k = r ? window.grecaptcha.enterprise : window.grecaptcha;
          k.ready((function() {
            d(k);
          }));
        } else _u("<GoogleRecaptchaProvider /> " + Ga.SCRIPT_NOT_AVAILABLE);
      } }), function() {
        B1(w, l == null ? void 0 : l.element);
      };
    }
    _u("<GoogleReCaptchaProvider /> recaptcha key not provided");
  }), [r, a, p, m, s, t, l == null ? void 0 : l.element]);
  var y = Ee((function(w) {
    if (!f || !f.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
    return f.execute(h.current, { action: w });
  }), [f, h]), g = Zt((function() {
    return { executeRecaptcha: f ? y : void 0, container: l == null ? void 0 : l.element };
  }), [y, f, l == null ? void 0 : l.element]);
  return el.createElement(tl.Provider, { value: g }, u);
}
var vo = function() {
  return Ce(tl);
};
function dh(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}
var Se = typeof Symbol == "function" && Symbol.for, qa = Se ? Symbol.for("react.element") : 60103, Ka = Se ? Symbol.for("react.portal") : 60106, Mi = Se ? Symbol.for("react.fragment") : 60107, Di = Se ? Symbol.for("react.strict_mode") : 60108, Li = Se ? Symbol.for("react.profiler") : 60114, Ni = Se ? Symbol.for("react.provider") : 60109, Oi = Se ? Symbol.for("react.context") : 60110, Ya = Se ? Symbol.for("react.async_mode") : 60111, Qi = Se ? Symbol.for("react.concurrent_mode") : 60111, Fi = Se ? Symbol.for("react.forward_ref") : 60112, _i = Se ? Symbol.for("react.suspense") : 60113, H1 = Se ? Symbol.for("react.suspense_list") : 60120, zi = Se ? Symbol.for("react.memo") : 60115, Vi = Se ? Symbol.for("react.lazy") : 60116, G1 = Se ? Symbol.for("react.block") : 60121, q1 = Se ? Symbol.for("react.fundamental") : 60117, K1 = Se ? Symbol.for("react.responder") : 60118, Y1 = Se ? Symbol.for("react.scope") : 60119;
function Ue(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case qa:
        switch (e = e.type) {
          case Ya:
          case Qi:
          case Mi:
          case Li:
          case Di:
          case _i:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case Oi:
              case Fi:
              case Vi:
              case zi:
              case Ni:
                return e;
              default:
                return t;
            }
        }
      case Ka:
        return t;
    }
  }
}
function zu(e) {
  return Ue(e) === Qi;
}
var X1 = { AsyncMode: Ya, ConcurrentMode: Qi, ContextConsumer: Oi, ContextProvider: Ni, Element: qa, ForwardRef: Fi, Fragment: Mi, Lazy: Vi, Memo: zi, Portal: Ka, Profiler: Li, StrictMode: Di, Suspense: _i, isAsyncMode: function(e) {
  return zu(e) || Ue(e) === Ya;
}, isConcurrentMode: zu, isContextConsumer: function(e) {
  return Ue(e) === Oi;
}, isContextProvider: function(e) {
  return Ue(e) === Ni;
}, isElement: function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === qa;
}, isForwardRef: function(e) {
  return Ue(e) === Fi;
}, isFragment: function(e) {
  return Ue(e) === Mi;
}, isLazy: function(e) {
  return Ue(e) === Vi;
}, isMemo: function(e) {
  return Ue(e) === zi;
}, isPortal: function(e) {
  return Ue(e) === Ka;
}, isProfiler: function(e) {
  return Ue(e) === Li;
}, isStrictMode: function(e) {
  return Ue(e) === Di;
}, isSuspense: function(e) {
  return Ue(e) === _i;
}, isValidElementType: function(e) {
  return typeof e == "string" || typeof e == "function" || e === Mi || e === Qi || e === Li || e === Di || e === _i || e === H1 || typeof e == "object" && e !== null && (e.$$typeof === Vi || e.$$typeof === zi || e.$$typeof === Ni || e.$$typeof === Oi || e.$$typeof === Fi || e.$$typeof === q1 || e.$$typeof === K1 || e.$$typeof === Y1 || e.$$typeof === G1);
}, typeOf: Ue }, re = dh((function(e, t) {
})), Vu = (re.AsyncMode, re.ConcurrentMode, re.ContextConsumer, re.ContextProvider, re.Element, re.ForwardRef, re.Fragment, re.Lazy, re.Memo, re.Portal, re.Profiler, re.StrictMode, re.Suspense, re.isAsyncMode, re.isConcurrentMode, re.isContextConsumer, re.isContextProvider, re.isElement, re.isForwardRef, re.isFragment, re.isLazy, re.isMemo, re.isPortal, re.isProfiler, re.isStrictMode, re.isSuspense, re.isValidElementType, re.typeOf, dh((function(e) {
  e.exports = X1;
}))), Z1 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, $u = {};
$u[Vu.ForwardRef] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, $u[Vu.Memo] = Z1;
/*!
 * Font Awesome Pro 7.0.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2025 Fonticons, Inc.
 */
var J1 = {
  prefix: "fal",
  iconName: "thumbs-down",
  icon: [512, 512, [128078, 61576], "f165", "M368 32l7.5 .4c32.4 3.9 56.5 32.4 56.4 64.2 25.5 14.8 37.7 46.1 29.2 74.2 21.5 21.6 24.6 56.1 7.7 81.2 25.9 38.1 2.2 95.8-47.3 99.8l-5.4 .2-151.5 0 30.8 54.7 3.1 6.2c12.9 29.5 3.1 64.1-23.2 82.7l-5.9 3.7c-30.7 17.2-69 8.1-88.9-20l-3.7-5.9-51.1-90.7C119.5 402 101.4 416 80 416l-32 0c-26.5 0-48-21.5-48-48L0 144c0-26.5 21.5-48 48-48l32 0c13.3 0 25.3 5.4 34 14.1 14.1-24.6 35.8-44.8 62.8-56.8l.1 0C199.1 43.5 224 32 253.6 32L368 32zM253.6 64c-21.7 0-40.3 8.2-63.9 18.6l0 0c-37.5 16.7-61.7 53.9-61.8 95l.2 130.7c.7 10.1 3.6 19.9 8.6 28.7l67.9 120.7 2 3.1c10.5 14.9 30.8 19.7 47.1 10.6l3.1-2c13.9-9.8 19-28.1 12.2-43.7l-1.6-3.3-44.2-78.5c-2.8-5-2.7-11 .1-15.9s8.1-7.9 13.8-7.9l178.8 0 5.2-.4c25-4.2 35.9-37.9 15.9-55.5-3.4-3-5.4-7.4-5.4-12s2-9 5.4-12c15.6-13.7 13.7-39.7-3.9-51-7.1-4.6-9.5-14-5.3-21.3 9.6-17 .9-40-17.9-46.1-7.8-2.5-12.4-10.6-10.7-18.7 4-18.2-9.4-36.5-27.5-38.7L368 64 253.6 64zM48 128c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-32 0z"]
}, Q1 = {
  prefix: "fal",
  iconName: "thumbs-up",
  icon: [512, 512, [128077, 61575], "f164", "M180.5 32.8c19.8-28.2 58.2-37.3 88.9-20l5.9 3.7c26.3 18.5 36 53.2 23.2 82.7l-3.1 6.2-30.8 54.7 151.5 0 5.4 .2c49.5 4 73.2 61.7 47.3 99.8 16.9 25 13.8 59.6-7.7 81.2 8.5 28-3.7 59.3-29.2 74.2 .1 31.8-24 60.3-56.4 64.2l-7.5 .4-114.4 0c-29.6 0-54.5-11.5-76.7-21.3l-.1 0c-19.2-8.6-35.7-21.3-48.8-36.7l0 10.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 208c0-26.5 21.5-48 48-48l32 0c9.2 0 17.7 2.6 25 7 1.2-2.6 2.5-5.2 3.9-7.7l67.9-120.7 3.7-5.9zM48 192c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-32 0zM253.7 40.6c-16.2-9.1-36.6-4.3-47.1 10.6l-2 3.1-67.9 120.7c-5 8.8-7.9 18.6-8.6 28.7L128 334.4c0 41.1 24.2 78.3 61.8 95l0 0c23.6 10.3 42.2 18.6 63.9 18.6l114.4 0 3.7-.2c18.2-2.2 31.5-20.5 27.5-38.7-1.8-8 2.9-16.1 10.7-18.7 18.8-6.1 27.6-29.1 17.9-46.1-4.2-7.4-1.8-16.8 5.3-21.3 17.6-11.2 19.6-37.2 3.9-51-3.4-3-5.4-7.4-5.4-12s2-9 5.4-12c20-17.6 9.1-51.4-15.9-55.5l-5.2-.4-178.8 0c-5.7 0-10.9-3-13.8-7.9s-2.9-11-.1-15.9l44.2-78.5 1.6-3.3c6.8-15.6 1.7-33.9-12.2-43.7l-3.1-2z"]
}, hh = {
  prefix: "fal",
  iconName: "paperclip",
  icon: [512, 512, [128206], "f0c6", "M260.9 18.4c50-50 131-50 181 0s50 131 0 181L272.2 369.1c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1L317.4 97.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L181.7 278.6c-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0L419.3 176.8c37.5-37.5 37.5-98.3 0-135.8S321 3.5 283.5 41L91.2 233.4c-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0L453.2 278.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L317.4 459.6c-68.7 68.7-180.2 68.7-248.9 0s-68.7-180.2 0-248.9L260.9 18.4z"]
}, e0 = {
  prefix: "fal",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M441.4 67.1c7.1 5.2 8.7 15.2 3.5 22.4l-280 384c-2.8 3.8-7 6.2-11.7 6.5s-9.2-1.3-12.6-4.6l-136-136c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l122.8 122.8 269-368.9c5.2-7.1 15.2-8.7 22.4-3.5z"]
}, t0 = {
  prefix: "fal",
  iconName: "user",
  icon: [448, 512, [128100, 62144, 62470, "user-alt", "user-large"], "f007", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM32 480c0-79.5 64.5-144 144-144l96 0c79.5 0 144 64.5 144 144l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-97.2-78.8-176-176-176l-96 0C78.8 304 0 382.8 0 480l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16z"]
}, ph = {
  prefix: "fal",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 27.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 356.7 443.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 379.3 91.3z"]
}, n0 = {
  prefix: "fal",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", "M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1 17.1-34.3 26.7-73 26.7-113.9 0-136-106.1-247.2-240-255.5-8.8-.5-16 6.7-16 15.5s7.2 15.9 16 16.6c116.2 8.2 208 105.1 208 223.4 0 35.1-8.1 68.3-22.5 97.9-3.9 8-1.3 17.7 6.4 22.2z"]
}, r0 = {
  prefix: "fal",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M240 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 192-192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0 0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192 192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0 0-192z"]
}, i0 = {
  prefix: "fal",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M160 64c0-17.7 14.3-32 32-32l132.1 0c8.5 0 16.6 3.4 22.6 9.4l59.9 59.9c6 6 9.4 14.1 9.4 22.6L416 320c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-256zM192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-196.1c0-17-6.7-33.3-18.7-45.3L369.4 18.7C357.4 6.7 341.1 0 324.1 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-32 0 0 16c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l16 0 0-32-16 0z"]
}, o0 = {
  prefix: "fal",
  iconName: "arrow-rotate-right",
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M496 0c-8.8 0-16 7.2-16 16l0 103.8-37-39.1C394.4 29.2 326.8 0 256 0 114.6 0 0 114.6 0 256S114.6 512 256 512c98.3 0 183.6-55.4 226.5-136.5 4.1-7.8 1.1-17.5-6.7-21.6s-17.5-1.1-21.6 6.7C416.6 431.6 341.9 480 256 480 132.3 480 32 379.7 32 256S132.3 32 256 32c62 0 121.2 25.5 163.8 70.6L458.9 144 352 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l144 0c8.8 0 16-7.2 16-16l0-144c0-8.8-7.2-16-16-16z"]
}, a0 = {
  prefix: "fal",
  iconName: "compress",
  icon: [448, 512, [], "f066", "M160 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112-112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-128zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L16 320zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-112zM304 320c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z"]
}, s0 = {
  prefix: "fal",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M304 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l153.4 0-260.7 260.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6 480 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L304 0zM80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 96z"]
}, l0 = {
  prefix: "fal",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M180.7 507.3c6.2 6.2 16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 457.4 208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 441.4-148.7-148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176z"]
};
/*!
 * Font Awesome Free 7.0.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2025 Fonticons, Inc.
 */
function Xa(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function u0(e) {
  if (Array.isArray(e)) return e;
}
function c0(e) {
  if (Array.isArray(e)) return Xa(e);
}
function f0(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function d0(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mh(r.key), r);
  }
}
function h0(e, t, n) {
  return t && d0(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function $i(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = nl(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return o = l.done, l;
    },
    e: function(l) {
      s = !0, a = l;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function Q(e, t, n) {
  return (t = mh(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function p0(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function m0(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], l = !0, u = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function g0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ju(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function F(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ju(Object(n), !0).forEach(function(r) {
      Q(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ju(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bo(e, t) {
  return u0(e) || m0(e, t) || nl(e, t) || g0();
}
function st(e) {
  return c0(e) || p0(e) || nl(e) || y0();
}
function w0(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function mh(e) {
  var t = w0(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function eo(e) {
  "@babel/helpers - typeof";
  return eo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, eo(e);
}
function nl(e, t) {
  if (e) {
    if (typeof e == "string") return Xa(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xa(e, t) : void 0;
  }
}
var Bu = function() {
}, rl = {}, gh = {}, yh = null, wh = {
  mark: Bu,
  measure: Bu
};
try {
  typeof window < "u" && (rl = window), typeof document < "u" && (gh = document), typeof MutationObserver < "u" && (yh = MutationObserver), typeof performance < "u" && (wh = performance);
} catch {
}
var v0 = rl.navigator || {}, Wu = v0.userAgent, Uu = Wu === void 0 ? "" : Wu, Jt = rl, ue = gh, Hu = yh, pi = wh;
Jt.document;
var Wt = !!ue.documentElement && !!ue.head && typeof ue.addEventListener == "function" && typeof ue.createElement == "function", vh = ~Uu.indexOf("MSIE") || ~Uu.indexOf("Trident/"), Ko, b0 = /fa(k|kd|s|r|l|t|d|dr|dl|dt|b|slr|slpr|wsb|tl|ns|nds|es|jr|jfr|jdr|cr|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, x0 = /Font ?Awesome ?([567 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit|Notdog Duo|Notdog|Chisel|Etch|Thumbprint|Jelly Fill|Jelly Duo|Jelly|Slab Press|Slab|Whiteboard)?.*/i, bh = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  },
  slab: {
    "fa-regular": "regular",
    faslr: "regular"
  },
  "slab-press": {
    "fa-regular": "regular",
    faslpr: "regular"
  },
  thumbprint: {
    "fa-light": "light",
    fatl: "light"
  },
  whiteboard: {
    "fa-semibold": "semibold",
    fawsb: "semibold"
  },
  notdog: {
    "fa-solid": "solid",
    fans: "solid"
  },
  "notdog-duo": {
    "fa-solid": "solid",
    fands: "solid"
  },
  etch: {
    "fa-solid": "solid",
    faes: "solid"
  },
  jelly: {
    "fa-regular": "regular",
    fajr: "regular"
  },
  "jelly-fill": {
    "fa-regular": "regular",
    fajfr: "regular"
  },
  "jelly-duo": {
    "fa-regular": "regular",
    fajdr: "regular"
  },
  chisel: {
    "fa-regular": "regular",
    facr: "regular"
  }
}, k0 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, xh = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone", "fa-thumbprint", "fa-whiteboard", "fa-notdog", "fa-notdog-duo", "fa-chisel", "fa-etch", "fa-jelly", "fa-jelly-fill", "fa-jelly-duo", "fa-slab", "fa-slab-press"], Pe = "classic", Xr = "duotone", kh = "sharp", Ch = "sharp-duotone", Sh = "chisel", Ah = "etch", Th = "jelly", Eh = "jelly-duo", Ph = "jelly-fill", Ih = "notdog", Rh = "notdog-duo", Mh = "slab", Dh = "slab-press", Lh = "thumbprint", Nh = "whiteboard", C0 = "Classic", S0 = "Duotone", A0 = "Sharp", T0 = "Sharp Duotone", E0 = "Chisel", P0 = "Etch", I0 = "Jelly", R0 = "Jelly Duo", M0 = "Jelly Fill", D0 = "Notdog", L0 = "Notdog Duo", N0 = "Slab", O0 = "Slab Press", F0 = "Thumbprint", _0 = "Whiteboard", Oh = [Pe, Xr, kh, Ch, Sh, Ah, Th, Eh, Ph, Ih, Rh, Mh, Dh, Lh, Nh];
Ko = {}, Q(Q(Q(Q(Q(Q(Q(Q(Q(Q(Ko, Pe, C0), Xr, S0), kh, A0), Ch, T0), Sh, E0), Ah, P0), Th, I0), Eh, R0), Ph, M0), Ih, D0), Q(Q(Q(Q(Q(Ko, Rh, L0), Mh, N0), Dh, O0), Lh, F0), Nh, _0);
var z0 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  },
  slab: {
    400: "faslr"
  },
  "slab-press": {
    400: "faslpr"
  },
  whiteboard: {
    600: "fawsb"
  },
  thumbprint: {
    300: "fatl"
  },
  notdog: {
    900: "fans"
  },
  "notdog-duo": {
    900: "fands"
  },
  etch: {
    900: "faes"
  },
  chisel: {
    400: "facr"
  },
  jelly: {
    400: "fajr"
  },
  "jelly-fill": {
    400: "fajfr"
  },
  "jelly-duo": {
    400: "fajdr"
  }
}, V0 = {
  "Font Awesome 7 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 7 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 7 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 7 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 7 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 7 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  },
  "Font Awesome 7 Jelly": {
    400: "fajr",
    normal: "fajr"
  },
  "Font Awesome 7 Jelly Fill": {
    400: "fajfr",
    normal: "fajfr"
  },
  "Font Awesome 7 Jelly Duo": {
    400: "fajdr",
    normal: "fajdr"
  },
  "Font Awesome 7 Slab": {
    400: "faslr",
    normal: "faslr"
  },
  "Font Awesome 7 Slab Press": {
    400: "faslpr",
    normal: "faslpr"
  },
  "Font Awesome 7 Thumbprint": {
    300: "fatl",
    normal: "fatl"
  },
  "Font Awesome 7 Notdog": {
    900: "fans",
    normal: "fans"
  },
  "Font Awesome 7 Notdog Duo": {
    900: "fands",
    normal: "fands"
  },
  "Font Awesome 7 Etch": {
    900: "faes",
    normal: "faes"
  },
  "Font Awesome 7 Chisel": {
    400: "facr",
    normal: "facr"
  },
  "Font Awesome 7 Whiteboard": {
    600: "fawsb",
    normal: "fawsb"
  }
}, $0 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["chisel", {
  defaultShortPrefixId: "facr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["etch", {
  defaultShortPrefixId: "faes",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["jelly", {
  defaultShortPrefixId: "fajr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["jelly-duo", {
  defaultShortPrefixId: "fajdr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["jelly-fill", {
  defaultShortPrefixId: "fajfr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["notdog", {
  defaultShortPrefixId: "fans",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["notdog-duo", {
  defaultShortPrefixId: "fands",
  defaultStyleId: "solid",
  styleIds: ["solid"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["slab", {
  defaultShortPrefixId: "faslr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["slab-press", {
  defaultShortPrefixId: "faslpr",
  defaultStyleId: "regular",
  styleIds: ["regular"],
  futureStyleIds: [],
  defaultFontWeight: 400
}], ["thumbprint", {
  defaultShortPrefixId: "fatl",
  defaultStyleId: "light",
  styleIds: ["light"],
  futureStyleIds: [],
  defaultFontWeight: 300
}], ["whiteboard", {
  defaultShortPrefixId: "fawsb",
  defaultStyleId: "semibold",
  styleIds: ["semibold"],
  futureStyleIds: [],
  defaultFontWeight: 600
}]]), j0 = {
  chisel: {
    regular: "facr"
  },
  classic: {
    brands: "fab",
    light: "fal",
    regular: "far",
    solid: "fas",
    thin: "fat"
  },
  duotone: {
    light: "fadl",
    regular: "fadr",
    solid: "fad",
    thin: "fadt"
  },
  etch: {
    solid: "faes"
  },
  jelly: {
    regular: "fajr"
  },
  "jelly-duo": {
    regular: "fajdr"
  },
  "jelly-fill": {
    regular: "fajfr"
  },
  notdog: {
    solid: "fans"
  },
  "notdog-duo": {
    solid: "fands"
  },
  sharp: {
    light: "fasl",
    regular: "fasr",
    solid: "fass",
    thin: "fast"
  },
  "sharp-duotone": {
    light: "fasdl",
    regular: "fasdr",
    solid: "fasds",
    thin: "fasdt"
  },
  slab: {
    regular: "faslr"
  },
  "slab-press": {
    regular: "faslpr"
  },
  thumbprint: {
    light: "fatl"
  },
  whiteboard: {
    semibold: "fawsb"
  }
}, Fh = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Gu = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, B0 = ["kit"], W0 = "kit", U0 = "kit-duotone", H0 = "Kit", G0 = "Kit Duotone";
Q(Q({}, W0, H0), U0, G0);
var q0 = {
  kit: {
    "fa-kit": "fak"
  }
}, K0 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, Y0 = {
  kit: {
    fak: "fa-kit"
  }
}, qu = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Yo, mi = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, X0 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone", "fa-thumbprint", "fa-whiteboard", "fa-notdog", "fa-notdog-duo", "fa-chisel", "fa-etch", "fa-jelly", "fa-jelly-fill", "fa-jelly-duo", "fa-slab", "fa-slab-press"], Z0 = "classic", J0 = "duotone", Q0 = "sharp", ew = "sharp-duotone", tw = "chisel", nw = "etch", rw = "jelly", iw = "jelly-duo", ow = "jelly-fill", aw = "notdog", sw = "notdog-duo", lw = "slab", uw = "slab-press", cw = "thumbprint", fw = "whiteboard", dw = "Classic", hw = "Duotone", pw = "Sharp", mw = "Sharp Duotone", gw = "Chisel", yw = "Etch", ww = "Jelly", vw = "Jelly Duo", bw = "Jelly Fill", xw = "Notdog", kw = "Notdog Duo", Cw = "Slab", Sw = "Slab Press", Aw = "Thumbprint", Tw = "Whiteboard";
Yo = {}, Q(Q(Q(Q(Q(Q(Q(Q(Q(Q(Yo, Z0, dw), J0, hw), Q0, pw), ew, mw), tw, gw), nw, yw), rw, ww), iw, vw), ow, bw), aw, xw), Q(Q(Q(Q(Q(Yo, sw, kw), lw, Cw), uw, Sw), cw, Aw), fw, Tw);
var Ew = "kit", Pw = "kit-duotone", Iw = "Kit", Rw = "Kit Duotone";
Q(Q({}, Ew, Iw), Pw, Rw);
var Mw = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  },
  slab: {
    "fa-regular": "faslr"
  },
  "slab-press": {
    "fa-regular": "faslpr"
  },
  whiteboard: {
    "fa-semibold": "fawsb"
  },
  thumbprint: {
    "fa-light": "fatl"
  },
  notdog: {
    "fa-solid": "fans"
  },
  "notdog-duo": {
    "fa-solid": "fands"
  },
  etch: {
    "fa-solid": "faes"
  },
  jelly: {
    "fa-regular": "fajr"
  },
  "jelly-fill": {
    "fa-regular": "fajfr"
  },
  "jelly-duo": {
    "fa-regular": "fajdr"
  },
  chisel: {
    "fa-regular": "facr"
  }
}, Dw = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"],
  slab: ["faslr"],
  "slab-press": ["faslpr"],
  whiteboard: ["fawsb"],
  thumbprint: ["fatl"],
  notdog: ["fans"],
  "notdog-duo": ["fands"],
  etch: ["faes"],
  jelly: ["fajr"],
  "jelly-fill": ["fajfr"],
  "jelly-duo": ["fajdr"],
  chisel: ["facr"]
}, Za = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  },
  slab: {
    faslr: "fa-regular"
  },
  "slab-press": {
    faslpr: "fa-regular"
  },
  whiteboard: {
    fawsb: "fa-semibold"
  },
  thumbprint: {
    fatl: "fa-light"
  },
  notdog: {
    fans: "fa-solid"
  },
  "notdog-duo": {
    fands: "fa-solid"
  },
  etch: {
    faes: "fa-solid"
  },
  jelly: {
    fajr: "fa-regular"
  },
  "jelly-fill": {
    fajfr: "fa-regular"
  },
  "jelly-duo": {
    fajdr: "fa-regular"
  },
  chisel: {
    facr: "fa-regular"
  }
}, Lw = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands", "fa-semibold"], _h = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", "faslr", "faslpr", "fawsb", "fatl", "fans", "fands", "faes", "fajr", "fajfr", "fajdr", "facr"].concat(X0, Lw), Nw = ["solid", "regular", "light", "thin", "duotone", "brands", "semibold"], zh = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Ow = zh.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Fw = ["aw", "fw", "pull-left", "pull-right"], _w = [].concat(st(Object.keys(Dw)), Nw, Fw, ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "inverse", "layers", "layers-bottom-left", "layers-bottom-right", "layers-counter", "layers-text", "layers-top-left", "layers-top-right", "li", "pull-end", "pull-start", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", "width-auto", "width-fixed", mi.GROUP, mi.SWAP_OPACITY, mi.PRIMARY, mi.SECONDARY]).concat(zh.map(function(e) {
  return "".concat(e, "x");
})).concat(Ow.map(function(e) {
  return "w-".concat(e);
})), zw = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
}, Ft = "___FONT_AWESOME___", Ja = 16, Vh = "fa", $h = "svg-inline--fa", Cn = "data-fa-i2svg", Qa = "data-fa-pseudo-element", Vw = "data-fa-pseudo-element-pending", il = "data-prefix", ol = "data-icon", Ku = "fontawesome-i2svg", $w = "async", jw = ["HTML", "HEAD", "STYLE", "SCRIPT"], jh = ["::before", "::after", ":before", ":after"], Bh = (function() {
  try {
    return !0;
  } catch {
    return !1;
  }
})();
function Zr(e) {
  return new Proxy(e, {
    get: function(n, r) {
      return r in n ? n[r] : n[Pe];
    }
  });
}
var Wh = F({}, bh);
Wh[Pe] = F(F(F(F({}, {
  "fa-duotone": "duotone"
}), bh[Pe]), Gu.kit), Gu["kit-duotone"]);
var Bw = Zr(Wh), es = F({}, j0);
es[Pe] = F(F(F(F({}, {
  duotone: "fad"
}), es[Pe]), qu.kit), qu["kit-duotone"]);
var Yu = Zr(es), ts = F({}, Za);
ts[Pe] = F(F({}, ts[Pe]), Y0.kit);
var al = Zr(ts), ns = F({}, Mw);
ns[Pe] = F(F({}, ns[Pe]), q0.kit);
Zr(ns);
var Ww = b0, Uh = "fa-layers-text", Uw = x0, Hw = F({}, z0);
Zr(Hw);
var Gw = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Xo = k0, qw = [].concat(st(B0), st(_w)), Er = Jt.FontAwesomeConfig || {};
function Kw(e) {
  var t = ue.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function Yw(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (ue && typeof ue.querySelector == "function") {
  var Xw = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-search-pseudo-elements-warnings", "searchPseudoElementsWarnings"], ["data-search-pseudo-elements-full-scan", "searchPseudoElementsFullScan"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Xw.forEach(function(e) {
    var t = bo(e, 2), n = t[0], r = t[1], i = Yw(Kw(n));
    i != null && (Er[r] = i);
  });
}
var Hh = {
  styleDefault: "solid",
  familyDefault: Pe,
  cssPrefix: Vh,
  replacementClass: $h,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  searchPseudoElements: !1,
  searchPseudoElementsWarnings: !0,
  searchPseudoElementsFullScan: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Er.familyPrefix && (Er.cssPrefix = Er.familyPrefix);
var Zn = F(F({}, Hh), Er);
Zn.autoReplaceSvg || (Zn.observeMutations = !1);
var W = {};
Object.keys(Hh).forEach(function(e) {
  Object.defineProperty(W, e, {
    enumerable: !0,
    set: function(n) {
      Zn[e] = n, Pr.forEach(function(r) {
        return r(W);
      });
    },
    get: function() {
      return Zn[e];
    }
  });
});
Object.defineProperty(W, "familyPrefix", {
  enumerable: !0,
  set: function(t) {
    Zn.cssPrefix = t, Pr.forEach(function(n) {
      return n(W);
    });
  },
  get: function() {
    return Zn.cssPrefix;
  }
});
Jt.FontAwesomeConfig = W;
var Pr = [];
function Zw(e) {
  return Pr.push(e), function() {
    Pr.splice(Pr.indexOf(e), 1);
  };
}
var Mn = Ja, gt = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Jw(e) {
  if (!(!e || !Wt)) {
    var t = ue.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    for (var n = ue.head.childNodes, r = null, i = n.length - 1; i > -1; i--) {
      var a = n[i], o = (a.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(o) > -1 && (r = a);
    }
    return ue.head.insertBefore(t, r), e;
  }
}
var Qw = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Xu() {
  for (var e = 12, t = ""; e-- > 0; )
    t += Qw[Math.random() * 62 | 0];
  return t;
}
function or(e) {
  for (var t = [], n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function sl(e) {
  return e.classList ? or(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function(t) {
    return t;
  });
}
function Gh(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function ev(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, '="').concat(Gh(e[n]), '" ');
  }, "").trim();
}
function xo(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, ": ").concat(e[n].trim(), ";");
  }, "");
}
function ll(e) {
  return e.size !== gt.size || e.x !== gt.x || e.y !== gt.y || e.rotate !== gt.rotate || e.flipX || e.flipY;
}
function tv(e) {
  var t = e.transform, n = e.containerWidth, r = e.iconWidth, i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, a = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), o = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(a, " ").concat(o, " ").concat(s)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: u
  };
}
function nv(e) {
  var t = e.transform, n = e.width, r = n === void 0 ? Ja : n, i = e.height, a = i === void 0 ? Ja : i, o = "";
  return vh ? o += "translate(".concat(t.x / Mn - r / 2, "em, ").concat(t.y / Mn - a / 2, "em) ") : o += "translate(calc(-50% + ".concat(t.x / Mn, "em), calc(-50% + ").concat(t.y / Mn, "em)) "), o += "scale(".concat(t.size / Mn * (t.flipX ? -1 : 1), ", ").concat(t.size / Mn * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var rv = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 7 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 7 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 7 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 7 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 7 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 7 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 7 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 7 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 7 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 7 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 7 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 7 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 7 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 7 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 7 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 7 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 7 Sharp Duotone";
  --fa-font-slab-regular: normal 400 1em/1 "Font Awesome 7 Slab";
  --fa-font-slab-press-regular: normal 400 1em/1 "Font Awesome 7 Slab Press";
  --fa-font-whiteboard-semibold: normal 600 1em/1 "Font Awesome 7 Whiteboard";
  --fa-font-thumbprint-light: normal 300 1em/1 "Font Awesome 7 Thumbprint";
  --fa-font-notdog-solid: normal 900 1em/1 "Font Awesome 7 Notdog";
  --fa-font-notdog-duo-solid: normal 900 1em/1 "Font Awesome 7 Notdog Duo";
  --fa-font-etch-solid: normal 900 1em/1 "Font Awesome 7 Etch";
  --fa-font-jelly-regular: normal 400 1em/1 "Font Awesome 7 Jelly";
  --fa-font-jelly-fill-regular: normal 400 1em/1 "Font Awesome 7 Jelly Fill";
  --fa-font-jelly-duo-regular: normal 400 1em/1 "Font Awesome 7 Jelly Duo";
  --fa-font-chisel-regular: normal 400 1em/1 "Font Awesome 7 Chisel";
}

.svg-inline--fa {
  box-sizing: content-box;
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
  width: var(--fa-width, 1.25em);
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285714em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left,
.svg-inline--fa .fa-pull-start {
  float: inline-start;
  margin-inline-end: var(--fa-pull-margin, 0.3em);
}
.svg-inline--fa.fa-pull-right,
.svg-inline--fa .fa-pull-end {
  float: inline-end;
  margin-inline-start: var(--fa-pull-margin, 0.3em);
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));
  inset-block-start: 0.25em; /* syncing vertical alignment with Web Font rendering */
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: var(--fa-width, 1.25em);
}
.fa-layers .svg-inline--fa {
  inset: 0;
  margin: auto;
  position: absolute;
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: calc(10 / 16 * 1em); /* converts a 10px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 10 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 10 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-xs {
  font-size: calc(12 / 16 * 1em); /* converts a 12px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 12 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 12 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-sm {
  font-size: calc(14 / 16 * 1em); /* converts a 14px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 14 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 14 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-lg {
  font-size: calc(20 / 16 * 1em); /* converts a 20px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 20 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 20 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-xl {
  font-size: calc(24 / 16 * 1em); /* converts a 24px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 24 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 24 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-2xl {
  font-size: calc(32 / 16 * 1em); /* converts a 32px size into an em-based value that's relative to the scale's 16px base */
  line-height: calc(1 / 32 * 1em); /* sets the line-height of the icon back to that of it's parent */
  vertical-align: calc((6 / 32 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */
}

.fa-width-auto {
  --fa-width: auto;
}

.fa-fw,
.fa-width-fixed {
  --fa-width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-inline-start: var(--fa-li-margin, 2.5em);
  padding-inline-start: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

/* Heads Up: Bordered Icons will not be supported in the future!
  - This feature will be deprecated in the next major release of Font Awesome (v8)!
  - You may continue to use it in this version *v7), but it will not be supported in Font Awesome v8.
*/
/* Notes:
* --@{v.$css-prefix}-border-width = 1/16 by default (to render as ~1px based on a 16px default font-size)
* --@{v.$css-prefix}-border-padding =
  ** 3/16 for vertical padding (to give ~2px of vertical whitespace around an icon considering it's vertical alignment)
  ** 4/16 for horizontal padding (to give ~4px of horizontal whitespace around an icon)
*/
.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.0625em);
  box-sizing: var(--fa-border-box-sizing, content-box);
  padding: var(--fa-border-padding, 0.1875em 0.25em);
}

.fa-pull-left,
.fa-pull-start {
  float: inline-start;
  margin-inline-end: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right,
.fa-pull-end {
  float: inline-end;
  margin-inline-start: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse {
    animation: none !important;
    transition: none !important;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.svg-inline--fa.fa-inverse {
  fill: var(--fa-inverse, #fff);
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.svg-inline--fa.fa-stack-1x {
  --fa-width: 1.25em;
  height: 1em;
  width: var(--fa-width);
}
.svg-inline--fa.fa-stack-2x {
  --fa-width: 2.5em;
  height: 2em;
  width: var(--fa-width);
}

.fa-stack-1x,
.fa-stack-2x {
  inset: 0;
  margin: auto;
  position: absolute;
  z-index: var(--fa-stack-z-index, auto);
}`;
function qh() {
  var e = Vh, t = $h, n = W.cssPrefix, r = W.replacementClass, i = rv;
  if (n !== e || r !== t) {
    var a = new RegExp("\\.".concat(e, "\\-"), "g"), o = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    i = i.replace(a, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return i;
}
var Zu = !1;
function Zo() {
  W.autoAddCss && !Zu && (Jw(qh()), Zu = !0);
}
var iv = {
  mixout: function() {
    return {
      dom: {
        css: qh,
        insertCss: Zo
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Zo();
      },
      beforeI2svg: function() {
        Zo();
      }
    };
  }
}, _t = Jt || {};
_t[Ft] || (_t[Ft] = {});
_t[Ft].styles || (_t[Ft].styles = {});
_t[Ft].hooks || (_t[Ft].hooks = {});
_t[Ft].shims || (_t[Ft].shims = []);
var it = _t[Ft], Kh = [], Yh = function() {
  ue.removeEventListener("DOMContentLoaded", Yh), to = 1, Kh.map(function(t) {
    return t();
  });
}, to = !1;
Wt && (to = (ue.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(ue.readyState), to || ue.addEventListener("DOMContentLoaded", Yh));
function ov(e) {
  Wt && (to ? setTimeout(e, 0) : Kh.push(e));
}
function Jr(e) {
  var t = e.tag, n = e.attributes, r = n === void 0 ? {} : n, i = e.children, a = i === void 0 ? [] : i;
  return typeof e == "string" ? Gh(e) : "<".concat(t, " ").concat(ev(r), ">").concat(a.map(Jr).join(""), "</").concat(t, ">");
}
function Ju(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var Jo = function(t, n, r, i) {
  var a = Object.keys(t), o = a.length, s = n, l, u, c;
  for (r === void 0 ? (l = 1, c = t[a[0]]) : (l = 0, c = r); l < o; l++)
    u = a[l], c = s(c, t[u], u, t);
  return c;
};
function Xh(e) {
  return st(e).length !== 1 ? null : e.codePointAt(0).toString(16);
}
function Qu(e) {
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n], i = !!r.icon;
    return i ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function rs(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.skipHooks, i = r === void 0 ? !1 : r, a = Qu(t);
  typeof it.hooks.addPack == "function" && !i ? it.hooks.addPack(e, Qu(t)) : it.styles[e] = F(F({}, it.styles[e] || {}), a), e === "fas" && rs("fa", t);
}
var _r = it.styles, av = it.shims, Zh = Object.keys(al), sv = Zh.reduce(function(e, t) {
  return e[t] = Object.keys(al[t]), e;
}, {}), ul = null, Jh = {}, Qh = {}, ep = {}, tp = {}, np = {};
function lv(e) {
  return ~qw.indexOf(e);
}
function uv(e, t) {
  var n = t.split("-"), r = n[0], i = n.slice(1).join("-");
  return r === e && i !== "" && !lv(i) ? i : null;
}
var rp = function() {
  var t = function(a) {
    return Jo(_r, function(o, s, l) {
      return o[l] = Jo(s, a, {}), o;
    }, {});
  };
  Jh = t(function(i, a, o) {
    if (a[3] && (i[a[3]] = o), a[2]) {
      var s = a[2].filter(function(l) {
        return typeof l == "number";
      });
      s.forEach(function(l) {
        i[l.toString(16)] = o;
      });
    }
    return i;
  }), Qh = t(function(i, a, o) {
    if (i[o] = o, a[2]) {
      var s = a[2].filter(function(l) {
        return typeof l == "string";
      });
      s.forEach(function(l) {
        i[l] = o;
      });
    }
    return i;
  }), np = t(function(i, a, o) {
    var s = a[2];
    return i[o] = o, s.forEach(function(l) {
      i[l] = o;
    }), i;
  });
  var n = "far" in _r || W.autoFetchSvg, r = Jo(av, function(i, a) {
    var o = a[0], s = a[1], l = a[2];
    return s === "far" && !n && (s = "fas"), typeof o == "string" && (i.names[o] = {
      prefix: s,
      iconName: l
    }), typeof o == "number" && (i.unicodes[o.toString(16)] = {
      prefix: s,
      iconName: l
    }), i;
  }, {
    names: {},
    unicodes: {}
  });
  ep = r.names, tp = r.unicodes, ul = ko(W.styleDefault, {
    family: W.familyDefault
  });
};
Zw(function(e) {
  ul = ko(e.styleDefault, {
    family: W.familyDefault
  });
});
rp();
function cl(e, t) {
  return (Jh[e] || {})[t];
}
function cv(e, t) {
  return (Qh[e] || {})[t];
}
function yn(e, t) {
  return (np[e] || {})[t];
}
function ip(e) {
  return ep[e] || {
    prefix: null,
    iconName: null
  };
}
function fv(e) {
  var t = tp[e], n = cl("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Qt() {
  return ul;
}
var op = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function dv(e) {
  var t = Pe, n = Zh.reduce(function(r, i) {
    return r[i] = "".concat(W.cssPrefix, "-").concat(i), r;
  }, {});
  return Oh.forEach(function(r) {
    (e.includes(n[r]) || e.some(function(i) {
      return sv[r].includes(i);
    })) && (t = r);
  }), t;
}
function ko(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.family, r = n === void 0 ? Pe : n, i = Bw[r][e];
  if (r === Xr && !e)
    return "fad";
  var a = Yu[r][e] || Yu[r][i], o = e in it.styles ? e : null, s = a || o || null;
  return s;
}
function hv(e) {
  var t = [], n = null;
  return e.forEach(function(r) {
    var i = uv(W.cssPrefix, r);
    i ? n = i : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function ec(e) {
  return e.sort().filter(function(t, n, r) {
    return r.indexOf(t) === n;
  });
}
var tc = _h.concat(Fh);
function Co(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.skipLookups, r = n === void 0 ? !1 : n, i = null, a = ec(e.filter(function(h) {
    return tc.includes(h);
  })), o = ec(e.filter(function(h) {
    return !tc.includes(h);
  })), s = a.filter(function(h) {
    return i = h, !xh.includes(h);
  }), l = bo(s, 1), u = l[0], c = u === void 0 ? null : u, f = dv(a), d = F(F({}, hv(o)), {}, {
    prefix: ko(c, {
      family: f
    })
  });
  return F(F(F({}, d), yv({
    values: e,
    family: f,
    styles: _r,
    config: W,
    canonical: d,
    givenPrefix: i
  })), pv(r, i, d));
}
function pv(e, t, n) {
  var r = n.prefix, i = n.iconName;
  if (e || !r || !i)
    return {
      prefix: r,
      iconName: i
    };
  var a = t === "fa" ? ip(i) : {}, o = yn(r, i);
  return i = a.iconName || o || i, r = a.prefix || r, r === "far" && !_r.far && _r.fas && !W.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: i
  };
}
var mv = Oh.filter(function(e) {
  return e !== Pe || e !== Xr;
}), gv = Object.keys(Za).filter(function(e) {
  return e !== Pe;
}).map(function(e) {
  return Object.keys(Za[e]);
}).flat();
function yv(e) {
  var t = e.values, n = e.family, r = e.canonical, i = e.givenPrefix, a = i === void 0 ? "" : i, o = e.styles, s = o === void 0 ? {} : o, l = e.config, u = l === void 0 ? {} : l, c = n === Xr, f = t.includes("fa-duotone") || t.includes("fad"), d = u.familyDefault === "duotone", h = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!c && (f || d || h) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && mv.includes(n)) {
    var p = Object.keys(s).find(function(y) {
      return gv.includes(y);
    });
    if (p || u.autoFetchSvg) {
      var m = $0.get(n).defaultShortPrefixId;
      r.prefix = m, r.iconName = yn(r.prefix, r.iconName) || r.iconName;
    }
  }
  return (r.prefix === "fa" || a === "fa") && (r.prefix = Qt() || "fas"), r;
}
var wv = /* @__PURE__ */ (function() {
  function e() {
    f0(this, e), this.definitions = {};
  }
  return h0(e, [{
    key: "add",
    value: function() {
      for (var n = this, r = arguments.length, i = new Array(r), a = 0; a < r; a++)
        i[a] = arguments[a];
      var o = i.reduce(this._pullDefinitions, {});
      Object.keys(o).forEach(function(s) {
        n.definitions[s] = F(F({}, n.definitions[s] || {}), o[s]), rs(s, o[s]);
        var l = al[Pe][s];
        l && rs(l, o[s]), rp();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, r) {
      var i = r.prefix && r.iconName && r.icon ? {
        0: r
      } : r;
      return Object.keys(i).map(function(a) {
        var o = i[a], s = o.prefix, l = o.iconName, u = o.icon, c = u[2];
        n[s] || (n[s] = {}), c.length > 0 && c.forEach(function(f) {
          typeof f == "string" && (n[s][f] = u);
        }), n[s][l] = u;
      }), n;
    }
  }]);
})(), nc = [], Vn = {}, Hn = {}, vv = Object.keys(Hn);
function bv(e, t) {
  var n = t.mixoutsTo;
  return nc = e, Vn = {}, Object.keys(Hn).forEach(function(r) {
    vv.indexOf(r) === -1 && delete Hn[r];
  }), nc.forEach(function(r) {
    var i = r.mixout ? r.mixout() : {};
    if (Object.keys(i).forEach(function(o) {
      typeof i[o] == "function" && (n[o] = i[o]), eo(i[o]) === "object" && Object.keys(i[o]).forEach(function(s) {
        n[o] || (n[o] = {}), n[o][s] = i[o][s];
      });
    }), r.hooks) {
      var a = r.hooks();
      Object.keys(a).forEach(function(o) {
        Vn[o] || (Vn[o] = []), Vn[o].push(a[o]);
      });
    }
    r.provides && r.provides(Hn);
  }), n;
}
function is(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  var a = Vn[e] || [];
  return a.forEach(function(o) {
    t = o.apply(null, [t].concat(r));
  }), t;
}
function Sn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var i = Vn[e] || [];
  i.forEach(function(a) {
    a.apply(null, n);
  });
}
function en() {
  var e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Hn[e] ? Hn[e].apply(null, t) : void 0;
}
function os(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  var t = e.iconName, n = e.prefix || Qt();
  if (t)
    return t = yn(n, t) || t, Ju(ap.definitions, n, t) || Ju(it.styles, n, t);
}
var ap = new wv(), xv = function() {
  W.autoReplaceSvg = !1, W.observeMutations = !1, Sn("noAuto");
}, kv = {
  i2svg: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Wt ? (Sn("beforeI2svg", t), en("pseudoElements2svg", t), en("i2svg", t)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot;
    W.autoReplaceSvg === !1 && (W.autoReplaceSvg = !0), W.observeMutations = !0, ov(function() {
      Sv({
        autoReplaceSvgRoot: n
      }), Sn("watch", t);
    });
  }
}, Cv = {
  icon: function(t) {
    if (t === null)
      return null;
    if (eo(t) === "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: yn(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      var n = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], r = ko(t[0]);
      return {
        prefix: r,
        iconName: yn(r, n) || n
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(W.cssPrefix, "-")) > -1 || t.match(Ww))) {
      var i = Co(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: i.prefix || Qt(),
        iconName: yn(i.prefix, i.iconName) || i.iconName
      };
    }
    if (typeof t == "string") {
      var a = Qt();
      return {
        prefix: a,
        iconName: yn(a, t) || t
      };
    }
  }
}, Ye = {
  noAuto: xv,
  config: W,
  dom: kv,
  parse: Cv,
  library: ap,
  findIconDefinition: os,
  toHtml: Jr
}, Sv = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot, r = n === void 0 ? ue : n;
  (Object.keys(it.styles).length > 0 || W.autoFetchSvg) && Wt && W.autoReplaceSvg && Ye.dom.i2svg({
    node: r
  });
};
function So(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map(function(r) {
        return Jr(r);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (Wt) {
        var r = ue.createElement("div");
        return r.innerHTML = e.html, r.children;
      }
    }
  }), e;
}
function Av(e) {
  var t = e.children, n = e.main, r = e.mask, i = e.attributes, a = e.styles, o = e.transform;
  if (ll(o) && n.found && !r.found) {
    var s = n.width, l = n.height, u = {
      x: s / l / 2,
      y: 0.5
    };
    i.style = xo(F(F({}, a), {}, {
      "transform-origin": "".concat(u.x + o.x / 16, "em ").concat(u.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: t
  }];
}
function Tv(e) {
  var t = e.prefix, n = e.iconName, r = e.children, i = e.attributes, a = e.symbol, o = a === !0 ? "".concat(t, "-").concat(W.cssPrefix, "-").concat(n) : a;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: F(F({}, i), {}, {
        id: o
      }),
      children: r
    }]
  }];
}
function Ev(e) {
  var t = ["aria-label", "aria-labelledby", "title", "role"];
  return t.some(function(n) {
    return n in e;
  });
}
function fl(e) {
  var t = e.icons, n = t.main, r = t.mask, i = e.prefix, a = e.iconName, o = e.transform, s = e.symbol, l = e.maskId, u = e.extra, c = e.watchable, f = c === void 0 ? !1 : c, d = r.found ? r : n, h = d.width, p = d.height, m = [W.replacementClass, a ? "".concat(W.cssPrefix, "-").concat(a) : ""].filter(function(x) {
    return u.classes.indexOf(x) === -1;
  }).filter(function(x) {
    return x !== "" || !!x;
  }).concat(u.classes).join(" "), y = {
    children: [],
    attributes: F(F({}, u.attributes), {}, {
      "data-prefix": i,
      "data-icon": a,
      class: m,
      role: u.attributes.role || "img",
      viewBox: "0 0 ".concat(h, " ").concat(p)
    })
  };
  !Ev(u.attributes) && !u.attributes["aria-hidden"] && (y.attributes["aria-hidden"] = "true"), f && (y.attributes[Cn] = "");
  var g = F(F({}, y), {}, {
    prefix: i,
    iconName: a,
    main: n,
    mask: r,
    maskId: l,
    transform: o,
    symbol: s,
    styles: F({}, u.styles)
  }), w = r.found && n.found ? en("generateAbstractMask", g) || {
    children: [],
    attributes: {}
  } : en("generateAbstractIcon", g) || {
    children: [],
    attributes: {}
  }, v = w.children, k = w.attributes;
  return g.children = v, g.attributes = k, s ? Tv(g) : Av(g);
}
function rc(e) {
  var t = e.content, n = e.width, r = e.height, i = e.transform, a = e.extra, o = e.watchable, s = o === void 0 ? !1 : o, l = F(F({}, a.attributes), {}, {
    class: a.classes.join(" ")
  });
  s && (l[Cn] = "");
  var u = F({}, a.styles);
  ll(i) && (u.transform = nv({
    transform: i,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  var c = xo(u);
  c.length > 0 && (l.style = c);
  var f = [];
  return f.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), f;
}
function Pv(e) {
  var t = e.content, n = e.extra, r = F(F({}, n.attributes), {}, {
    class: n.classes.join(" ")
  }), i = xo(n.styles);
  i.length > 0 && (r.style = i);
  var a = [];
  return a.push({
    tag: "span",
    attributes: r,
    children: [t]
  }), a;
}
var Qo = it.styles;
function as(e) {
  var t = e[0], n = e[1], r = e.slice(4), i = bo(r, 1), a = i[0], o = null;
  return Array.isArray(a) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(W.cssPrefix, "-").concat(Xo.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(W.cssPrefix, "-").concat(Xo.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(W.cssPrefix, "-").concat(Xo.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: o
  };
}
var Iv = {
  found: !1,
  width: 512,
  height: 512
};
function Rv(e, t) {
  !Bh && !W.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function ss(e, t) {
  var n = t;
  return t === "fa" && W.styleDefault !== null && (t = Qt()), new Promise(function(r, i) {
    if (n === "fa") {
      var a = ip(e) || {};
      e = a.iconName || e, t = a.prefix || t;
    }
    if (e && t && Qo[t] && Qo[t][e]) {
      var o = Qo[t][e];
      return r(as(o));
    }
    Rv(e, t), r(F(F({}, Iv), {}, {
      icon: W.showMissingIcons && e ? en("missingIconAbstract") || {} : {}
    }));
  });
}
var ic = function() {
}, ls = W.measurePerformance && pi && pi.mark && pi.measure ? pi : {
  mark: ic,
  measure: ic
}, Sr = 'FA "7.0.1"', Mv = function(t) {
  return ls.mark("".concat(Sr, " ").concat(t, " begins")), function() {
    return sp(t);
  };
}, sp = function(t) {
  ls.mark("".concat(Sr, " ").concat(t, " ends")), ls.measure("".concat(Sr, " ").concat(t), "".concat(Sr, " ").concat(t, " begins"), "".concat(Sr, " ").concat(t, " ends"));
}, dl = {
  begin: Mv,
  end: sp
}, ji = function() {
};
function oc(e) {
  var t = e.getAttribute ? e.getAttribute(Cn) : null;
  return typeof t == "string";
}
function Dv(e) {
  var t = e.getAttribute ? e.getAttribute(il) : null, n = e.getAttribute ? e.getAttribute(ol) : null;
  return t && n;
}
function Lv(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(W.replacementClass);
}
function Nv() {
  if (W.autoReplaceSvg === !0)
    return Bi.replace;
  var e = Bi[W.autoReplaceSvg];
  return e || Bi.replace;
}
function Ov(e) {
  return ue.createElementNS("http://www.w3.org/2000/svg", e);
}
function Fv(e) {
  return ue.createElement(e);
}
function lp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.ceFn, r = n === void 0 ? e.tag === "svg" ? Ov : Fv : n;
  if (typeof e == "string")
    return ue.createTextNode(e);
  var i = r(e.tag);
  Object.keys(e.attributes || []).forEach(function(o) {
    i.setAttribute(o, e.attributes[o]);
  });
  var a = e.children || [];
  return a.forEach(function(o) {
    i.appendChild(lp(o, {
      ceFn: r
    }));
  }), i;
}
function _v(e) {
  var t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
var Bi = {
  replace: function(t) {
    var n = t[0];
    if (n.parentNode)
      if (t[1].forEach(function(i) {
        n.parentNode.insertBefore(lp(i), n);
      }), n.getAttribute(Cn) === null && W.keepOriginalSource) {
        var r = ue.createComment(_v(n));
        n.parentNode.replaceChild(r, n);
      } else
        n.remove();
  },
  nest: function(t) {
    var n = t[0], r = t[1];
    if (~sl(n).indexOf(W.replacementClass))
      return Bi.replace(t);
    var i = new RegExp("".concat(W.cssPrefix, "-.*"));
    if (delete r[0].attributes.id, r[0].attributes.class) {
      var a = r[0].attributes.class.split(" ").reduce(function(s, l) {
        return l === W.replacementClass || l.match(i) ? s.toSvg.push(l) : s.toNode.push(l), s;
      }, {
        toNode: [],
        toSvg: []
      });
      r[0].attributes.class = a.toSvg.join(" "), a.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", a.toNode.join(" "));
    }
    var o = r.map(function(s) {
      return Jr(s);
    }).join(`
`);
    n.setAttribute(Cn, ""), n.innerHTML = o;
  }
};
function ac(e) {
  e();
}
function up(e, t) {
  var n = typeof t == "function" ? t : ji;
  if (e.length === 0)
    n();
  else {
    var r = ac;
    W.mutateApproach === $w && (r = Jt.requestAnimationFrame || ac), r(function() {
      var i = Nv(), a = dl.begin("mutate");
      e.map(i), a(), n();
    });
  }
}
var hl = !1;
function cp() {
  hl = !0;
}
function us() {
  hl = !1;
}
var no = null;
function sc(e) {
  if (Hu && W.observeMutations) {
    var t = e.treeCallback, n = t === void 0 ? ji : t, r = e.nodeCallback, i = r === void 0 ? ji : r, a = e.pseudoElementsCallback, o = a === void 0 ? ji : a, s = e.observeMutationsRoot, l = s === void 0 ? ue : s;
    no = new Hu(function(u) {
      if (!hl) {
        var c = Qt();
        or(u).forEach(function(f) {
          if (f.type === "childList" && f.addedNodes.length > 0 && !oc(f.addedNodes[0]) && (W.searchPseudoElements && o(f.target), n(f.target)), f.type === "attributes" && f.target.parentNode && W.searchPseudoElements && o([f.target], !0), f.type === "attributes" && oc(f.target) && ~Gw.indexOf(f.attributeName))
            if (f.attributeName === "class" && Dv(f.target)) {
              var d = Co(sl(f.target)), h = d.prefix, p = d.iconName;
              f.target.setAttribute(il, h || c), p && f.target.setAttribute(ol, p);
            } else Lv(f.target) && i(f.target);
        });
      }
    }), Wt && no.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function zv() {
  no && no.disconnect();
}
function Vv(e) {
  var t = e.getAttribute("style"), n = [];
  return t && (n = t.split(";").reduce(function(r, i) {
    var a = i.split(":"), o = a[0], s = a.slice(1);
    return o && s.length > 0 && (r[o] = s.join(":").trim()), r;
  }, {})), n;
}
function $v(e) {
  var t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "", i = Co(sl(e));
  return i.prefix || (i.prefix = Qt()), t && n && (i.prefix = t, i.iconName = n), i.iconName && i.prefix || (i.prefix && r.length > 0 && (i.iconName = cv(i.prefix, e.innerText) || cl(i.prefix, Xh(e.innerText))), !i.iconName && W.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = e.firstChild.data)), i;
}
function jv(e) {
  var t = or(e.attributes).reduce(function(n, r) {
    return n.name !== "class" && n.name !== "style" && (n[r.name] = r.value), n;
  }, {});
  return t;
}
function Bv() {
  return {
    iconName: null,
    prefix: null,
    transform: gt,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function lc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = $v(e), r = n.iconName, i = n.prefix, a = n.rest, o = jv(e), s = is("parseNodeAttributes", {}, e), l = t.styleParser ? Vv(e) : [];
  return F({
    iconName: r,
    prefix: i,
    transform: gt,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: l,
      attributes: o
    }
  }, s);
}
var Wv = it.styles;
function fp(e) {
  var t = W.autoReplaceSvg === "nest" ? lc(e, {
    styleParser: !1
  }) : lc(e);
  return ~t.extra.classes.indexOf(Uh) ? en("generateLayersText", e, t) : en("generateSvgReplacementMutation", e, t);
}
function Uv() {
  return [].concat(st(Fh), st(_h));
}
function uc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Wt) return Promise.resolve();
  var n = ue.documentElement.classList, r = function(f) {
    return n.add("".concat(Ku, "-").concat(f));
  }, i = function(f) {
    return n.remove("".concat(Ku, "-").concat(f));
  }, a = W.autoFetchSvg ? Uv() : xh.concat(Object.keys(Wv));
  a.includes("fa") || a.push("fa");
  var o = [".".concat(Uh, ":not([").concat(Cn, "])")].concat(a.map(function(c) {
    return ".".concat(c, ":not([").concat(Cn, "])");
  })).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  var s = [];
  try {
    s = or(e.querySelectorAll(o));
  } catch {
  }
  if (s.length > 0)
    r("pending"), i("complete");
  else
    return Promise.resolve();
  var l = dl.begin("onTree"), u = s.reduce(function(c, f) {
    try {
      var d = fp(f);
      d && c.push(d);
    } catch (h) {
      Bh || h.name === "MissingIcon" && console.error(h);
    }
    return c;
  }, []);
  return new Promise(function(c, f) {
    Promise.all(u).then(function(d) {
      up(d, function() {
        r("active"), r("complete"), i("pending"), typeof t == "function" && t(), l(), c();
      });
    }).catch(function(d) {
      l(), f(d);
    });
  });
}
function Hv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  fp(e).then(function(n) {
    n && up([n], t);
  });
}
function Gv(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (t || {}).icon ? t : os(t || {}), i = n.mask;
    return i && (i = (i || {}).icon ? i : os(i || {})), e(r, F(F({}, n), {}, {
      mask: i
    }));
  };
}
var qv = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.transform, i = r === void 0 ? gt : r, a = n.symbol, o = a === void 0 ? !1 : a, s = n.mask, l = s === void 0 ? null : s, u = n.maskId, c = u === void 0 ? null : u, f = n.classes, d = f === void 0 ? [] : f, h = n.attributes, p = h === void 0 ? {} : h, m = n.styles, y = m === void 0 ? {} : m;
  if (t) {
    var g = t.prefix, w = t.iconName, v = t.icon;
    return So(F({
      type: "icon"
    }, t), function() {
      return Sn("beforeDOMElementCreation", {
        iconDefinition: t,
        params: n
      }), fl({
        icons: {
          main: as(v),
          mask: l ? as(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: g,
        iconName: w,
        transform: F(F({}, gt), i),
        symbol: o,
        maskId: c,
        extra: {
          attributes: p,
          styles: y,
          classes: d
        }
      });
    });
  }
}, Kv = {
  mixout: function() {
    return {
      icon: Gv(qv)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = uc, n.nodeCallback = Hv, n;
      }
    };
  },
  provides: function(t) {
    t.i2svg = function(n) {
      var r = n.node, i = r === void 0 ? ue : r, a = n.callback, o = a === void 0 ? function() {
      } : a;
      return uc(i, o);
    }, t.generateSvgReplacementMutation = function(n, r) {
      var i = r.iconName, a = r.prefix, o = r.transform, s = r.symbol, l = r.mask, u = r.maskId, c = r.extra;
      return new Promise(function(f, d) {
        Promise.all([ss(i, a), l.iconName ? ss(l.iconName, l.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(h) {
          var p = bo(h, 2), m = p[0], y = p[1];
          f([n, fl({
            icons: {
              main: m,
              mask: y
            },
            prefix: a,
            iconName: i,
            transform: o,
            symbol: s,
            maskId: u,
            extra: c,
            watchable: !0
          })]);
        }).catch(d);
      });
    }, t.generateAbstractIcon = function(n) {
      var r = n.children, i = n.attributes, a = n.main, o = n.transform, s = n.styles, l = xo(s);
      l.length > 0 && (i.style = l);
      var u;
      return ll(o) && (u = en("generateAbstractTransformGrouping", {
        main: a,
        transform: o,
        containerWidth: a.width,
        iconWidth: a.width
      })), r.push(u || a.icon), {
        children: r,
        attributes: i
      };
    };
  }
}, Yv = {
  mixout: function() {
    return {
      layer: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.classes, a = i === void 0 ? [] : i;
        return So({
          type: "layer"
        }, function() {
          Sn("beforeDOMElementCreation", {
            assembler: n,
            params: r
          });
          var o = [];
          return n(function(s) {
            Array.isArray(s) ? s.map(function(l) {
              o = o.concat(l.abstract);
            }) : o = o.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(W.cssPrefix, "-layers")].concat(st(a)).join(" ")
            },
            children: o
          }];
        });
      }
    };
  }
}, Xv = {
  mixout: function() {
    return {
      counter: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        r.title;
        var i = r.classes, a = i === void 0 ? [] : i, o = r.attributes, s = o === void 0 ? {} : o, l = r.styles, u = l === void 0 ? {} : l;
        return So({
          type: "counter",
          content: n
        }, function() {
          return Sn("beforeDOMElementCreation", {
            content: n,
            params: r
          }), Pv({
            content: n.toString(),
            extra: {
              attributes: s,
              styles: u,
              classes: ["".concat(W.cssPrefix, "-layers-counter")].concat(st(a))
            }
          });
        });
      }
    };
  }
}, Zv = {
  mixout: function() {
    return {
      text: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.transform, a = i === void 0 ? gt : i, o = r.classes, s = o === void 0 ? [] : o, l = r.attributes, u = l === void 0 ? {} : l, c = r.styles, f = c === void 0 ? {} : c;
        return So({
          type: "text",
          content: n
        }, function() {
          return Sn("beforeDOMElementCreation", {
            content: n,
            params: r
          }), rc({
            content: n,
            transform: F(F({}, gt), a),
            extra: {
              attributes: u,
              styles: f,
              classes: ["".concat(W.cssPrefix, "-layers-text")].concat(st(s))
            }
          });
        });
      }
    };
  },
  provides: function(t) {
    t.generateLayersText = function(n, r) {
      var i = r.transform, a = r.extra, o = null, s = null;
      if (vh) {
        var l = parseInt(getComputedStyle(n).fontSize, 10), u = n.getBoundingClientRect();
        o = u.width / l, s = u.height / l;
      }
      return Promise.resolve([n, rc({
        content: n.innerHTML,
        width: o,
        height: s,
        transform: i,
        extra: a,
        watchable: !0
      })]);
    };
  }
}, dp = new RegExp('"', "ug"), cc = [1105920, 1112319], fc = F(F(F(F({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), V0), zw), K0), cs = Object.keys(fc).reduce(function(e, t) {
  return e[t.toLowerCase()] = fc[t], e;
}, {}), Jv = Object.keys(cs).reduce(function(e, t) {
  var n = cs[t];
  return e[t] = n[900] || st(Object.entries(n))[0][1], e;
}, {});
function Qv(e) {
  var t = e.replace(dp, "");
  return Xh(st(t)[0] || "");
}
function eb(e) {
  var t = e.getPropertyValue("font-feature-settings").includes("ss01"), n = e.getPropertyValue("content"), r = n.replace(dp, ""), i = r.codePointAt(0), a = i >= cc[0] && i <= cc[1], o = r.length === 2 ? r[0] === r[1] : !1;
  return a || o || t;
}
function tb(e, t) {
  var n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), i = isNaN(r) ? "normal" : r;
  return (cs[n] || {})[i] || Jv[n];
}
function dc(e, t) {
  var n = "".concat(Vw).concat(t.replace(":", "-"));
  return new Promise(function(r, i) {
    if (e.getAttribute(n) !== null)
      return r();
    var a = or(e.children), o = a.filter(function(C) {
      return C.getAttribute(Qa) === t;
    })[0], s = Jt.getComputedStyle(e, t), l = s.getPropertyValue("font-family"), u = l.match(Uw), c = s.getPropertyValue("font-weight"), f = s.getPropertyValue("content");
    if (o && !u)
      return e.removeChild(o), r();
    if (u && f !== "none" && f !== "") {
      var d = s.getPropertyValue("content"), h = tb(l, c), p = Qv(d), m = u[0].startsWith("FontAwesome"), y = eb(s), g = cl(h, p), w = g;
      if (m) {
        var v = fv(p);
        v.iconName && v.prefix && (g = v.iconName, h = v.prefix);
      }
      if (g && !y && (!o || o.getAttribute(il) !== h || o.getAttribute(ol) !== w)) {
        e.setAttribute(n, w), o && e.removeChild(o);
        var k = Bv(), x = k.extra;
        x.attributes[Qa] = t, ss(g, h).then(function(C) {
          var P = fl(F(F({}, k), {}, {
            icons: {
              main: C,
              mask: op()
            },
            prefix: h,
            iconName: w,
            extra: x,
            watchable: !0
          })), I = ue.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(I, e.firstChild) : e.appendChild(I), I.outerHTML = P.map(function(N) {
            return Jr(N);
          }).join(`
`), e.removeAttribute(n), r();
        }).catch(i);
      } else
        r();
    } else
      r();
  });
}
function nb(e) {
  return Promise.all([dc(e, "::before"), dc(e, "::after")]);
}
function rb(e) {
  return e.parentNode !== document.head && !~jw.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Qa) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
var ib = function(t) {
  return !!t && jh.some(function(n) {
    return t.includes(n);
  });
}, ob = function(t) {
  if (!t) return [];
  var n = /* @__PURE__ */ new Set(), r = t.split(/,(?![^()]*\))/).map(function(l) {
    return l.trim();
  });
  r = r.flatMap(function(l) {
    return l.includes("(") ? l : l.split(",").map(function(u) {
      return u.trim();
    });
  });
  var i = $i(r), a;
  try {
    for (i.s(); !(a = i.n()).done; ) {
      var o = a.value;
      if (ib(o)) {
        var s = jh.reduce(function(l, u) {
          return l.replace(u, "");
        }, o);
        s !== "" && s !== "*" && n.add(s);
      }
    }
  } catch (l) {
    i.e(l);
  } finally {
    i.f();
  }
  return n;
};
function hc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (Wt) {
    var n;
    if (t)
      n = e;
    else if (W.searchPseudoElementsFullScan)
      n = e.querySelectorAll("*");
    else {
      var r = /* @__PURE__ */ new Set(), i = $i(document.styleSheets), a;
      try {
        for (i.s(); !(a = i.n()).done; ) {
          var o = a.value;
          try {
            var s = $i(o.cssRules), l;
            try {
              for (s.s(); !(l = s.n()).done; ) {
                var u = l.value, c = ob(u.selectorText), f = $i(c), d;
                try {
                  for (f.s(); !(d = f.n()).done; ) {
                    var h = d.value;
                    r.add(h);
                  }
                } catch (m) {
                  f.e(m);
                } finally {
                  f.f();
                }
              }
            } catch (m) {
              s.e(m);
            } finally {
              s.f();
            }
          } catch (m) {
            W.searchPseudoElementsWarnings && console.warn("Font Awesome: cannot parse stylesheet: ".concat(o.href, " (").concat(m.message, `)
If it declares any Font Awesome CSS pseudo-elements, they will not be rendered as SVG icons. Add crossorigin="anonymous" to the <link>, enable searchPseudoElementsFullScan for slower but more thorough DOM parsing, or suppress this warning by setting searchPseudoElementsWarnings to false.`));
          }
        }
      } catch (m) {
        i.e(m);
      } finally {
        i.f();
      }
      if (!r.size) return;
      var p = Array.from(r).join(", ");
      try {
        n = e.querySelectorAll(p);
      } catch {
      }
    }
    return new Promise(function(m, y) {
      var g = or(n).filter(rb).map(nb), w = dl.begin("searchPseudoElements");
      cp(), Promise.all(g).then(function() {
        w(), us(), m();
      }).catch(function() {
        w(), us(), y();
      });
    });
  }
}
var ab = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = hc, n;
      }
    };
  },
  provides: function(t) {
    t.pseudoElements2svg = function(n) {
      var r = n.node, i = r === void 0 ? ue : r;
      W.searchPseudoElements && hc(i);
    };
  }
}, pc = !1, sb = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          cp(), pc = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        sc(is("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        zv();
      },
      watch: function(n) {
        var r = n.observeMutationsRoot;
        pc ? us() : sc(is("mutationObserverCallbacks", {
          observeMutationsRoot: r
        }));
      }
    };
  }
}, mc = function(t) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce(function(r, i) {
    var a = i.toLowerCase().split("-"), o = a[0], s = a.slice(1).join("-");
    if (o && s === "h")
      return r.flipX = !0, r;
    if (o && s === "v")
      return r.flipY = !0, r;
    if (s = parseFloat(s), isNaN(s))
      return r;
    switch (o) {
      case "grow":
        r.size = r.size + s;
        break;
      case "shrink":
        r.size = r.size - s;
        break;
      case "left":
        r.x = r.x - s;
        break;
      case "right":
        r.x = r.x + s;
        break;
      case "up":
        r.y = r.y - s;
        break;
      case "down":
        r.y = r.y + s;
        break;
      case "rotate":
        r.rotate = r.rotate + s;
        break;
    }
    return r;
  }, n);
}, lb = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return mc(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var i = r.getAttribute("data-fa-transform");
        return i && (n.transform = mc(i)), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractTransformGrouping = function(n) {
      var r = n.main, i = n.transform, a = n.containerWidth, o = n.iconWidth, s = {
        transform: "translate(".concat(a / 2, " 256)")
      }, l = "translate(".concat(i.x * 32, ", ").concat(i.y * 32, ") "), u = "scale(".concat(i.size / 16 * (i.flipX ? -1 : 1), ", ").concat(i.size / 16 * (i.flipY ? -1 : 1), ") "), c = "rotate(".concat(i.rotate, " 0 0)"), f = {
        transform: "".concat(l, " ").concat(u, " ").concat(c)
      }, d = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, h = {
        outer: s,
        inner: f,
        path: d
      };
      return {
        tag: "g",
        attributes: F({}, h.outer),
        children: [{
          tag: "g",
          attributes: F({}, h.inner),
          children: [{
            tag: r.icon.tag,
            children: r.icon.children,
            attributes: F(F({}, r.icon.attributes), h.path)
          }]
        }]
      };
    };
  }
}, ea = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function gc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function ub(e) {
  return e.tag === "g" ? e.children : [e];
}
var cb = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var i = r.getAttribute("data-fa-mask"), a = i ? Co(i.split(" ").map(function(o) {
          return o.trim();
        })) : op();
        return a.prefix || (a.prefix = Qt()), n.mask = a, n.maskId = r.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractMask = function(n) {
      var r = n.children, i = n.attributes, a = n.main, o = n.mask, s = n.maskId, l = n.transform, u = a.width, c = a.icon, f = o.width, d = o.icon, h = tv({
        transform: l,
        containerWidth: f,
        iconWidth: u
      }), p = {
        tag: "rect",
        attributes: F(F({}, ea), {}, {
          fill: "white"
        })
      }, m = c.children ? {
        children: c.children.map(gc)
      } : {}, y = {
        tag: "g",
        attributes: F({}, h.inner),
        children: [gc(F({
          tag: c.tag,
          attributes: F(F({}, c.attributes), h.path)
        }, m))]
      }, g = {
        tag: "g",
        attributes: F({}, h.outer),
        children: [y]
      }, w = "mask-".concat(s || Xu()), v = "clip-".concat(s || Xu()), k = {
        tag: "mask",
        attributes: F(F({}, ea), {}, {
          id: w,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, g]
      }, x = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: v
          },
          children: ub(d)
        }, k]
      };
      return r.push(x, {
        tag: "rect",
        attributes: F({
          fill: "currentColor",
          "clip-path": "url(#".concat(v, ")"),
          mask: "url(#".concat(w, ")")
        }, ea)
      }), {
        children: r,
        attributes: i
      };
    };
  }
}, fb = {
  provides: function(t) {
    var n = !1;
    Jt.matchMedia && (n = Jt.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      var r = [], i = {
        fill: "currentColor"
      }, a = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      r.push({
        tag: "path",
        attributes: F(F({}, i), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var o = F(F({}, a), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: F(F({}, i), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || s.children.push({
        tag: "animate",
        attributes: F(F({}, a), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: F(F({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), r.push(s), r.push({
        tag: "path",
        attributes: F(F({}, i), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: F(F({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || r.push({
        tag: "path",
        attributes: F(F({}, i), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: F(F({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: r
      };
    };
  }
}, db = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var i = r.getAttribute("data-fa-symbol"), a = i === null ? !1 : i === "" ? !0 : i;
        return n.symbol = a, n;
      }
    };
  }
}, hb = [iv, Kv, Yv, Xv, Zv, ab, sb, lb, cb, fb, db];
bv(hb, {
  mixoutsTo: Ye
});
Ye.noAuto;
var pb = Ye.config;
Ye.library;
Ye.dom;
var hp = Ye.parse;
Ye.findIconDefinition;
Ye.toHtml;
var mb = Ye.icon;
Ye.layer;
Ye.text;
Ye.counter;
function gb(e) {
  return e = e - 0, e === e;
}
function pp(e) {
  return gb(e) ? e : (e = e.replaceAll(/[_-]+(.)?/g, (t, n) => n ? n.toUpperCase() : ""), e.charAt(0).toLowerCase() + e.slice(1));
}
function yb(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var Dn = /* @__PURE__ */ new Map(), wb = 1e3;
function vb(e) {
  if (Dn.has(e))
    return Dn.get(e);
  const t = {};
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.indexOf(";", n), a = i === -1 ? r : i, o = e.slice(n, a).trim();
    if (o) {
      const s = o.indexOf(":");
      if (s > 0) {
        const l = o.slice(0, s).trim(), u = o.slice(s + 1).trim();
        if (l && u) {
          const c = pp(l);
          t[c.startsWith("webkit") ? yb(c) : c] = u;
        }
      }
    }
    n = a + 1;
  }
  if (Dn.size === wb) {
    const i = Dn.keys().next().value;
    i && Dn.delete(i);
  }
  return Dn.set(e, t), t;
}
function mp(e, t, n = {}) {
  if (typeof t == "string")
    return t;
  const r = (t.children || []).map((u) => mp(e, u)), i = t.attributes || {}, a = {};
  for (const [u, c] of Object.entries(i))
    switch (!0) {
      case u === "class": {
        a.className = c, delete i.class;
        break;
      }
      case u === "style": {
        a.style = vb(String(c));
        break;
      }
      case u.startsWith("aria-"):
      case u.startsWith("data-"): {
        a[u.toLowerCase()] = c;
        break;
      }
      default:
        a[pp(u)] = c;
    }
  const {
    style: o,
    "aria-label": s,
    ...l
  } = n;
  return o && (a.style = a.style ? { ...a.style, ...o } : o), s && (a["aria-label"] = s, a["aria-hidden"] = "false"), e(t.tag, { ...l, ...a }, ...r);
}
var yc = (e, t) => {
  const n = wo();
  return e || (t ? n : void 0);
}, bb = class {
  constructor(e = "react-fontawesome") {
    this.enabled = !1;
    let t = !1;
    try {
      t = typeof process < "u" && !1;
    } catch {
    }
    this.scope = e, this.enabled = t;
  }
  /**
   * Logs messages to the console if not in production.
   * @param args - The message and/or data to log.
   */
  log(...e) {
    this.enabled && console.log(`[${this.scope}]`, ...e);
  }
  /**
   * Logs warnings to the console if not in production.
   * @param args - The warning message and/or data to log.
   */
  warn(...e) {
    this.enabled && console.warn(`[${this.scope}]`, ...e);
  }
  /**
   * Logs errors to the console if not in production.
   * @param args - The error message and/or data to log.
   */
  error(...e) {
    this.enabled && console.error(`[${this.scope}]`, ...e);
  }
};
typeof process < "u" && process.env.FA_VERSION;
var xb = (
  // @ts-expect-error TS2872 - Expression is always truthy - This is true when v7 of SVGCore is used, but not when v6 is used.
  // This is the point of this check - if the property exists on config, we have v7, otherwise we have v6.
  // TS is checking this against the dev dependencies which uses v7, so it reports a false error here.
  "searchPseudoElementsFullScan" in pb ? "7.0.0" : "6.0.0"
), kb = Number.parseInt(xb) >= 7, It = {
  beat: "fa-beat",
  fade: "fa-fade",
  beatFade: "fa-beat-fade",
  bounce: "fa-bounce",
  shake: "fa-shake",
  spin: "fa-spin",
  spinPulse: "fa-spin-pulse",
  spinReverse: "fa-spin-reverse",
  pulse: "fa-pulse"
}, Cb = {
  left: "fa-pull-left",
  right: "fa-pull-right"
}, Sb = {
  90: "fa-rotate-90",
  180: "fa-rotate-180",
  270: "fa-rotate-270"
}, Ab = {
  "2xs": "fa-2xs",
  xs: "fa-xs",
  sm: "fa-sm",
  lg: "fa-lg",
  xl: "fa-xl",
  "2xl": "fa-2xl",
  "1x": "fa-1x",
  "2x": "fa-2x",
  "3x": "fa-3x",
  "4x": "fa-4x",
  "5x": "fa-5x",
  "6x": "fa-6x",
  "7x": "fa-7x",
  "8x": "fa-8x",
  "9x": "fa-9x",
  "10x": "fa-10x"
}, Rt = {
  border: "fa-border",
  /** @deprecated */
  fixedWidth: "fa-fw",
  flip: "fa-flip",
  flipHorizontal: "fa-flip-horizontal",
  flipVertical: "fa-flip-vertical",
  inverse: "fa-inverse",
  rotateBy: "fa-rotate-by",
  swapOpacity: "fa-swap-opacity",
  widthAuto: "fa-width-auto"
};
function Tb(e) {
  const {
    beat: t,
    fade: n,
    beatFade: r,
    bounce: i,
    shake: a,
    spin: o,
    spinPulse: s,
    spinReverse: l,
    pulse: u,
    fixedWidth: c,
    inverse: f,
    border: d,
    flip: h,
    size: p,
    rotation: m,
    pull: y,
    swapOpacity: g,
    rotateBy: w,
    widthAuto: v,
    className: k
  } = e, x = [];
  return k && x.push(...k.split(" ")), t && x.push(It.beat), n && x.push(It.fade), r && x.push(It.beatFade), i && x.push(It.bounce), a && x.push(It.shake), o && x.push(It.spin), l && x.push(It.spinReverse), s && x.push(It.spinPulse), u && x.push(It.pulse), c && x.push(Rt.fixedWidth), f && x.push(Rt.inverse), d && x.push(Rt.border), h === !0 && x.push(Rt.flip), (h === "horizontal" || h === "both") && x.push(Rt.flipHorizontal), (h === "vertical" || h === "both") && x.push(Rt.flipVertical), p != null && x.push(Ab[p]), m != null && m !== 0 && x.push(Sb[m]), y != null && x.push(Cb[y]), g && x.push(Rt.swapOpacity), kb && (w && x.push(Rt.rotateBy), v && x.push(Rt.widthAuto)), x;
}
var Eb = (e) => typeof e == "object" && "icon" in e && !!e.icon;
function wc(e) {
  if (e)
    return Eb(e) ? e : hp.icon(e);
}
function Pb(e) {
  return Object.keys(e);
}
var vc = new bb("FontAwesomeIcon"), gp = {
  border: !1,
  className: "",
  mask: void 0,
  maskId: void 0,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: void 0,
  listItem: !1,
  pull: void 0,
  pulse: !1,
  rotation: void 0,
  rotateBy: !1,
  size: void 0,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: void 0,
  transform: void 0,
  swapOpacity: !1,
  widthAuto: !1
}, Ib = new Set(Object.keys(gp)), ve = el.forwardRef((e, t) => {
  const n = { ...gp, ...e }, {
    icon: r,
    mask: i,
    symbol: a,
    title: o,
    titleId: s,
    maskId: l,
    transform: u
  } = n, c = yc(l, !!i), f = yc(s, !!o), d = wc(r);
  if (!d)
    return vc.error("Icon lookup is undefined", r), null;
  const h = Tb(n), p = typeof u == "string" ? hp.transform(u) : u, m = wc(i), y = mb(d, {
    ...h.length > 0 && { classes: h },
    ...p && { transform: p },
    ...m && { mask: m },
    symbol: a,
    title: o,
    titleId: f,
    maskId: c
  });
  if (!y)
    return vc.error("Could not find icon", d), null;
  const { abstract: g } = y, w = { ref: t };
  for (const v of Pb(n))
    Ib.has(v) || (w[v] = n[v]);
  return Rb(g[0], w);
});
ve.displayName = "FontAwesomeIcon";
var Rb = mp.bind(null, el.createElement);
const Mb = ({
  message: e,
  sessionId: t,
  userId: n,
  clientWebApiKey: r,
  environment: i
}) => ({
  message: e.content,
  userId: n,
  sessionId: t,
  clientWebApiKey: r,
  environment: i
}), yp = (e) => ({
  id: e.id,
  content: e.content,
  role: e.role,
  createdAt: e.created_at,
  sessionId: e.session_id,
  userId: e.user_id,
  liked: e.liked,
  disliked: e.disliked
}), Db = (e) => {
  if (e.event === "custom_saved_chat_messages") {
    const { aiMessage: t } = e.data;
    return {
      id: t.id,
      content: t.content,
      role: t.role,
      createdAt: new Date(t.created_at),
      sessionId: t.chat_session_id,
      userId: t.user_id ?? void 0,
      liked: t.liked,
      disliked: t.disliked
    };
  }
  return null;
}, wp = async ({
  sessionId: e,
  apiKey: t,
  displayMode: n,
  recaptchaToken: r,
  messageId: i,
  liked: a,
  disliked: o,
  dislikeReason: s,
  apiBaseUrl: l
}) => {
  const u = {
    "Content-Type": "application/json",
    "Client-Web-Api-Key": t,
    "Recaptcha-Token": r
  };
  n === "page-mobile" && (u["X-Client-Type"] = "page-mobile");
  const c = await fetch(`${l}/chat/v1/rate-message`, {
    method: "POST",
    body: JSON.stringify({
      messageId: i,
      sessionId: e,
      liked: a,
      disliked: o,
      dislike_reason: s
    }),
    headers: u
  });
  if (!c.ok) {
    const d = await c.json().catch(() => null);
    throw new Error(
      (d == null ? void 0 : d.message) || "Something went wrong! Please refresh or try again later."
    );
  }
  const f = await c.json();
  return yp(f);
};
function pl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ta = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var bc;
function Lb() {
  return bc || (bc = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var a = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (a = i(a, r(s)));
        }
        return a;
      }
      function r(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return n.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var o = "";
        for (var s in a)
          t.call(a, s) && a[s] && (o = i(o, s));
        return o;
      }
      function i(a, o) {
        return o ? a ? a + " " + o : a + o : a;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(ta)), ta.exports;
}
var Nb = Lb();
const Ob = /* @__PURE__ */ pl(Nb), ml = "-", Fb = (e) => {
  const t = zb(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (o) => {
      const s = o.split(ml);
      return s[0] === "" && s.length !== 1 && s.shift(), vp(s, t) || _b(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const l = n[o] || [];
      return s && r[o] ? [...l, ...r[o]] : l;
    }
  };
}, vp = (e, t) => {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? vp(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const a = e.join(ml);
  return (o = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : o.classGroupId;
}, xc = /^\[(.+)\]$/, _b = (e) => {
  if (xc.test(e)) {
    const t = xc.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, zb = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return $b(Object.entries(e.classGroups), n).forEach(([a, o]) => {
    fs(o, r, a, t);
  }), r;
}, fs = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const a = i === "" ? t : kc(t, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (Vb(i)) {
        fs(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([a, o]) => {
      fs(o, kc(t, a), n, r);
    });
  });
}, kc = (e, t) => {
  let n = e;
  return t.split(ml).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Vb = (e) => e.isThemeGetter, $b = (e, t) => t ? e.map(([n, r]) => {
  const i = r.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([o, s]) => [t + o, s])) : a);
  return [n, i];
}) : e, jb = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (a, o) => {
    n.set(a, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let o = n.get(a);
      if (o !== void 0)
        return o;
      if ((o = r.get(a)) !== void 0)
        return i(a, o), o;
    },
    set(a, o) {
      n.has(a) ? n.set(a, o) : i(a, o);
    }
  };
}, bp = "!", Bb = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], a = t.length, o = (s) => {
    const l = [];
    let u = 0, c = 0, f;
    for (let y = 0; y < s.length; y++) {
      let g = s[y];
      if (u === 0) {
        if (g === i && (r || s.slice(y, y + a) === t)) {
          l.push(s.slice(c, y)), c = y + a;
          continue;
        }
        if (g === "/") {
          f = y;
          continue;
        }
      }
      g === "[" ? u++ : g === "]" && u--;
    }
    const d = l.length === 0 ? s : s.substring(c), h = d.startsWith(bp), p = h ? d.substring(1) : d, m = f && f > c ? f - c : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: p,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: o
  }) : o;
}, Wb = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Ub = (e) => ({
  cache: jb(e.cacheSize),
  parseClassName: Bb(e),
  ...Fb(e)
}), Hb = /\s+/, Gb = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, a = [], o = e.trim().split(Hb);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const u = o[l], {
      modifiers: c,
      hasImportantModifier: f,
      baseClassName: d,
      maybePostfixModifierPosition: h
    } = n(u);
    let p = !!h, m = r(p ? d.substring(0, h) : d);
    if (!m) {
      if (!p) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (m = r(d), !m) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      p = !1;
    }
    const y = Wb(c).join(":"), g = f ? y + bp : y, w = g + m;
    if (a.includes(w))
      continue;
    a.push(w);
    const v = i(m, p);
    for (let k = 0; k < v.length; ++k) {
      const x = v[k];
      a.push(g + x);
    }
    s = u + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function qb() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = xp(t)) && (r && (r += " "), r += n);
  return r;
}
const xp = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = xp(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Cc(e, ...t) {
  let n, r, i, a = o;
  function o(l) {
    const u = t.reduce((c, f) => f(c), e());
    return n = Ub(u), r = n.cache.get, i = n.cache.set, a = s, s(l);
  }
  function s(l) {
    const u = r(l);
    if (u)
      return u;
    const c = Gb(l, n);
    return i(l, c), c;
  }
  return function() {
    return a(qb.apply(null, arguments));
  };
}
const le = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, kp = /^\[(?:([a-z-]+):)?(.+)\]$/i, Kb = /^\d+\/\d+$/, Yb = /* @__PURE__ */ new Set(["px", "full", "screen"]), Xb = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Zb = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Jb = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Qb = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Mt = (e) => Gn(e) || Yb.has(e) || Kb.test(e), Ht = (e) => ar(e, "length", lx), Gn = (e) => !!e && !Number.isNaN(Number(e)), na = (e) => ar(e, "number", Gn), gr = (e) => !!e && Number.isInteger(Number(e)), tx = (e) => e.endsWith("%") && Gn(e.slice(0, -1)), Y = (e) => kp.test(e), Gt = (e) => Xb.test(e), nx = /* @__PURE__ */ new Set(["length", "size", "percentage"]), rx = (e) => ar(e, nx, Cp), ix = (e) => ar(e, "position", Cp), ox = /* @__PURE__ */ new Set(["image", "url"]), ax = (e) => ar(e, ox, cx), sx = (e) => ar(e, "", ux), yr = () => !0, ar = (e, t, n) => {
  const r = kp.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, lx = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Zb.test(e) && !Jb.test(e)
), Cp = () => !1, ux = (e) => Qb.test(e), cx = (e) => ex.test(e), Sc = () => {
  const e = le("colors"), t = le("spacing"), n = le("blur"), r = le("brightness"), i = le("borderColor"), a = le("borderRadius"), o = le("borderSpacing"), s = le("borderWidth"), l = le("contrast"), u = le("grayscale"), c = le("hueRotate"), f = le("invert"), d = le("gap"), h = le("gradientColorStops"), p = le("gradientColorStopPositions"), m = le("inset"), y = le("margin"), g = le("opacity"), w = le("padding"), v = le("saturate"), k = le("scale"), x = le("sepia"), C = le("skew"), P = le("space"), I = le("translate"), N = () => ["auto", "contain", "none"], E = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", Y, t], M = () => [Y, t], _ = () => ["", Mt, Ht], D = () => ["auto", Gn, Y], j = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], G = () => ["solid", "dashed", "dotted", "double", "none"], $ = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], V = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], U = () => ["", "0", Y], S = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ne = () => [Gn, Y];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [yr],
      spacing: [Mt, Ht],
      blur: ["none", "", Gt, Y],
      brightness: ne(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Gt, Y],
      borderSpacing: M(),
      borderWidth: _(),
      contrast: ne(),
      grayscale: U(),
      hueRotate: ne(),
      invert: U(),
      gap: M(),
      gradientColorStops: [e],
      gradientColorStopPositions: [tx, Ht],
      inset: L(),
      margin: L(),
      opacity: ne(),
      padding: M(),
      saturate: ne(),
      scale: ne(),
      sepia: U(),
      skew: ne(),
      space: M(),
      translate: M()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Y]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Gt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": S()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": S()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...j(), Y]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: E()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": E()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": E()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: N()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": N()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": N()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", gr, Y]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: L()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Y]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: U()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: U()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", gr, Y]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [yr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", gr, Y]
        }, Y]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": D()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": D()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [yr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [gr, Y]
        }, Y]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": D()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": D()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Y]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Y]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...V()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...V(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...V(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Y, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Y, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Y, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Gt]
        }, Gt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Y, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Y, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Y, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Y, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Gt, Ht]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", na]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [yr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Y]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Gn, na]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Mt, Y]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Y]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Y]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...G(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Mt, Ht]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Mt, Y]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Y]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Y]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...j(), ix]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", rx]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ax]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...G(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: G()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...G()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Mt, Y]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Mt, Ht]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: _()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Mt, Ht]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Gt, sx]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [yr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...$(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": $()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Gt, Y]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [v]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [v]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Y]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ne()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Y]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ne()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Y]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [k]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [k]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [k]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [gr, Y]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [I]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [I]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [C]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [C]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Y]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Y]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Y]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Mt, Ht, na]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, fx = (e, {
  cacheSize: t,
  prefix: n,
  separator: r,
  experimentalParseClassName: i,
  extend: a = {},
  override: o = {}
}) => {
  Ar(e, "cacheSize", t), Ar(e, "prefix", n), Ar(e, "separator", r), Ar(e, "experimentalParseClassName", i);
  for (const s in o)
    dx(e[s], o[s]);
  for (const s in a)
    hx(e[s], a[s]);
  return e;
}, Ar = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, dx = (e, t) => {
  if (t)
    for (const n in t)
      Ar(e, n, t[n]);
}, hx = (e, t) => {
  if (t)
    for (const n in t) {
      const r = t[n];
      r !== void 0 && (e[n] = (e[n] || []).concat(r));
    }
}, px = (e, ...t) => typeof e == "function" ? Cc(Sc, e, ...t) : Cc(() => fx(Sc(), e), ...t), mx = px({
  prefix: "wgt-"
}), te = (...e) => mx(Ob(e));
/*!
 * Font Awesome Pro 7.0.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2025 Fonticons, Inc.
 */
var gx = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z"]
}, yx = {
  prefix: "fas",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z"]
};
let wx = { data: "" }, vx = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || wx, bx = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, xx = /\/\*[^]*?\*\/|  +/g, Ac = /\n+/g, Xt = (e, t) => {
  let n = "", r = "", i = "";
  for (let a in e) {
    let o = e[a];
    a[0] == "@" ? a[1] == "i" ? n = a + " " + o + ";" : r += a[1] == "f" ? Xt(o, a) : a + "{" + Xt(o, a[1] == "k" ? "" : t) + "}" : typeof o == "object" ? r += Xt(o, t ? t.replace(/([^,])+/g, (s) => a.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (l) => /&/.test(l) ? l.replace(/&/g, s) : s ? s + " " + l : l)) : a) : o != null && (a = /^--/.test(a) ? a : a.replace(/[A-Z]/g, "-$&").toLowerCase(), i += Xt.p ? Xt.p(a, o) : a + ":" + o + ";");
  }
  return n + (t && i ? t + "{" + i + "}" : i) + r;
}, Dt = {}, Sp = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let n in e) t += n + Sp(e[n]);
    return t;
  }
  return e;
}, kx = (e, t, n, r, i) => {
  let a = Sp(e), o = Dt[a] || (Dt[a] = ((l) => {
    let u = 0, c = 11;
    for (; u < l.length; ) c = 101 * c + l.charCodeAt(u++) >>> 0;
    return "go" + c;
  })(a));
  if (!Dt[o]) {
    let l = a !== e ? e : ((u) => {
      let c, f, d = [{}];
      for (; c = bx.exec(u.replace(xx, "")); ) c[4] ? d.shift() : c[3] ? (f = c[3].replace(Ac, " ").trim(), d.unshift(d[0][f] = d[0][f] || {})) : d[0][c[1]] = c[2].replace(Ac, " ").trim();
      return d[0];
    })(e);
    Dt[o] = Xt(i ? { ["@keyframes " + o]: l } : l, n ? "" : "." + o);
  }
  let s = n && Dt.g ? Dt.g : null;
  return n && (Dt.g = Dt[o]), ((l, u, c, f) => {
    f ? u.data = u.data.replace(f, l) : u.data.indexOf(l) === -1 && (u.data = c ? l + u.data : u.data + l);
  })(Dt[o], t, r, s), o;
}, Cx = (e, t, n) => e.reduce((r, i, a) => {
  let o = t[a];
  if (o && o.call) {
    let s = o(n), l = s && s.props && s.props.className || /^go/.test(s) && s;
    o = l ? "." + l : s && typeof s == "object" ? s.props ? "" : Xt(s, "") : s === !1 ? "" : s;
  }
  return r + i + (o ?? "");
}, "");
function Ao(e) {
  let t = this || {}, n = e.call ? e(t.p) : e;
  return kx(n.unshift ? n.raw ? Cx(n, [].slice.call(arguments, 1), t.p) : n.reduce((r, i) => Object.assign(r, i && i.call ? i(t.p) : i), {}) : n, vx(t.target), t.g, t.o, t.k);
}
let Ap, ds, hs;
Ao.bind({ g: 1 });
let zt = Ao.bind({ k: 1 });
function Sx(e, t, n, r) {
  Xt.p = t, Ap = e, ds = n, hs = r;
}
function ln(e, t) {
  let n = this || {};
  return function() {
    let r = arguments;
    function i(a, o) {
      let s = Object.assign({}, a), l = s.className || i.className;
      n.p = Object.assign({ theme: ds && ds() }, s), n.o = / *go\d+/.test(l), s.className = Ao.apply(n, r) + (l ? " " + l : "");
      let u = e;
      return e[0] && (u = s.as || e, delete s.as), hs && u[0] && hs(s), Ap(u, s);
    }
    return t ? t(i) : i;
  };
}
var Ax = (e) => typeof e == "function", ro = (e, t) => Ax(e) ? e(t) : e, Tx = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), Tp = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), Ex = 20, gl = "default", Ep = (e, t) => {
  let { toastLimit: n } = e.settings;
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, n) };
    case 1:
      return { ...e, toasts: e.toasts.map((o) => o.id === t.toast.id ? { ...o, ...t.toast } : o) };
    case 2:
      let { toast: r } = t;
      return Ep(e, { type: e.toasts.find((o) => o.id === r.id) ? 1 : 0, toast: r });
    case 3:
      let { toastId: i } = t;
      return { ...e, toasts: e.toasts.map((o) => o.id === i || i === void 0 ? { ...o, dismissed: !0, visible: !1 } : o) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((o) => o.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let a = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((o) => ({ ...o, pauseDuration: o.pauseDuration + a })) };
  }
}, Wi = [], Pp = { toasts: [], pausedAt: void 0, settings: { toastLimit: Ex } }, yt = {}, Ip = (e, t = gl) => {
  yt[t] = Ep(yt[t] || Pp, e), Wi.forEach(([n, r]) => {
    n === t && r(yt[t]);
  });
}, Rp = (e) => Object.keys(yt).forEach((t) => Ip(e, t)), Px = (e) => Object.keys(yt).find((t) => yt[t].toasts.some((n) => n.id === e)), To = (e = gl) => (t) => {
  Ip(t, e);
}, Ix = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 }, Rx = (e = {}, t = gl) => {
  let [n, r] = oe(yt[t] || Pp), i = ge(yt[t]);
  De(() => (i.current !== yt[t] && r(yt[t]), Wi.push([t, r]), () => {
    let o = Wi.findIndex(([s]) => s === t);
    o > -1 && Wi.splice(o, 1);
  }), [t]);
  let a = n.toasts.map((o) => {
    var s, l, u;
    return { ...e, ...e[o.type], ...o, removeDelay: o.removeDelay || ((s = e[o.type]) == null ? void 0 : s.removeDelay) || (e == null ? void 0 : e.removeDelay), duration: o.duration || ((l = e[o.type]) == null ? void 0 : l.duration) || (e == null ? void 0 : e.duration) || Ix[o.type], style: { ...e.style, ...(u = e[o.type]) == null ? void 0 : u.style, ...o.style } };
  });
  return { ...n, toasts: a };
}, Mx = (e, t = "blank", n) => ({ createdAt: Date.now(), visible: !0, dismissed: !1, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...n, id: (n == null ? void 0 : n.id) || Tx() }), Qr = (e) => (t, n) => {
  let r = Mx(t, e, n);
  return To(r.toasterId || Px(r.id))({ type: 2, toast: r }), r.id;
}, xe = (e, t) => Qr("blank")(e, t);
xe.error = Qr("error");
xe.success = Qr("success");
xe.loading = Qr("loading");
xe.custom = Qr("custom");
xe.dismiss = (e, t) => {
  let n = { type: 3, toastId: e };
  t ? To(t)(n) : Rp(n);
};
xe.dismissAll = (e) => xe.dismiss(void 0, e);
xe.remove = (e, t) => {
  let n = { type: 4, toastId: e };
  t ? To(t)(n) : Rp(n);
};
xe.removeAll = (e) => xe.remove(void 0, e);
xe.promise = (e, t, n) => {
  let r = xe.loading(t.loading, { ...n, ...n == null ? void 0 : n.loading });
  return typeof e == "function" && (e = e()), e.then((i) => {
    let a = t.success ? ro(t.success, i) : void 0;
    return a ? xe.success(a, { id: r, ...n, ...n == null ? void 0 : n.success }) : xe.dismiss(r), i;
  }).catch((i) => {
    let a = t.error ? ro(t.error, i) : void 0;
    a ? xe.error(a, { id: r, ...n, ...n == null ? void 0 : n.error }) : xe.dismiss(r);
  }), e;
};
var Dx = 1e3, Lx = (e, t = "default") => {
  let { toasts: n, pausedAt: r } = Rx(e, t), i = ge(/* @__PURE__ */ new Map()).current, a = Ee((f, d = Dx) => {
    if (i.has(f)) return;
    let h = setTimeout(() => {
      i.delete(f), o({ type: 4, toastId: f });
    }, d);
    i.set(f, h);
  }, []);
  De(() => {
    if (r) return;
    let f = Date.now(), d = n.map((h) => {
      if (h.duration === 1 / 0) return;
      let p = (h.duration || 0) + h.pauseDuration - (f - h.createdAt);
      if (p < 0) {
        h.visible && xe.dismiss(h.id);
        return;
      }
      return setTimeout(() => xe.dismiss(h.id, t), p);
    });
    return () => {
      d.forEach((h) => h && clearTimeout(h));
    };
  }, [n, r, t]);
  let o = Ee(To(t), [t]), s = Ee(() => {
    o({ type: 5, time: Date.now() });
  }, [o]), l = Ee((f, d) => {
    o({ type: 1, toast: { id: f, height: d } });
  }, [o]), u = Ee(() => {
    r && o({ type: 6, time: Date.now() });
  }, [r, o]), c = Ee((f, d) => {
    let { reverseOrder: h = !1, gutter: p = 8, defaultPosition: m } = d || {}, y = n.filter((v) => (v.position || m) === (f.position || m) && v.height), g = y.findIndex((v) => v.id === f.id), w = y.filter((v, k) => k < g && v.visible).length;
    return y.filter((v) => v.visible).slice(...h ? [w + 1] : [0, w]).reduce((v, k) => v + (k.height || 0) + p, 0);
  }, [n]);
  return De(() => {
    n.forEach((f) => {
      if (f.dismissed) a(f.id, f.removeDelay);
      else {
        let d = i.get(f.id);
        d && (clearTimeout(d), i.delete(f.id));
      }
    });
  }, [n, a]), { toasts: n, handlers: { updateHeight: l, startPause: s, endPause: u, calculateOffset: c } };
}, Nx = zt`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, Ox = zt`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, Fx = zt`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, _x = ln("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${Nx} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${Ox} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${Fx} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, zx = zt`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, Vx = ln("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${zx} 1s linear infinite;
`, $x = zt`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, jx = zt`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, Bx = ln("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$x} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${jx} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, Wx = ln("div")`
  position: absolute;
`, Ux = ln("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, Hx = zt`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, Gx = ln("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Hx} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, qx = ({ toast: e }) => {
  let { icon: t, type: n, iconTheme: r } = e;
  return t !== void 0 ? typeof t == "string" ? A.createElement(Gx, null, t) : t : n === "blank" ? null : A.createElement(Ux, null, A.createElement(Vx, { ...r }), n !== "loading" && A.createElement(Wx, null, n === "error" ? A.createElement(_x, { ...r }) : A.createElement(Bx, { ...r })));
}, Kx = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, Yx = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, Xx = "0%{opacity:0;} 100%{opacity:1;}", Zx = "0%{opacity:1;} 100%{opacity:0;}", Jx = ln("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, Qx = ln("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, e2 = (e, t) => {
  let n = e.includes("top") ? 1 : -1, [r, i] = Tp() ? [Xx, Zx] : [Kx(n), Yx(n)];
  return { animation: t ? `${zt(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${zt(i)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
}, t2 = A.memo(({ toast: e, position: t, style: n, children: r }) => {
  let i = e.height ? e2(e.position || t || "top-center", e.visible) : { opacity: 0 }, a = A.createElement(qx, { toast: e }), o = A.createElement(Qx, { ...e.ariaProps }, ro(e.message, e));
  return A.createElement(Jx, { className: e.className, style: { ...i, ...n, ...e.style } }, typeof r == "function" ? r({ icon: a, message: o }) : A.createElement(A.Fragment, null, a, o));
});
Sx(A.createElement);
var n2 = ({ id: e, className: t, style: n, onHeightUpdate: r, children: i }) => {
  let a = A.useCallback((o) => {
    if (o) {
      let s = () => {
        let l = o.getBoundingClientRect().height;
        r(e, l);
      };
      s(), new MutationObserver(s).observe(o, { subtree: !0, childList: !0, characterData: !0 });
    }
  }, [e, r]);
  return A.createElement("div", { ref: a, className: t, style: n }, i);
}, r2 = (e, t) => {
  let n = e.includes("top"), r = n ? { top: 0 } : { bottom: 0 }, i = e.includes("center") ? { justifyContent: "center" } : e.includes("right") ? { justifyContent: "flex-end" } : {};
  return { left: 0, right: 0, display: "flex", position: "absolute", transition: Tp() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)", transform: `translateY(${t * (n ? 1 : -1)}px)`, ...r, ...i };
}, i2 = Ao`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, gi = 16, o2 = ({ reverseOrder: e, position: t = "top-center", toastOptions: n, gutter: r, children: i, toasterId: a, containerStyle: o, containerClassName: s }) => {
  let { toasts: l, handlers: u } = Lx(n, a);
  return A.createElement("div", { "data-rht-toaster": a || "", style: { position: "fixed", zIndex: 9999, top: gi, left: gi, right: gi, bottom: gi, pointerEvents: "none", ...o }, className: s, onMouseEnter: u.startPause, onMouseLeave: u.endPause }, l.map((c) => {
    let f = c.position || t, d = u.calculateOffset(c, { reverseOrder: e, gutter: r, defaultPosition: t }), h = r2(f, d);
    return A.createElement(n2, { id: c.id, key: c.id, onHeightUpdate: u.updateHeight, className: c.visible ? i2 : "", style: h }, c.type === "custom" ? ro(c.message, c) : i ? i(c) : A.createElement(t2, { toast: c, position: f }));
  }));
}, Tc = xe;
const Mp = sn(void 0), ct = () => {
  const e = Ce(Mp);
  if (!e)
    throw new Error(
      "useChatWidgetOptions must be used within a ChatWidgetProvider"
    );
  return e;
};
function Ec(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Dp(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const a = Ec(i, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const a = r[i];
          typeof a == "function" ? a() : Ec(e[i], null);
        }
      };
  };
}
function ft(...e) {
  return A.useCallback(Dp(...e), e);
}
// @__NO_SIDE_EFFECTS__
function yl(e) {
  const t = /* @__PURE__ */ s2(e), n = A.forwardRef((r, i) => {
    const { children: a, ...o } = r, s = A.Children.toArray(a), l = s.find(u2);
    if (l) {
      const u = l.props.children, c = s.map((f) => f === l ? A.Children.count(u) > 1 ? A.Children.only(null) : A.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ b(t, { ...o, ref: i, children: A.isValidElement(u) ? A.cloneElement(u, void 0, c) : null });
    }
    return /* @__PURE__ */ b(t, { ...o, ref: i, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var a2 = /* @__PURE__ */ yl("Slot");
// @__NO_SIDE_EFFECTS__
function s2(e) {
  const t = A.forwardRef((n, r) => {
    const { children: i, ...a } = n;
    if (A.isValidElement(i)) {
      const o = f2(i), s = c2(a, i.props);
      return i.type !== A.Fragment && (s.ref = r ? Dp(r, o) : o), A.cloneElement(i, s);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Lp = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function l2(e) {
  const t = ({ children: n }) => /* @__PURE__ */ b(tt, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = Lp, t;
}
function u2(e) {
  return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Lp;
}
function c2(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...s) => {
      const l = a(...s);
      return i(...s), l;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function f2(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Np(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = Np(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function d2() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Np(e)) && (r && (r += " "), r += t);
  return r;
}
const Pc = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ic = d2, Eo = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return Ic(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: a } = t, o = Object.keys(i).map((u) => {
    const c = n == null ? void 0 : n[u], f = a == null ? void 0 : a[u];
    if (c === null) return null;
    const d = Pc(c) || Pc(f);
    return i[u][d];
  }), s = n && Object.entries(n).reduce((u, c) => {
    let [f, d] = c;
    return d === void 0 || (u[f] = d), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: f, className: d, ...h } = c;
    return Object.entries(h).every((p) => {
      let [m, y] = p;
      return Array.isArray(y) ? y.includes({
        ...a,
        ...s
      }[m]) : {
        ...a,
        ...s
      }[m] === y;
    }) ? [
      ...u,
      f,
      d
    ] : u;
  }, []);
  return Ic(e, o, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, h2 = Eo(
  "wgt-inline-flex wgt-items-center wgt-justify-center wgt-gap-2 wgt-whitespace-nowrap wgt-rounded-md wgt-text-sm wgt-font-medium wgt-ring-offset-background wgt-transition-colors focus-visible:wgt-outline-none focus-visible:wgt-ring-2 focus-visible:wgt-ring-ring focus-visible:wgt-ring-offset-2 disabled:wgt-pointer-events-none disabled:wgt-opacity-50 [&_svg]:wgt-pointer-events-none [&_svg]:wgt-size-3.5 [&_svg]:wgt-shrink-0",
  {
    variants: {
      variant: {
        default: "wgt-bg-primary wgt-text-primary-foreground hover:wgt-bg-primary/90",
        destructive: "wgt-bg-destructive wgt-text-destructive-foreground hover:wgt-bg-destructive/90",
        outline: "wgt-border wgt-border-input wgt-bg-background hover:wgt-bg-accent hover:wgt-text-accent-foreground",
        secondary: "wgt-bg-secondary wgt-text-secondary-foreground hover:wgt-bg-secondary/80",
        ghost: "hover:wgt-bg-accent hover:wgt-text-accent-foreground",
        brand: "wgt-bg-brand wgt-text-brand-foreground hover:wgt-bg-brand/80",
        link: "wgt-text-primary wgt-underline-offset-4 hover:wgt-underline"
      },
      size: {
        default: "wgt-min-h-10 wgt-px-4 wgt-py-2",
        sm: "wgt-h-9 wgt-rounded-md wgt-px-3",
        lg: "wgt-h-11 wgt-rounded-md wgt-px-8",
        icon: "wgt-h-10 wgt-w-10",
        "icon-sm": "wgt-h-4 wgt-w-4"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), ot = Pn(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...i }, a) => /* @__PURE__ */ b(
    r ? a2 : "button",
    {
      className: te(h2({ variant: t, size: n, className: e })),
      ref: a,
      ...i
    }
  )
);
ot.displayName = "Button";
const p2 = {
  inaccurate: "Inaccurate",
  unclear: "Unclear",
  slow: "Too slow",
  outdated: "Outdated",
  other: "Other"
}, m2 = ({ message: e, onClose: t, updateMessage: n }) => {
  const { executeRecaptcha: r } = vo(), { options: i, session: a } = ct(), {
    mode: o,
    api: { key: s, baseUrl: l }
  } = i, { sessionId: u } = a, c = o === "page-mobile", f = async (d) => {
    try {
      let h = "";
      if (r && !c && (h = await r("rate_message")), !h && !c)
        return;
      const p = await wp({
        sessionId: u,
        apiKey: s,
        messageId: e.id,
        displayMode: o,
        liked: e.liked,
        disliked: !0,
        recaptchaToken: h,
        dislikeReason: d,
        apiBaseUrl: l
      });
      n(p), Tc.success("Thanks for your feedback"), t();
    } catch {
      Tc.error("Failed to submit feedback");
    }
  };
  return /* @__PURE__ */ b("div", { className: "wgt-flex wgt-w-full wgt-items-center wgt-justify-center wgt-rounded-lg wgt-bg-background", children: /* @__PURE__ */ B("div", { className: "wgt-w-fit wgt-space-y-2 wgt-rounded-lg wgt-border wgt-p-2 wgt-text-sm wgt-shadow-lg", children: [
    /* @__PURE__ */ B("div", { className: "wgt-flex wgt-items-center wgt-justify-between", children: [
      /* @__PURE__ */ b("div", { className: "wgt-w-full wgt-text-center wgt-font-medium", children: "Why did you choose this rating?" }),
      /* @__PURE__ */ b(
        "button",
        {
          className: "wgt-flex wgt-items-center wgt-justify-center",
          type: "button",
          onClick: t,
          children: /* @__PURE__ */ b(ve, { icon: gx, className: "wgt-h-3 wgt-w-3" })
        }
      )
    ] }),
    /* @__PURE__ */ b("div", { className: "wgt-flex wgt-w-full wgt-flex-wrap wgt-justify-center wgt-gap-2", children: Object.entries(p2).map(([d, h]) => /* @__PURE__ */ b("div", { children: /* @__PURE__ */ b(
      ot,
      {
        variant: "secondary",
        className: "wgt-py-1 wgt-text-xs wgt-font-normal hover:wgt-bg-gray-300",
        size: "sm",
        onClick: () => f(d),
        children: h
      }
    ) }, d)) })
  ] }) });
}, g2 = ({ text: e }) => {
  const [t, n] = oe(!1), r = ge(null), i = Ee(() => {
    navigator.clipboard.writeText(e).then(() => {
      n(!0), r.current && (clearTimeout(r.current), r.current = null), r.current = setTimeout(() => {
        n(!1);
      }, 2e3);
    }).catch(() => {
    });
  }, [e]);
  return { isCopied: t, handleCopy: i };
};
function Ve(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function y2(e, t) {
  const n = A.createContext(t), r = (a) => {
    const { children: o, ...s } = a, l = A.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ b(n.Provider, { value: l, children: o });
  };
  r.displayName = e + "Provider";
  function i(a) {
    const o = A.useContext(n);
    if (o) return o;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function wl(e, t = []) {
  let n = [];
  function r(a, o) {
    const s = A.createContext(o), l = n.length;
    n = [...n, o];
    const u = (f) => {
      var g;
      const { scope: d, children: h, ...p } = f, m = ((g = d == null ? void 0 : d[e]) == null ? void 0 : g[l]) || s, y = A.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ b(m.Provider, { value: y, children: h });
    };
    u.displayName = a + "Provider";
    function c(f, d) {
      var m;
      const h = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[l]) || s, p = A.useContext(h);
      if (p) return p;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [u, c];
  }
  const i = () => {
    const a = n.map((o) => A.createContext(o));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return A.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, w2(i, ...t)];
}
function w2(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(a) {
      const o = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(a)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return A.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var v2 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], je = v2.reduce((e, t) => {
  const n = /* @__PURE__ */ yl(`Primitive.${t}`), r = A.forwardRef((i, a) => {
    const { asChild: o, ...s } = i, l = o ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ b(l, { ...s, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function b2(e, t) {
  e && fh.flushSync(() => e.dispatchEvent(t));
}
function Jn(e) {
  const t = A.useRef(e);
  return A.useEffect(() => {
    t.current = e;
  }), A.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function x2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Jn(e);
  A.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var k2 = "DismissableLayer", ps = "dismissableLayer.update", C2 = "dismissableLayer.pointerDownOutside", S2 = "dismissableLayer.focusOutside", Rc, Op = A.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), vl = A.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: o,
      onDismiss: s,
      ...l
    } = e, u = A.useContext(Op), [c, f] = A.useState(null), d = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = A.useState({}), p = ft(t, (P) => f(P)), m = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), g = m.indexOf(y), w = c ? m.indexOf(c) : -1, v = u.layersWithOutsidePointerEventsDisabled.size > 0, k = w >= g, x = E2((P) => {
      const I = P.target, N = [...u.branches].some((E) => E.contains(I));
      !k || N || (i == null || i(P), o == null || o(P), P.defaultPrevented || s == null || s());
    }, d), C = P2((P) => {
      const I = P.target;
      [...u.branches].some((E) => E.contains(I)) || (a == null || a(P), o == null || o(P), P.defaultPrevented || s == null || s());
    }, d);
    return x2((P) => {
      w === u.layers.size - 1 && (r == null || r(P), !P.defaultPrevented && s && (P.preventDefault(), s()));
    }, d), A.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Rc = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), Mc(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = Rc);
        };
    }, [c, d, n, u]), A.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), Mc());
    }, [c, u]), A.useEffect(() => {
      const P = () => h({});
      return document.addEventListener(ps, P), () => document.removeEventListener(ps, P);
    }, []), /* @__PURE__ */ b(
      je.div,
      {
        ...l,
        ref: p,
        style: {
          pointerEvents: v ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ve(e.onFocusCapture, C.onFocusCapture),
        onBlurCapture: Ve(e.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: Ve(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
vl.displayName = k2;
var A2 = "DismissableLayerBranch", T2 = A.forwardRef((e, t) => {
  const n = A.useContext(Op), r = A.useRef(null), i = ft(t, r);
  return A.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ b(je.div, { ...e, ref: i });
});
T2.displayName = A2;
function E2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Jn(e), r = A.useRef(!1), i = A.useRef(() => {
  });
  return A.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Fp(
            C2,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", a), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function P2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Jn(e), r = A.useRef(!1);
  return A.useEffect(() => {
    const i = (a) => {
      a.target && !r.current && Fp(S2, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Mc() {
  const e = new CustomEvent(ps);
  document.dispatchEvent(e);
}
function Fp(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? b2(i, a) : i.dispatchEvent(a);
}
var tn = globalThis != null && globalThis.document ? A.useLayoutEffect : () => {
}, I2 = A[" useId ".trim().toString()] || (() => {
}), R2 = 0;
function Ui(e) {
  const [t, n] = A.useState(I2());
  return tn(() => {
    n((r) => r ?? String(R2++));
  }, [e]), t ? `radix-${t}` : "";
}
const M2 = ["top", "right", "bottom", "left"], nn = Math.min, Ge = Math.max, io = Math.round, yi = Math.floor, vt = (e) => ({
  x: e,
  y: e
}), D2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, L2 = {
  start: "end",
  end: "start"
};
function ms(e, t, n) {
  return Ge(e, nn(t, n));
}
function Vt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function $t(e) {
  return e.split("-")[0];
}
function sr(e) {
  return e.split("-")[1];
}
function bl(e) {
  return e === "x" ? "y" : "x";
}
function xl(e) {
  return e === "y" ? "height" : "width";
}
const N2 = /* @__PURE__ */ new Set(["top", "bottom"]);
function wt(e) {
  return N2.has($t(e)) ? "y" : "x";
}
function kl(e) {
  return bl(wt(e));
}
function O2(e, t, n) {
  n === void 0 && (n = !1);
  const r = sr(e), i = kl(e), a = xl(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = oo(o)), [o, oo(o)];
}
function F2(e) {
  const t = oo(e);
  return [gs(e), t, gs(t)];
}
function gs(e) {
  return e.replace(/start|end/g, (t) => L2[t]);
}
const Dc = ["left", "right"], Lc = ["right", "left"], _2 = ["top", "bottom"], z2 = ["bottom", "top"];
function V2(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Lc : Dc : t ? Dc : Lc;
    case "left":
    case "right":
      return t ? _2 : z2;
    default:
      return [];
  }
}
function $2(e, t, n, r) {
  const i = sr(e);
  let a = V2($t(e), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(gs)))), a;
}
function oo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => D2[t]);
}
function j2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function _p(e) {
  return typeof e != "number" ? j2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ao(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function Nc(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const a = wt(t), o = kl(t), s = xl(o), l = $t(t), u = a === "y", c = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, d = r[s] / 2 - i[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: c,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (sr(t)) {
    case "start":
      h[o] -= d * (n && u ? -1 : 1);
      break;
    case "end":
      h[o] += d * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const B2 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: c,
    y: f
  } = Nc(u, r, l), d = r, h = {}, p = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: y,
      fn: g
    } = s[m], {
      x: w,
      y: v,
      data: k,
      reset: x
    } = await g({
      x: c,
      y: f,
      initialPlacement: r,
      placement: d,
      strategy: i,
      middlewareData: h,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = w ?? c, f = v ?? f, h = {
      ...h,
      [y]: {
        ...h[y],
        ...k
      }
    }, x && p <= 50 && (p++, typeof x == "object" && (x.placement && (d = x.placement), x.rects && (u = x.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : x.rects), {
      x: c,
      y: f
    } = Nc(u, d, l)), m = -1);
  }
  return {
    x: c,
    y: f,
    placement: d,
    strategy: i,
    middlewareData: h
  };
};
async function zr(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: h = 0
  } = Vt(t, e), p = _p(h), y = s[d ? f === "floating" ? "reference" : "floating" : f], g = ao(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(y))) == null || n ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), w = f === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, v = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), k = await (a.isElement == null ? void 0 : a.isElement(v)) ? await (a.getScale == null ? void 0 : a.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = ao(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: v,
    strategy: l
  }) : w);
  return {
    top: (g.top - x.top + p.top) / k.y,
    bottom: (x.bottom - g.bottom + p.bottom) / k.y,
    left: (g.left - x.left + p.left) / k.x,
    right: (x.right - g.right + p.right) / k.x
  };
}
const W2 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: c = 0
    } = Vt(e, t) || {};
    if (u == null)
      return {};
    const f = _p(c), d = {
      x: n,
      y: r
    }, h = kl(i), p = xl(h), m = await o.getDimensions(u), y = h === "y", g = y ? "top" : "left", w = y ? "bottom" : "right", v = y ? "clientHeight" : "clientWidth", k = a.reference[p] + a.reference[h] - d[h] - a.floating[p], x = d[h] - a.reference[h], C = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let P = C ? C[v] : 0;
    (!P || !await (o.isElement == null ? void 0 : o.isElement(C))) && (P = s.floating[v] || a.floating[p]);
    const I = k / 2 - x / 2, N = P / 2 - m[p] / 2 - 1, E = nn(f[g], N), L = nn(f[w], N), M = E, _ = P - m[p] - L, D = P / 2 - m[p] / 2 + I, j = ms(M, D, _), G = !l.arrow && sr(i) != null && D !== j && a.reference[p] / 2 - (D < M ? E : L) - m[p] / 2 < 0, $ = G ? D < M ? D - M : D - _ : 0;
    return {
      [h]: d[h] + $,
      data: {
        [h]: j,
        centerOffset: D - j - $,
        ...G && {
          alignmentOffset: $
        }
      },
      reset: G
    };
  }
}), U2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...y
      } = Vt(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const g = $t(i), w = wt(s), v = $t(s) === s, k = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), x = d || (v || !m ? [oo(s)] : F2(s)), C = p !== "none";
      !d && C && x.push(...$2(s, m, p, k));
      const P = [s, ...x], I = await zr(t, y), N = [];
      let E = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (c && N.push(I[g]), f) {
        const D = O2(i, o, k);
        N.push(I[D[0]], I[D[1]]);
      }
      if (E = [...E, {
        placement: i,
        overflows: N
      }], !N.every((D) => D <= 0)) {
        var L, M;
        const D = (((L = a.flip) == null ? void 0 : L.index) || 0) + 1, j = P[D];
        if (j && (!(f === "alignment" ? w !== wt(j) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        E.every((V) => wt(V.placement) === w ? V.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: E
            },
            reset: {
              placement: j
            }
          };
        let G = (M = E.filter(($) => $.overflows[0] <= 0).sort(($, V) => $.overflows[1] - V.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!G)
          switch (h) {
            case "bestFit": {
              var _;
              const $ = (_ = E.filter((V) => {
                if (C) {
                  const U = wt(V.placement);
                  return U === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  U === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((U) => U > 0).reduce((U, S) => U + S, 0)]).sort((V, U) => V[1] - U[1])[0]) == null ? void 0 : _[0];
              $ && (G = $);
              break;
            }
            case "initialPlacement":
              G = s;
              break;
          }
        if (i !== G)
          return {
            reset: {
              placement: G
            }
          };
      }
      return {};
    }
  };
};
function Oc(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Fc(e) {
  return M2.some((t) => e[t] >= 0);
}
const H2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = Vt(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await zr(t, {
            ...i,
            elementContext: "reference"
          }), o = Oc(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Fc(o)
            }
          };
        }
        case "escaped": {
          const a = await zr(t, {
            ...i,
            altBoundary: !0
          }), o = Oc(a, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Fc(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, zp = /* @__PURE__ */ new Set(["left", "top"]);
async function G2(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = $t(n), s = sr(n), l = wt(n) === "y", u = zp.has(o) ? -1 : 1, c = a && l ? -1 : 1, f = Vt(t, e);
  let {
    mainAxis: d,
    crossAxis: h,
    alignmentAxis: p
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof p == "number" && (h = s === "end" ? p * -1 : p), l ? {
    x: h * c,
    y: d * u
  } : {
    x: d * u,
    y: h * c
  };
}
const q2 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = t, l = await G2(t, e);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, K2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: g,
              y: w
            } = y;
            return {
              x: g,
              y: w
            };
          }
        },
        ...l
      } = Vt(e, t), u = {
        x: n,
        y: r
      }, c = await zr(t, l), f = wt($t(i)), d = bl(f);
      let h = u[d], p = u[f];
      if (a) {
        const y = d === "y" ? "top" : "left", g = d === "y" ? "bottom" : "right", w = h + c[y], v = h - c[g];
        h = ms(w, h, v);
      }
      if (o) {
        const y = f === "y" ? "top" : "left", g = f === "y" ? "bottom" : "right", w = p + c[y], v = p - c[g];
        p = ms(w, p, v);
      }
      const m = s.fn({
        ...t,
        [d]: h,
        [f]: p
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [d]: a,
            [f]: o
          }
        }
      };
    }
  };
}, Y2 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: a,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Vt(e, t), c = {
        x: n,
        y: r
      }, f = wt(i), d = bl(f);
      let h = c[d], p = c[f];
      const m = Vt(s, t), y = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const v = d === "y" ? "height" : "width", k = a.reference[d] - a.floating[v] + y.mainAxis, x = a.reference[d] + a.reference[v] - y.mainAxis;
        h < k ? h = k : h > x && (h = x);
      }
      if (u) {
        var g, w;
        const v = d === "y" ? "width" : "height", k = zp.has($t(i)), x = a.reference[f] - a.floating[v] + (k && ((g = o.offset) == null ? void 0 : g[f]) || 0) + (k ? 0 : y.crossAxis), C = a.reference[f] + a.reference[v] + (k ? 0 : ((w = o.offset) == null ? void 0 : w[f]) || 0) - (k ? y.crossAxis : 0);
        p < x ? p = x : p > C && (p = C);
      }
      return {
        [d]: h,
        [f]: p
      };
    }
  };
}, X2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: a,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = Vt(e, t), c = await zr(t, u), f = $t(i), d = sr(i), h = wt(i) === "y", {
        width: p,
        height: m
      } = a.floating;
      let y, g;
      f === "top" || f === "bottom" ? (y = f, g = d === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = f, y = d === "end" ? "top" : "bottom");
      const w = m - c.top - c.bottom, v = p - c.left - c.right, k = nn(m - c[y], w), x = nn(p - c[g], v), C = !t.middlewareData.shift;
      let P = k, I = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (I = v), (r = t.middlewareData.shift) != null && r.enabled.y && (P = w), C && !d) {
        const E = Ge(c.left, 0), L = Ge(c.right, 0), M = Ge(c.top, 0), _ = Ge(c.bottom, 0);
        h ? I = p - 2 * (E !== 0 || L !== 0 ? E + L : Ge(c.left, c.right)) : P = m - 2 * (M !== 0 || _ !== 0 ? M + _ : Ge(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: I,
        availableHeight: P
      });
      const N = await o.getDimensions(s.floating);
      return p !== N.width || m !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Po() {
  return typeof window < "u";
}
function lr(e) {
  return Vp(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function qe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function At(e) {
  var t;
  return (t = (Vp(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Vp(e) {
  return Po() ? e instanceof Node || e instanceof qe(e).Node : !1;
}
function lt(e) {
  return Po() ? e instanceof Element || e instanceof qe(e).Element : !1;
}
function St(e) {
  return Po() ? e instanceof HTMLElement || e instanceof qe(e).HTMLElement : !1;
}
function _c(e) {
  return !Po() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof qe(e).ShadowRoot;
}
const Z2 = /* @__PURE__ */ new Set(["inline", "contents"]);
function ei(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ut(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Z2.has(i);
}
const J2 = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Q2(e) {
  return J2.has(lr(e));
}
const ek = [":popover-open", ":modal"];
function Io(e) {
  return ek.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const tk = ["transform", "translate", "scale", "rotate", "perspective"], nk = ["transform", "translate", "scale", "rotate", "perspective", "filter"], rk = ["paint", "layout", "strict", "content"];
function Cl(e) {
  const t = Sl(), n = lt(e) ? ut(e) : e;
  return tk.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || nk.some((r) => (n.willChange || "").includes(r)) || rk.some((r) => (n.contain || "").includes(r));
}
function ik(e) {
  let t = rn(e);
  for (; St(t) && !Qn(t); ) {
    if (Cl(t))
      return t;
    if (Io(t))
      return null;
    t = rn(t);
  }
  return null;
}
function Sl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ok = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Qn(e) {
  return ok.has(lr(e));
}
function ut(e) {
  return qe(e).getComputedStyle(e);
}
function Ro(e) {
  return lt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function rn(e) {
  if (lr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    _c(e) && e.host || // Fallback.
    At(e)
  );
  return _c(t) ? t.host : t;
}
function $p(e) {
  const t = rn(e);
  return Qn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : St(t) && ei(t) ? t : $p(t);
}
function Vr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = $p(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = qe(i);
  if (a) {
    const s = ys(o);
    return t.concat(o, o.visualViewport || [], ei(i) ? i : [], s && n ? Vr(s) : []);
  }
  return t.concat(i, Vr(i, [], n));
}
function ys(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function jp(e) {
  const t = ut(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = St(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = io(n) !== a || io(r) !== o;
  return s && (n = a, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function Al(e) {
  return lt(e) ? e : e.contextElement;
}
function qn(e) {
  const t = Al(e);
  if (!St(t))
    return vt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = jp(t);
  let o = (a ? io(n.width) : n.width) / r, s = (a ? io(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const ak = /* @__PURE__ */ vt(0);
function Bp(e) {
  const t = qe(e);
  return !Sl() || !t.visualViewport ? ak : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sk(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== qe(e) ? !1 : t;
}
function An(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = Al(e);
  let o = vt(1);
  t && (r ? lt(r) && (o = qn(r)) : o = qn(e));
  const s = sk(a, n, r) ? Bp(a) : vt(0);
  let l = (i.left + s.x) / o.x, u = (i.top + s.y) / o.y, c = i.width / o.x, f = i.height / o.y;
  if (a) {
    const d = qe(a), h = r && lt(r) ? qe(r) : r;
    let p = d, m = ys(p);
    for (; m && r && h !== p; ) {
      const y = qn(m), g = m.getBoundingClientRect(), w = ut(m), v = g.left + (m.clientLeft + parseFloat(w.paddingLeft)) * y.x, k = g.top + (m.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, u *= y.y, c *= y.x, f *= y.y, l += v, u += k, p = qe(m), m = ys(p);
    }
  }
  return ao({
    width: c,
    height: f,
    x: l,
    y: u
  });
}
function Mo(e, t) {
  const n = Ro(e).scrollLeft;
  return t ? t.left + n : An(At(e)).left + n;
}
function Wp(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Mo(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function lk(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const a = i === "fixed", o = At(r), s = t ? Io(t.floating) : !1;
  if (r === o || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = vt(1);
  const c = vt(0), f = St(r);
  if ((f || !f && !a) && ((lr(r) !== "body" || ei(o)) && (l = Ro(r)), St(r))) {
    const h = An(r);
    u = qn(r), c.x = h.x + r.clientLeft, c.y = h.y + r.clientTop;
  }
  const d = o && !f && !a ? Wp(o, l) : vt(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + c.x + d.x,
    y: n.y * u.y - l.scrollTop * u.y + c.y + d.y
  };
}
function uk(e) {
  return Array.from(e.getClientRects());
}
function ck(e) {
  const t = At(e), n = Ro(e), r = e.ownerDocument.body, i = Ge(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Ge(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + Mo(e);
  const s = -n.scrollTop;
  return ut(r).direction === "rtl" && (o += Ge(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
const zc = 25;
function fk(e, t) {
  const n = qe(e), r = At(e), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const c = Sl();
    (!c || c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  const u = Mo(r);
  if (u <= 0) {
    const c = r.ownerDocument, f = c.body, d = getComputedStyle(f), h = c.compatMode === "CSS1Compat" && parseFloat(d.marginLeft) + parseFloat(d.marginRight) || 0, p = Math.abs(r.clientWidth - f.clientWidth - h);
    p <= zc && (a -= p);
  } else u <= zc && (a += u);
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
const dk = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function hk(e, t) {
  const n = An(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = St(e) ? qn(e) : vt(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, l = i * a.x, u = r * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: u
  };
}
function Vc(e, t, n) {
  let r;
  if (t === "viewport")
    r = fk(e, n);
  else if (t === "document")
    r = ck(At(e));
  else if (lt(t))
    r = hk(t, n);
  else {
    const i = Bp(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return ao(r);
}
function Up(e, t) {
  const n = rn(e);
  return n === t || !lt(n) || Qn(n) ? !1 : ut(n).position === "fixed" || Up(n, t);
}
function pk(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Vr(e, [], !1).filter((s) => lt(s) && lr(s) !== "body"), i = null;
  const a = ut(e).position === "fixed";
  let o = a ? rn(e) : e;
  for (; lt(o) && !Qn(o); ) {
    const s = ut(o), l = Cl(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && dk.has(i.position) || ei(o) && !l && Up(e, o)) ? r = r.filter((c) => c !== o) : i = s, o = rn(o);
  }
  return t.set(e, r), r;
}
function mk(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? Io(t) ? [] : pk(t, this._c) : [].concat(n), r], s = o[0], l = o.reduce((u, c) => {
    const f = Vc(t, c, i);
    return u.top = Ge(f.top, u.top), u.right = nn(f.right, u.right), u.bottom = nn(f.bottom, u.bottom), u.left = Ge(f.left, u.left), u;
  }, Vc(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function gk(e) {
  const {
    width: t,
    height: n
  } = jp(e);
  return {
    width: t,
    height: n
  };
}
function yk(e, t, n) {
  const r = St(t), i = At(t), a = n === "fixed", o = An(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = vt(0);
  function u() {
    l.x = Mo(i);
  }
  if (r || !r && !a)
    if ((lr(t) !== "body" || ei(i)) && (s = Ro(t)), r) {
      const h = An(t, !0, a, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else i && u();
  a && !r && i && u();
  const c = i && !r && !a ? Wp(i, s) : vt(0), f = o.left + s.scrollLeft - l.x - c.x, d = o.top + s.scrollTop - l.y - c.y;
  return {
    x: f,
    y: d,
    width: o.width,
    height: o.height
  };
}
function ra(e) {
  return ut(e).position === "static";
}
function $c(e, t) {
  if (!St(e) || ut(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return At(e) === n && (n = n.ownerDocument.body), n;
}
function Hp(e, t) {
  const n = qe(e);
  if (Io(e))
    return n;
  if (!St(e)) {
    let i = rn(e);
    for (; i && !Qn(i); ) {
      if (lt(i) && !ra(i))
        return i;
      i = rn(i);
    }
    return n;
  }
  let r = $c(e, t);
  for (; r && Q2(r) && ra(r); )
    r = $c(r, t);
  return r && Qn(r) && ra(r) && !Cl(r) ? n : r || ik(e) || n;
}
const wk = async function(e) {
  const t = this.getOffsetParent || Hp, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: yk(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function vk(e) {
  return ut(e).direction === "rtl";
}
const bk = {
  convertOffsetParentRelativeRectToViewportRelativeRect: lk,
  getDocumentElement: At,
  getClippingRect: mk,
  getOffsetParent: Hp,
  getElementRects: wk,
  getClientRects: uk,
  getDimensions: gk,
  getScale: qn,
  isElement: lt,
  isRTL: vk
};
function Gp(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function xk(e, t) {
  let n = null, r;
  const i = At(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: d,
      height: h
    } = u;
    if (s || t(), !d || !h)
      return;
    const p = yi(f), m = yi(i.clientWidth - (c + d)), y = yi(i.clientHeight - (f + h)), g = yi(c), v = {
      rootMargin: -p + "px " + -m + "px " + -y + "px " + -g + "px",
      threshold: Ge(0, nn(1, l)) || 1
    };
    let k = !0;
    function x(C) {
      const P = C[0].intersectionRatio;
      if (P !== l) {
        if (!k)
          return o();
        P ? o(!1, P) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !Gp(u, e.getBoundingClientRect()) && o(), k = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...v,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, v);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function kk(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = Al(e), c = i || a ? [...u ? Vr(u) : [], ...Vr(t)] : [];
  c.forEach((g) => {
    i && g.addEventListener("scroll", n, {
      passive: !0
    }), a && g.addEventListener("resize", n);
  });
  const f = u && s ? xk(u, n) : null;
  let d = -1, h = null;
  o && (h = new ResizeObserver((g) => {
    let [w] = g;
    w && w.target === u && h && (h.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var v;
      (v = h) == null || v.observe(t);
    })), n();
  }), u && !l && h.observe(u), h.observe(t));
  let p, m = l ? An(e) : null;
  l && y();
  function y() {
    const g = An(e);
    m && !Gp(m, g) && n(), m = g, p = requestAnimationFrame(y);
  }
  return n(), () => {
    var g;
    c.forEach((w) => {
      i && w.removeEventListener("scroll", n), a && w.removeEventListener("resize", n);
    }), f == null || f(), (g = h) == null || g.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const Ck = q2, Sk = K2, Ak = U2, Tk = X2, Ek = H2, jc = W2, Pk = Y2, Ik = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: bk,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return B2(e, t, {
    ...i,
    platform: a
  });
};
var Rk = typeof document < "u", Mk = function() {
}, Hi = Rk ? Yr : Mk;
function so(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!so(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && e.$$typeof) && !so(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function qp(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Bc(e, t) {
  const n = qp(e);
  return Math.round(t * n) / n;
}
function ia(e) {
  const t = A.useRef(e);
  return Hi(() => {
    t.current = e;
  }), t;
}
function Dk(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: a,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, f] = A.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, h] = A.useState(r);
  so(d, r) || h(r);
  const [p, m] = A.useState(null), [y, g] = A.useState(null), w = A.useCallback((V) => {
    V !== C.current && (C.current = V, m(V));
  }, []), v = A.useCallback((V) => {
    V !== P.current && (P.current = V, g(V));
  }, []), k = a || p, x = o || y, C = A.useRef(null), P = A.useRef(null), I = A.useRef(c), N = l != null, E = ia(l), L = ia(i), M = ia(u), _ = A.useCallback(() => {
    if (!C.current || !P.current)
      return;
    const V = {
      placement: t,
      strategy: n,
      middleware: d
    };
    L.current && (V.platform = L.current), Ik(C.current, P.current, V).then((U) => {
      const S = {
        ...U,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: M.current !== !1
      };
      D.current && !so(I.current, S) && (I.current = S, fh.flushSync(() => {
        f(S);
      }));
    });
  }, [d, t, n, L, M]);
  Hi(() => {
    u === !1 && I.current.isPositioned && (I.current.isPositioned = !1, f((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [u]);
  const D = A.useRef(!1);
  Hi(() => (D.current = !0, () => {
    D.current = !1;
  }), []), Hi(() => {
    if (k && (C.current = k), x && (P.current = x), k && x) {
      if (E.current)
        return E.current(k, x, _);
      _();
    }
  }, [k, x, _, E, N]);
  const j = A.useMemo(() => ({
    reference: C,
    floating: P,
    setReference: w,
    setFloating: v
  }), [w, v]), G = A.useMemo(() => ({
    reference: k,
    floating: x
  }), [k, x]), $ = A.useMemo(() => {
    const V = {
      position: n,
      left: 0,
      top: 0
    };
    if (!G.floating)
      return V;
    const U = Bc(G.floating, c.x), S = Bc(G.floating, c.y);
    return s ? {
      ...V,
      transform: "translate(" + U + "px, " + S + "px)",
      ...qp(G.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: U,
      top: S
    };
  }, [n, s, G.floating, c.x, c.y]);
  return A.useMemo(() => ({
    ...c,
    update: _,
    refs: j,
    elements: G,
    floatingStyles: $
  }), [c, _, j, G, $]);
}
const Lk = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? jc({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? jc({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, Nk = (e, t) => ({
  ...Ck(e),
  options: [e, t]
}), Ok = (e, t) => ({
  ...Sk(e),
  options: [e, t]
}), Fk = (e, t) => ({
  ...Pk(e),
  options: [e, t]
}), _k = (e, t) => ({
  ...Ak(e),
  options: [e, t]
}), zk = (e, t) => ({
  ...Tk(e),
  options: [e, t]
}), Vk = (e, t) => ({
  ...Ek(e),
  options: [e, t]
}), $k = (e, t) => ({
  ...Lk(e),
  options: [e, t]
});
var jk = "Arrow", Kp = A.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...a } = e;
  return /* @__PURE__ */ b(
    je.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ b("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Kp.displayName = jk;
var Bk = Kp;
function Wk(e) {
  const [t, n] = A.useState(void 0);
  return tn(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const a = i[0];
        let o, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          o = u.inlineSize, s = u.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        n({ width: o, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Tl = "Popper", [Yp, Xp] = wl(Tl), [Uk, Zp] = Yp(Tl), Jp = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = A.useState(null);
  return /* @__PURE__ */ b(Uk, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
Jp.displayName = Tl;
var Qp = "PopperAnchor", em = A.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, a = Zp(Qp, n), o = A.useRef(null), s = ft(t, o), l = A.useRef(null);
    return A.useEffect(() => {
      const u = l.current;
      l.current = (r == null ? void 0 : r.current) || o.current, u !== l.current && a.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ b(je.div, { ...i, ref: s });
  }
);
em.displayName = Qp;
var El = "PopperContent", [Hk, Gk] = Yp(El), tm = A.forwardRef(
  (e, t) => {
    var ke, be, pe, Ie, ht, ui;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: a = "center",
      alignOffset: o = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: c = 0,
      sticky: f = "partial",
      hideWhenDetached: d = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: p,
      ...m
    } = e, y = Zp(El, n), [g, w] = A.useState(null), v = ft(t, (fn) => w(fn)), [k, x] = A.useState(null), C = Wk(k), P = (C == null ? void 0 : C.width) ?? 0, I = (C == null ? void 0 : C.height) ?? 0, N = r + (a !== "center" ? "-" + a : ""), E = typeof c == "number" ? c : { top: 0, right: 0, bottom: 0, left: 0, ...c }, L = Array.isArray(u) ? u : [u], M = L.length > 0, _ = {
      padding: E,
      boundary: L.filter(Kk),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: M
    }, { refs: D, floatingStyles: j, placement: G, isPositioned: $, middlewareData: V } = Dk({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...fn) => kk(...fn, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        Nk({ mainAxis: i + I, alignmentAxis: o }),
        l && Ok({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Fk() : void 0,
          ..._
        }),
        l && _k({ ..._ }),
        zk({
          ..._,
          apply: ({ elements: fn, rects: ci, availableWidth: fi, availableHeight: di }) => {
            const { width: hi, height: qo } = ci.reference, dn = fn.floating.style;
            dn.setProperty("--radix-popper-available-width", `${fi}px`), dn.setProperty("--radix-popper-available-height", `${di}px`), dn.setProperty("--radix-popper-anchor-width", `${hi}px`), dn.setProperty("--radix-popper-anchor-height", `${qo}px`);
          }
        }),
        k && $k({ element: k, padding: s }),
        Yk({ arrowWidth: P, arrowHeight: I }),
        d && Vk({ strategy: "referenceHidden", ..._ })
      ]
    }), [U, S] = im(G), ne = Jn(p);
    tn(() => {
      $ && (ne == null || ne());
    }, [$, ne]);
    const _e = (ke = V.arrow) == null ? void 0 : ke.x, T = (be = V.arrow) == null ? void 0 : be.y, Ne = ((pe = V.arrow) == null ? void 0 : pe.centerOffset) !== 0, [Xe, de] = A.useState();
    return tn(() => {
      g && de(window.getComputedStyle(g).zIndex);
    }, [g]), /* @__PURE__ */ b(
      "div",
      {
        ref: D.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...j,
          transform: $ ? j.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Xe,
          "--radix-popper-transform-origin": [
            (Ie = V.transformOrigin) == null ? void 0 : Ie.x,
            (ht = V.transformOrigin) == null ? void 0 : ht.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ui = V.hide) == null ? void 0 : ui.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ b(
          Hk,
          {
            scope: n,
            placedSide: U,
            onArrowChange: x,
            arrowX: _e,
            arrowY: T,
            shouldHideArrow: Ne,
            children: /* @__PURE__ */ b(
              je.div,
              {
                "data-side": U,
                "data-align": S,
                ...m,
                ref: v,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: $ ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
tm.displayName = El;
var nm = "PopperArrow", qk = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, rm = A.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, a = Gk(nm, r), o = qk[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ b(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ b(
          Bk,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
rm.displayName = nm;
function Kk(e) {
  return e !== null;
}
var Yk = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, g, w;
    const { placement: n, rects: r, middlewareData: i } = t, o = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, s = o ? 0 : e.arrowWidth, l = o ? 0 : e.arrowHeight, [u, c] = im(n), f = { start: "0%", center: "50%", end: "100%" }[c], d = (((g = i.arrow) == null ? void 0 : g.x) ?? 0) + s / 2, h = (((w = i.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
    let p = "", m = "";
    return u === "bottom" ? (p = o ? f : `${d}px`, m = `${-l}px`) : u === "top" ? (p = o ? f : `${d}px`, m = `${r.floating.height + l}px`) : u === "right" ? (p = `${-l}px`, m = o ? f : `${h}px`) : u === "left" && (p = `${r.floating.width + l}px`, m = o ? f : `${h}px`), { data: { x: p, y: m } };
  }
});
function im(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Xk = Jp, Zk = em, Jk = tm, Qk = rm, eC = "Portal", om = A.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, a] = A.useState(!1);
  tn(() => a(!0), []);
  const o = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return o ? $1.createPortal(/* @__PURE__ */ b(je.div, { ...r, ref: t }), o) : null;
});
om.displayName = eC;
function tC(e, t) {
  return A.useReducer((n, r) => t[n][r] ?? n, e);
}
var ti = (e) => {
  const { present: t, children: n } = e, r = nC(t), i = typeof n == "function" ? n({ present: r.isPresent }) : A.Children.only(n), a = ft(r.ref, rC(i));
  return typeof n == "function" || r.isPresent ? A.cloneElement(i, { ref: a }) : null;
};
ti.displayName = "Presence";
function nC(e) {
  const [t, n] = A.useState(), r = A.useRef(null), i = A.useRef(e), a = A.useRef("none"), o = e ? "mounted" : "unmounted", [s, l] = tC(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return A.useEffect(() => {
    const u = wi(r.current);
    a.current = s === "mounted" ? u : "none";
  }, [s]), tn(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const d = a.current, h = wi(u);
      e ? l("MOUNT") : h === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), tn(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (h) => {
        const m = wi(r.current).includes(CSS.escape(h.animationName));
        if (h.target === t && m && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, d = (h) => {
        h.target === t && (a.current = wi(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: A.useCallback((u) => {
      r.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function wi(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function rC(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var iC = A[" useInsertionEffect ".trim().toString()] || tn;
function am({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, a, o] = oC({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : i;
  {
    const c = A.useRef(e !== void 0);
    A.useEffect(() => {
      const f = c.current;
      f !== s && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), c.current = s;
    }, [s, r]);
  }
  const u = A.useCallback(
    (c) => {
      var f;
      if (s) {
        const d = aC(c) ? c(e) : c;
        d !== e && ((f = o.current) == null || f.call(o, d));
      } else
        a(c);
    },
    [s, e, a, o]
  );
  return [l, u];
}
function oC({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = A.useState(e), i = A.useRef(n), a = A.useRef(t);
  return iC(() => {
    a.current = t;
  }, [t]), A.useEffect(() => {
    var o;
    i.current !== n && ((o = a.current) == null || o.call(a, n), i.current = n);
  }, [n, i]), [n, r, a];
}
function aC(e) {
  return typeof e == "function";
}
var sC = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), lC = "VisuallyHidden", sm = A.forwardRef(
  (e, t) => /* @__PURE__ */ b(
    je.span,
    {
      ...e,
      ref: t,
      style: { ...sC, ...e.style }
    }
  )
);
sm.displayName = lC;
var uC = sm, [Do, jI] = wl("Tooltip", [
  Xp
]), Lo = Xp(), lm = "TooltipProvider", cC = 700, ws = "tooltip.open", [fC, Pl] = Do(lm), um = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = cC,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: a
  } = e, o = A.useRef(!0), s = A.useRef(!1), l = A.useRef(0);
  return A.useEffect(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ b(
    fC,
    {
      scope: t,
      isOpenDelayedRef: o,
      delayDuration: n,
      onOpen: A.useCallback(() => {
        window.clearTimeout(l.current), o.current = !1;
      }, []),
      onClose: A.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => o.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: A.useCallback((u) => {
        s.current = u;
      }, []),
      disableHoverableContent: i,
      children: a
    }
  );
};
um.displayName = lm;
var $r = "Tooltip", [dC, No] = Do($r), cm = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    disableHoverableContent: o,
    delayDuration: s
  } = e, l = Pl($r, e.__scopeTooltip), u = Lo(t), [c, f] = A.useState(null), d = Ui(), h = A.useRef(0), p = o ?? l.disableHoverableContent, m = s ?? l.delayDuration, y = A.useRef(!1), [g, w] = am({
    prop: r,
    defaultProp: i ?? !1,
    onChange: (P) => {
      P ? (l.onOpen(), document.dispatchEvent(new CustomEvent(ws))) : l.onClose(), a == null || a(P);
    },
    caller: $r
  }), v = A.useMemo(() => g ? y.current ? "delayed-open" : "instant-open" : "closed", [g]), k = A.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, y.current = !1, w(!0);
  }, [w]), x = A.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, w(!1);
  }, [w]), C = A.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      y.current = !0, w(!0), h.current = 0;
    }, m);
  }, [m, w]);
  return A.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ b(Xk, { ...u, children: /* @__PURE__ */ b(
    dC,
    {
      scope: t,
      contentId: d,
      open: g,
      stateAttribute: v,
      trigger: c,
      onTriggerChange: f,
      onTriggerEnter: A.useCallback(() => {
        l.isOpenDelayedRef.current ? C() : k();
      }, [l.isOpenDelayedRef, C, k]),
      onTriggerLeave: A.useCallback(() => {
        p ? x() : (window.clearTimeout(h.current), h.current = 0);
      }, [x, p]),
      onOpen: k,
      onClose: x,
      disableHoverableContent: p,
      children: n
    }
  ) });
};
cm.displayName = $r;
var vs = "TooltipTrigger", fm = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = No(vs, n), a = Pl(vs, n), o = Lo(n), s = A.useRef(null), l = ft(t, s, i.onTriggerChange), u = A.useRef(!1), c = A.useRef(!1), f = A.useCallback(() => u.current = !1, []);
    return A.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ b(Zk, { asChild: !0, ...o, children: /* @__PURE__ */ b(
      je.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: Ve(e.onPointerMove, (d) => {
          d.pointerType !== "touch" && !c.current && !a.isPointerInTransitRef.current && (i.onTriggerEnter(), c.current = !0);
        }),
        onPointerLeave: Ve(e.onPointerLeave, () => {
          i.onTriggerLeave(), c.current = !1;
        }),
        onPointerDown: Ve(e.onPointerDown, () => {
          i.open && i.onClose(), u.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: Ve(e.onFocus, () => {
          u.current || i.onOpen();
        }),
        onBlur: Ve(e.onBlur, i.onClose),
        onClick: Ve(e.onClick, i.onClose)
      }
    ) });
  }
);
fm.displayName = vs;
var hC = "TooltipPortal", [BI, pC] = Do(hC, {
  forceMount: void 0
}), er = "TooltipContent", dm = A.forwardRef(
  (e, t) => {
    const n = pC(er, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, o = No(er, e.__scopeTooltip);
    return /* @__PURE__ */ b(ti, { present: r || o.open, children: o.disableHoverableContent ? /* @__PURE__ */ b(hm, { side: i, ...a, ref: t }) : /* @__PURE__ */ b(mC, { side: i, ...a, ref: t }) });
  }
), mC = A.forwardRef((e, t) => {
  const n = No(er, e.__scopeTooltip), r = Pl(er, e.__scopeTooltip), i = A.useRef(null), a = ft(t, i), [o, s] = A.useState(null), { trigger: l, onClose: u } = n, c = i.current, { onPointerInTransitChange: f } = r, d = A.useCallback(() => {
    s(null), f(!1);
  }, [f]), h = A.useCallback(
    (p, m) => {
      const y = p.currentTarget, g = { x: p.clientX, y: p.clientY }, w = bC(g, y.getBoundingClientRect()), v = xC(g, w), k = kC(m.getBoundingClientRect()), x = SC([...v, ...k]);
      s(x), f(!0);
    },
    [f]
  );
  return A.useEffect(() => () => d(), [d]), A.useEffect(() => {
    if (l && c) {
      const p = (y) => h(y, c), m = (y) => h(y, l);
      return l.addEventListener("pointerleave", p), c.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", p), c.removeEventListener("pointerleave", m);
      };
    }
  }, [l, c, h, d]), A.useEffect(() => {
    if (o) {
      const p = (m) => {
        const y = m.target, g = { x: m.clientX, y: m.clientY }, w = (l == null ? void 0 : l.contains(y)) || (c == null ? void 0 : c.contains(y)), v = !CC(g, o);
        w ? d() : v && (d(), u());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [l, c, o, u, d]), /* @__PURE__ */ b(hm, { ...e, ref: a });
}), [gC, yC] = Do($r, { isInside: !1 }), wC = /* @__PURE__ */ l2("TooltipContent"), hm = A.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: a,
      onPointerDownOutside: o,
      ...s
    } = e, l = No(er, n), u = Lo(n), { onClose: c } = l;
    return A.useEffect(() => (document.addEventListener(ws, c), () => document.removeEventListener(ws, c)), [c]), A.useEffect(() => {
      if (l.trigger) {
        const f = (d) => {
          const h = d.target;
          h != null && h.contains(l.trigger) && c();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, c]), /* @__PURE__ */ b(
      vl,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: o,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: c,
        children: /* @__PURE__ */ B(
          Jk,
          {
            "data-state": l.stateAttribute,
            ...u,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ b(wC, { children: r }),
              /* @__PURE__ */ b(gC, { scope: n, isInside: !0, children: /* @__PURE__ */ b(uC, { id: l.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
dm.displayName = er;
var pm = "TooltipArrow", vC = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = Lo(n);
    return yC(
      pm,
      n
    ).isInside ? null : /* @__PURE__ */ b(Qk, { ...i, ...r, ref: t });
  }
);
vC.displayName = pm;
function bC(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, a)) {
    case a:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function xC(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function kC(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function CC(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let a = 0, o = t.length - 1; a < t.length; o = a++) {
    const s = t[a], l = t[o], u = s.x, c = s.y, f = l.x, d = l.y;
    c > r != d > r && n < (f - u) * (r - c) / (d - c) + u && (i = !i);
  }
  return i;
}
function SC(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), AC(t);
}
function AC(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], o = t[t.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], o = n[n.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var TC = um, EC = cm, PC = fm, mm = dm;
const IC = Eo(
  "data-[state=closed]:wgt-animate-out wgt-font-base wgt-z-[60] wgt-overflow-hidden wgt-rounded-md wgt-border wgt-px-3 wgt-py-1.5 wgt-text-sm wgt-shadow-md wgt-animate-in wgt-fade-in-0 wgt-zoom-in-95 data-[state=closed]:wgt-fade-out-0 data-[state=closed]:wgt-zoom-out-95 data-[side=bottom]:wgt-slide-in-from-top-2 data-[side=left]:wgt-slide-in-from-right-2 data-[side=right]:wgt-slide-in-from-left-2 data-[side=top]:wgt-slide-in-from-bottom-2",
  {
    variants: {
      variant: {
        default: "wgt-bg-popover wgt-text-popover-foreground",
        primary: "wgt-bg-primary wgt-text-primary-foreground",
        trigger: "wgt-bg-trigger-tooltip wgt-text-trigger-tooltip-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Lt = TC, Nt = (e) => /* @__PURE__ */ b(EC, { ...e }), Ot = PC, bt = Pn(({ className: e, sideOffset: t = 4, variant: n = "default", ...r }, i) => /* @__PURE__ */ b(
  mm,
  {
    ref: i,
    sideOffset: t,
    className: te(IC({ variant: n }), e),
    ...r
  }
));
bt.displayName = mm.displayName;
const RC = ({ content: e, className: t }) => {
  const { isCopied: n, handleCopy: r } = g2({
    text: e
  });
  return /* @__PURE__ */ b(Lt, { children: /* @__PURE__ */ B(Nt, { children: [
    /* @__PURE__ */ b(Ot, { asChild: !0, children: /* @__PURE__ */ B(
      ot,
      {
        variant: "ghost",
        size: "icon",
        className: te(
          "wgt-group wgt-relative wgt-h-fit wgt-w-fit wgt-opacity-50 hover:wgt-opacity-100",
          t
        ),
        "aria-label": "Copy to clipboard",
        onClick: r,
        children: [
          /* @__PURE__ */ b("div", { className: "wgt-absolute wgt-inset-0 wgt-flex wgt-items-center wgt-justify-center", children: /* @__PURE__ */ b(
            ve,
            {
              icon: e0,
              className: te(
                "wgt-h-4 wgt-w-4 wgt-transition-transform wgt-ease-in-out group-hover:wgt-bg-accent group-hover:wgt-text-accent-foreground group-hover:wgt-opacity-100",
                n ? "wgt-scale-100" : "wgt-scale-0"
              )
            }
          ) }),
          /* @__PURE__ */ b(
            ve,
            {
              icon: i0,
              className: te(
                "wgt-h-4 wgt-w-4 wgt-transition-transform wgt-ease-in-out",
                n ? "wgt-scale-0" : "wgt-scale-100"
              )
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ b(bt, { children: "Copy" })
  ] }) });
};
function MC({
  className: e,
  messages: t,
  handleSubmit: n,
  currentMessage: r
}) {
  return /* @__PURE__ */ b(Lt, { children: /* @__PURE__ */ B(Nt, { children: [
    /* @__PURE__ */ b(Ot, { asChild: !0, children: /* @__PURE__ */ b(
      ot,
      {
        onClick: async () => {
          const a = t.findIndex((s) => s.id === r.id) - 1, o = t[a].content;
          await n(void 0, {
            id: "some-random-temp-id",
            role: "user",
            content: o,
            createdAt: /* @__PURE__ */ new Date(),
            liked: !1,
            disliked: !1
          });
        },
        variant: "ghost",
        size: "icon",
        className: e,
        "aria-label": "Resend",
        children: /* @__PURE__ */ b(ve, { icon: o0 })
      }
    ) }),
    /* @__PURE__ */ b(bt, { children: "Resend" })
  ] }) });
}
/*!
 * Font Awesome Pro 7.0.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2025 Fonticons, Inc.
 */
var DC = {
  prefix: "far",
  iconName: "arrow-right",
  icon: [512, 512, [8594], "f061", "M505 273c9.4-9.4 9.4-24.6 0-33.9L337 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l127 127-406.1 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l406.1 0-127 127c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z"]
}, LC = {
  prefix: "far",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M7.5 105c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l151 151 151-151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-151 151 151 151c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-151-151-151 151c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l151-151-151-151z"]
};
const Il = sn({});
function Rl(e) {
  const t = ge(null);
  return t.current === null && (t.current = e()), t.current;
}
const Ml = typeof window < "u", gm = Ml ? Yr : De, Oo = /* @__PURE__ */ sn(null);
function Dl(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Ll(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const jt = (e, t, n) => n > t ? t : n < e ? e : n;
let Nl = () => {
};
const Bt = {}, ym = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
function wm(e) {
  return typeof e == "object" && e !== null;
}
const vm = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function Ol(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const et = /* @__NO_SIDE_EFFECTS__ */ (e) => e, NC = (e, t) => (n) => t(e(n)), ni = (...e) => e.reduce(NC), jr = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
class Fl {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Dl(this.subscriptions, t), () => Ll(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let a = 0; a < i; a++) {
          const o = this.subscriptions[a];
          o && o(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const xt = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, kt = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function bm(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const xm = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, OC = 1e-7, FC = 12;
function _C(e, t, n, r, i) {
  let a, o, s = 0;
  do
    o = t + (n - t) / 2, a = xm(o, r, i) - e, a > 0 ? n = o : t = o;
  while (Math.abs(a) > OC && ++s < FC);
  return o;
}
function ri(e, t, n, r) {
  if (e === t && n === r)
    return et;
  const i = (a) => _C(a, 0, 1, e, n);
  return (a) => a === 0 || a === 1 ? a : xm(i(a), t, r);
}
const km = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Cm = (e) => (t) => 1 - e(1 - t), Sm = /* @__PURE__ */ ri(0.33, 1.53, 0.69, 0.99), _l = /* @__PURE__ */ Cm(Sm), Am = /* @__PURE__ */ km(_l), Tm = (e) => (e *= 2) < 1 ? 0.5 * _l(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), zl = (e) => 1 - Math.sin(Math.acos(e)), Em = Cm(zl), Pm = km(zl), zC = /* @__PURE__ */ ri(0.42, 0, 1, 1), VC = /* @__PURE__ */ ri(0, 0, 0.58, 1), Im = /* @__PURE__ */ ri(0.42, 0, 0.58, 1), $C = (e) => Array.isArray(e) && typeof e[0] != "number", Rm = (e) => Array.isArray(e) && typeof e[0] == "number", jC = {
  linear: et,
  easeIn: zC,
  easeInOut: Im,
  easeOut: VC,
  circIn: zl,
  circInOut: Pm,
  circOut: Em,
  backIn: _l,
  backInOut: Am,
  backOut: Sm,
  anticipate: Tm
}, BC = (e) => typeof e == "string", Wc = (e) => {
  if (Rm(e)) {
    Nl(e.length === 4);
    const [t, n, r, i] = e;
    return ri(t, n, r, i);
  } else if (BC(e))
    return jC[e];
  return e;
}, vi = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function WC(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, a = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(c) {
    o.has(c) && (u.schedule(c), e()), c(s);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, f = !1, d = !1) => {
      const p = d && i ? n : r;
      return f && o.add(c), p.has(c) || p.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      r.delete(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (s = c, i) {
        a = !0;
        return;
      }
      i = !0, [n, r] = [r, n], n.forEach(l), n.clear(), i = !1, a && (a = !1, u.process(c));
    }
  };
  return u;
}
const UC = 40;
function Mm(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, o = vi.reduce((v, k) => (v[k] = WC(a), v), {}), { setup: s, read: l, resolveKeyframes: u, preUpdate: c, update: f, preRender: d, render: h, postRender: p } = o, m = () => {
    const v = Bt.useManualTiming ? i.timestamp : performance.now();
    n = !1, Bt.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(v - i.timestamp, UC), 1)), i.timestamp = v, i.isProcessing = !0, s.process(i), l.process(i), u.process(i), c.process(i), f.process(i), d.process(i), h.process(i), p.process(i), i.isProcessing = !1, n && t && (r = !1, e(m));
  }, y = () => {
    n = !0, r = !0, i.isProcessing || e(m);
  };
  return { schedule: vi.reduce((v, k) => {
    const x = o[k];
    return v[k] = (C, P = !1, I = !1) => (n || y(), x.schedule(C, P, I)), v;
  }, {}), cancel: (v) => {
    for (let k = 0; k < vi.length; k++)
      o[vi[k]].cancel(v);
  }, state: i, steps: o };
}
const { schedule: ce, cancel: on, state: Te, steps: oa } = /* @__PURE__ */ Mm(typeof requestAnimationFrame < "u" ? requestAnimationFrame : et, !0);
let Gi;
function HC() {
  Gi = void 0;
}
const $e = {
  now: () => (Gi === void 0 && $e.set(Te.isProcessing || Bt.useManualTiming ? Te.timestamp : performance.now()), Gi),
  set: (e) => {
    Gi = e, queueMicrotask(HC);
  }
}, Dm = (e) => (t) => typeof t == "string" && t.startsWith(e), Vl = /* @__PURE__ */ Dm("--"), GC = /* @__PURE__ */ Dm("var(--"), $l = (e) => GC(e) ? qC.test(e.split("/*")[0].trim()) : !1, qC = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, ur = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Br = {
  ...ur,
  transform: (e) => jt(0, 1, e)
}, bi = {
  ...ur,
  default: 1
}, Ir = (e) => Math.round(e * 1e5) / 1e5, jl = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function KC(e) {
  return e == null;
}
const YC = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Bl = (e, t) => (n) => !!(typeof n == "string" && YC.test(n) && n.startsWith(e) || t && !KC(n) && Object.prototype.hasOwnProperty.call(n, t)), Lm = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, a, o, s] = r.match(jl);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, XC = (e) => jt(0, 255, e), aa = {
  ...ur,
  transform: (e) => Math.round(XC(e))
}, wn = {
  test: /* @__PURE__ */ Bl("rgb", "red"),
  parse: /* @__PURE__ */ Lm("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + aa.transform(e) + ", " + aa.transform(t) + ", " + aa.transform(n) + ", " + Ir(Br.transform(r)) + ")"
};
function ZC(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const bs = {
  test: /* @__PURE__ */ Bl("#"),
  parse: ZC,
  transform: wn.transform
}, ii = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Kt = /* @__PURE__ */ ii("deg"), Ct = /* @__PURE__ */ ii("%"), q = /* @__PURE__ */ ii("px"), JC = /* @__PURE__ */ ii("vh"), QC = /* @__PURE__ */ ii("vw"), Uc = {
  ...Ct,
  parse: (e) => Ct.parse(e) / 100,
  transform: (e) => Ct.transform(e * 100)
}, $n = {
  test: /* @__PURE__ */ Bl("hsl", "hue"),
  parse: /* @__PURE__ */ Lm("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Ct.transform(Ir(t)) + ", " + Ct.transform(Ir(n)) + ", " + Ir(Br.transform(r)) + ")"
}, we = {
  test: (e) => wn.test(e) || bs.test(e) || $n.test(e),
  parse: (e) => wn.test(e) ? wn.parse(e) : $n.test(e) ? $n.parse(e) : bs.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? wn.transform(e) : $n.transform(e),
  getAnimatableNone: (e) => {
    const t = we.parse(e);
    return t.alpha = 0, we.transform(t);
  }
}, eS = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function tS(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(jl)) == null ? void 0 : t.length) || 0) + (((n = e.match(eS)) == null ? void 0 : n.length) || 0) > 0;
}
const Nm = "number", Om = "color", nS = "var", rS = "var(", Hc = "${}", iS = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Wr(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let a = 0;
  const s = t.replace(iS, (l) => (we.test(l) ? (r.color.push(a), i.push(Om), n.push(we.parse(l))) : l.startsWith(rS) ? (r.var.push(a), i.push(nS), n.push(l)) : (r.number.push(a), i.push(Nm), n.push(parseFloat(l))), ++a, Hc)).split(Hc);
  return { values: n, split: s, indexes: r, types: i };
}
function Fm(e) {
  return Wr(e).values;
}
function _m(e) {
  const { split: t, types: n } = Wr(e), r = t.length;
  return (i) => {
    let a = "";
    for (let o = 0; o < r; o++)
      if (a += t[o], i[o] !== void 0) {
        const s = n[o];
        s === Nm ? a += Ir(i[o]) : s === Om ? a += we.transform(i[o]) : a += i[o];
      }
    return a;
  };
}
const oS = (e) => typeof e == "number" ? 0 : we.test(e) ? we.getAnimatableNone(e) : e;
function aS(e) {
  const t = Fm(e);
  return _m(e)(t.map(oS));
}
const an = {
  test: tS,
  parse: Fm,
  createTransformer: _m,
  getAnimatableNone: aS
};
function sa(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function sS({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, a = 0, o = 0;
  if (!t)
    i = a = o = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = sa(l, s, e + 1 / 3), a = sa(l, s, e), o = sa(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function lo(e, t) {
  return (n) => n > 0 ? t : e;
}
const fe = (e, t, n) => e + (t - e) * n, la = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, lS = [bs, wn, $n], uS = (e) => lS.find((t) => t.test(e));
function Gc(e) {
  const t = uS(e);
  if (!t)
    return !1;
  let n = t.parse(e);
  return t === $n && (n = sS(n)), n;
}
const qc = (e, t) => {
  const n = Gc(e), r = Gc(t);
  if (!n || !r)
    return lo(e, t);
  const i = { ...n };
  return (a) => (i.red = la(n.red, r.red, a), i.green = la(n.green, r.green, a), i.blue = la(n.blue, r.blue, a), i.alpha = fe(n.alpha, r.alpha, a), wn.transform(i));
}, xs = /* @__PURE__ */ new Set(["none", "hidden"]);
function cS(e, t) {
  return xs.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function fS(e, t) {
  return (n) => fe(e, t, n);
}
function Wl(e) {
  return typeof e == "number" ? fS : typeof e == "string" ? $l(e) ? lo : we.test(e) ? qc : pS : Array.isArray(e) ? zm : typeof e == "object" ? we.test(e) ? qc : dS : lo;
}
function zm(e, t) {
  const n = [...e], r = n.length, i = e.map((a, o) => Wl(a)(a, t[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](a);
    return n;
  };
}
function dS(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = Wl(e[i])(e[i], t[i]));
  return (i) => {
    for (const a in r)
      n[a] = r[a](i);
    return n;
  };
}
function hS(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const a = t.types[i], o = e.indexes[a][r[a]], s = e.values[o] ?? 0;
    n[i] = s, r[a]++;
  }
  return n;
}
const pS = (e, t) => {
  const n = an.createTransformer(t), r = Wr(e), i = Wr(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? xs.has(e) && !i.values.length || xs.has(t) && !r.values.length ? cS(e, t) : ni(zm(hS(r, i), i.values), n) : lo(e, t);
};
function Vm(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? fe(e, t, n) : Wl(e)(e, t);
}
const mS = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => ce.update(t, n),
    stop: () => on(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Te.isProcessing ? Te.timestamp : $e.now()
  };
}, $m = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let a = 0; a < i; a++)
    r += Math.round(e(a / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, uo = 2e4;
function Ul(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < uo; )
    t += n, r = e.next(t);
  return t >= uo ? 1 / 0 : t;
}
function gS(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(Ul(r), uo);
  return {
    type: "keyframes",
    ease: (a) => r.next(i * a).value / t,
    duration: /* @__PURE__ */ kt(i)
  };
}
const yS = 5;
function jm(e, t, n) {
  const r = Math.max(t - yS, 0);
  return bm(n - e(r), t - r);
}
const he = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, ua = 1e-3;
function wS({ duration: e = he.duration, bounce: t = he.bounce, velocity: n = he.velocity, mass: r = he.mass }) {
  let i, a, o = 1 - t;
  o = jt(he.minDamping, he.maxDamping, o), e = jt(he.minDuration, he.maxDuration, /* @__PURE__ */ kt(e)), o < 1 ? (i = (u) => {
    const c = u * o, f = c * e, d = c - n, h = ks(u, o), p = Math.exp(-f);
    return ua - d / h * p;
  }, a = (u) => {
    const f = u * o * e, d = f * n + n, h = Math.pow(o, 2) * Math.pow(u, 2) * e, p = Math.exp(-f), m = ks(Math.pow(u, 2), o);
    return (-i(u) + ua > 0 ? -1 : 1) * ((d - h) * p) / m;
  }) : (i = (u) => {
    const c = Math.exp(-u * e), f = (u - n) * e + 1;
    return -ua + c * f;
  }, a = (u) => {
    const c = Math.exp(-u * e), f = (n - u) * (e * e);
    return c * f;
  });
  const s = 5 / e, l = bS(i, a, s);
  if (e = /* @__PURE__ */ xt(e), isNaN(l))
    return {
      stiffness: he.stiffness,
      damping: he.damping,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const vS = 12;
function bS(e, t, n) {
  let r = n;
  for (let i = 1; i < vS; i++)
    r = r - e(r) / t(r);
  return r;
}
function ks(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const xS = ["duration", "bounce"], kS = ["stiffness", "damping", "mass"];
function Kc(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function CS(e) {
  let t = {
    velocity: he.velocity,
    stiffness: he.stiffness,
    damping: he.damping,
    mass: he.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Kc(e, kS) && Kc(e, xS))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, a = 2 * jt(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: he.mass,
        stiffness: i,
        damping: a
      };
    } else {
      const n = wS(e);
      t = {
        ...t,
        ...n,
        mass: he.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function co(e = he.visualDuration, t = he.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: a }, { stiffness: l, damping: u, mass: c, duration: f, velocity: d, isResolvedFromDuration: h } = CS({
    ...n,
    velocity: -/* @__PURE__ */ kt(n.velocity || 0)
  }), p = d || 0, m = u / (2 * Math.sqrt(l * c)), y = o - a, g = /* @__PURE__ */ kt(Math.sqrt(l / c)), w = Math.abs(y) < 5;
  r || (r = w ? he.restSpeed.granular : he.restSpeed.default), i || (i = w ? he.restDelta.granular : he.restDelta.default);
  let v;
  if (m < 1) {
    const x = ks(g, m);
    v = (C) => {
      const P = Math.exp(-m * g * C);
      return o - P * ((p + m * g * y) / x * Math.sin(x * C) + y * Math.cos(x * C));
    };
  } else if (m === 1)
    v = (x) => o - Math.exp(-g * x) * (y + (p + g * y) * x);
  else {
    const x = g * Math.sqrt(m * m - 1);
    v = (C) => {
      const P = Math.exp(-m * g * C), I = Math.min(x * C, 300);
      return o - P * ((p + m * g * y) * Math.sinh(I) + x * y * Math.cosh(I)) / x;
    };
  }
  const k = {
    calculatedDuration: h && f || null,
    next: (x) => {
      const C = v(x);
      if (h)
        s.done = x >= f;
      else {
        let P = x === 0 ? p : 0;
        m < 1 && (P = x === 0 ? /* @__PURE__ */ xt(p) : jm(v, x, C));
        const I = Math.abs(P) <= r, N = Math.abs(o - C) <= i;
        s.done = I && N;
      }
      return s.value = s.done ? o : C, s;
    },
    toString: () => {
      const x = Math.min(Ul(k), uo), C = $m((P) => k.next(x * P).value, x, 30);
      return x + "ms " + C;
    },
    toTransition: () => {
    }
  };
  return k;
}
co.applyToOptions = (e) => {
  const t = gS(e, 100, co);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ xt(t.duration), e.type = "keyframes", e;
};
function Cs({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const f = e[0], d = {
    done: !1,
    value: f
  }, h = (I) => s !== void 0 && I < s || l !== void 0 && I > l, p = (I) => s === void 0 ? l : l === void 0 || Math.abs(s - I) < Math.abs(l - I) ? s : l;
  let m = n * t;
  const y = f + m, g = o === void 0 ? y : o(y);
  g !== y && (m = g - f);
  const w = (I) => -m * Math.exp(-I / r), v = (I) => g + w(I), k = (I) => {
    const N = w(I), E = v(I);
    d.done = Math.abs(N) <= u, d.value = d.done ? g : E;
  };
  let x, C;
  const P = (I) => {
    h(d.value) && (x = I, C = co({
      keyframes: [d.value, p(d.value)],
      velocity: jm(v, I, d.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: a,
      restDelta: u,
      restSpeed: c
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (I) => {
      let N = !1;
      return !C && x === void 0 && (N = !0, k(I), P(I)), x !== void 0 && I >= x ? C.next(I - x) : (!N && k(I), d);
    }
  };
}
function SS(e, t, n) {
  const r = [], i = n || Bt.mix || Vm, a = e.length - 1;
  for (let o = 0; o < a; o++) {
    let s = i(e[o], e[o + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[o] || et : t;
      s = ni(l, s);
    }
    r.push(s);
  }
  return r;
}
function AS(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const a = e.length;
  if (Nl(a === t.length), a === 1)
    return () => t[0];
  if (a === 2 && t[0] === t[1])
    return () => t[1];
  const o = e[0] === e[1];
  e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = SS(t, r, i), l = s.length, u = (c) => {
    if (o && c < e[0])
      return t[0];
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const d = /* @__PURE__ */ jr(e[f], e[f + 1], c);
    return s[f](d);
  };
  return n ? (c) => u(jt(e[0], e[a - 1], c)) : u;
}
function TS(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ jr(0, t, r);
    e.push(fe(n, 1, i));
  }
}
function ES(e) {
  const t = [0];
  return TS(t, e.length - 1), t;
}
function PS(e, t) {
  return e.map((n) => n * t);
}
function IS(e, t) {
  return e.map(() => t || Im).splice(0, e.length - 1);
}
function Rr({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = $C(r) ? r.map(Wc) : Wc(r), a = {
    done: !1,
    value: t[0]
  }, o = PS(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : ES(t),
    e
  ), s = AS(o, t, {
    ease: Array.isArray(i) ? i : IS(t, i)
  });
  return {
    calculatedDuration: e,
    next: (l) => (a.value = s(l), a.done = l >= e, a)
  };
}
const RS = (e) => e !== null;
function Hl(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
  const a = e.filter(RS), s = i < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : a.length - 1;
  return !s || r === void 0 ? a[s] : r;
}
const MS = {
  decay: Cs,
  inertia: Cs,
  tween: Rr,
  keyframes: Rr,
  spring: co
};
function Bm(e) {
  typeof e.type == "string" && (e.type = MS[e.type]);
}
class Gl {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const DS = (e) => e / 100;
class ql extends Gl {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, i;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== $e.now() && this.tick($e.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (i = (r = this.options).onStop) == null || i.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    Bm(t);
    const { type: n = Rr, repeat: r = 0, repeatDelay: i = 0, repeatType: a, velocity: o = 0 } = t;
    let { keyframes: s } = t;
    const l = n || Rr;
    l !== Rr && typeof s[0] != "number" && (this.mixKeyframes = ni(DS, Vm(s[0], s[1])), s = [0, 100]);
    const u = l({ ...t, keyframes: s });
    a === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...s].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = Ul(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = u;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: a, mirroredGenerator: o, resolvedDuration: s, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: c, repeat: f, repeatType: d, repeatDelay: h, type: p, onUpdate: m, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const g = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), w = this.playbackSpeed >= 0 ? g < 0 : g > i;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let v = this.currentTime, k = r;
    if (f) {
      const I = Math.min(this.currentTime, i) / s;
      let N = Math.floor(I), E = I % 1;
      !E && I >= 1 && (E = 1), E === 1 && N--, N = Math.min(N, f + 1), !!(N % 2) && (d === "reverse" ? (E = 1 - E, h && (E -= h / s)) : d === "mirror" && (k = o)), v = jt(0, 1, E) * s;
    }
    const x = w ? { done: !1, value: c[0] } : k.next(v);
    a && (x.value = a(x.value));
    let { done: C } = x;
    !w && l !== null && (C = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && C);
    return P && p !== Cs && (x.value = Hl(c, this.options, y, this.speed)), m && m(x.value), P && this.finish(), x;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ kt(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ kt(this.currentTime);
  }
  set time(t) {
    var n;
    t = /* @__PURE__ */ xt(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime($e.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ kt(this.currentTime));
  }
  play() {
    var i, a;
    if (this.isStopped)
      return;
    const { driver: t = mS, startTime: n } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), (a = (i = this.options).onPlay) == null || a.call(i);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime($e.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function LS(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const vn = (e) => e * 180 / Math.PI, Ss = (e) => {
  const t = vn(Math.atan2(e[1], e[0]));
  return As(t);
}, NS = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: Ss,
  rotateZ: Ss,
  skewX: (e) => vn(Math.atan(e[1])),
  skewY: (e) => vn(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, As = (e) => (e = e % 360, e < 0 && (e += 360), e), Yc = Ss, Xc = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Zc = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), OS = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Xc,
  scaleY: Zc,
  scale: (e) => (Xc(e) + Zc(e)) / 2,
  rotateX: (e) => As(vn(Math.atan2(e[6], e[5]))),
  rotateY: (e) => As(vn(Math.atan2(-e[2], e[0]))),
  rotateZ: Yc,
  rotate: Yc,
  skewX: (e) => vn(Math.atan(e[4])),
  skewY: (e) => vn(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function Ts(e) {
  return e.includes("scale") ? 1 : 0;
}
function Es(e, t) {
  if (!e || e === "none")
    return Ts(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = OS, i = n;
  else {
    const s = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = NS, i = s;
  }
  if (!i)
    return Ts(t);
  const a = r[t], o = i[1].split(",").map(_S);
  return typeof a == "function" ? a(o) : o[a];
}
const FS = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return Es(n, t);
};
function _S(e) {
  return parseFloat(e.trim());
}
const cr = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], fr = new Set(cr), Jc = (e) => e === ur || e === q, zS = /* @__PURE__ */ new Set(["x", "y", "z"]), VS = cr.filter((e) => !zS.has(e));
function $S(e) {
  const t = [];
  return VS.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const bn = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => Es(t, "x"),
  y: (e, { transform: t }) => Es(t, "y")
};
bn.translateX = bn.x;
bn.translateY = bn.y;
const xn = /* @__PURE__ */ new Set();
let Ps = !1, Is = !1, Rs = !1;
function Wm() {
  if (Is) {
    const e = Array.from(xn).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = $S(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([a, o]) => {
        var s;
        (s = r.getValue(a)) == null || s.set(o);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Is = !1, Ps = !1, xn.forEach((e) => e.complete(Rs)), xn.clear();
}
function Um() {
  xn.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Is = !0);
  });
}
function jS() {
  Rs = !0, Um(), Wm(), Rs = !1;
}
class Kl {
  constructor(t, n, r, i, a, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (xn.add(this), Ps || (Ps = !0, ce.read(Um), ce.resolveKeyframes(Wm))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const a = i == null ? void 0 : i.get(), o = t[t.length - 1];
      if (a !== void 0)
        t[0] = a;
      else if (r && n) {
        const s = r.readValue(n, o);
        s != null && (t[0] = s);
      }
      t[0] === void 0 && (t[0] = o), i && a === void 0 && i.set(t[0]);
    }
    LS(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), xn.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (xn.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const BS = (e) => e.startsWith("--");
function WS(e, t, n) {
  BS(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const US = /* @__PURE__ */ Ol(() => window.ScrollTimeline !== void 0), HS = {};
function GS(e, t) {
  const n = /* @__PURE__ */ Ol(e);
  return () => HS[t] ?? n();
}
const Hm = /* @__PURE__ */ GS(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Tr = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Qc = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Tr([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Tr([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Tr([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Tr([0.33, 1.53, 0.69, 0.99])
};
function Gm(e, t) {
  if (e)
    return typeof e == "function" ? Hm() ? $m(e, t) : "ease-out" : Rm(e) ? Tr(e) : Array.isArray(e) ? e.map((n) => Gm(n, t) || Qc.easeOut) : Qc[e];
}
function qS(e, t, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [t]: n
  };
  l && (c.offset = l);
  const f = Gm(s, i);
  Array.isArray(f) && (c.easing = f);
  const d = {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (d.pseudoElement = u), e.animate(c, d);
}
function qm(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function KS({ type: e, ...t }) {
  return qm(e) && Hm() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class YS extends Gl {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: r, keyframes: i, pseudoElement: a, allowFlatten: o = !1, finalKeyframe: s, onComplete: l } = t;
    this.isPseudoElement = !!a, this.allowFlatten = o, this.options = t, Nl(typeof t.type != "string");
    const u = KS(t);
    this.animation = qS(n, r, i, u, a), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !a) {
        const c = Hl(i, this.options, s, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : WS(n, r, c), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ kt(Number(t));
  }
  get time() {
    return /* @__PURE__ */ kt(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ xt(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && US() ? (this.animation.timeline = t, et) : n(this);
  }
}
const Km = {
  anticipate: Tm,
  backInOut: Am,
  circInOut: Pm
};
function XS(e) {
  return e in Km;
}
function ZS(e) {
  typeof e.ease == "string" && XS(e.ease) && (e.ease = Km[e.ease]);
}
const ef = 10;
class JS extends YS {
  constructor(t) {
    ZS(t), Bm(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: i, element: a, ...o } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const s = new ql({
      ...o,
      autoplay: !1
    }), l = /* @__PURE__ */ xt(this.finishedTime ?? this.time);
    n.setWithVelocity(s.sample(l - ef).value, s.sample(l).value, ef), s.stop();
  }
}
const tf = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(an.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function QS(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function e6(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const a = e[e.length - 1], o = tf(i, t), s = tf(a, t);
  return !o || !s ? !1 : QS(e) || (n === "spring" || qm(n)) && r;
}
function Ms(e) {
  e.duration = 0, e.type;
}
const t6 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), n6 = /* @__PURE__ */ Ol(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function r6(e) {
  var c;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: a, type: o } = e;
  if (!(((c = t == null ? void 0 : t.owner) == null ? void 0 : c.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: l, transformTemplate: u } = t.owner.getProps();
  return n6() && n && t6.has(n) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !r && i !== "mirror" && a !== 0 && o !== "inertia";
}
const i6 = 40;
class o6 extends Gl {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: o = "loop", keyframes: s, name: l, motionValue: u, element: c, ...f }) {
    var p;
    super(), this.stop = () => {
      var m, y;
      this._animation && (this._animation.stop(), (m = this.stopTimeline) == null || m.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = $e.now();
    const d = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: a,
      repeatType: o,
      name: l,
      motionValue: u,
      element: c,
      ...f
    }, h = (c == null ? void 0 : c.KeyframeResolver) || Kl;
    this.keyframeResolver = new h(s, (m, y, g) => this.onKeyframesResolved(m, y, d, !g), l, u, c), (p = this.keyframeResolver) == null || p.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, i) {
    this.keyframeResolver = void 0;
    const { name: a, type: o, velocity: s, delay: l, isHandoff: u, onUpdate: c } = r;
    this.resolvedAt = $e.now(), e6(t, a, o, s) || ((Bt.instantAnimations || !l) && (c == null || c(Hl(t, r, n))), t[0] = t[t.length - 1], Ms(r), r.repeat = 0);
    const d = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > i6 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, h = !u && r6(d) ? new JS({
      ...d,
      element: d.motionValue.owner.current
    }) : new ql(d);
    h.finished.then(() => this.notifyFinished()).catch(et), this.pendingTimeline && (this.stopTimeline = h.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = h;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), jS()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
const a6 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function s6(e) {
  const t = a6.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
function Ym(e, t, n = 1) {
  const [r, i] = s6(e);
  if (!r)
    return;
  const a = window.getComputedStyle(t).getPropertyValue(r);
  if (a) {
    const o = a.trim();
    return ym(o) ? parseFloat(o) : o;
  }
  return $l(i) ? Ym(i, t, n + 1) : i;
}
function Yl(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Xm = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...cr
]), l6 = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Zm = (e) => (t) => t.test(e), Jm = [ur, q, Ct, Kt, QC, JC, l6], nf = (e) => Jm.find(Zm(e));
function u6(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || vm(e) : !0;
}
const c6 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function f6(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(jl) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let a = c6.has(t) ? 1 : 0;
  return r !== n && (a *= 100), t + "(" + a + i + ")";
}
const d6 = /\b([a-z-]*)\(.*?\)/gu, Ds = {
  ...an,
  getAnimatableNone: (e) => {
    const t = e.match(d6);
    return t ? t.map(f6).join(" ") : e;
  }
}, rf = {
  ...ur,
  transform: Math.round
}, h6 = {
  rotate: Kt,
  rotateX: Kt,
  rotateY: Kt,
  rotateZ: Kt,
  scale: bi,
  scaleX: bi,
  scaleY: bi,
  scaleZ: bi,
  skew: Kt,
  skewX: Kt,
  skewY: Kt,
  distance: q,
  translateX: q,
  translateY: q,
  translateZ: q,
  x: q,
  y: q,
  z: q,
  perspective: q,
  transformPerspective: q,
  opacity: Br,
  originX: Uc,
  originY: Uc,
  originZ: q
}, Xl = {
  // Border props
  borderWidth: q,
  borderTopWidth: q,
  borderRightWidth: q,
  borderBottomWidth: q,
  borderLeftWidth: q,
  borderRadius: q,
  radius: q,
  borderTopLeftRadius: q,
  borderTopRightRadius: q,
  borderBottomRightRadius: q,
  borderBottomLeftRadius: q,
  // Positioning props
  width: q,
  maxWidth: q,
  height: q,
  maxHeight: q,
  top: q,
  right: q,
  bottom: q,
  left: q,
  // Spacing props
  padding: q,
  paddingTop: q,
  paddingRight: q,
  paddingBottom: q,
  paddingLeft: q,
  margin: q,
  marginTop: q,
  marginRight: q,
  marginBottom: q,
  marginLeft: q,
  // Misc
  backgroundPositionX: q,
  backgroundPositionY: q,
  ...h6,
  zIndex: rf,
  // SVG
  fillOpacity: Br,
  strokeOpacity: Br,
  numOctaves: rf
}, p6 = {
  ...Xl,
  // Color props
  color: we,
  backgroundColor: we,
  outlineColor: we,
  fill: we,
  stroke: we,
  // Border props
  borderColor: we,
  borderTopColor: we,
  borderRightColor: we,
  borderBottomColor: we,
  borderLeftColor: we,
  filter: Ds,
  WebkitFilter: Ds
}, Qm = (e) => p6[e];
function eg(e, t) {
  let n = Qm(e);
  return n !== Ds && (n = an), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const m6 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function g6(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const a = e[r];
    typeof a == "string" && !m6.has(a) && Wr(a).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const a of t)
      e[a] = eg(n, i);
}
class y6 extends Kl {
  constructor(t, n, r, i, a) {
    super(t, n, r, i, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let u = t[l];
      if (typeof u == "string" && (u = u.trim(), $l(u))) {
        const c = Ym(u, n.current);
        c !== void 0 && (t[l] = c), l === t.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !Xm.has(r) || t.length !== 2)
      return;
    const [i, a] = t, o = nf(i), s = nf(a);
    if (o !== s)
      if (Jc(o) && Jc(s))
        for (let l = 0; l < t.length; l++) {
          const u = t[l];
          typeof u == "string" && (t[l] = parseFloat(u));
        }
      else bn[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || u6(t[i])) && r.push(i);
    r.length && g6(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = bn[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var s;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const a = r.length - 1, o = r[a];
    r[a] = bn[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (s = this.removedTransforms) != null && s.length && this.removedTransforms.forEach(([l, u]) => {
      t.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function w6(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const i = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e);
}
const tg = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function ng(e) {
  return wm(e) && "offsetHeight" in e;
}
const of = 30, v6 = (e) => !isNaN(parseFloat(e));
class b6 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var a;
      const i = $e.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((a = this.events.change) == null || a.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = $e.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = v6(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Fl());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), ce.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = $e.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > of)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, of);
    return bm(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function tr(e, t) {
  return new b6(e, t);
}
const { schedule: Zl } = /* @__PURE__ */ Mm(queueMicrotask, !1), rt = {
  x: !1,
  y: !1
};
function rg() {
  return rt.x || rt.y;
}
function x6(e) {
  return e === "x" || e === "y" ? rt[e] ? null : (rt[e] = !0, () => {
    rt[e] = !1;
  }) : rt.x || rt.y ? null : (rt.x = rt.y = !0, () => {
    rt.x = rt.y = !1;
  });
}
function ig(e, t) {
  const n = w6(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function af(e) {
  return !(e.pointerType === "touch" || rg());
}
function k6(e, t, n = {}) {
  const [r, i, a] = ig(e, n), o = (s) => {
    if (!af(s))
      return;
    const { target: l } = s, u = t(l, s);
    if (typeof u != "function" || !l)
      return;
    const c = (f) => {
      af(f) && (u(f), l.removeEventListener("pointerleave", c));
    };
    l.addEventListener("pointerleave", c, i);
  };
  return r.forEach((s) => {
    s.addEventListener("pointerenter", o, i);
  }), a;
}
const og = (e, t) => t ? e === t ? !0 : og(e, t.parentElement) : !1, Jl = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, C6 = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function S6(e) {
  return C6.has(e.tagName) || e.tabIndex !== -1;
}
const qi = /* @__PURE__ */ new WeakSet();
function sf(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function ca(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const A6 = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = sf(() => {
    if (qi.has(n))
      return;
    ca(n, "down");
    const i = sf(() => {
      ca(n, "up");
    }), a = () => ca(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", a, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function lf(e) {
  return Jl(e) && !rg();
}
function T6(e, t, n = {}) {
  const [r, i, a] = ig(e, n), o = (s) => {
    const l = s.currentTarget;
    if (!lf(s))
      return;
    qi.add(l);
    const u = t(l, s), c = (h, p) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", d), qi.has(l) && qi.delete(l), lf(h) && typeof u == "function" && u(h, { success: p });
    }, f = (h) => {
      c(h, l === window || l === document || n.useGlobalTarget || og(l, h.target));
    }, d = (h) => {
      c(h, !1);
    };
    window.addEventListener("pointerup", f, i), window.addEventListener("pointercancel", d, i);
  };
  return r.forEach((s) => {
    (n.useGlobalTarget ? window : s).addEventListener("pointerdown", o, i), ng(s) && (s.addEventListener("focus", (u) => A6(u, i)), !S6(s) && !s.hasAttribute("tabindex") && (s.tabIndex = 0));
  }), a;
}
function ag(e) {
  return wm(e) && "ownerSVGElement" in e;
}
function E6(e) {
  return ag(e) && e.tagName === "svg";
}
const Re = (e) => !!(e && e.getVelocity), P6 = [...Jm, we, an], I6 = (e) => P6.find(Zm(e)), Ql = sn({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
class R6 extends A.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = n.offsetParent, i = ng(r) && r.offsetWidth || 0, a = this.props.sizeRef.current;
      a.height = n.offsetHeight || 0, a.width = n.offsetWidth || 0, a.top = n.offsetTop, a.left = n.offsetLeft, a.right = i - a.width - a.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function M6({ children: e, isPresent: t, anchorX: n, root: r }) {
  const i = wo(), a = ge(null), o = ge({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: s } = Ce(Ql);
  return lh(() => {
    const { width: l, height: u, top: c, left: f, right: d } = o.current;
    if (t || !a.current || !l || !u)
      return;
    const h = n === "left" ? `left: ${f}` : `right: ${d}`;
    a.current.dataset.motionPopId = i;
    const p = document.createElement("style");
    s && (p.nonce = s);
    const m = r ?? document.head;
    return m.appendChild(p), p.sheet && p.sheet.insertRule(`
          [data-motion-pop-id="${i}"] {
            position: absolute !important;
            width: ${l}px !important;
            height: ${u}px !important;
            ${h}px !important;
            top: ${c}px !important;
          }
        `), () => {
      m.contains(p) && m.removeChild(p);
    };
  }, [t]), b(R6, { isPresent: t, childRef: a, sizeRef: o, children: A.cloneElement(e, { ref: a }) });
}
const D6 = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: a, mode: o, anchorX: s, root: l }) => {
  const u = Rl(L6), c = wo();
  let f = !0, d = Zt(() => (f = !1, {
    id: c,
    initial: t,
    isPresent: n,
    custom: i,
    onExitComplete: (h) => {
      u.set(h, !0);
      for (const p of u.values())
        if (!p)
          return;
      r && r();
    },
    register: (h) => (u.set(h, !1), () => u.delete(h))
  }), [n, u, r]);
  return a && f && (d = { ...d }), Zt(() => {
    u.forEach((h, p) => u.set(p, !1));
  }, [n]), A.useEffect(() => {
    !n && !u.size && r && r();
  }, [n]), o === "popLayout" && (e = b(M6, { isPresent: n, anchorX: s, root: l, children: e })), b(Oo.Provider, { value: d, children: e });
};
function L6() {
  return /* @__PURE__ */ new Map();
}
function sg(e = !0) {
  const t = Ce(Oo);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = t, a = wo();
  De(() => {
    if (e)
      return i(a);
  }, [e]);
  const o = Ee(() => e && r && r(a), [a, r, e]);
  return !n && r ? [!1, o] : [!0];
}
const xi = (e) => e.key || "";
function uf(e) {
  const t = [];
  return _1.forEach(e, (n) => {
    z1(n) && t.push(n);
  }), t;
}
const eu = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: a = "sync", propagate: o = !1, anchorX: s = "left", root: l }) => {
  const [u, c] = sg(o), f = Zt(() => uf(e), [e]), d = o && !u ? [] : f.map(xi), h = ge(!0), p = ge(f), m = Rl(() => /* @__PURE__ */ new Map()), [y, g] = oe(f), [w, v] = oe(f);
  gm(() => {
    h.current = !1, p.current = f;
    for (let C = 0; C < w.length; C++) {
      const P = xi(w[C]);
      d.includes(P) ? m.delete(P) : m.get(P) !== !0 && m.set(P, !1);
    }
  }, [w, d.length, d.join("-")]);
  const k = [];
  if (f !== y) {
    let C = [...f];
    for (let P = 0; P < w.length; P++) {
      const I = w[P], N = xi(I);
      d.includes(N) || (C.splice(P, 0, I), k.push(I));
    }
    return a === "wait" && k.length && (C = k), v(uf(C)), g(f), null;
  }
  const { forceRender: x } = Ce(Il);
  return b(tt, { children: w.map((C) => {
    const P = xi(C), I = o && !u ? !1 : f === w || d.includes(P), N = () => {
      if (m.has(P))
        m.set(P, !0);
      else
        return;
      let E = !0;
      m.forEach((L) => {
        L || (E = !1);
      }), E && (x == null || x(), v(p.current), o && (c == null || c()), r && r());
    };
    return b(D6, { isPresent: I, initial: !h.current || n ? void 0 : !1, custom: t, presenceAffectsLayout: i, mode: a, root: l, onExitComplete: I ? void 0 : N, anchorX: s, children: C }, P);
  }) });
}, lg = sn({ strict: !1 }), cf = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, nr = {};
for (const e in cf)
  nr[e] = {
    isEnabled: (t) => cf[e].some((n) => !!t[n])
  };
function N6(e) {
  for (const t in e)
    nr[t] = {
      ...nr[t],
      ...e[t]
    };
}
const O6 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function fo(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || O6.has(e);
}
let ug = (e) => !fo(e);
function F6(e) {
  typeof e == "function" && (ug = (t) => t.startsWith("on") ? !fo(t) : e(t));
}
try {
  F6(require("@emotion/is-prop-valid").default);
} catch {
}
function _6(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (ug(i) || n === !0 && fo(i) || !t && !fo(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
const Fo = /* @__PURE__ */ sn({});
function _o(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Ur(e) {
  return typeof e == "string" || Array.isArray(e);
}
const tu = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], nu = ["initial", ...tu];
function zo(e) {
  return _o(e.animate) || nu.some((t) => Ur(e[t]));
}
function cg(e) {
  return !!(zo(e) || e.variants);
}
function z6(e, t) {
  if (zo(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Ur(n) ? n : void 0,
      animate: Ur(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function V6(e) {
  const { initial: t, animate: n } = z6(e, Ce(Fo));
  return Zt(() => ({ initial: t, animate: n }), [ff(t), ff(n)]);
}
function ff(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Hr = {};
function $6(e) {
  for (const t in e)
    Hr[t] = e[t], Vl(t) && (Hr[t].isCSSVariable = !0);
}
function fg(e, { layout: t, layoutId: n }) {
  return fr.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Hr[e] || e === "opacity");
}
const j6 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, B6 = cr.length;
function W6(e, t, n) {
  let r = "", i = !0;
  for (let a = 0; a < B6; a++) {
    const o = cr[a], s = e[o];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const u = tg(s, Xl[o]);
      if (!l) {
        i = !1;
        const c = j6[o] || o;
        r += `${c}(${u}) `;
      }
      n && (t[o] = u);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function ru(e, t, n) {
  const { style: r, vars: i, transformOrigin: a } = e;
  let o = !1, s = !1;
  for (const l in t) {
    const u = t[l];
    if (fr.has(l)) {
      o = !0;
      continue;
    } else if (Vl(l)) {
      i[l] = u;
      continue;
    } else {
      const c = tg(u, Xl[l]);
      l.startsWith("origin") ? (s = !0, a[l] = c) : r[l] = c;
    }
  }
  if (t.transform || (o || n ? r.transform = W6(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = a;
    r.transformOrigin = `${l} ${u} ${c}`;
  }
}
const iu = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function dg(e, t, n) {
  for (const r in t)
    !Re(t[r]) && !fg(r, n) && (e[r] = t[r]);
}
function U6({ transformTemplate: e }, t) {
  return Zt(() => {
    const n = iu();
    return ru(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function H6(e, t) {
  const n = e.style || {}, r = {};
  return dg(r, n, e), Object.assign(r, U6(e, t)), r;
}
function G6(e, t) {
  const n = {}, r = H6(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const q6 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, K6 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Y6(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const a = i ? q6 : K6;
  e[a.offset] = q.transform(-r);
  const o = q.transform(t), s = q.transform(n);
  e[a.array] = `${o} ${s}`;
}
function hg(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: i,
  pathSpacing: a = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...s
}, l, u, c) {
  if (ru(e, s, u), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: d } = e;
  f.transform && (d.transform = f.transform, delete f.transform), (d.transform || f.transformOrigin) && (d.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), d.transform && (d.transformBox = (c == null ? void 0 : c.transformBox) ?? "fill-box", delete f.transformBox), t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), i !== void 0 && Y6(f, i, a, o, !1);
}
const pg = () => ({
  ...iu(),
  attrs: {}
}), mg = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function X6(e, t, n, r) {
  const i = Zt(() => {
    const a = pg();
    return hg(a, t, mg(r), e.transformTemplate, e.style), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [t]);
  if (e.style) {
    const a = {};
    dg(a, e.style, e), i.style = { ...a, ...i.style };
  }
  return i;
}
const Z6 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function ou(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Z6.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function J6(e, t, n, { latestValues: r }, i, a = !1) {
  const s = (ou(e) ? X6 : G6)(t, r, i, e), l = _6(t, typeof e == "string", a), u = e !== uh ? { ...l, ...s, ref: n } : {}, { children: c } = t, f = Zt(() => Re(c) ? c.get() : c, [c]);
  return ch(e, {
    ...u,
    children: f
  });
}
function df(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function au(e, t, n, r) {
  if (typeof t == "function") {
    const [i, a] = df(r);
    t = t(n !== void 0 ? n : e.custom, i, a);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, a] = df(r);
    t = t(n !== void 0 ? n : e.custom, i, a);
  }
  return t;
}
function Ki(e) {
  return Re(e) ? e.get() : e;
}
function Q6({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
  return {
    latestValues: e4(n, r, i, e),
    renderState: t()
  };
}
function e4(e, t, n, r) {
  const i = {}, a = r(e, {});
  for (const d in a)
    i[d] = Ki(a[d]);
  let { initial: o, animate: s } = e;
  const l = zo(e), u = cg(e);
  t && u && !l && e.inherit !== !1 && (o === void 0 && (o = t.initial), s === void 0 && (s = t.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || o === !1;
  const f = c ? s : o;
  if (f && typeof f != "boolean" && !_o(f)) {
    const d = Array.isArray(f) ? f : [f];
    for (let h = 0; h < d.length; h++) {
      const p = au(e, d[h]);
      if (p) {
        const { transitionEnd: m, transition: y, ...g } = p;
        for (const w in g) {
          let v = g[w];
          if (Array.isArray(v)) {
            const k = c ? v.length - 1 : 0;
            v = v[k];
          }
          v !== null && (i[w] = v);
        }
        for (const w in m)
          i[w] = m[w];
      }
    }
  }
  return i;
}
const gg = (e) => (t, n) => {
  const r = Ce(Fo), i = Ce(Oo), a = () => Q6(e, t, r, i);
  return n ? a() : Rl(a);
};
function su(e, t, n) {
  var a;
  const { style: r } = e, i = {};
  for (const o in r)
    (Re(r[o]) || t.style && Re(t.style[o]) || fg(o, e) || ((a = n == null ? void 0 : n.getValue(o)) == null ? void 0 : a.liveStyle) !== void 0) && (i[o] = r[o]);
  return i;
}
const t4 = /* @__PURE__ */ gg({
  scrapeMotionValuesFromProps: su,
  createRenderState: iu
});
function yg(e, t, n) {
  const r = su(e, t, n);
  for (const i in e)
    if (Re(e[i]) || Re(t[i])) {
      const a = cr.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[a] = e[i];
    }
  return r;
}
const n4 = /* @__PURE__ */ gg({
  scrapeMotionValuesFromProps: yg,
  createRenderState: pg
}), r4 = Symbol.for("motionComponentSymbol");
function jn(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function i4(e, t, n) {
  return Ee(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : jn(n) && (n.current = r));
    },
    /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */
    [t, n]
  );
}
const lu = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), o4 = "framerAppearId", wg = "data-" + lu(o4), vg = sn({});
function a4(e, t, n, r, i) {
  var m, y;
  const { visualElement: a } = Ce(Fo), o = Ce(lg), s = Ce(Oo), l = Ce(Ql).reducedMotion, u = ge(null);
  r = r || o.renderer, !u.current && r && (u.current = r(e, {
    visualState: t,
    parent: a,
    props: n,
    presenceContext: s,
    blockInitialAnimation: s ? s.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const c = u.current, f = Ce(vg);
  c && !c.projection && i && (c.type === "html" || c.type === "svg") && s4(u.current, n, i, f);
  const d = ge(!1);
  lh(() => {
    c && d.current && c.update(n, s);
  });
  const h = n[wg], p = ge(!!h && !((m = window.MotionHandoffIsComplete) != null && m.call(window, h)) && ((y = window.MotionHasOptimisedAnimation) == null ? void 0 : y.call(window, h)));
  return gm(() => {
    c && (d.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), c.scheduleRenderMicrotask(), p.current && c.animationState && c.animationState.animateChanges());
  }), De(() => {
    c && (!p.current && c.animationState && c.animationState.animateChanges(), p.current && (queueMicrotask(() => {
      var g;
      (g = window.MotionHandoffMarkAsComplete) == null || g.call(window, h);
    }), p.current = !1), c.enteringChildren = void 0);
  }), c;
}
function s4(e, t, n, r) {
  const { layoutId: i, layout: a, drag: o, dragConstraints: s, layoutScroll: l, layoutRoot: u, layoutCrossfade: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : bg(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!o || s && jn(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: u
  });
}
function bg(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : bg(e.parent);
}
function fa(e, { forwardMotionProps: t = !1 } = {}, n, r) {
  n && N6(n);
  const i = ou(e) ? n4 : t4;
  function a(s, l) {
    let u;
    const c = {
      ...Ce(Ql),
      ...s,
      layoutId: l4(s)
    }, { isStatic: f } = c, d = V6(s), h = i(s, f);
    if (!f && Ml) {
      u4();
      const p = c4(c);
      u = p.MeasureLayout, d.visualElement = a4(e, h, c, r, p.ProjectionNode);
    }
    return B(Fo.Provider, { value: d, children: [u && d.visualElement ? b(u, { visualElement: d.visualElement, ...c }) : null, J6(e, s, i4(h, d.visualElement, l), h, f, t)] });
  }
  a.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const o = Pn(a);
  return o[r4] = e, o;
}
function l4({ layoutId: e }) {
  const t = Ce(Il).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function u4(e, t) {
  Ce(lg).strict;
}
function c4(e) {
  const { drag: t, layout: n } = nr;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
function f4(e, t) {
  if (typeof Proxy > "u")
    return fa;
  const n = /* @__PURE__ */ new Map(), r = (a, o) => fa(a, o, e, t), i = (a, o) => r(a, o);
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (a, o) => o === "create" ? r : (n.has(o) || n.set(o, fa(o, void 0, e, t)), n.get(o))
  });
}
function xg({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function d4({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function h4(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function da(e) {
  return e === void 0 || e === 1;
}
function Ls({ scale: e, scaleX: t, scaleY: n }) {
  return !da(e) || !da(t) || !da(n);
}
function gn(e) {
  return Ls(e) || kg(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function kg(e) {
  return hf(e.x) || hf(e.y);
}
function hf(e) {
  return e && e !== "0%";
}
function ho(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function pf(e, t, n, r, i) {
  return i !== void 0 && (e = ho(e, i, r)), ho(e, n, r) + t;
}
function Ns(e, t = 0, n = 1, r, i) {
  e.min = pf(e.min, t, n, r, i), e.max = pf(e.max, t, n, r, i);
}
function Cg(e, { x: t, y: n }) {
  Ns(e.x, t.translate, t.scale, t.originPoint), Ns(e.y, n.translate, n.scale, n.originPoint);
}
const mf = 0.999999999999, gf = 1.0000000000001;
function p4(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let a, o;
  for (let s = 0; s < i; s++) {
    a = n[s], o = a.projectionDelta;
    const { visualElement: l } = a.options;
    l && l.props.style && l.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && Wn(e, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), o && (t.x *= o.x.scale, t.y *= o.y.scale, Cg(e, o)), r && gn(a.latestValues) && Wn(e, a.latestValues));
  }
  t.x < gf && t.x > mf && (t.x = 1), t.y < gf && t.y > mf && (t.y = 1);
}
function Bn(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function yf(e, t, n, r, i = 0.5) {
  const a = fe(e.min, e.max, i);
  Ns(e, t, n, a, r);
}
function Wn(e, t) {
  yf(e.x, t.x, t.scaleX, t.scale, t.originX), yf(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function Sg(e, t) {
  return xg(h4(e.getBoundingClientRect(), t));
}
function m4(e, t, n) {
  const r = Sg(e, n), { scroll: i } = t;
  return i && (Bn(r.x, i.offset.x), Bn(r.y, i.offset.y)), r;
}
const wf = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Un = () => ({
  x: wf(),
  y: wf()
}), vf = () => ({ min: 0, max: 0 }), me = () => ({
  x: vf(),
  y: vf()
}), Os = { current: null }, Ag = { current: !1 };
function g4() {
  if (Ag.current = !0, !!Ml)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Os.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Os.current = !1;
}
const y4 = /* @__PURE__ */ new WeakMap();
function w4(e, t, n) {
  for (const r in t) {
    const i = t[r], a = n[r];
    if (Re(i))
      e.addValue(r, i);
    else if (Re(a))
      e.addValue(r, tr(i, { owner: e }));
    else if (a !== i)
      if (e.hasValue(r)) {
        const o = e.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = e.getStaticValue(r);
        e.addValue(r, tr(o !== void 0 ? o : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const bf = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class v4 {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: a, visualState: o }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Kl, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const d = $e.now();
      this.renderScheduledAt < d && (this.renderScheduledAt = d, ce.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!a, this.isControllingVariants = zo(n), this.isVariantNode = cg(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: c, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const d in f) {
      const h = f[d];
      l[d] !== void 0 && Re(h) && h.set(l[d]);
    }
  }
  mount(t) {
    var n;
    this.current = t, y4.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, i) => this.bindToMotionValue(i, r)), Ag.current || g4(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Os.current, (n = this.parent) == null || n.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), on(this.notifyUpdate), on(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const r = this.features[n];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = fr.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && ce.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let a;
    window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), a && a(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in nr) {
      const n = nr[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const a = this.features[t];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : me();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < bf.length; r++) {
      const i = bf[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = "on" + i, o = t[a];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = w4(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = tr(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (ym(r) || vm(r)) ? r = parseFloat(r) : !I6(r) && an.test(n) && (r = eg(t, n)), this.setBaseTarget(t, Re(r) ? r.get() : r)), Re(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var a;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const o = au(this.props, n, (a = this.presenceContext) == null ? void 0 : a.custom);
      o && (r = o[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !Re(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Fl()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    Zl.render(this.render);
  }
}
class Tg extends v4 {
  constructor() {
    super(...arguments), this.KeyframeResolver = y6;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Re(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Eg(e, { style: t, vars: n }, r, i) {
  const a = e.style;
  let o;
  for (o in t)
    a[o] = t[o];
  i == null || i.applyProjectionStyles(a, r);
  for (o in n)
    a.setProperty(o, n[o]);
}
function b4(e) {
  return window.getComputedStyle(e);
}
class x4 extends Tg {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Eg;
  }
  readValueFromInstance(t, n) {
    var r;
    if (fr.has(n))
      return (r = this.projection) != null && r.isProjecting ? Ts(n) : FS(t, n);
    {
      const i = b4(t), a = (Vl(n) ? i.getPropertyValue(n) : i[n]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Sg(t, n);
  }
  build(t, n, r) {
    ru(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return su(t, n, r);
  }
}
const Pg = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function k4(e, t, n, r) {
  Eg(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(Pg.has(i) ? i : lu(i), t.attrs[i]);
}
class C4 extends Tg {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = me;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (fr.has(n)) {
      const r = Qm(n);
      return r && r.default || 0;
    }
    return n = Pg.has(n) ? n : lu(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return yg(t, n, r);
  }
  build(t, n, r) {
    hg(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, i) {
    k4(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = mg(t.tagName), super.mount(t);
  }
}
const S4 = (e, t) => ou(e) ? new C4(t) : new x4(t, {
  allowProjection: e !== uh
});
function Kn(e, t, n) {
  const r = e.getProps();
  return au(r, t, n !== void 0 ? n : r.custom, e);
}
const Fs = (e) => Array.isArray(e);
function A4(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, tr(n));
}
function T4(e) {
  return Fs(e) ? e[e.length - 1] || 0 : e;
}
function E4(e, t) {
  const n = Kn(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const o in a) {
    const s = T4(a[o]);
    A4(e, o, s);
  }
}
function P4(e) {
  return !!(Re(e) && e.add);
}
function _s(e, t) {
  const n = e.getValue("willChange");
  if (P4(n))
    return n.add(t);
  if (!n && Bt.WillChange) {
    const r = new Bt.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Ig(e) {
  return e.props[wg];
}
const I4 = (e) => e !== null;
function R4(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(I4), a = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return i[a];
}
const M4 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, D4 = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), L4 = {
  type: "keyframes",
  duration: 0.8
}, N4 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, O4 = (e, { keyframes: t }) => t.length > 2 ? L4 : fr.has(e) ? e.startsWith("scale") ? D4(t[1]) : M4 : N4;
function F4({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: a, repeatType: o, repeatDelay: s, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const uu = (e, t, n, r = {}, i, a) => (o) => {
  const s = Yl(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ xt(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -u,
    onUpdate: (d) => {
      t.set(d), s.onUpdate && s.onUpdate(d);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: a ? void 0 : i
  };
  F4(s) || Object.assign(c, O4(e, c)), c.duration && (c.duration = /* @__PURE__ */ xt(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ xt(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let f = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (Ms(c), c.delay === 0 && (f = !0)), (Bt.instantAnimations || Bt.skipAnimations) && (f = !0, Ms(c), c.delay = 0), c.allowFlatten = !s.type && !s.ease, f && !a && t.get() !== void 0) {
    const d = R4(c.keyframes, s);
    if (d !== void 0) {
      ce.update(() => {
        c.onUpdate(d), c.onComplete();
      });
      return;
    }
  }
  return s.isSync ? new ql(c) : new o6(c);
};
function _4({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Rg(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: a = e.getDefaultTransition(), transitionEnd: o, ...s } = t;
  r && (a = r);
  const l = [], u = i && e.animationState && e.animationState.getState()[i];
  for (const c in s) {
    const f = e.getValue(c, e.latestValues[c] ?? null), d = s[c];
    if (d === void 0 || u && _4(u, c))
      continue;
    const h = {
      delay: n,
      ...Yl(a || {}, c)
    }, p = f.get();
    if (p !== void 0 && !f.isAnimating && !Array.isArray(d) && d === p && !h.velocity)
      continue;
    let m = !1;
    if (window.MotionHandoffAnimation) {
      const g = Ig(e);
      if (g) {
        const w = window.MotionHandoffAnimation(g, c, ce);
        w !== null && (h.startTime = w, m = !0);
      }
    }
    _s(e, c), f.start(uu(c, f, d, e.shouldReduceMotion && Xm.has(c) ? { type: !1 } : h, e, m));
    const y = f.animation;
    y && l.push(y);
  }
  return o && Promise.all(l).then(() => {
    ce.update(() => {
      o && E4(e, o);
    });
  }), l;
}
function Mg(e, t, n, r = 0, i = 1) {
  const a = Array.from(e).sort((u, c) => u.sortNodePosition(c)).indexOf(t), o = e.size, s = (o - 1) * r;
  return typeof n == "function" ? n(a, o) : i === 1 ? a * r : s - a * r;
}
function zs(e, t, n = {}) {
  var l;
  const r = Kn(e, t, n.type === "exit" ? (l = e.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const a = r ? () => Promise.all(Rg(e, r, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: f, staggerDirection: d } = i;
    return z4(e, t, u, c, f, d, n);
  } : () => Promise.resolve(), { when: s } = i;
  if (s) {
    const [u, c] = s === "beforeChildren" ? [a, o] : [o, a];
    return u().then(() => c());
  } else
    return Promise.all([a(), o(n.delay)]);
}
function z4(e, t, n = 0, r = 0, i = 0, a = 1, o) {
  const s = [];
  for (const l of e.variantChildren)
    l.notify("AnimationStart", t), s.push(zs(l, t, {
      ...o,
      delay: n + (typeof r == "function" ? 0 : r) + Mg(e.variantChildren, l, r, i, a)
    }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(s);
}
function V4(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((a) => zs(e, a, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = zs(e, t, n);
  else {
    const i = typeof t == "function" ? Kn(e, t, n.custom) : t;
    r = Promise.all(Rg(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function Dg(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const $4 = nu.length;
function Lg(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Lg(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < $4; n++) {
    const r = nu[n], i = e.props[r];
    (Ur(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const j4 = [...tu].reverse(), B4 = tu.length;
function W4(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => V4(e, n, r)));
}
function U4(e) {
  let t = W4(e), n = xf(), r = !0;
  const i = (l) => (u, c) => {
    var d;
    const f = Kn(e, c, l === "exit" ? (d = e.presenceContext) == null ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: p, ...m } = f;
      u = { ...u, ...m, ...p };
    }
    return u;
  };
  function a(l) {
    t = l(e);
  }
  function o(l) {
    const { props: u } = e, c = Lg(e.parent) || {}, f = [], d = /* @__PURE__ */ new Set();
    let h = {}, p = 1 / 0;
    for (let y = 0; y < B4; y++) {
      const g = j4[y], w = n[g], v = u[g] !== void 0 ? u[g] : c[g], k = Ur(v), x = g === l ? w.isActive : null;
      x === !1 && (p = y);
      let C = v === c[g] && v !== u[g] && k;
      if (C && r && e.manuallyAnimateOnMount && (C = !1), w.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !v && !w.prevProp || // Or if the prop doesn't define an animation
      _o(v) || typeof v == "boolean")
        continue;
      const P = H4(w.prevProp, v);
      let I = P || // If we're making this variant active, we want to always make it active
      g === l && w.isActive && !C && k || // If we removed a higher-priority variant (i is in reverse order)
      y > p && k, N = !1;
      const E = Array.isArray(v) ? v : [v];
      let L = E.reduce(i(g), {});
      x === !1 && (L = {});
      const { prevResolvedValues: M = {} } = w, _ = {
        ...M,
        ...L
      }, D = ($) => {
        I = !0, d.has($) && (N = !0, d.delete($)), w.needsAnimating[$] = !0;
        const V = e.getValue($);
        V && (V.liveStyle = !1);
      };
      for (const $ in _) {
        const V = L[$], U = M[$];
        if (h.hasOwnProperty($))
          continue;
        let S = !1;
        Fs(V) && Fs(U) ? S = !Dg(V, U) : S = V !== U, S ? V != null ? D($) : d.add($) : V !== void 0 && d.has($) ? D($) : w.protectedKeys[$] = !0;
      }
      w.prevProp = v, w.prevResolvedValues = L, w.isActive && (h = { ...h, ...L }), r && e.blockInitialAnimation && (I = !1);
      const j = C && P;
      I && (!j || N) && f.push(...E.map(($) => {
        const V = { type: g };
        if (typeof $ == "string" && r && !j && e.manuallyAnimateOnMount && e.parent) {
          const { parent: U } = e, S = Kn(U, $);
          if (U.enteringChildren && S) {
            const { delayChildren: ne } = S.transition || {};
            V.delay = Mg(U.enteringChildren, e, ne);
          }
        }
        return {
          animation: $,
          options: V
        };
      }));
    }
    if (d.size) {
      const y = {};
      if (typeof u.initial != "boolean") {
        const g = Kn(e, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        g && g.transition && (y.transition = g.transition);
      }
      d.forEach((g) => {
        const w = e.getBaseTarget(g), v = e.getValue(g);
        v && (v.liveStyle = !0), y[g] = w ?? null;
      }), f.push({ animation: y });
    }
    let m = !!f.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (m = !1), r = !1, m ? t(f) : Promise.resolve();
  }
  function s(l, u) {
    var f;
    if (n[l].isActive === u)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((d) => {
      var h;
      return (h = d.animationState) == null ? void 0 : h.setActive(l, u);
    }), n[l].isActive = u;
    const c = o(l);
    for (const d in n)
      n[d].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: o,
    setActive: s,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = xf(), r = !0;
    }
  };
}
function H4(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Dg(t, e) : !1;
}
function pn(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function xf() {
  return {
    animate: pn(!0),
    whileInView: pn(),
    whileHover: pn(),
    whileTap: pn(),
    whileDrag: pn(),
    whileFocus: pn(),
    exit: pn()
  };
}
class un {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class G4 extends un {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = U4(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    _o(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let q4 = 0;
class K4 extends un {
  constructor() {
    super(...arguments), this.id = q4++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const Y4 = {
  animation: {
    Feature: G4
  },
  exit: {
    Feature: K4
  }
};
function Gr(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function oi(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const X4 = (e) => (t) => Jl(t) && e(t, oi(t));
function Mr(e, t, n, r) {
  return Gr(e, t, X4(n), r);
}
const Ng = 1e-4, Z4 = 1 - Ng, J4 = 1 + Ng, Og = 0.01, Q4 = 0 - Og, e5 = 0 + Og;
function Fe(e) {
  return e.max - e.min;
}
function t5(e, t, n) {
  return Math.abs(e - t) <= n;
}
function kf(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = fe(t.min, t.max, e.origin), e.scale = Fe(n) / Fe(t), e.translate = fe(n.min, n.max, e.origin) - e.originPoint, (e.scale >= Z4 && e.scale <= J4 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= Q4 && e.translate <= e5 || isNaN(e.translate)) && (e.translate = 0);
}
function Dr(e, t, n, r) {
  kf(e.x, t.x, n.x, r ? r.originX : void 0), kf(e.y, t.y, n.y, r ? r.originY : void 0);
}
function Cf(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Fe(t);
}
function n5(e, t, n) {
  Cf(e.x, t.x, n.x), Cf(e.y, t.y, n.y);
}
function Sf(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Fe(t);
}
function Lr(e, t, n) {
  Sf(e.x, t.x, n.x), Sf(e.y, t.y, n.y);
}
function Je(e) {
  return [e("x"), e("y")];
}
const Fg = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Af = (e, t) => Math.abs(e - t);
function r5(e, t) {
  const n = Af(e.x, t.x), r = Af(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class _g {
  constructor(t, n, { transformPagePoint: r, contextWindow: i = window, dragSnapToOrigin: a = !1, distanceThreshold: o = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = pa(this.lastMoveEventInfo, this.history), h = this.startEvent !== null, p = r5(d.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!h && !p)
        return;
      const { point: m } = d, { timestamp: y } = Te;
      this.history.push({ ...m, timestamp: y });
      const { onStart: g, onMove: w } = this.handlers;
      h || (g && g(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), w && w(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, h) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = ha(h, this.transformPagePoint), ce.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, h) => {
      this.end();
      const { onEnd: p, onSessionEnd: m, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = pa(d.type === "pointercancel" ? this.lastMoveEventInfo : ha(h, this.transformPagePoint), this.history);
      this.startEvent && p && p(d, g), m && m(d, g);
    }, !Jl(t))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = o, this.contextWindow = i || window;
    const s = oi(t), l = ha(s, this.transformPagePoint), { point: u } = l, { timestamp: c } = Te;
    this.history = [{ ...u, timestamp: c }];
    const { onSessionStart: f } = n;
    f && f(t, pa(l, this.history)), this.removeListeners = ni(Mr(this.contextWindow, "pointermove", this.handlePointerMove), Mr(this.contextWindow, "pointerup", this.handlePointerUp), Mr(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), on(this.updatePoint);
  }
}
function ha(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Tf(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function pa({ point: e }, t) {
  return {
    point: e,
    delta: Tf(e, zg(t)),
    offset: Tf(e, i5(t)),
    velocity: o5(t, 0.1)
  };
}
function i5(e) {
  return e[0];
}
function zg(e) {
  return e[e.length - 1];
}
function o5(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = zg(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ xt(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = /* @__PURE__ */ kt(i.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / a,
    y: (i.y - r.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function a5(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? fe(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? fe(n, e, r.max) : Math.min(e, n)), e;
}
function Ef(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function s5(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: Ef(e.x, n, i),
    y: Ef(e.y, t, r)
  };
}
function Pf(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function l5(e, t) {
  return {
    x: Pf(e.x, t.x),
    y: Pf(e.y, t.y)
  };
}
function u5(e, t) {
  let n = 0.5;
  const r = Fe(e), i = Fe(t);
  return i > r ? n = /* @__PURE__ */ jr(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ jr(e.min, e.max - i, t.min)), jt(0, 1, n);
}
function c5(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Vs = 0.35;
function f5(e = Vs) {
  return e === !1 ? e = 0 : e === !0 && (e = Vs), {
    x: If(e, "left", "right"),
    y: If(e, "top", "bottom")
  };
}
function If(e, t, n) {
  return {
    min: Rf(e, t),
    max: Rf(e, n)
  };
}
function Rf(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const d5 = /* @__PURE__ */ new WeakMap();
class h5 {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = me(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const a = (f) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(oi(f).point);
    }, o = (f, d) => {
      const { drag: h, dragPropagation: p, onDragStart: m } = this.getProps();
      if (h && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = x6(h), !this.openDragLock))
        return;
      this.latestPointerEvent = f, this.latestPanInfo = d, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Je((g) => {
        let w = this.getAxisMotionValue(g).get() || 0;
        if (Ct.test(w)) {
          const { projection: v } = this.visualElement;
          if (v && v.layout) {
            const k = v.layout.layoutBox[g];
            k && (w = Fe(k) * (parseFloat(w) / 100));
          }
        }
        this.originPoint[g] = w;
      }), m && ce.postRender(() => m(f, d)), _s(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, s = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d;
      const { dragPropagation: h, dragDirectionLock: p, onDirectionLock: m, onDrag: y } = this.getProps();
      if (!h && !this.openDragLock)
        return;
      const { offset: g } = d;
      if (p && this.currentDirection === null) {
        this.currentDirection = p5(g), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, g), this.updateAxis("y", d.point, g), this.visualElement.render(), y && y(f, d);
    }, l = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d, this.stop(f, d), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => Je((f) => {
      var d;
      return this.getAnimationState(f) === "paused" && ((d = this.getAxisMotionValue(f).animation) == null ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new _g(t, {
      onSessionStart: a,
      onStart: o,
      onMove: s,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: r,
      contextWindow: Fg(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, i = n || this.latestPanInfo, a = this.isDragging;
    if (this.cancel(), !a || !i || !r)
      return;
    const { velocity: o } = i;
    this.startAnimation(o);
    const { onDragEnd: s } = this.getProps();
    s && ce.postRender(() => s(r, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !ki(t, i, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (o = a5(o, this.constraints[t], this.elastic[t])), a.set(o);
  }
  resolveConstraints() {
    var a;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (a = this.visualElement.projection) == null ? void 0 : a.layout, i = this.constraints;
    t && jn(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = s5(r.layoutBox, t) : this.constraints = !1, this.elastic = f5(n), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && Je((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = c5(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !jn(t))
      return !1;
    const r = t.current, { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const a = m4(r, i.root, this.visualElement.getTransformPagePoint());
    let o = l5(i.layout.layoutBox, a);
    if (n) {
      const s = n(d4(o));
      this.hasMutatedConstraints = !!s, s && (o = xg(s));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, u = Je((c) => {
      if (!ki(c, n, this.currentDirection))
        return;
      let f = l && l[c] || {};
      o && (f = { min: 0, max: 0 });
      const d = i ? 200 : 1e6, h = i ? 40 : 1e7, p = {
        type: "inertia",
        velocity: r ? t[c] : 0,
        bounceStiffness: d,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...f
      };
      return this.startAxisValueAnimation(c, p);
    });
    return Promise.all(u).then(s);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return _s(this.visualElement, t), r.start(uu(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Je((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    Je((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    Je((n) => {
      const { drag: r } = this.getProps();
      if (!ki(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, a = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: o, max: s } = i.layout.layoutBox[n];
        a.set(t[n] - fe(o, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!jn(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Je((o) => {
      const s = this.getAxisMotionValue(o);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[o] = u5({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Je((o) => {
      if (!ki(o, t, null))
        return;
      const s = this.getAxisMotionValue(o), { min: l, max: u } = this.constraints[o];
      s.set(fe(l, u, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    d5.set(this.visualElement, this);
    const t = this.visualElement.current, n = Mr(t, "pointerdown", (l) => {
      const { drag: u, dragListener: c = !0 } = this.getProps();
      u && c && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      jn(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, a = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), ce.read(r);
    const o = Gr(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", (({ delta: l, hasLayoutChanged: u }) => {
      this.isDragging && u && (Je((c) => {
        const f = this.getAxisMotionValue(c);
        f && (this.originPoint[c] += l[c].translate, f.set(f.get() + l[c].translate));
      }), this.visualElement.render());
    }));
    return () => {
      o(), n(), a(), s && s();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: a = !1, dragElastic: o = Vs, dragMomentum: s = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: s
    };
  }
}
function ki(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function p5(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class m5 extends un {
  constructor(t) {
    super(t), this.removeGroupControls = et, this.removeListeners = et, this.controls = new h5(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || et;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Mf = (e) => (t, n) => {
  e && ce.postRender(() => e(t, n));
};
class g5 extends un {
  constructor() {
    super(...arguments), this.removePointerDownListener = et;
  }
  onPointerDown(t) {
    this.session = new _g(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Fg(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: Mf(t),
      onStart: Mf(n),
      onMove: r,
      onEnd: (a, o) => {
        delete this.session, i && ce.postRender(() => i(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Mr(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Yi = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Df(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const wr = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (q.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Df(e, t.target.x), r = Df(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, y5 = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = an.parse(e);
    if (i.length > 5)
      return r;
    const a = an.createTransformer(e), o = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * t.x, l = n.y.scale * t.y;
    i[0 + o] /= s, i[1 + o] /= l;
    const u = fe(s, l, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= u), typeof i[3 + o] == "number" && (i[3 + o] /= u), a(i);
  }
};
let ma = !1;
class w5 extends V1 {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: a } = t;
    $6(v5), a && (n.group && n.group.add(a), r && r.register && i && r.register(a), ma && a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), Yi.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: a } = this.props, { projection: o } = r;
    return o && (o.isPresent = a, ma = !0, i || t.layoutDependency !== n || n === void 0 || t.isPresent !== a ? o.willUpdate() : this.safeToRemove(), t.isPresent !== a && (a ? o.promote() : o.relegate() || ce.postRender(() => {
      const s = o.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), Zl.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    ma = !0, i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Vg(e) {
  const [t, n] = sg(), r = Ce(Il);
  return b(w5, { ...e, layoutGroup: r, switchLayoutGroup: Ce(vg), isPresent: t, safeToRemove: n });
}
const v5 = {
  borderRadius: {
    ...wr,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: wr,
  borderTopRightRadius: wr,
  borderBottomLeftRadius: wr,
  borderBottomRightRadius: wr,
  boxShadow: y5
};
function b5(e, t, n) {
  const r = Re(e) ? e : tr(e);
  return r.start(uu("", r, t, n)), r.animation;
}
const x5 = (e, t) => e.depth - t.depth;
class k5 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Dl(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Ll(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(x5), this.isDirty = !1, this.children.forEach(t);
  }
}
function C5(e, t) {
  const n = $e.now(), r = ({ timestamp: i }) => {
    const a = i - n;
    a >= t && (on(r), e(a - t));
  };
  return ce.setup(r, !0), () => on(r);
}
const $g = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], S5 = $g.length, Lf = (e) => typeof e == "string" ? parseFloat(e) : e, Nf = (e) => typeof e == "number" || q.test(e);
function A5(e, t, n, r, i, a) {
  i ? (e.opacity = fe(0, n.opacity ?? 1, T5(r)), e.opacityExit = fe(t.opacity ?? 1, 0, E5(r))) : a && (e.opacity = fe(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let o = 0; o < S5; o++) {
    const s = `border${$g[o]}Radius`;
    let l = Of(t, s), u = Of(n, s);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || Nf(l) === Nf(u) ? (e[s] = Math.max(fe(Lf(l), Lf(u), r), 0), (Ct.test(u) || Ct.test(l)) && (e[s] += "%")) : e[s] = u;
  }
  (t.rotate || n.rotate) && (e.rotate = fe(t.rotate || 0, n.rotate || 0, r));
}
function Of(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const T5 = /* @__PURE__ */ jg(0, 0.5, Em), E5 = /* @__PURE__ */ jg(0.5, 0.95, et);
function jg(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ jr(e, t, r));
}
function Ff(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ze(e, t) {
  Ff(e.x, t.x), Ff(e.y, t.y);
}
function _f(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function zf(e, t, n, r, i) {
  return e -= t, e = ho(e, 1 / n, r), i !== void 0 && (e = ho(e, 1 / i, r)), e;
}
function P5(e, t = 0, n = 1, r = 0.5, i, a = e, o = e) {
  if (Ct.test(t) && (t = parseFloat(t), t = fe(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let s = fe(a.min, a.max, r);
  e === a && (s -= t), e.min = zf(e.min, t, n, s, i), e.max = zf(e.max, t, n, s, i);
}
function Vf(e, t, [n, r, i], a, o) {
  P5(e, t[n], t[r], t[i], t.scale, a, o);
}
const I5 = ["x", "scaleX", "originX"], R5 = ["y", "scaleY", "originY"];
function $f(e, t, n, r) {
  Vf(e.x, t, I5, n ? n.x : void 0, r ? r.x : void 0), Vf(e.y, t, R5, n ? n.y : void 0, r ? r.y : void 0);
}
function jf(e) {
  return e.translate === 0 && e.scale === 1;
}
function Bg(e) {
  return jf(e.x) && jf(e.y);
}
function Bf(e, t) {
  return e.min === t.min && e.max === t.max;
}
function M5(e, t) {
  return Bf(e.x, t.x) && Bf(e.y, t.y);
}
function Wf(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Wg(e, t) {
  return Wf(e.x, t.x) && Wf(e.y, t.y);
}
function Uf(e) {
  return Fe(e.x) / Fe(e.y);
}
function Hf(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class D5 {
  constructor() {
    this.members = [];
  }
  add(t) {
    Dl(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (Ll(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((i) => t === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const a = this.members[i];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: i } = t.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function L5(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, a = e.y.translate / t.y, o = (n == null ? void 0 : n.z) || 0;
  if ((i || a || o) && (r = `translate3d(${i}px, ${a}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: u, rotate: c, rotateX: f, rotateY: d, skewX: h, skewY: p } = n;
    u && (r = `perspective(${u}px) ${r}`), c && (r += `rotate(${c}deg) `), f && (r += `rotateX(${f}deg) `), d && (r += `rotateY(${d}deg) `), h && (r += `skewX(${h}deg) `), p && (r += `skewY(${p}deg) `);
  }
  const s = e.x.scale * t.x, l = e.y.scale * t.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const ga = ["", "X", "Y", "Z"], N5 = 1e3;
let O5 = 0;
function ya(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function Ug(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Ig(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: a } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", ce, !(i || a));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && Ug(r);
}
function Hg({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(o = {}, s = t == null ? void 0 : t()) {
      this.id = O5++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(z5), this.nodes.forEach(B5), this.nodes.forEach(W5), this.nodes.forEach(V5);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new k5());
    }
    addEventListener(o, s) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Fl()), this.eventHandlers.get(o).add(s);
    }
    notifyListeners(o, ...s) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...s);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = ag(o) && !E6(o), this.instance = o;
      const { layoutId: s, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || s) && (this.isLayoutDirty = !0), e) {
        let c, f = 0;
        const d = () => this.root.updateBlockedByResize = !1;
        ce.read(() => {
          f = window.innerWidth;
        }), e(o, () => {
          const h = window.innerWidth;
          h !== f && (f = h, this.root.updateBlockedByResize = !0, c && c(), c = C5(d, 250), Yi.hasAnimatedSinceResize && (Yi.hasAnimatedSinceResize = !1, this.nodes.forEach(Kf)));
        });
      }
      s && this.root.registerSharedNode(s, this), this.options.animate !== !1 && u && (s || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: f, hasRelativeLayoutChanged: d, layout: h }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || u.getDefaultTransition() || K5, { onLayoutAnimationStart: m, onLayoutAnimationComplete: y } = u.getProps(), g = !this.targetLayout || !Wg(this.targetLayout, h), w = !f && d;
        if (this.options.layoutRoot || this.resumeFrom || w || f && (g || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const v = {
            ...Yl(p, "layout"),
            onPlay: m,
            onComplete: y
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (v.delay = 0, v.type = !1), this.startAnimation(v), this.setAnimationOrigin(c, w);
        } else
          f || Kf(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = h;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), on(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(U5), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Ug(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Gf);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(qf);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(j5), this.nodes.forEach(F5), this.nodes.forEach(_5)) : this.nodes.forEach(qf), this.clearAllSnapshots();
      const s = $e.now();
      Te.delta = jt(0, 1e3 / 60, s - Te.timestamp), Te.timestamp = s, Te.isProcessing = !0, oa.update.process(Te), oa.preRender.process(Te), oa.render.process(Te), Te.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Zl.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach($5), this.sharedNodes.forEach(H5);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, ce.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      ce.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Fe(this.snapshot.measuredBox.x) && !Fe(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = me(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (s = !1), s && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !Bg(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      o && this.instance && (s || gn(this.latestValues) || c) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return o && (l = this.removeTransform(l)), Y5(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: o } = this.options;
      if (!o)
        return me();
      const s = o.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(X5))) {
        const { scroll: c } = this.root;
        c && (Bn(s.x, c.offset.x), Bn(s.y, c.offset.y));
      }
      return s;
    }
    removeElementScroll(o) {
      var l;
      const s = me();
      if (Ze(s, o), (l = this.scroll) != null && l.wasRoot)
        return s;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: f, options: d } = c;
        c !== this.root && f && d.layoutScroll && (f.wasRoot && Ze(s, o), Bn(s.x, f.offset.x), Bn(s.y, f.offset.y));
      }
      return s;
    }
    applyTransform(o, s = !1) {
      const l = me();
      Ze(l, o);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        !s && c.options.layoutScroll && c.scroll && c !== c.root && Wn(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), gn(c.latestValues) && Wn(l, c.latestValues);
      }
      return gn(this.latestValues) && Wn(l, this.latestValues), l;
    }
    removeTransform(o) {
      const s = me();
      Ze(s, o);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!u.instance || !gn(u.latestValues))
          continue;
        Ls(u.latestValues) && u.updateSnapshot();
        const c = me(), f = u.measurePageBox();
        Ze(c, f), $f(s, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, c);
      }
      return gn(this.latestValues) && $f(s, this.latestValues), s;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Te.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var d;
      const s = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = s.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = s.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = s.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== s;
      if (!(o || l && this.isSharedProjectionDirty || this.isProjectionDirty || (d = this.parent) != null && d.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: f } = this.options;
      if (!(!this.layout || !(c || f))) {
        if (this.resolvedRelativeTargetAt = Te.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = me(), this.relativeTargetOrigin = me(), Lr(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), Ze(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = me(), this.targetWithTransforms = me()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), n5(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ze(this.target, this.layout.layoutBox), Cg(this.target, this.targetDelta)) : Ze(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const h = this.getClosestProjectingParent();
          h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = me(), this.relativeTargetOrigin = me(), Lr(this.relativeTargetOrigin, this.target, h.target), Ze(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Ls(this.parent.latestValues) || kg(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var p;
      const o = this.getLead(), s = !!this.resumingFrom || this !== o;
      let l = !0;
      if ((this.isProjectionDirty || (p = this.parent) != null && p.isProjectionDirty) && (l = !1), s && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === Te.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      Ze(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, d = this.treeScale.y;
      p4(this.layoutCorrected, this.treeScale, this.path, s), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = me());
      const { target: h } = o;
      if (!h) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (_f(this.prevProjectionDelta.x, this.projectionDelta.x), _f(this.prevProjectionDelta.y, this.projectionDelta.y)), Dr(this.projectionDelta, this.layoutCorrected, h, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== d || !Hf(this.projectionDelta.x, this.prevProjectionDelta.x) || !Hf(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var s;
      if ((s = this.options.visualElement) == null || s.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Un(), this.projectionDelta = Un(), this.projectionDeltaWithTransform = Un();
    }
    setAnimationOrigin(o, s = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, f = Un();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const d = me(), h = l ? l.source : void 0, p = this.layout ? this.layout.source : void 0, m = h !== p, y = this.getStack(), g = !y || y.members.length <= 1, w = !!(m && !g && this.options.crossfade === !0 && !this.path.some(q5));
      this.animationProgress = 0;
      let v;
      this.mixTargetDelta = (k) => {
        const x = k / 1e3;
        Yf(f.x, o.x, x), Yf(f.y, o.y, x), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Lr(d, this.layout.layoutBox, this.relativeParent.layout.layoutBox), G5(this.relativeTarget, this.relativeTargetOrigin, d, x), v && M5(this.relativeTarget, v) && (this.isProjectionDirty = !1), v || (v = me()), Ze(v, this.relativeTarget)), m && (this.animationValues = c, A5(c, u, this.latestValues, x, w, g)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = x;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var s, l, u;
      this.notifyListeners("animationStart"), (s = this.currentAnimation) == null || s.stop(), (u = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || u.stop(), this.pendingAnimation && (on(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ce.update(() => {
        Yi.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = tr(0)), this.currentAnimation = b5(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (c) => {
            this.mixTargetDelta(c), o.onUpdate && o.onUpdate(c);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(N5), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: s, target: l, layout: u, latestValues: c } = o;
      if (!(!s || !l || !u)) {
        if (this !== o && this.layout && u && Gg(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || me();
          const f = Fe(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + f;
          const d = Fe(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + d;
        }
        Ze(s, l), Wn(s, c), Dr(this.projectionDeltaWithTransform, this.layoutCorrected, s, c);
      }
    }
    registerSharedNode(o, s) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new D5()), this.sharedNodes.get(o).add(s);
      const u = s.options.initialPromotionConfig;
      s.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var s;
      const { layoutId: o } = this.options;
      return o ? ((s = this.getStack()) == null ? void 0 : s.lead) || this : this;
    }
    getPrevLead() {
      var s;
      const { layoutId: o } = this.options;
      return o ? (s = this.getStack()) == null ? void 0 : s.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: s, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let s = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const u = {};
      l.z && ya("z", o, u, this.animationValues);
      for (let c = 0; c < ga.length; c++)
        ya(`rotate${ga[c]}`, o, u, this.animationValues), ya(`skew${ga[c]}`, o, u, this.animationValues);
      o.render();
      for (const c in u)
        o.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, s) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = Ki(s == null ? void 0 : s.pointerEvents) || "", o.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = Ki(s == null ? void 0 : s.pointerEvents) || ""), this.hasProjected && !gn(this.latestValues) && (o.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let f = L5(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (f = l(c, f)), o.transform = f;
      const { x: d, y: h } = this.projectionDelta;
      o.transformOrigin = `${d.origin * 100}% ${h.origin * 100}% 0`, u.animationValues ? o.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : o.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const p in Hr) {
        if (c[p] === void 0)
          continue;
        const { correct: m, applyTo: y, isCSSVariable: g } = Hr[p], w = f === "none" ? c[p] : m(c[p], u);
        if (y) {
          const v = y.length;
          for (let k = 0; k < v; k++)
            o[y[k]] = w;
        } else
          g ? this.options.visualElement.renderState.vars[p] = w : o[p] = w;
      }
      this.options.layoutId && (o.pointerEvents = u === this ? Ki(s == null ? void 0 : s.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var s;
        return (s = o.currentAnimation) == null ? void 0 : s.stop();
      }), this.root.nodes.forEach(Gf), this.root.sharedNodes.clear();
    }
  };
}
function F5(e) {
  e.updateLayout();
}
function _5(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = e.layout, { animationType: a } = e.options, o = t.source !== e.layout.source;
    a === "size" ? Je((f) => {
      const d = o ? t.measuredBox[f] : t.layoutBox[f], h = Fe(d);
      d.min = r[f].min, d.max = d.min + h;
    }) : Gg(a, t.layoutBox, r) && Je((f) => {
      const d = o ? t.measuredBox[f] : t.layoutBox[f], h = Fe(r[f]);
      d.max = d.min + h, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[f].max = e.relativeTarget[f].min + h);
    });
    const s = Un();
    Dr(s, r, t.layoutBox);
    const l = Un();
    o ? Dr(l, e.applyTransform(i, !0), t.measuredBox) : Dr(l, r, t.layoutBox);
    const u = !Bg(s);
    let c = !1;
    if (!e.resumeFrom) {
      const f = e.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: d, layout: h } = f;
        if (d && h) {
          const p = me();
          Lr(p, t.layoutBox, d.layoutBox);
          const m = me();
          Lr(m, r, h.layoutBox), Wg(p, m) || (c = !0), f.options.layoutRoot && (e.relativeTarget = m, e.relativeTargetOrigin = p, e.relativeParent = f);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: c
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function z5(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function V5(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function $5(e) {
  e.clearSnapshot();
}
function Gf(e) {
  e.clearMeasurements();
}
function qf(e) {
  e.isLayoutDirty = !1;
}
function j5(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Kf(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function B5(e) {
  e.resolveTargetDelta();
}
function W5(e) {
  e.calcProjection();
}
function U5(e) {
  e.resetSkewAndRotation();
}
function H5(e) {
  e.removeLeadSnapshot();
}
function Yf(e, t, n) {
  e.translate = fe(t.translate, 0, n), e.scale = fe(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Xf(e, t, n, r) {
  e.min = fe(t.min, n.min, r), e.max = fe(t.max, n.max, r);
}
function G5(e, t, n, r) {
  Xf(e.x, t.x, n.x, r), Xf(e.y, t.y, n.y, r);
}
function q5(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const K5 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Zf = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Jf = Zf("applewebkit/") && !Zf("chrome/") ? Math.round : et;
function Qf(e) {
  e.min = Jf(e.min), e.max = Jf(e.max);
}
function Y5(e) {
  Qf(e.x), Qf(e.y);
}
function Gg(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !t5(Uf(t), Uf(n), 0.2);
}
function X5(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const Z5 = Hg({
  attachResizeListener: (e, t) => Gr(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), wa = {
  current: void 0
}, qg = Hg({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!wa.current) {
      const e = new Z5({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), wa.current = e;
    }
    return wa.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), J5 = {
  pan: {
    Feature: g5
  },
  drag: {
    Feature: m5,
    ProjectionNode: qg,
    MeasureLayout: Vg
  }
};
function ed(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, a = r[i];
  a && ce.postRender(() => a(t, oi(t)));
}
class Q5 extends un {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = k6(t, (n, r) => (ed(this.node, r, "Start"), (i) => ed(this.node, i, "End"))));
  }
  unmount() {
  }
}
class e3 extends un {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ni(Gr(this.node.current, "focus", () => this.onFocus()), Gr(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function td(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), a = r[i];
  a && ce.postRender(() => a(t, oi(t)));
}
class t3 extends un {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = T6(t, (n, r) => (td(this.node, r, "Start"), (i, { success: a }) => td(this.node, i, a ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const $s = /* @__PURE__ */ new WeakMap(), va = /* @__PURE__ */ new WeakMap(), n3 = (e) => {
  const t = $s.get(e.target);
  t && t(e);
}, r3 = (e) => {
  e.forEach(n3);
};
function i3({ root: e, ...t }) {
  const n = e || document;
  va.has(n) || va.set(n, {});
  const r = va.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(r3, { root: e, ...t })), r[i];
}
function o3(e, t, n) {
  const r = i3(t);
  return $s.set(e, n), r.observe(e), () => {
    $s.delete(e), r.unobserve(e);
  };
}
const a3 = {
  some: 0,
  all: 1
};
class s3 extends un {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: a } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : a3[i]
    }, s = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, a && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: f } = this.node.getProps(), d = u ? c : f;
      d && d(l);
    };
    return o3(this.node.current, o, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(l3(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function l3({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const u3 = {
  inView: {
    Feature: s3
  },
  tap: {
    Feature: t3
  },
  focus: {
    Feature: e3
  },
  hover: {
    Feature: Q5
  }
}, c3 = {
  layout: {
    ProjectionNode: qg,
    MeasureLayout: Vg
  }
}, f3 = {
  ...Y4,
  ...u3,
  ...J5,
  ...c3
}, cu = /* @__PURE__ */ f4(f3, S4);
function d3(e, t, n) {
  let r = (i) => e(i, ...t);
  return n === void 0 ? r : Object.assign(r, { lazy: n, lazyArgs: t });
}
function fu(e, t, n) {
  let r = e.length - t.length;
  if (r === 0) return e(...t);
  if (r === 1) return d3(e, t, n);
  throw Error("Wrong number of arguments");
}
function nd(...e) {
  return fu(h3, e);
}
const h3 = (e, t) => e.length >= t;
function p3(...e) {
  return fu(m3, e);
}
const m3 = (e, t) => e.findIndex(t);
function rd(...e) {
  return fu(g3, e);
}
function g3(e, t) {
  if (!nd(t, 1)) return { ...e };
  if (!nd(t, 2)) {
    let { [t[0]]: r, ...i } = e;
    return i;
  }
  let n = { ...e };
  for (let r of t) delete n[r];
  return n;
}
const y3 = ({
  ref: e,
  maxHeight: t = Number.MAX_SAFE_INTEGER,
  borderWidth: n = 0,
  dependencies: r
}) => {
  const i = ge(null);
  Yr(() => {
    if (!(e != null && e.current)) return;
    const a = e.current, o = n * 2;
    i.current === null && (i.current = a.scrollHeight - o), a.style.removeProperty("height");
    const s = a.scrollHeight, l = Math.min(s, t), u = Math.max(l, i.current);
    a.style.height = `${u + o}px`;
  }, [t, e, ...r]);
}, w3 = async ({
  userId: e,
  sessionId: t,
  apiKey: n,
  displayMode: r,
  recaptchaToken: i,
  apiBaseUrl: a,
  environment: o
}) => {
  const s = {
    "Content-Type": "application/json",
    "Client-Web-Api-Key": n,
    "Recaptcha-Token": i || ""
  };
  r === "page-mobile" && (s["X-Client-Type"] = "page-mobile");
  const l = await fetch(`${a}/chat/v1/session`, {
    method: "POST",
    body: JSON.stringify({
      userId: e,
      sessionId: t,
      clientWebApiKey: n,
      environment: o
    }),
    headers: s
  });
  if (!l.ok) {
    const u = await l.json().catch(() => null);
    throw new Error(
      (u == null ? void 0 : u.message) || "Something went wrong! Please refresh or try again later."
    );
  }
  return l.json();
}, v3 = async ({
  userId: e,
  sessionId: t,
  apiKey: n,
  displayMode: r,
  message: i,
  abortSignal: a,
  recaptchaToken: o,
  onMessageChunk: s,
  apiBaseUrl: l,
  environment: u
}) => {
  const c = `${l}/chat/v1/stream`, f = {
    "Content-Type": "application/json",
    "Client-Web-Api-Key": n,
    "Recaptcha-Token": o
  };
  r === "page-mobile" && (f["X-Client-Type"] = "page-mobile");
  const d = await fetch(c, {
    method: "POST",
    body: JSON.stringify(
      Mb({
        message: i,
        userId: e,
        sessionId: t,
        clientWebApiKey: n,
        environment: u
      })
    ),
    headers: f,
    signal: a
  });
  if (!d.ok || !d.body) {
    const y = await d.json().catch(() => null);
    throw new Error(
      (y == null ? void 0 : y.message) || "Something went wrong! Please refresh or try again later."
    );
  }
  const h = d.body.getReader(), p = new TextDecoder();
  let m = "";
  for (; ; ) {
    const { done: y, value: g } = await h.read();
    if (y) break;
    const w = p.decode(g, { stream: !0 });
    m += w, s(w);
  }
  return {
    content: m
  };
}, b3 = (e) => {
  const t = e.split(`
`), n = t.pop() || "", r = [];
  for (const i of t) {
    const a = i.trim();
    if (a)
      try {
        r.push(JSON.parse(a));
      } catch {
        continue;
      }
  }
  return { parsedChunks: r, remaining: n };
}, js = 1500;
function x3() {
  const { executeRecaptcha: e } = vo(), { options: t, dialogOpenInternal: n, session: r } = ct(), {
    environment: i,
    mode: a,
    api: { key: o, baseUrl: s, userId: l }
  } = t, { sessionId: u, setSessionId: c } = r, [f, d] = oe([]), [h, p] = oe(""), [m, y] = oe(!1), [g, w] = oe(null), [v, k] = oe(!1), [x, C] = oe(null), [P, I] = oe(null), N = ge(null), E = ge(!1), L = a === "page-mobile";
  return De(() => {
    if (!n && !L) {
      E.current = !1;
      return;
    }
    if (E.current && u !== "")
      return;
    (async () => {
      k(!0);
      let V;
      if (!L)
        try {
          V = await (e == null ? void 0 : e(
            "get_or_create_chat_session"
          ));
        } catch (U) {
          console.error("get_or_create_chat_session recaptcha error: ", U);
        }
      if (!(!V && !L))
        try {
          E.current = !0;
          const U = await w3({
            userId: l,
            sessionId: u,
            apiKey: o,
            displayMode: a,
            recaptchaToken: V,
            environment: i,
            apiBaseUrl: s
          });
          c(String(U.id)), d(U.messages.map(yp));
        } catch {
          C(
            "Could not create chat session. Please refresh or try again later."
          );
        } finally {
          k(!1);
        }
    })();
  }, [
    o,
    n,
    a,
    e,
    L,
    u,
    c,
    l,
    s,
    i
  ]), {
    messages: f,
    input: h,
    handleInputChange: ($) => {
      p($.target.value), $.target.value.length > js - 1 ? I(`Max characters allowed: ${js} `) : I(null);
    },
    handleSubmit: async ($, V) => {
      var _e;
      if ((_e = $ == null ? void 0 : $.preventDefault) == null || _e.call($), C(null), w("Thinking"), !V && !h.trim())
        return;
      const U = V ?? {
        role: "user",
        content: h,
        id: `temp-user-msg-${(/* @__PURE__ */ new Date()).toISOString()}`,
        createdAt: /* @__PURE__ */ new Date(),
        liked: !1,
        disliked: !1
      };
      d((T) => [...T, U]), p(""), y(!0), N.current = new AbortController();
      let S = null;
      const ne = (T) => {
        var Xe, de;
        const { parsedChunks: Ne } = b3(T);
        for (const ke of Ne) {
          if (ke.event !== "custom_saved_chat_messages" && !((Xe = ke.chunk) != null && Xe.content) && w(ke.agent_state), ke.event === "custom_saved_chat_messages") {
            const be = Db(ke);
            w(null), be && d((pe) => {
              const Ie = p3(
                pe,
                (ht) => ht.id === S
              );
              return Ie >= 0 ? [
                ...pe.slice(0, Ie),
                be,
                ...pe.slice(Ie + 1)
              ] : pe;
            });
            break;
          }
          if (ke.agent_state !== "Complete" && ((de = ke.chunk) != null && de.content))
            if (S)
              d(
                (be) => be.map(
                  (pe) => {
                    var Ie;
                    return pe.id === S ? {
                      ...pe,
                      content: pe.content + ((Ie = ke.chunk) == null ? void 0 : Ie.content)
                    } : pe;
                  }
                )
              );
            else {
              w(null);
              const be = {
                id: `temp-assistant-msg-${(/* @__PURE__ */ new Date()).getTime()}`,
                role: "assistant",
                content: ke.chunk.content,
                createdAt: /* @__PURE__ */ new Date(),
                liked: !1,
                disliked: !1
              };
              S = be.id, d((pe) => [...pe, be]);
            }
        }
      };
      try {
        let T = "";
        if (e && !L && (T = await e("send_chat_message_stream")), !T && !L)
          return;
        await v3({
          userId: l,
          sessionId: u,
          apiKey: o,
          displayMode: a,
          message: U,
          abortSignal: N.current.signal,
          recaptchaToken: T,
          onMessageChunk: ne,
          apiBaseUrl: s,
          environment: i
        });
      } catch (T) {
        if (T instanceof Error) {
          if (T.name === "AbortError")
            return;
          C(T.message);
        } else
          C("Something went wrong. Please refresh or try again later.");
      } finally {
        y(!1), w(null);
      }
    },
    append: ($) => {
      d((V) => [
        ...V,
        {
          id: "some-temp-id",
          createdAt: /* @__PURE__ */ new Date(),
          liked: !1,
          disliked: !1,
          ...$
        }
      ]);
    },
    isLoading: m,
    isSessionLoading: v,
    error: x,
    stop: () => {
      N.current && (N.current.abort(), y(!1));
    },
    updateMessage: ($) => {
      d((V) => {
        const U = V.findIndex((S) => S.id === $.id);
        return U < 0 ? V : [
          ...V.slice(0, U),
          $,
          ...V.slice(U + 1)
        ];
      });
    },
    info: P,
    agentLoadingStatus: g
  };
}
function du({
  placeholder: e = "Ask me anything",
  className: t,
  onKeyDown: n,
  submitOnEnter: r = !0,
  stop: i,
  isGenerating: a,
  enableInterrupt: o = !0,
  ...s
}) {
  const [l, u] = oe(!1), [c, f] = oe(!1);
  De(() => {
    a || f(!1);
  }, [a]);
  const d = (k) => {
    s.allowAttachments && s.setFiles((x) => x === null ? k : k === null ? x : [...x, ...k]);
  }, h = (k) => {
    s.allowAttachments === !0 && (k.preventDefault(), u(!0));
  }, p = (k) => {
    s.allowAttachments === !0 && (k.preventDefault(), u(!1));
  }, m = (k) => {
    if (u(!1), s.allowAttachments !== !0) return;
    k.preventDefault();
    const x = k.dataTransfer;
    x.files.length && d(Array.from(x.files));
  }, y = (k) => {
    var I;
    const x = (I = k.clipboardData) == null ? void 0 : I.items;
    if (!x) return;
    const C = k.clipboardData.getData("text");
    if (C && C.length > 500 && s.allowAttachments) {
      k.preventDefault();
      const N = new Blob([C], { type: "text/plain" }), E = new File([N], "Pasted text", {
        type: "text/plain",
        lastModified: Date.now()
      });
      d([E]);
      return;
    }
    const P = Array.from(x).map((N) => N.getAsFile()).filter((N) => N !== null);
    s.allowAttachments && P.length > 0 && d(P);
  }, g = (k) => {
    var x, C, P;
    if (r && k.key === "Enter" && !k.shiftKey) {
      if (k.preventDefault(), a && i && o) {
        if (c)
          i(), f(!1), (x = k.currentTarget.form) == null || x.requestSubmit();
        else if (s.value || s.allowAttachments && ((C = s.files) != null && C.length)) {
          f(!0);
          return;
        }
      }
      (P = k.currentTarget.form) == null || P.requestSubmit();
    }
    n == null || n(k);
  }, w = ge(null), v = s.allowAttachments && s.files && s.files.length > 0;
  return y3({
    ref: w,
    maxHeight: 120,
    borderWidth: 1,
    dependencies: [s.value, v]
  }), /* @__PURE__ */ B(
    "div",
    {
      className: "wgt-relative wgt-flex wgt-w-full wgt-rounded-xl wgt-border wgt-border-input wgt-py-3 wgt-pl-3 wgt-pr-2 focus-within:wgt-border-primary",
      onDragOver: h,
      onDragLeave: p,
      onDrop: m,
      children: [
        o && /* @__PURE__ */ b(
          k3,
          {
            isOpen: c,
            close: () => f(!1)
          }
        ),
        /* @__PURE__ */ b(
          "textarea",
          {
            name: "wgt-prompt",
            "aria-label": "Write your prompt here",
            placeholder: e,
            maxLength: js,
            ref: w,
            onPaste: y,
            onKeyDown: g,
            rows: 1,
            className: te(
              "wgt-z-10 wgt-w-full wgt-grow wgt-resize-none wgt-border-none wgt-bg-background wgt-pr-12 wgt-text-base wgt-ring-offset-background wgt-transition-[border] placeholder:wgt-text-muted-foreground focus:wgt-ring-0 focus-visible:wgt-border-primary focus-visible:wgt-outline-none disabled:wgt-cursor-not-allowed disabled:wgt-opacity-50 md:wgt-text-sm",
              v && "wgt-pb-16",
              t
            ),
            ...s.allowAttachments ? rd(s, ["allowAttachments", "files", "setFiles"]) : rd(s, ["allowAttachments"])
          }
        ),
        /* @__PURE__ */ B("div", { className: "wgt-absolute wgt-right-2 wgt-top-1/2 wgt-z-20 wgt-flex -wgt-translate-y-1/2 wgt-gap-2", children: [
          s.allowAttachments && /* @__PURE__ */ b(
            ot,
            {
              type: "button",
              size: "icon",
              variant: "outline",
              className: "wgt-h-8 wgt-w-8",
              "aria-label": "Attach a file",
              onClick: async () => {
                const k = await S3();
                d(k);
              },
              children: /* @__PURE__ */ b(ve, { icon: hh, className: "wgt-h-4 wgt-w-4" })
            }
          ),
          a && i ? /* @__PURE__ */ b(
            ot,
            {
              type: "button",
              size: "icon",
              className: te(
                "wgt-h-8 wgt-w-8 wgt-rounded-full wgt-bg-brand wgt-text-brand-foreground hover:wgt-bg-brand/90"
              ),
              "aria-label": "Stop generating",
              onClick: i,
              children: /* @__PURE__ */ b(
                ve,
                {
                  icon: yx,
                  className: "wgt-h-3 wgt-w-3 wgt-animate-pulse"
                }
              )
            }
          ) : /* @__PURE__ */ b(
            ot,
            {
              type: "submit",
              size: "icon",
              variant: "brand",
              className: "wgt-h-8 wgt-w-8 wgt-rounded-full wgt-transition-opacity",
              "aria-label": "Send message",
              disabled: s.value === "" || a,
              children: /* @__PURE__ */ b(ve, { icon: DC, className: "wgt-h-8 wgt-w-8" })
            }
          )
        ] }),
        s.allowAttachments && /* @__PURE__ */ b(C3, { isDragging: l })
      ]
    }
  );
}
du.displayName = "MessageInput";
function k3({ isOpen: e, close: t }) {
  return /* @__PURE__ */ b(eu, { children: e && /* @__PURE__ */ B(
    cu.div,
    {
      initial: { top: 0, filter: "blur(5px)" },
      animate: {
        top: -40,
        filter: "blur(0px)",
        transition: {
          type: "spring",
          filter: { type: "tween" }
        }
      },
      exit: { top: 0, filter: "blur(5px)" },
      className: "wgt-absolute wgt-left-1/2 wgt-flex -wgt-translate-x-1/2 wgt-overflow-hidden wgt-whitespace-nowrap wgt-rounded-full wgt-border wgt-bg-background wgt-py-1 wgt-text-center wgt-text-sm wgt-text-muted-foreground",
      children: [
        /* @__PURE__ */ b("span", { className: "wgt-ml-2.5", children: "Press Enter again to interrupt" }),
        /* @__PURE__ */ b(
          "button",
          {
            className: "wgt-ml-1 wgt-mr-2.5 wgt-flex wgt-items-center",
            type: "button",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ b(ve, { icon: ph, className: "wgt-h-3 wgt-w-3" })
          }
        )
      ]
    }
  ) });
}
function C3({ isDragging: e }) {
  return /* @__PURE__ */ b(eu, { children: e && /* @__PURE__ */ B(
    cu.div,
    {
      className: "wgt-pointer-events-none wgt-absolute wgt-inset-0 wgt-z-20 wgt-flex wgt-items-center wgt-justify-center wgt-space-x-2 wgt-rounded-xl wgt-border wgt-border-dashed wgt-border-border wgt-bg-background wgt-text-sm wgt-text-muted-foreground",
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 0.2 },
      "aria-hidden": !0,
      children: [
        /* @__PURE__ */ b(ve, { icon: hh, className: "wgt-h-4 wgt-w-4" }),
        /* @__PURE__ */ b("span", { children: "Drop your files here to attach them." })
      ]
    }
  ) });
}
function S3() {
  const e = document.createElement("input");
  return e.type = "file", e.multiple = !0, e.accept = "*/*", e.click(), new Promise((t) => {
    e.onchange = (n) => {
      const r = n.currentTarget.files;
      if (r) {
        t(Array.from(r));
        return;
      }
      t(null);
    };
  });
}
const rr = ({ className: e }) => /* @__PURE__ */ b(
  "svg",
  {
    id: "ag-logo",
    className: te("wgt-h-4 wgt-w-4", e),
    viewBox: "0 0 80 55",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ b(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M79.8874 32.2984C79.1852 29.7547 78.0617 27.7288 76.6134 25.8574C74.8228 23.5317 72.5758 21.8964 69.9689 20.7427C67.4761 19.6434 64.8604 19.2165 62.1745 19.4436C58.8566 19.7252 55.8372 20.9153 53.1776 23.0229C49.5174 25.9391 47.3055 29.7365 46.656 34.4787C46.6121 34.8149 46.4804 34.9057 46.1995 34.9057H35.1399C34.7311 34.9057 34.6955 34.7089 34.6421 34.4132C34.6358 34.3788 34.6294 34.3431 34.6221 34.3061C34.0428 31.3082 32.928 28.5283 31.0496 26.1663C28.5042 22.9594 25.318 20.7609 21.3506 19.8433C17.5762 18.9712 13.9775 19.4163 10.4928 21.1333C6.07778 23.3137 3.18123 26.8385 1.58373 31.5626C1.52229 31.7533 1.43451 31.8805 1.24141 31.9986C0.872755 31.1265 0.530434 30.2544 0.530434 29.2914C0.530434 28.1975 0.522826 27.1035 0.515217 26.0096C0.498309 23.5787 0.481401 21.1477 0.547989 18.7168C0.635764 15.6643 2.47025 13.6475 5.27026 13.0843C6.90952 12.7515 8.54877 12.4277 10.1872 12.1041L10.1873 12.1041L10.1876 12.104C12.2162 11.7033 14.2437 11.3029 16.2684 10.8858C17.4446 10.6405 18.3925 9.91373 19.2527 9.07794C23.5976 4.83539 28.6534 2.02822 34.5606 0.847207C37.1412 0.329379 39.7218 0.0750076 42.3199 0.247617C48.4904 0.665513 54.1343 2.70048 59.1199 6.51606C59.994 7.18501 60.812 7.94332 61.6283 8.70013L61.6283 8.70015C61.9761 9.0225 62.3235 9.34458 62.6748 9.65936C63.9677 10.8211 65.5999 11.0902 67.2223 11.3577C67.6044 11.4207 67.9861 11.4836 68.3626 11.5581C69.173 11.7172 69.9857 11.8651 70.7982 12.013L70.7983 12.013L70.7984 12.013C72.7227 12.3632 74.6459 12.7133 76.5344 13.2115C79.3344 13.9473 80.7037 16.0913 80.7651 19.0529C80.801 20.8335 80.795 22.614 80.789 24.3945C80.7848 25.6665 80.7805 26.9384 80.7915 28.2103C80.809 29.5548 80.5808 30.8176 79.8962 32.2893L79.8874 32.2984ZM75.0774 37.0043C75.1388 43.7724 69.9426 49.1323 63.4999 49.0142C56.8115 48.887 52.0453 44.0358 51.9664 36.9497C51.8874 30.7358 56.5921 24.4674 64.641 25.076C69.8987 25.4667 75.2266 30.2907 75.0774 37.0043ZM29.2855 37.0043C29.3996 30.7994 24.7914 24.8399 17.6554 25.0852L17.6466 25.0761C11.239 24.7036 6.43777 30.6995 6.15689 36.1049C5.76191 43.6543 11.3883 49.0688 17.6202 49.0052C24.0453 48.9416 29.1538 44.4083 29.2855 37.0043Z"
      }
    )
  }
), hu = ({ className: e, svgClassName: t }) => /* @__PURE__ */ B(
  "div",
  {
    className: te(
      "wgt-flex wgt-items-center wgt-justify-center wgt-space-x-2",
      e
    ),
    children: [
      /* @__PURE__ */ b("div", { className: "wgt-text-xs", children: "Provided by" }),
      /* @__PURE__ */ b("a", { href: "https://www.autograb.com.au", target: "_blank", children: /* @__PURE__ */ B(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "99",
          height: "14",
          viewBox: "0 0 99 14",
          fill: "none",
          className: t,
          children: [
            /* @__PURE__ */ b(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.7522 9.05949C22.554 8.34169 22.237 7.77001 21.8283 7.24191C21.323 6.58564 20.6889 6.12419 19.9533 5.79862C19.2499 5.48842 18.5118 5.36793 17.7538 5.43202C16.8176 5.5115 15.9655 5.84732 15.215 6.44208C14.1822 7.26499 13.558 8.33656 13.3747 9.67475C13.3623 9.76961 13.3252 9.79524 13.2459 9.79524H10.125C10.0097 9.79524 9.99963 9.7397 9.98455 9.65626C9.98279 9.64655 9.98097 9.63647 9.9789 9.62605C9.81543 8.78006 9.50086 7.99561 8.97081 7.32908C8.25252 6.42413 7.35341 5.80374 6.23385 5.54482C5.16879 5.29872 4.15327 5.42433 3.16995 5.90885C1.92408 6.52411 1.1067 7.51878 0.655912 8.85184C0.638574 8.90568 0.613805 8.94157 0.559313 8.9749C0.455284 8.72879 0.358686 8.48269 0.358686 8.21095C0.358686 7.90226 0.356539 7.59357 0.354392 7.28488C0.349621 6.5989 0.344849 5.91292 0.36364 5.22694C0.388408 4.36557 0.906077 3.79646 1.6962 3.63752C2.15879 3.54359 2.62137 3.45223 3.08374 3.36091C3.65622 3.24784 4.22836 3.13484 4.79974 3.01713C5.13164 2.94791 5.39914 2.74283 5.64188 2.50698C6.86794 1.30978 8.29462 0.517635 9.96157 0.184369C10.6898 0.0382452 11.418 -0.0335351 12.1511 0.0151729C13.8924 0.133098 15.485 0.70734 16.8919 1.78405C17.1385 1.97281 17.3693 2.18679 17.5997 2.40035L17.5997 2.40036L17.5998 2.40041C17.6979 2.49136 17.7959 2.58223 17.895 2.67105C18.2599 2.99887 18.7204 3.0748 19.1783 3.15028C19.2861 3.16806 19.3938 3.18582 19.5 3.20683C19.7287 3.25174 19.9581 3.29348 20.1874 3.33521C20.7304 3.43404 21.2731 3.53281 21.806 3.67341C22.5961 3.88106 22.9825 4.48606 22.9999 5.32179C23.01 5.82425 23.0083 6.32672 23.0066 6.82918C23.0054 7.18808 23.0042 7.54698 23.0073 7.90588C23.0123 8.28529 22.9479 8.64163 22.7547 9.05693L22.7522 9.05949ZM21.522 10.329C21.5397 12.2058 20.0448 13.6921 18.1913 13.6593C16.2671 13.6241 14.8959 12.2788 14.8732 10.3138C14.8505 8.59072 16.204 6.85247 18.5196 7.02126C20.0322 7.12958 21.565 8.46727 21.522 10.329ZM8.59021 10.3339C8.62299 8.61079 7.29928 6.95578 5.24942 7.0239L5.2469 7.02138C3.40632 6.91794 2.02714 8.58304 1.94646 10.0841C1.833 12.1807 3.44918 13.6843 5.23934 13.6666C7.08497 13.649 8.55239 12.3901 8.59021 10.3339Z",
                fill: "currentColor"
              }
            ),
            /* @__PURE__ */ b(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M68.528 1.40002C67.337 1.40002 66.296 1.6575 65.4052 2.17247L65.4066 2.16834C64.5157 2.6833 63.8314 3.40617 63.3508 4.33696C62.8703 5.26775 62.6307 6.35826 62.6307 7.57269C62.6307 8.78712 62.8731 9.86248 63.3591 10.7988C63.8451 11.7351 64.5212 12.4607 65.3887 12.9757C66.2561 13.4906 67.2502 13.7481 68.3724 13.7481C69.2523 13.7481 70.0123 13.5691 70.6539 13.2111C71.2956 12.8531 71.7899 12.4194 72.1369 11.9099V13.6448H73.8539V7.00127H68.5803V8.68385H71.9455V8.97851C71.9 9.92582 71.5489 10.6666 70.8963 11.1981C70.2436 11.7309 69.4299 11.9967 68.4592 11.9967C67.6964 11.9967 67.0285 11.8094 66.4558 11.4335C65.883 11.0576 65.4437 10.5372 65.1367 9.87212C64.8296 9.20707 64.6768 8.44152 64.6768 7.57407C64.6768 6.70662 64.8324 5.94106 65.1449 5.27601C65.4575 4.61097 65.8995 4.0905 66.4723 3.7146C67.0451 3.33871 67.7129 3.15145 68.4757 3.15145C69.3087 3.15145 70.0109 3.37175 70.5837 3.81099C71.1565 4.25022 71.5407 4.85743 71.7376 5.63263H73.7148C73.5055 4.33834 72.9396 3.30841 72.0143 2.54561C71.089 1.78143 69.9269 1.40002 68.528 1.40002ZM33.2682 1.50467H33.1773V1.50329C32.4903 1.50329 31.8762 1.93013 31.6352 2.57314L27.4907 13.6462H29.5547L30.6824 10.6459H35.6613L36.8069 13.6462H38.9397L34.8117 2.5759C34.5708 1.93151 33.9553 1.50467 33.2682 1.50467ZM33.1636 3.65402L35.1064 8.94409H31.2387L33.1636 3.65402ZM45.2762 13.6476H47.1323L47.1351 13.6462V4.76517H45.2611V9.17127C45.2611 10.0842 45.0587 10.8043 44.6539 11.3303C44.2491 11.8562 43.6887 12.1192 42.9713 12.1192C42.2897 12.1192 41.7748 11.8934 41.4278 11.4432C41.0808 10.9929 40.9073 10.3334 40.9073 9.46592V4.76517H39.0334V9.65731C39.0334 11.092 39.3569 12.1316 40.0041 12.7801C40.6512 13.4287 41.4953 13.7522 42.5362 13.7522C43.6928 13.7522 44.6057 13.3405 45.2762 12.5199V13.6476ZM75.2018 13.6476V7.17751C75.2018 6.35687 75.396 5.74966 75.7829 5.35587C76.1698 4.96207 76.7866 4.76655 77.6307 4.76655H79.4344V6.4147H78.0121C77.6761 6.4147 77.4393 6.4863 77.3016 6.63088C77.1625 6.77545 77.0937 7.02192 77.0937 7.36752V13.6476H75.2032H75.2018ZM48.4445 2.28674V4.76655H48.4431V11.2366C48.4431 12.0586 48.6372 12.6645 49.0242 13.0583C49.4124 13.4507 50.0279 13.6476 50.872 13.6476H52.6757V11.9994H51.2534C50.9188 11.9994 50.6819 11.9278 50.5429 11.7833C50.4038 11.6387 50.335 11.3936 50.335 11.0466V6.4147H52.4678V4.76655H50.335V2.28674H48.4445ZM53.4399 11.5919C53.064 10.9034 52.8767 10.1089 52.8767 9.20707C52.8767 8.30519 53.064 7.52724 53.4399 6.83879C53.8158 6.15034 54.3472 5.6161 55.0357 5.2347C55.7241 4.85329 56.5131 4.6619 57.404 4.6619C58.2948 4.6619 59.0838 4.85329 59.7722 5.2347C60.4607 5.6161 60.9922 6.15172 61.3681 6.83879C61.744 7.52724 61.9312 8.31621 61.9312 9.20707C61.9312 10.0979 61.744 10.9048 61.3681 11.5919C60.9922 12.2803 60.4607 12.8118 59.7722 13.1877C59.0838 13.5636 58.2948 13.7522 57.404 13.7522C56.5131 13.7522 55.7241 13.565 55.0357 13.1877C54.3472 12.8118 53.8158 12.2803 53.4399 11.5919ZM60.0228 9.20707C60.0228 8.33962 59.7833 7.63189 59.3027 7.0825C58.8222 6.53312 58.1902 6.25912 57.404 6.25912C56.6178 6.25912 55.9871 6.53312 55.5135 7.0825C55.0398 7.63189 54.803 8.33962 54.803 9.20707C54.803 10.0745 55.0398 10.7822 55.5135 11.3316C55.9871 11.881 56.6178 12.155 57.404 12.155C58.1902 12.155 58.8236 11.881 59.3027 11.3316C59.7833 10.7822 60.0228 10.0745 60.0228 9.20707ZM88.4505 13.6476H88.4491V12.0215H88.0856C87.6932 12.0215 87.4963 11.8122 87.4963 11.3963V7.89213C87.4963 6.85119 87.1727 6.05258 86.5256 5.49769C85.8785 4.9428 84.9587 4.66466 83.7677 4.66466C82.6455 4.66466 81.7381 4.90975 81.0441 5.4013C80.3502 5.89148 79.9564 6.58269 79.8641 7.47355H81.7023C81.7725 7.07975 81.9832 6.76444 82.3357 6.52761C82.6882 6.29078 83.1357 6.17237 83.6795 6.17237C84.2923 6.17237 84.7728 6.31419 85.1198 6.59783C85.4668 6.8801 85.6403 7.27114 85.6403 7.7682V8.30657H83.4028C82.1649 8.30657 81.2218 8.55166 80.5746 9.04322C79.9275 9.53477 79.6039 10.237 79.6039 11.1513C79.6039 11.9609 79.9041 12.597 80.5058 13.0597C81.1075 13.5223 81.9061 13.7536 82.9002 13.7536C84.1835 13.7536 85.1611 13.2442 85.8316 12.2266C85.8316 12.6879 85.9583 13.0417 86.213 13.2841C86.4678 13.5264 86.8836 13.6476 87.4619 13.6476H88.4491V13.6517L88.4505 13.6476ZM83.316 9.69312C82.7377 9.69312 82.293 9.80602 81.9804 10.0318C81.6679 10.2576 81.5123 10.5895 81.5123 11.0287C81.5123 11.4101 81.6596 11.7172 81.9543 11.9485C82.2489 12.1798 82.651 12.2955 83.1604 12.2955C83.9356 12.2955 84.5401 12.0876 84.9725 11.6704C85.4062 11.2545 85.6292 10.6996 85.6403 10.0057V9.69312H83.316ZM98.075 9.20707C98.075 8.2694 97.8947 7.45978 97.5367 6.77821C97.1787 6.09665 96.6816 5.57205 96.0455 5.20854C95.4094 4.84366 94.6865 4.66191 93.8769 4.66191C92.6624 4.66191 91.7027 5.13557 90.9978 6.08425V1.50467H89.1238V13.6476H90.9799V12.3643C91.2814 12.7925 91.6738 13.1299 92.1599 13.3791C92.6459 13.6283 93.2173 13.7522 93.8769 13.7522C94.6865 13.7522 95.4094 13.5608 96.0455 13.1794C96.6802 12.798 97.1787 12.2638 97.5367 11.5754C97.896 10.8869 98.075 10.1447 98.075 9.20707ZM95.4465 7.08251C95.9271 7.6319 96.1666 8.33962 96.1666 9.20707V9.20845C96.1666 10.0869 95.9271 10.8015 95.4465 11.3509C94.966 11.9003 94.3395 12.1743 93.5643 12.1743C92.7891 12.1743 92.164 11.8962 91.6903 11.3413C91.2167 10.7864 90.9799 10.058 90.9799 9.19055C90.9799 8.3231 91.2167 7.61813 91.6903 7.07425C92.1654 6.53037 92.7891 6.25912 93.5643 6.25912C94.3395 6.25912 94.966 6.53312 95.4465 7.08251Z",
                className: "wgt-fill-muted-foreground"
              }
            )
          ]
        }
      ) })
    ]
  }
);
var ba = "focusScope.autoFocusOnMount", xa = "focusScope.autoFocusOnUnmount", id = { bubbles: !1, cancelable: !0 }, A3 = "FocusScope", Kg = A.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...o
  } = e, [s, l] = A.useState(null), u = Jn(i), c = Jn(a), f = A.useRef(null), d = ft(t, (m) => l(m)), h = A.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  A.useEffect(() => {
    if (r) {
      let m = function(v) {
        if (h.paused || !s) return;
        const k = v.target;
        s.contains(k) ? f.current = k : Yt(f.current, { select: !0 });
      }, y = function(v) {
        if (h.paused || !s) return;
        const k = v.relatedTarget;
        k !== null && (s.contains(k) || Yt(f.current, { select: !0 }));
      }, g = function(v) {
        if (document.activeElement === document.body)
          for (const x of v)
            x.removedNodes.length > 0 && Yt(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", y);
      const w = new MutationObserver(g);
      return s && w.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", y), w.disconnect();
      };
    }
  }, [r, s, h.paused]), A.useEffect(() => {
    if (s) {
      ad.add(h);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const g = new CustomEvent(ba, id);
        s.addEventListener(ba, u), s.dispatchEvent(g), g.defaultPrevented || (T3(M3(Yg(s)), { select: !0 }), document.activeElement === m && Yt(s));
      }
      return () => {
        s.removeEventListener(ba, u), setTimeout(() => {
          const g = new CustomEvent(xa, id);
          s.addEventListener(xa, c), s.dispatchEvent(g), g.defaultPrevented || Yt(m ?? document.body, { select: !0 }), s.removeEventListener(xa, c), ad.remove(h);
        }, 0);
      };
    }
  }, [s, u, c, h]);
  const p = A.useCallback(
    (m) => {
      if (!n && !r || h.paused) return;
      const y = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, g = document.activeElement;
      if (y && g) {
        const w = m.currentTarget, [v, k] = E3(w);
        v && k ? !m.shiftKey && g === k ? (m.preventDefault(), n && Yt(v, { select: !0 })) : m.shiftKey && g === v && (m.preventDefault(), n && Yt(k, { select: !0 })) : g === w && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ b(je.div, { tabIndex: -1, ...o, ref: d, onKeyDown: p });
});
Kg.displayName = A3;
function T3(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Yt(r, { select: t }), document.activeElement !== n) return;
}
function E3(e) {
  const t = Yg(e), n = od(t, e), r = od(t.reverse(), e);
  return [n, r];
}
function Yg(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function od(e, t) {
  for (const n of e)
    if (!P3(n, { upTo: t })) return n;
}
function P3(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function I3(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Yt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && I3(e) && t && e.select();
  }
}
var ad = R3();
function R3() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = sd(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = sd(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function sd(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function M3(e) {
  return e.filter((t) => t.tagName !== "A");
}
var ka = 0;
function D3() {
  A.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? ld()), document.body.insertAdjacentElement("beforeend", e[1] ?? ld()), ka++, () => {
      ka === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ka--;
    };
  }, []);
}
function ld() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var mt = function() {
  return mt = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, mt.apply(this, arguments);
};
function Xg(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function L3(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Xi = "right-scroll-bar-position", Zi = "width-before-scroll-bar", N3 = "with-scroll-bars-hidden", O3 = "--removed-body-scroll-bar-size";
function Ca(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function F3(e, t) {
  var n = oe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var _3 = typeof window < "u" ? A.useLayoutEffect : A.useEffect, ud = /* @__PURE__ */ new WeakMap();
function z3(e, t) {
  var n = F3(null, function(r) {
    return e.forEach(function(i) {
      return Ca(i, r);
    });
  });
  return _3(function() {
    var r = ud.get(n);
    if (r) {
      var i = new Set(r), a = new Set(e), o = n.current;
      i.forEach(function(s) {
        a.has(s) || Ca(s, null);
      }), a.forEach(function(s) {
        i.has(s) || Ca(s, o);
      });
    }
    ud.set(n, e);
  }, [e]), n;
}
function V3(e) {
  return e;
}
function $3(e, t) {
  t === void 0 && (t = V3);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var o = t(a, r);
      return n.push(o), function() {
        n = n.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var o = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), o = n;
      }
      var l = function() {
        var c = o;
        o = [], c.forEach(a);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(c) {
          o.push(c), u();
        },
        filter: function(c) {
          return o = o.filter(c), n;
        }
      };
    }
  };
  return i;
}
function j3(e) {
  e === void 0 && (e = {});
  var t = $3(null);
  return t.options = mt({ async: !0, ssr: !1 }, e), t;
}
var Zg = function(e) {
  var t = e.sideCar, n = Xg(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return A.createElement(r, mt({}, n));
};
Zg.isSideCarExport = !0;
function B3(e, t) {
  return e.useMedium(t), Zg;
}
var Jg = j3(), Sa = function() {
}, Vo = A.forwardRef(function(e, t) {
  var n = A.useRef(null), r = A.useState({
    onScrollCapture: Sa,
    onWheelCapture: Sa,
    onTouchMoveCapture: Sa
  }), i = r[0], a = r[1], o = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, d = e.sideCar, h = e.noRelative, p = e.noIsolation, m = e.inert, y = e.allowPinchZoom, g = e.as, w = g === void 0 ? "div" : g, v = e.gapMode, k = Xg(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = d, C = z3([n, t]), P = mt(mt({}, k), i);
  return A.createElement(
    A.Fragment,
    null,
    c && A.createElement(x, { sideCar: Jg, removeScrollBar: u, shards: f, noRelative: h, noIsolation: p, inert: m, setCallbacks: a, allowPinchZoom: !!y, lockRef: n, gapMode: v }),
    o ? A.cloneElement(A.Children.only(s), mt(mt({}, P), { ref: C })) : A.createElement(w, mt({}, P, { className: l, ref: C }), s)
  );
});
Vo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Vo.classNames = {
  fullWidth: Zi,
  zeroRight: Xi
};
var W3 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function U3() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = W3();
  return t && e.setAttribute("nonce", t), e;
}
function H3(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function G3(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var q3 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = U3()) && (H3(t, n), G3(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, K3 = function() {
  var e = q3();
  return function(t, n) {
    A.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Qg = function() {
  var e = K3(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, Y3 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Aa = function(e) {
  return parseInt(e || "", 10) || 0;
}, X3 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Aa(n), Aa(r), Aa(i)];
}, Z3 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Y3;
  var t = X3(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, J3 = Qg(), Yn = "data-scroll-locked", Q3 = function(e, t, n, r) {
  var i = e.left, a = e.top, o = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(N3, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Yn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Xi, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Zi, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Xi, " .").concat(Xi, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Zi, " .").concat(Zi, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Yn, `] {
    `).concat(O3, ": ").concat(s, `px;
  }
`);
}, cd = function() {
  var e = parseInt(document.body.getAttribute(Yn) || "0", 10);
  return isFinite(e) ? e : 0;
}, eA = function() {
  A.useEffect(function() {
    return document.body.setAttribute(Yn, (cd() + 1).toString()), function() {
      var e = cd() - 1;
      e <= 0 ? document.body.removeAttribute(Yn) : document.body.setAttribute(Yn, e.toString());
    };
  }, []);
}, tA = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  eA();
  var a = A.useMemo(function() {
    return Z3(i);
  }, [i]);
  return A.createElement(J3, { styles: Q3(a, !t, i, n ? "" : "!important") });
}, Bs = !1;
if (typeof window < "u")
  try {
    var Ci = Object.defineProperty({}, "passive", {
      get: function() {
        return Bs = !0, !0;
      }
    });
    window.addEventListener("test", Ci, Ci), window.removeEventListener("test", Ci, Ci);
  } catch {
    Bs = !1;
  }
var Ln = Bs ? { passive: !1 } : !1, nA = function(e) {
  return e.tagName === "TEXTAREA";
}, ey = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !nA(e) && n[t] === "visible")
  );
}, rA = function(e) {
  return ey(e, "overflowY");
}, iA = function(e) {
  return ey(e, "overflowX");
}, fd = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = ty(e, r);
    if (i) {
      var a = ny(e, r), o = a[1], s = a[2];
      if (o > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, oA = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, aA = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ty = function(e, t) {
  return e === "v" ? rA(t) : iA(t);
}, ny = function(e, t) {
  return e === "v" ? oA(t) : aA(t);
}, sA = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, lA = function(e, t, n, r, i) {
  var a = sA(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, l = t.contains(s), u = !1, c = o > 0, f = 0, d = 0;
  do {
    if (!s)
      break;
    var h = ny(e, s), p = h[0], m = h[1], y = h[2], g = m - y - a * p;
    (p || g) && ty(e, s) && (f += g, d += p);
    var w = s.parentNode;
    s = w && w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? w.host : w;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && Math.abs(f) < 1 || !c && Math.abs(d) < 1) && (u = !0), u;
}, Si = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, dd = function(e) {
  return [e.deltaX, e.deltaY];
}, hd = function(e) {
  return e && "current" in e ? e.current : e;
}, uA = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, cA = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, fA = 0, Nn = [];
function dA(e) {
  var t = A.useRef([]), n = A.useRef([0, 0]), r = A.useRef(), i = A.useState(fA++)[0], a = A.useState(Qg)[0], o = A.useRef(e);
  A.useEffect(function() {
    o.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = L3([e.lockRef.current], (e.shards || []).map(hd), !0).filter(Boolean);
      return m.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = A.useCallback(function(m, y) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !o.current.allowPinchZoom;
    var g = Si(m), w = n.current, v = "deltaX" in m ? m.deltaX : w[0] - g[0], k = "deltaY" in m ? m.deltaY : w[1] - g[1], x, C = m.target, P = Math.abs(v) > Math.abs(k) ? "h" : "v";
    if ("touches" in m && P === "h" && C.type === "range")
      return !1;
    var I = fd(P, C);
    if (!I)
      return !0;
    if (I ? x = P : (x = P === "v" ? "h" : "v", I = fd(P, C)), !I)
      return !1;
    if (!r.current && "changedTouches" in m && (v || k) && (r.current = x), !x)
      return !0;
    var N = r.current || x;
    return lA(N, y, m, N === "h" ? v : k);
  }, []), l = A.useCallback(function(m) {
    var y = m;
    if (!(!Nn.length || Nn[Nn.length - 1] !== a)) {
      var g = "deltaY" in y ? dd(y) : Si(y), w = t.current.filter(function(x) {
        return x.name === y.type && (x.target === y.target || y.target === x.shadowParent) && uA(x.delta, g);
      })[0];
      if (w && w.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!w) {
        var v = (o.current.shards || []).map(hd).filter(Boolean).filter(function(x) {
          return x.contains(y.target);
        }), k = v.length > 0 ? s(y, v[0]) : !o.current.noIsolation;
        k && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = A.useCallback(function(m, y, g, w) {
    var v = { name: m, delta: y, target: g, should: w, shadowParent: hA(g) };
    t.current.push(v), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== v;
      });
    }, 1);
  }, []), c = A.useCallback(function(m) {
    n.current = Si(m), r.current = void 0;
  }, []), f = A.useCallback(function(m) {
    u(m.type, dd(m), m.target, s(m, e.lockRef.current));
  }, []), d = A.useCallback(function(m) {
    u(m.type, Si(m), m.target, s(m, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return Nn.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", l, Ln), document.addEventListener("touchmove", l, Ln), document.addEventListener("touchstart", c, Ln), function() {
      Nn = Nn.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", l, Ln), document.removeEventListener("touchmove", l, Ln), document.removeEventListener("touchstart", c, Ln);
    };
  }, []);
  var h = e.removeScrollBar, p = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    p ? A.createElement(a, { styles: cA(i) }) : null,
    h ? A.createElement(tA, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function hA(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const pA = B3(Jg, dA);
var ry = A.forwardRef(function(e, t) {
  return A.createElement(Vo, mt({}, e, { ref: t, sideCar: pA }));
});
ry.classNames = Vo.classNames;
var mA = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, On = /* @__PURE__ */ new WeakMap(), Ai = /* @__PURE__ */ new WeakMap(), Ti = {}, Ta = 0, iy = function(e) {
  return e && (e.host || iy(e.parentNode));
}, gA = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = iy(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, yA = function(e, t, n, r) {
  var i = gA(t, Array.isArray(e) ? e : [e]);
  Ti[n] || (Ti[n] = /* @__PURE__ */ new WeakMap());
  var a = Ti[n], o = [], s = /* @__PURE__ */ new Set(), l = new Set(i), u = function(f) {
    !f || s.has(f) || (s.add(f), u(f.parentNode));
  };
  i.forEach(u);
  var c = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(d) {
      if (s.has(d))
        c(d);
      else
        try {
          var h = d.getAttribute(r), p = h !== null && h !== "false", m = (On.get(d) || 0) + 1, y = (a.get(d) || 0) + 1;
          On.set(d, m), a.set(d, y), o.push(d), m === 1 && p && Ai.set(d, !0), y === 1 && d.setAttribute(n, "true"), p || d.setAttribute(r, "true");
        } catch (g) {
          console.error("aria-hidden: cannot operate on ", d, g);
        }
    });
  };
  return c(t), s.clear(), Ta++, function() {
    o.forEach(function(f) {
      var d = On.get(f) - 1, h = a.get(f) - 1;
      On.set(f, d), a.set(f, h), d || (Ai.has(f) || f.removeAttribute(r), Ai.delete(f)), h || f.removeAttribute(n);
    }), Ta--, Ta || (On = /* @__PURE__ */ new WeakMap(), On = /* @__PURE__ */ new WeakMap(), Ai = /* @__PURE__ */ new WeakMap(), Ti = {});
  };
}, wA = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = mA(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), yA(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, $o = "Dialog", [oy, UI] = wl($o), [vA, dt] = oy($o), ay = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: o = !0
  } = e, s = A.useRef(null), l = A.useRef(null), [u, c] = am({
    prop: r,
    defaultProp: i ?? !1,
    onChange: a,
    caller: $o
  });
  return /* @__PURE__ */ b(
    vA,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Ui(),
      titleId: Ui(),
      descriptionId: Ui(),
      open: u,
      onOpenChange: c,
      onOpenToggle: A.useCallback(() => c((f) => !f), [c]),
      modal: o,
      children: n
    }
  );
};
ay.displayName = $o;
var sy = "DialogTrigger", bA = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = dt(sy, n), a = ft(t, i.triggerRef);
    return /* @__PURE__ */ b(
      je.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": gu(i.open),
        ...r,
        ref: a,
        onClick: Ve(e.onClick, i.onOpenToggle)
      }
    );
  }
);
bA.displayName = sy;
var pu = "DialogPortal", [xA, ly] = oy(pu, {
  forceMount: void 0
}), uy = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = dt(pu, t);
  return /* @__PURE__ */ b(xA, { scope: t, forceMount: n, children: A.Children.map(r, (o) => /* @__PURE__ */ b(ti, { present: n || a.open, children: /* @__PURE__ */ b(om, { asChild: !0, container: i, children: o }) })) });
};
uy.displayName = pu;
var po = "DialogOverlay", cy = A.forwardRef(
  (e, t) => {
    const n = ly(po, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = dt(po, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ b(ti, { present: r || a.open, children: /* @__PURE__ */ b(CA, { ...i, ref: t }) }) : null;
  }
);
cy.displayName = po;
var kA = /* @__PURE__ */ yl("DialogOverlay.RemoveScroll"), CA = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = dt(po, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ b(ry, { as: kA, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ b(
        je.div,
        {
          "data-state": gu(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Tn = "DialogContent", fy = A.forwardRef(
  (e, t) => {
    const n = ly(Tn, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = dt(Tn, e.__scopeDialog);
    return /* @__PURE__ */ b(ti, { present: r || a.open, children: a.modal ? /* @__PURE__ */ b(SA, { ...i, ref: t }) : /* @__PURE__ */ b(AA, { ...i, ref: t }) });
  }
);
fy.displayName = Tn;
var SA = A.forwardRef(
  (e, t) => {
    const n = dt(Tn, e.__scopeDialog), r = A.useRef(null), i = ft(t, n.contentRef, r);
    return A.useEffect(() => {
      const a = r.current;
      if (a) return wA(a);
    }, []), /* @__PURE__ */ b(
      dy,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ve(e.onCloseAutoFocus, (a) => {
          var o;
          a.preventDefault(), (o = n.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: Ve(e.onPointerDownOutside, (a) => {
          const o = a.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: Ve(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), AA = A.forwardRef(
  (e, t) => {
    const n = dt(Tn, e.__scopeDialog), r = A.useRef(!1), i = A.useRef(!1);
    return /* @__PURE__ */ b(
      dy,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var o, s;
          (o = e.onCloseAutoFocus) == null || o.call(e, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const o = a.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(o)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), dy = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, s = dt(Tn, n), l = A.useRef(null), u = ft(t, l);
    return D3(), /* @__PURE__ */ B(tt, { children: [
      /* @__PURE__ */ b(
        Kg,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ b(
            vl,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": gu(s.open),
              ...o,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ B(tt, { children: [
        /* @__PURE__ */ b(PA, { titleId: s.titleId }),
        /* @__PURE__ */ b(RA, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), mu = "DialogTitle", hy = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = dt(mu, n);
    return /* @__PURE__ */ b(je.h2, { id: i.titleId, ...r, ref: t });
  }
);
hy.displayName = mu;
var py = "DialogDescription", TA = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = dt(py, n);
    return /* @__PURE__ */ b(je.p, { id: i.descriptionId, ...r, ref: t });
  }
);
TA.displayName = py;
var my = "DialogClose", EA = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = dt(my, n);
    return /* @__PURE__ */ b(
      je.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Ve(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
EA.displayName = my;
function gu(e) {
  return e ? "open" : "closed";
}
var gy = "DialogTitleWarning", [HI, yy] = y2(gy, {
  contentName: Tn,
  titleName: mu,
  docsSlug: "dialog"
}), PA = ({ titleId: e }) => {
  const t = yy(gy), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return A.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, IA = "DialogDescriptionWarning", RA = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${yy(IA).contentName}}.`;
  return A.useEffect(() => {
    var a;
    const i = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, MA = ay, wy = cy, vy = fy, by = hy;
const DA = Eo(
  "wgt-fixed wgt-z-[50] wgt-grid wgt-w-full wgt-gap-4 wgt-shadow-lg wgt-duration-200 data-[state=open]:wgt-animate-in data-[state=closed]:wgt-animate-out data-[state=closed]:wgt-fade-out-0 data-[state=open]:wgt-fade-in-0 sm:wgt-rounded-xl",
  {
    variants: {
      variant: {
        default: "wgt-border wgt-border-neutral-500 wgt-bg-background dark:wgt-border-neutral-900 dark:wgt-bg-neutral-950 dark:wgt-text-white"
      },
      position: {
        default: "wgt-left-[50%] wgt-top-[50%] wgt-translate-x-[-50%] wgt-translate-y-[-50%] data-[state=closed]:wgt-zoom-out-95 data-[state=open]:wgt-zoom-in-95 data-[state=closed]:wgt-slide-out-to-left-1/2 data-[state=closed]:wgt-slide-out-to-top-[48%] data-[state=open]:wgt-slide-in-from-left-1/2 data-[state=open]:wgt-slide-in-from-top-[48%]",
        bl: "wgt-left-6 wgt-bottom-6 data-[state=closed]:wgt-slide-out-to-bottom-16 data-[state=open]:wgt-slide-in-from-bottom-16",
        bc: "wgt-left-[50%] wgt-top-[50%] wgt-translate-x-[-50%] wgt-bottom-6 data-[state=closed]:wgt-slide-out-to-bottom-16 data-[state=open]:wgt-slide-in-from-bottom-16",
        br: "wgt-right-6 wgt-bottom-6 data-[state=closed]:wgt-slide-out-to-bottom-16 data-[state=open]:wgt-slide-in-from-bottom-16",
        "br-20": "wgt-right-1 sm:wgt-right-3 wgt-bottom-20 sm:wgt-bottom-20 data-[state=closed]:wgt-slide-out-to-bottom-20 data-[state=open]:wgt-slide-in-from-bottom-16"
      },
      size: {
        default: "wgt-max-w-full sm:wgt-max-w-96",
        sm: "wgt-max-w-md",
        md: "wgt-max-w-lg",
        lg: "wgt-max-w-xl",
        xl: "wgt-max-w-2xl",
        "3xl": "wgt-max-w-3xl",
        fullscreen: "wgt-w-screen wgt-h-screen"
      }
    },
    defaultVariants: {
      variant: "default",
      position: "default",
      size: "default"
    }
  }
), xy = Pn(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  wy,
  {
    ref: n,
    className: te(
      "wgt-fixed wgt-inset-0 wgt-z-50 wgt-bg-black/80 data-[state=open]:wgt-animate-in data-[state=closed]:wgt-animate-out data-[state=closed]:wgt-fade-out-0 data-[state=open]:wgt-fade-in-0",
      e
    ),
    ...t
  }
));
xy.displayName = wy.displayName;
const ky = Pn(
  ({
    className: e,
    variant: t = "default",
    size: n,
    position: r,
    hideOverlay: i,
    children: a,
    container: o,
    ...s
  }, l) => /* @__PURE__ */ B(uy, { container: o, children: [
    i === !0 ? null : /* @__PURE__ */ b(xy, {}),
    /* @__PURE__ */ b(
      vy,
      {
        ref: l,
        className: te(DA({ variant: t, size: n, position: r, className: e })),
        ...s,
        children: a
      }
    )
  ] })
);
ky.displayName = vy.displayName;
const Cy = Pn(({ className: e, ...t }, n) => /* @__PURE__ */ b(
  by,
  {
    ref: n,
    className: te(
      "wgt-text-lg wgt-font-semibold wgt-leading-none wgt-tracking-tight",
      e
    ),
    ...t
  }
));
Cy.displayName = by.displayName;
const LA = MA;
var pd = function() {
}, Sy = typeof window < "u", NA = function(e, t, n) {
  if (!Sy)
    return [t, pd, pd];
  var r = JSON.parse, i = ge(function(c) {
    try {
      var f = n ? n.raw ? String : n.serializer : JSON.stringify, d = localStorage.getItem(c);
      return d !== null ? r(d) : (t && localStorage.setItem(c, f(t)), t);
    } catch {
      return t;
    }
  }), a = oe(function() {
    return i.current(e);
  }), o = a[0], s = a[1];
  Yr(function() {
    return s(i.current(e));
  }, [e]);
  var l = Ee(function(c) {
    try {
      var f = typeof c == "function" ? c(o) : c;
      if (typeof f > "u")
        return;
      var d = void 0;
      n || (d = JSON.stringify(f)), localStorage.setItem(e, d), s(r(d));
    } catch {
    }
  }, [e, s]), u = Ee(function() {
    try {
      localStorage.removeItem(e), s(void 0);
    } catch {
    }
  }, [e, s]);
  return [o, l, u];
}, OA = function(e, t, n) {
  if (!Sy)
    return [t, function() {
    }];
  var r = oe(function() {
    try {
      var o = sessionStorage.getItem(e);
      return typeof o != "string" ? (sessionStorage.setItem(e, n ? String(t) : JSON.stringify(t)), t) : n ? o : JSON.parse(o || "null");
    } catch {
      return t;
    }
  }), i = r[0], a = r[1];
  return De(function() {
    try {
      var o = n ? String(i) : JSON.stringify(i);
      sessionStorage.setItem(e, o);
    } catch {
    }
  }), [i, a];
};
const FA = ({ onAccept: e }) => {
  var o;
  const { options: t } = ct(), { branding: n, legal: r } = t, i = (o = n.icons) == null ? void 0 : o.session, a = (i == null ? void 0 : i.icon) ?? /* @__PURE__ */ b("div", { className: i == null ? void 0 : i.className, children: /* @__PURE__ */ b(rr, { className: "wgt-h-7 wgt-w-7 wgt-fill-foreground" }) });
  return /* @__PURE__ */ B("div", { className: "wgt-space-y-8 wgt-px-4 wgt-pb-4 wgt-pt-8", children: [
    /* @__PURE__ */ B("div", { className: "wgt-space-y-4", children: [
      /* @__PURE__ */ b("div", { className: "wgt-flex wgt-items-center wgt-justify-center", children: a }),
      /* @__PURE__ */ B("div", { className: "wgt-text-center wgt-text-lg", children: [
        /* @__PURE__ */ B("div", { children: [
          "Hi, I'm ",
          n.name
        ] }),
        /* @__PURE__ */ b("div", { children: "Your virtual car assistant" })
      ] }),
      /* @__PURE__ */ b(hu, { svgClassName: "wgt-text-autograb" })
    ] }),
    /* @__PURE__ */ B("div", { className: "wgt-space-y-4", children: [
      /* @__PURE__ */ b("h3", { className: "wgt-text-center wgt-text-base wgt-font-medium", children: "Things you should know before continuing:" }),
      /* @__PURE__ */ B("ul", { className: "wgt-mx-4 wgt-list-disc wgt-space-y-2 wgt-text-sm", children: [
        r.customTerms && r.customTerms.map((s, l) => /* @__PURE__ */ b("li", { children: s }, `custom-term-${l}`)),
        /* @__PURE__ */ b("li", { children: "AI-generated content may contain errors. We recommend using this content as a helpful guide, but not as a final source for critical decisions, including purchasing decisions. To confirm the actual features and specifications of a vehicle, please contact the relevant dealer." }),
        /* @__PURE__ */ B("li", { children: [
          "By continuing, you agree to AutoGrab's ",
          /* @__PURE__ */ b(
            "a",
            {
              href: r.termsUrl,
              className: "wgt-text-tertiary hover:wgt-text-tertiary/85",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Terms of Use"
            }
          ),
          " and ",
          /* @__PURE__ */ b(
            "a",
            {
              href: r.privacyPolicyUrl,
              className: "wgt-text-tertiary hover:wgt-text-tertiary/85",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Privacy Policy."
            }
          ),
          " Please take a moment to review them."
        ] }),
        /* @__PURE__ */ B("li", { children: [
          "This service is protected by reCAPTCHA. ",
          /* @__PURE__ */ b(
            "a",
            {
              href: "https://policies.google.com/terms",
              className: "wgt-text-tertiary hover:wgt-text-tertiary/85",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Google Privacy and Terms apply."
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ b("div", { className: "wgt-flex", children: /* @__PURE__ */ b(
      ot,
      {
        className: "wgt-flex-1 wgt-rounded-full wgt-border-2",
        variant: "outline",
        onClick: e,
        children: "Continue"
      }
    ) })
  ] });
}, md = 50, _A = (e, t = "smooth", n = 50) => new Promise((r) => {
  if (e.scrollTo({
    top: e.scrollHeight,
    behavior: t
  }), t === "auto") {
    r();
    return;
  }
  if ("onscrollend" in window) {
    const a = () => {
      e.removeEventListener("scrollend", a), r();
    };
    e.addEventListener("scrollend", a);
    return;
  }
  const i = () => {
    e.scrollTop + e.clientHeight >= e.scrollHeight - n ? r() : requestAnimationFrame(i);
  };
  requestAnimationFrame(i);
}), zA = () => {
  const e = ge(null), t = ge(null), [n, r] = oe(!0), i = ge(!1), a = Ee(() => {
    const l = e.current;
    return l ? l.scrollTop + l.clientHeight >= l.scrollHeight - md : !0;
  }, []), o = Ee(
    async (l = "smooth") => {
      const u = e.current;
      if (u) {
        i.current = !0;
        try {
          await _A(u, l, md);
        } finally {
          i.current = !1;
        }
        r(!0);
      }
    },
    []
  ), s = Ee(() => {
    i.current || r(a());
  }, [a]);
  return Yr(() => {
    o();
  }, [o]), De(() => {
    const l = e.current, u = t.current;
    if (!l || !u)
      return;
    const c = typeof ResizeObserver < "u" ? new ResizeObserver(() => {
      n && o();
    }) : null;
    return c == null || c.observe(u), l.addEventListener("scroll", s, {
      passive: !0
    }), l.addEventListener("touchstart", s, {
      passive: !0
    }), () => {
      c == null || c.disconnect(), l.removeEventListener("scroll", s), l.removeEventListener("touchstart", s);
    };
  }, [n, s, o]), {
    scrollContainerRef: e,
    contentRef: t,
    isEnabled: n,
    scrollToBottom: o,
    isAtBottom: a
  };
}, VA = ({
  messages: e,
  children: t,
  className: n
}) => {
  const [r, i] = oe(!0), {
    scrollContainerRef: a,
    contentRef: o,
    scrollToBottom: s,
    isEnabled: l,
    isAtBottom: u
  } = zA();
  return De(() => {
    if (e.length === 0)
      return;
    (async () => {
      if (e[e.length - 1].role === "user" && !u()) {
        i(!1);
        try {
          await s();
        } finally {
          i(!0);
        }
      }
    })();
  }, [e, s, u]), /* @__PURE__ */ B(
    "div",
    {
      className: te(n, "wgt-grid wgt-grid-cols-1 wgt-overflow-y-auto"),
      ref: a,
      children: [
        /* @__PURE__ */ b("div", { className: "wgt-max-w-full", ref: o, children: t }),
        !l && r ? /* @__PURE__ */ b(Lt, { children: /* @__PURE__ */ B(Nt, { children: [
          /* @__PURE__ */ b(Ot, { asChild: !0, children: /* @__PURE__ */ b(
            ot,
            {
              variant: "outline",
              onClick: () => s(),
              className: "wgt-absolute wgt-bottom-28 wgt-left-1/2 wgt-flex wgt-h-10 wgt-w-10 wgt--translate-x-1/2 wgt-items-center wgt-justify-center wgt-rounded-full wgt-shadow-lg wgt-transition-all wgt-duration-200",
              children: /* @__PURE__ */ b(
                ve,
                {
                  icon: l0,
                  className: "wgt-h-4 wgt-w-4"
                }
              )
            }
          ) }),
          /* @__PURE__ */ b(bt, { children: "Scroll to bottom" })
        ] }) }) : null
      ]
    }
  );
};
function $A(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const jA = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, BA = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, WA = {};
function gd(e, t) {
  return (WA.jsx ? BA : jA).test(e);
}
const UA = /[ \t\n\f\r]/g;
function HA(e) {
  return typeof e == "object" ? e.type === "text" ? yd(e.value) : !1 : yd(e);
}
function yd(e) {
  return e.replace(UA, "") === "";
}
class ai {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
ai.prototype.normal = {};
ai.prototype.property = {};
ai.prototype.space = void 0;
function Ay(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new ai(n, r, t);
}
function Ws(e) {
  return e.toLowerCase();
}
class Be {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
Be.prototype.attribute = "";
Be.prototype.booleanish = !1;
Be.prototype.boolean = !1;
Be.prototype.commaOrSpaceSeparated = !1;
Be.prototype.commaSeparated = !1;
Be.prototype.defined = !1;
Be.prototype.mustUseProperty = !1;
Be.prototype.number = !1;
Be.prototype.overloadedBoolean = !1;
Be.prototype.property = "";
Be.prototype.spaceSeparated = !1;
Be.prototype.space = void 0;
let GA = 0;
const X = In(), ye = In(), Us = In(), O = In(), se = In(), Xn = In(), He = In();
function In() {
  return 2 ** ++GA;
}
const Hs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: X,
  booleanish: ye,
  commaOrSpaceSeparated: He,
  commaSeparated: Xn,
  number: O,
  overloadedBoolean: Us,
  spaceSeparated: se
}, Symbol.toStringTag, { value: "Module" })), Ea = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Hs)
);
class yu extends Be {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), wd(this, "space", i), typeof r == "number")
      for (; ++a < Ea.length; ) {
        const o = Ea[a];
        wd(this, Ea[a], (r & Hs[o]) === Hs[o]);
      }
  }
}
yu.prototype.defined = !0;
function wd(e, t, n) {
  n && (e[t] = n);
}
function dr(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const a = new yu(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[Ws(r)] = r, n[Ws(a.attribute)] = r;
  }
  return new ai(t, n, e.space);
}
const Ty = dr({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ye,
    ariaAutoComplete: null,
    ariaBusy: ye,
    ariaChecked: ye,
    ariaColCount: O,
    ariaColIndex: O,
    ariaColSpan: O,
    ariaControls: se,
    ariaCurrent: null,
    ariaDescribedBy: se,
    ariaDetails: null,
    ariaDisabled: ye,
    ariaDropEffect: se,
    ariaErrorMessage: null,
    ariaExpanded: ye,
    ariaFlowTo: se,
    ariaGrabbed: ye,
    ariaHasPopup: null,
    ariaHidden: ye,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: se,
    ariaLevel: O,
    ariaLive: null,
    ariaModal: ye,
    ariaMultiLine: ye,
    ariaMultiSelectable: ye,
    ariaOrientation: null,
    ariaOwns: se,
    ariaPlaceholder: null,
    ariaPosInSet: O,
    ariaPressed: ye,
    ariaReadOnly: ye,
    ariaRelevant: null,
    ariaRequired: ye,
    ariaRoleDescription: se,
    ariaRowCount: O,
    ariaRowIndex: O,
    ariaRowSpan: O,
    ariaSelected: ye,
    ariaSetSize: O,
    ariaSort: null,
    ariaValueMax: O,
    ariaValueMin: O,
    ariaValueNow: O,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function Ey(e, t) {
  return t in e ? e[t] : t;
}
function Py(e, t) {
  return Ey(e, t.toLowerCase());
}
const qA = dr({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Xn,
    acceptCharset: se,
    accessKey: se,
    action: null,
    allow: null,
    allowFullScreen: X,
    allowPaymentRequest: X,
    allowUserMedia: X,
    alt: null,
    as: null,
    async: X,
    autoCapitalize: null,
    autoComplete: se,
    autoFocus: X,
    autoPlay: X,
    blocking: se,
    capture: null,
    charSet: null,
    checked: X,
    cite: null,
    className: se,
    cols: O,
    colSpan: null,
    content: null,
    contentEditable: ye,
    controls: X,
    controlsList: se,
    coords: O | Xn,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: X,
    defer: X,
    dir: null,
    dirName: null,
    disabled: X,
    download: Us,
    draggable: ye,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: X,
    formTarget: null,
    headers: se,
    height: O,
    hidden: Us,
    high: O,
    href: null,
    hrefLang: null,
    htmlFor: se,
    httpEquiv: se,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: X,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: X,
    itemId: null,
    itemProp: se,
    itemRef: se,
    itemScope: X,
    itemType: se,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: X,
    low: O,
    manifest: null,
    max: null,
    maxLength: O,
    media: null,
    method: null,
    min: null,
    minLength: O,
    multiple: X,
    muted: X,
    name: null,
    nonce: null,
    noModule: X,
    noValidate: X,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: X,
    optimum: O,
    pattern: null,
    ping: se,
    placeholder: null,
    playsInline: X,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: X,
    referrerPolicy: null,
    rel: se,
    required: X,
    reversed: X,
    rows: O,
    rowSpan: O,
    sandbox: se,
    scope: null,
    scoped: X,
    seamless: X,
    selected: X,
    shadowRootClonable: X,
    shadowRootDelegatesFocus: X,
    shadowRootMode: null,
    shape: null,
    size: O,
    sizes: null,
    slot: null,
    span: O,
    spellCheck: ye,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: O,
    step: null,
    style: null,
    tabIndex: O,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: X,
    useMap: null,
    value: ye,
    width: O,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: se,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: O,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: O,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: X,
    // Lists. Use CSS to reduce space between items instead
    declare: X,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: O,
    // `<img>` and `<object>`
    leftMargin: O,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: O,
    // `<body>`
    marginWidth: O,
    // `<body>`
    noResize: X,
    // `<frame>`
    noHref: X,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: X,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: X,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: O,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ye,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: O,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: O,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: X,
    disableRemotePlayback: X,
    prefix: null,
    property: null,
    results: O,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Py
}), KA = dr({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: He,
    accentHeight: O,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: O,
    amplitude: O,
    arabicForm: null,
    ascent: O,
    attributeName: null,
    attributeType: null,
    azimuth: O,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: O,
    by: null,
    calcMode: null,
    capHeight: O,
    className: se,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: O,
    diffuseConstant: O,
    direction: null,
    display: null,
    dur: null,
    divisor: O,
    dominantBaseline: null,
    download: X,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: O,
    enableBackground: null,
    end: null,
    event: null,
    exponent: O,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: O,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Xn,
    g2: Xn,
    glyphName: Xn,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: O,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: O,
    horizOriginX: O,
    horizOriginY: O,
    id: null,
    ideographic: O,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: O,
    k: O,
    k1: O,
    k2: O,
    k3: O,
    k4: O,
    kernelMatrix: He,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: O,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: O,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: O,
    overlineThickness: O,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: O,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: se,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: O,
    pointsAtY: O,
    pointsAtZ: O,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: He,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: He,
    rev: He,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: He,
    requiredFeatures: He,
    requiredFonts: He,
    requiredFormats: He,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: O,
    specularExponent: O,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: O,
    strikethroughThickness: O,
    string: null,
    stroke: null,
    strokeDashArray: He,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: O,
    strokeOpacity: O,
    strokeWidth: null,
    style: null,
    surfaceScale: O,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: He,
    tabIndex: O,
    tableValues: null,
    target: null,
    targetX: O,
    targetY: O,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: He,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: O,
    underlineThickness: O,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: O,
    values: null,
    vAlphabetic: O,
    vMathematical: O,
    vectorEffect: null,
    vHanging: O,
    vIdeographic: O,
    version: null,
    vertAdvY: O,
    vertOriginX: O,
    vertOriginY: O,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: O,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Ey
}), Iy = dr({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), Ry = dr({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Py
}), My = dr({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), YA = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, XA = /[A-Z]/g, vd = /-[a-z]/g, ZA = /^data[-\w.:]+$/i;
function JA(e, t) {
  const n = Ws(t);
  let r = t, i = Be;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && ZA.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(vd, eT);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!vd.test(a)) {
        let o = a.replace(XA, QA);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = yu;
  }
  return new i(r, t);
}
function QA(e) {
  return "-" + e.toLowerCase();
}
function eT(e) {
  return e.charAt(1).toUpperCase();
}
const tT = Ay([Ty, qA, Iy, Ry, My], "html"), wu = Ay([Ty, KA, Iy, Ry, My], "svg");
function nT(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function rT(e) {
  return e.join(" ").trim();
}
var Fn = {}, Pa, bd;
function iT() {
  if (bd) return Pa;
  bd = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, a = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, o = /^[;\s]*/, s = /^\s+|\s+$/g, l = `
`, u = "/", c = "*", f = "", d = "comment", h = "declaration";
  Pa = function(m, y) {
    if (typeof m != "string")
      throw new TypeError("First argument must be a string");
    if (!m) return [];
    y = y || {};
    var g = 1, w = 1;
    function v(_) {
      var D = _.match(t);
      D && (g += D.length);
      var j = _.lastIndexOf(l);
      w = ~j ? _.length - j : w + _.length;
    }
    function k() {
      var _ = { line: g, column: w };
      return function(D) {
        return D.position = new x(_), I(), D;
      };
    }
    function x(_) {
      this.start = _, this.end = { line: g, column: w }, this.source = y.source;
    }
    x.prototype.content = m;
    function C(_) {
      var D = new Error(
        y.source + ":" + g + ":" + w + ": " + _
      );
      if (D.reason = _, D.filename = y.source, D.line = g, D.column = w, D.source = m, !y.silent) throw D;
    }
    function P(_) {
      var D = _.exec(m);
      if (D) {
        var j = D[0];
        return v(j), m = m.slice(j.length), D;
      }
    }
    function I() {
      P(n);
    }
    function N(_) {
      var D;
      for (_ = _ || []; D = E(); )
        D !== !1 && _.push(D);
      return _;
    }
    function E() {
      var _ = k();
      if (!(u != m.charAt(0) || c != m.charAt(1))) {
        for (var D = 2; f != m.charAt(D) && (c != m.charAt(D) || u != m.charAt(D + 1)); )
          ++D;
        if (D += 2, f === m.charAt(D - 1))
          return C("End of comment missing");
        var j = m.slice(2, D - 2);
        return w += 2, v(j), m = m.slice(D), w += 2, _({
          type: d,
          comment: j
        });
      }
    }
    function L() {
      var _ = k(), D = P(r);
      if (D) {
        if (E(), !P(i)) return C("property missing ':'");
        var j = P(a), G = _({
          type: h,
          property: p(D[0].replace(e, f)),
          value: j ? p(j[0].replace(e, f)) : f
        });
        return P(o), G;
      }
    }
    function M() {
      var _ = [];
      N(_);
      for (var D; D = L(); )
        D !== !1 && (_.push(D), N(_));
      return _;
    }
    return I(), M();
  };
  function p(m) {
    return m ? m.replace(s, f) : f;
  }
  return Pa;
}
var xd;
function oT() {
  if (xd) return Fn;
  xd = 1;
  var e = Fn && Fn.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Fn, "__esModule", { value: !0 }), Fn.default = n;
  var t = e(iT());
  function n(r, i) {
    var a = null;
    if (!r || typeof r != "string")
      return a;
    var o = (0, t.default)(r), s = typeof i == "function";
    return o.forEach(function(l) {
      if (l.type === "declaration") {
        var u = l.property, c = l.value;
        s ? i(u, c, l) : c && (a = a || {}, a[u] = c);
      }
    }), a;
  }
  return Fn;
}
var vr = {}, kd;
function aT() {
  if (kd) return vr;
  kd = 1, Object.defineProperty(vr, "__esModule", { value: !0 }), vr.camelCase = void 0;
  var e = /^--[a-zA-Z0-9_-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, i = /^-(ms)-/, a = function(u) {
    return !u || n.test(u) || e.test(u);
  }, o = function(u, c) {
    return c.toUpperCase();
  }, s = function(u, c) {
    return "".concat(c, "-");
  }, l = function(u, c) {
    return c === void 0 && (c = {}), a(u) ? u : (u = u.toLowerCase(), c.reactCompat ? u = u.replace(i, s) : u = u.replace(r, s), u.replace(t, o));
  };
  return vr.camelCase = l, vr;
}
var br, Cd;
function sT() {
  if (Cd) return br;
  Cd = 1;
  var e = br && br.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  }, t = e(oT()), n = aT();
  function r(i, a) {
    var o = {};
    return !i || typeof i != "string" || (0, t.default)(i, function(s, l) {
      s && l && (o[(0, n.camelCase)(s, a)] = l);
    }), o;
  }
  return r.default = r, br = r, br;
}
var lT = sT();
const uT = /* @__PURE__ */ pl(lT), Dy = Ly("end"), vu = Ly("start");
function Ly(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function cT(e) {
  const t = vu(e), n = Dy(e);
  if (t && n)
    return { start: t, end: n };
}
function Nr(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Sd(e.position) : "start" in e || "end" in e ? Sd(e) : "line" in e || "column" in e ? Gs(e) : "";
}
function Gs(e) {
  return Ad(e && e.line) + ":" + Ad(e && e.column);
}
function Sd(e) {
  return Gs(e && e.start) + "-" + Gs(e && e.end);
}
function Ad(e) {
  return e && typeof e == "number" ? e : 1;
}
class Le extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", a = {}, o = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? i = t : !a.cause && t && (o = !0, i = t.message, a.cause = t), !a.ruleId && !a.source && typeof r == "string") {
      const l = r.indexOf(":");
      l === -1 ? a.ruleId = r : (a.source = r.slice(0, l), a.ruleId = r.slice(l + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const l = a.ancestors[a.ancestors.length - 1];
      l && (a.place = l.position);
    }
    const s = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file = "", this.message = i, this.line = s ? s.line : void 0, this.name = Nr(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
Le.prototype.file = "";
Le.prototype.name = "";
Le.prototype.reason = "";
Le.prototype.message = "";
Le.prototype.stack = "";
Le.prototype.column = void 0;
Le.prototype.line = void 0;
Le.prototype.ancestors = void 0;
Le.prototype.cause = void 0;
Le.prototype.fatal = void 0;
Le.prototype.place = void 0;
Le.prototype.ruleId = void 0;
Le.prototype.source = void 0;
const bu = {}.hasOwnProperty, fT = /* @__PURE__ */ new Map(), dT = /[A-Z]/g, hT = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), pT = /* @__PURE__ */ new Set(["td", "th"]), Ny = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function mT(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = CT(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = kT(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? wu : tT,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, a = Oy(i, e, void 0);
  return a && typeof a != "string" ? a : i.create(
    e,
    i.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function Oy(e, t, n) {
  if (t.type === "element")
    return gT(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return yT(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return vT(e, t, n);
  if (t.type === "mdxjsEsm")
    return wT(e, t);
  if (t.type === "root")
    return bT(e, t, n);
  if (t.type === "text")
    return xT(e, t);
}
function gT(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = wu, e.schema = i), e.ancestors.push(t);
  const a = _y(e, t.tagName, !1), o = ST(e, t);
  let s = ku(e, t);
  return hT.has(t.tagName) && (s = s.filter(function(l) {
    return typeof l == "string" ? !HA(l) : !0;
  })), Fy(e, o, a, t), xu(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function yT(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  qr(e, t.position);
}
function wT(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  qr(e, t.position);
}
function vT(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = wu, e.schema = i), e.ancestors.push(t);
  const a = t.name === null ? e.Fragment : _y(e, t.name, !0), o = AT(e, t), s = ku(e, t);
  return Fy(e, o, a, t), xu(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function bT(e, t, n) {
  const r = {};
  return xu(r, ku(e, t)), e.create(t, e.Fragment, r, n);
}
function xT(e, t) {
  return t.value;
}
function Fy(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function xu(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function kT(e, t, n) {
  return r;
  function r(i, a, o, s) {
    const u = Array.isArray(o.children) ? n : t;
    return s ? u(a, o, s) : u(a, o);
  }
}
function CT(e, t) {
  return n;
  function n(r, i, a, o) {
    const s = Array.isArray(a.children), l = vu(r);
    return t(
      i,
      a,
      o,
      s,
      {
        columnNumber: l ? l.column - 1 : void 0,
        fileName: e,
        lineNumber: l ? l.line : void 0
      },
      void 0
    );
  }
}
function ST(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && bu.call(t.properties, i)) {
      const a = TT(e, i, t.properties[i]);
      if (a) {
        const [o, s] = a;
        e.tableCellAlignToStyle && o === "align" && typeof s == "string" && pT.has(t.tagName) ? r = s : n[o] = s;
      }
    }
  if (r) {
    const a = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    a[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function AT(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const a = r.data.estree.body[0];
        a.type;
        const o = a.expression;
        o.type;
        const s = o.properties[0];
        s.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(s.argument)
        );
      } else
        qr(e, t.position);
    else {
      const i = r.name;
      let a;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const s = r.value.data.estree.body[0];
          s.type, a = e.evaluater.evaluateExpression(s.expression);
        } else
          qr(e, t.position);
      else
        a = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      a;
    }
  return n;
}
function ku(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : fT;
  for (; ++r < t.children.length; ) {
    const a = t.children[r];
    let o;
    if (e.passKeys) {
      const l = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (l) {
        const u = i.get(l) || 0;
        o = l + "-" + u, i.set(l, u + 1);
      }
    }
    const s = Oy(e, a, o);
    s !== void 0 && n.push(s);
  }
  return n;
}
function TT(e, t, n) {
  const r = JA(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? $A(n) : rT(n)), r.property === "style") {
      let i = typeof n == "object" ? n : ET(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = PT(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? YA[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function ET(e, t) {
  try {
    return uT(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new Le("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = Ny + "#cannot-parse-style-attribute", i;
  }
}
function _y(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let a = -1, o;
    for (; ++a < i.length; ) {
      const s = gd(i[a]) ? { type: "Identifier", name: i[a] } : { type: "Literal", value: i[a] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: s,
        computed: !!(a && s.type === "Literal"),
        optional: !1
      } : s;
    }
    r = o;
  } else
    r = gd(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return bu.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  qr(e);
}
function qr(e, t) {
  const n = new Le(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = Ny + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function PT(e) {
  const t = {};
  let n;
  for (n in e)
    bu.call(e, n) && (t[IT(n)] = e[n]);
  return t;
}
function IT(e) {
  let t = e.replace(dT, RT);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function RT(e) {
  return "-" + e.toLowerCase();
}
const Ia = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, MT = {};
function Cu(e, t) {
  const n = MT, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return zy(e, r, i);
}
function zy(e, t, n) {
  if (DT(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Td(e.children, t, n);
  }
  return Array.isArray(e) ? Td(e, t, n) : "";
}
function Td(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = zy(e[i], t, n);
  return r.join("");
}
function DT(e) {
  return !!(e && typeof e == "object");
}
const Ed = document.createElement("i");
function Su(e) {
  const t = "&" + e + ";";
  Ed.innerHTML = t;
  const n = Ed.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function Ke(e, t, n, r) {
  const i = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); a < r.length; )
      o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function Qe(e, t) {
  return e.length > 0 ? (Ke(e, e.length, 0, t), e) : t;
}
const Pd = {}.hasOwnProperty;
function Vy(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    LT(t, e[n]);
  return t;
}
function LT(e, t) {
  let n;
  for (n in t) {
    const i = (Pd.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let o;
    if (a)
      for (o in a) {
        Pd.call(i, o) || (i[o] = []);
        const s = a[o];
        NT(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function NT(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Ke(e, 0, 0, r);
}
function $y(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function at(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Oe = cn(/[A-Za-z]/), Me = cn(/[\dA-Za-z]/), OT = cn(/[#-'*+\--9=?A-Z^-~]/);
function mo(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const qs = cn(/\d/), FT = cn(/[\dA-Fa-f]/), _T = cn(/[!-/:-@[-`{-~]/);
function H(e) {
  return e !== null && e < -2;
}
function ae(e) {
  return e !== null && (e < 0 || e === 32);
}
function Z(e) {
  return e === -2 || e === -1 || e === 32;
}
const jo = cn(new RegExp("\\p{P}|\\p{S}", "u")), En = cn(/\s/);
function cn(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function hr(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const a = e.charCodeAt(n);
    let o = "";
    if (a === 37 && Me(e.charCodeAt(n + 1)) && Me(e.charCodeAt(n + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const s = e.charCodeAt(n + 1);
      a < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(a, s), i = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function ee(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(l) {
    return Z(l) ? (e.enter(n), s(l)) : t(l);
  }
  function s(l) {
    return Z(l) && a++ < i ? (e.consume(l), s) : (e.exit(n), t(l));
  }
}
const zT = {
  tokenize: VT
};
function VT(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ee(e, t, "linePrefix");
  }
  function i(s) {
    return e.enter("paragraph"), a(s);
  }
  function a(s) {
    const l = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = l), n = l, o(s);
  }
  function o(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return H(s) ? (e.consume(s), e.exit("chunkText"), a) : (e.consume(s), o);
  }
}
const $T = {
  tokenize: jT
}, Id = {
  tokenize: BT
};
function jT(e) {
  const t = this, n = [];
  let r = 0, i, a, o;
  return s;
  function s(v) {
    if (r < n.length) {
      const k = n[r];
      return t.containerState = k[1], e.attempt(k[0].continuation, l, u)(v);
    }
    return u(v);
  }
  function l(v) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && w();
      const k = t.events.length;
      let x = k, C;
      for (; x--; )
        if (t.events[x][0] === "exit" && t.events[x][1].type === "chunkFlow") {
          C = t.events[x][1].end;
          break;
        }
      g(r);
      let P = k;
      for (; P < t.events.length; )
        t.events[P][1].end = {
          ...C
        }, P++;
      return Ke(t.events, x + 1, 0, t.events.slice(k)), t.events.length = P, u(v);
    }
    return s(v);
  }
  function u(v) {
    if (r === n.length) {
      if (!i)
        return d(v);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return p(v);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Id, c, f)(v);
  }
  function c(v) {
    return i && w(), g(r), d(v);
  }
  function f(v) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, p(v);
  }
  function d(v) {
    return t.containerState = {}, e.attempt(Id, h, p)(v);
  }
  function h(v) {
    return r++, n.push([t.currentConstruct, t.containerState]), d(v);
  }
  function p(v) {
    if (v === null) {
      i && w(), g(0), e.consume(v);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: a
    }), m(v);
  }
  function m(v) {
    if (v === null) {
      y(e.exit("chunkFlow"), !0), g(0), e.consume(v);
      return;
    }
    return H(v) ? (e.consume(v), y(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(v), m);
  }
  function y(v, k) {
    const x = t.sliceStream(v);
    if (k && x.push(null), v.previous = a, a && (a.next = v), a = v, i.defineSkip(v.start), i.write(x), t.parser.lazy[v.start.line]) {
      let C = i.events.length;
      for (; C--; )
        if (
          // The token starts before the line ending…
          i.events[C][1].start.offset < o && // …and either is not ended yet…
          (!i.events[C][1].end || // …or ends after it.
          i.events[C][1].end.offset > o)
        )
          return;
      const P = t.events.length;
      let I = P, N, E;
      for (; I--; )
        if (t.events[I][0] === "exit" && t.events[I][1].type === "chunkFlow") {
          if (N) {
            E = t.events[I][1].end;
            break;
          }
          N = !0;
        }
      for (g(r), C = P; C < t.events.length; )
        t.events[C][1].end = {
          ...E
        }, C++;
      Ke(t.events, I + 1, 0, t.events.slice(P)), t.events.length = C;
    }
  }
  function g(v) {
    let k = n.length;
    for (; k-- > v; ) {
      const x = n[k];
      t.containerState = x[1], x[0].exit.call(t, e);
    }
    n.length = v;
  }
  function w() {
    i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function BT(e, t, n) {
  return ee(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function ir(e) {
  if (e === null || ae(e) || En(e))
    return 1;
  if (jo(e))
    return 2;
}
function Bo(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (t = a(t, n), r.push(a));
  }
  return t;
}
const Ks = {
  name: "attention",
  resolveAll: WT,
  tokenize: UT
};
function WT(e, t) {
  let n = -1, r, i, a, o, s, l, u, c;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[r][1].end
          }, d = {
            ...e[n][1].start
          };
          Rd(f, -l), Rd(d, l), o = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[r][1].end
            }
          }, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: d
          }, a = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: l > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...s.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...s.end
          }, u = [], e[r][1].end.offset - e[r][1].start.offset && (u = Qe(u, [["enter", e[r][1], t], ["exit", e[r][1], t]])), u = Qe(u, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["enter", a, t]]), u = Qe(u, Bo(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), u = Qe(u, [["exit", a, t], ["enter", s, t], ["exit", s, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (c = 2, u = Qe(u, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : c = 0, Ke(e, r - 1, n - r + 3, u), n = r + u.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function UT(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = ir(r);
  let a;
  return o;
  function o(l) {
    return a = l, e.enter("attentionSequence"), s(l);
  }
  function s(l) {
    if (l === a)
      return e.consume(l), s;
    const u = e.exit("attentionSequence"), c = ir(l), f = !c || c === 2 && i || n.includes(l), d = !i || i === 2 && c || n.includes(r);
    return u._open = !!(a === 42 ? f : f && (i || !d)), u._close = !!(a === 42 ? d : d && (c || !f)), t(l);
  }
}
function Rd(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const HT = {
  name: "autolink",
  tokenize: GT
};
function GT(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(h) {
    return Oe(h) ? (e.consume(h), o) : h === 64 ? n(h) : u(h);
  }
  function o(h) {
    return h === 43 || h === 45 || h === 46 || Me(h) ? (r = 1, s(h)) : u(h);
  }
  function s(h) {
    return h === 58 ? (e.consume(h), r = 0, l) : (h === 43 || h === 45 || h === 46 || Me(h)) && r++ < 32 ? (e.consume(h), s) : (r = 0, u(h));
  }
  function l(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || mo(h) ? n(h) : (e.consume(h), l);
  }
  function u(h) {
    return h === 64 ? (e.consume(h), c) : OT(h) ? (e.consume(h), u) : n(h);
  }
  function c(h) {
    return Me(h) ? f(h) : n(h);
  }
  function f(h) {
    return h === 46 ? (e.consume(h), r = 0, c) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : d(h);
  }
  function d(h) {
    if ((h === 45 || Me(h)) && r++ < 63) {
      const p = h === 45 ? d : f;
      return e.consume(h), p;
    }
    return n(h);
  }
}
const si = {
  partial: !0,
  tokenize: qT
};
function qT(e, t, n) {
  return r;
  function r(a) {
    return Z(a) ? ee(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || H(a) ? t(a) : n(a);
  }
}
const jy = {
  continuation: {
    tokenize: YT
  },
  exit: XT,
  name: "blockQuote",
  tokenize: KT
};
function KT(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return n(o);
  }
  function a(o) {
    return Z(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function YT(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return Z(o) ? ee(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : a(o);
  }
  function a(o) {
    return e.attempt(jy, t, n)(o);
  }
}
function XT(e) {
  e.exit("blockQuote");
}
const By = {
  name: "characterEscape",
  tokenize: ZT
};
function ZT(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return _T(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const Wy = {
  name: "characterReference",
  tokenize: JT
};
function JT(e, t, n) {
  const r = this;
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), l;
  }
  function l(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), a = 31, o = Me, c(f));
  }
  function u(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = FT, c) : (e.enter("characterReferenceValue"), a = 7, o = qs, c(f));
  }
  function c(f) {
    if (f === 59 && i) {
      const d = e.exit("characterReferenceValue");
      return o === Me && !Su(r.sliceSerialize(d)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(f) && i++ < a ? (e.consume(f), c) : n(f);
  }
}
const Md = {
  partial: !0,
  tokenize: eE
}, Dd = {
  concrete: !0,
  name: "codeFenced",
  tokenize: QT
};
function QT(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: x
  };
  let a = 0, o = 0, s;
  return l;
  function l(C) {
    return u(C);
  }
  function u(C) {
    const P = r.events[r.events.length - 1];
    return a = P && P[1].type === "linePrefix" ? P[2].sliceSerialize(P[1], !0).length : 0, s = C, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c(C);
  }
  function c(C) {
    return C === s ? (o++, e.consume(C), c) : o < 3 ? n(C) : (e.exit("codeFencedFenceSequence"), Z(C) ? ee(e, f, "whitespace")(C) : f(C));
  }
  function f(C) {
    return C === null || H(C) ? (e.exit("codeFencedFence"), r.interrupt ? t(C) : e.check(Md, m, k)(C)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), d(C));
  }
  function d(C) {
    return C === null || H(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(C)) : Z(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ee(e, h, "whitespace")(C)) : C === 96 && C === s ? n(C) : (e.consume(C), d);
  }
  function h(C) {
    return C === null || H(C) ? f(C) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), p(C));
  }
  function p(C) {
    return C === null || H(C) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(C)) : C === 96 && C === s ? n(C) : (e.consume(C), p);
  }
  function m(C) {
    return e.attempt(i, k, y)(C);
  }
  function y(C) {
    return e.enter("lineEnding"), e.consume(C), e.exit("lineEnding"), g;
  }
  function g(C) {
    return a > 0 && Z(C) ? ee(e, w, "linePrefix", a + 1)(C) : w(C);
  }
  function w(C) {
    return C === null || H(C) ? e.check(Md, m, k)(C) : (e.enter("codeFlowValue"), v(C));
  }
  function v(C) {
    return C === null || H(C) ? (e.exit("codeFlowValue"), w(C)) : (e.consume(C), v);
  }
  function k(C) {
    return e.exit("codeFenced"), t(C);
  }
  function x(C, P, I) {
    let N = 0;
    return E;
    function E(j) {
      return C.enter("lineEnding"), C.consume(j), C.exit("lineEnding"), L;
    }
    function L(j) {
      return C.enter("codeFencedFence"), Z(j) ? ee(C, M, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(j) : M(j);
    }
    function M(j) {
      return j === s ? (C.enter("codeFencedFenceSequence"), _(j)) : I(j);
    }
    function _(j) {
      return j === s ? (N++, C.consume(j), _) : N >= o ? (C.exit("codeFencedFenceSequence"), Z(j) ? ee(C, D, "whitespace")(j) : D(j)) : I(j);
    }
    function D(j) {
      return j === null || H(j) ? (C.exit("codeFencedFence"), P(j)) : I(j);
    }
  }
}
function eE(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const Ra = {
  name: "codeIndented",
  tokenize: nE
}, tE = {
  partial: !0,
  tokenize: rE
};
function nE(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), ee(e, a, "linePrefix", 5)(u);
  }
  function a(u) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? o(u) : n(u);
  }
  function o(u) {
    return u === null ? l(u) : H(u) ? e.attempt(tE, o, l)(u) : (e.enter("codeFlowValue"), s(u));
  }
  function s(u) {
    return u === null || H(u) ? (e.exit("codeFlowValue"), o(u)) : (e.consume(u), s);
  }
  function l(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function rE(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : H(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : ee(e, a, "linePrefix", 5)(o);
  }
  function a(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : H(o) ? i(o) : n(o);
  }
}
const iE = {
  name: "codeText",
  previous: aE,
  resolve: oE,
  tokenize: sE
};
function oE(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function aE(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function sE(e, t, n) {
  let r = 0, i, a;
  return o;
  function o(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(f);
  }
  function s(f) {
    return f === 96 ? (e.consume(f), r++, s) : (e.exit("codeTextSequence"), l(f));
  }
  function l(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), l) : f === 96 ? (a = e.enter("codeTextSequence"), i = 0, c(f)) : H(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), l) : (e.enter("codeTextData"), u(f));
  }
  function u(f) {
    return f === null || f === 32 || f === 96 || H(f) ? (e.exit("codeTextData"), l(f)) : (e.consume(f), u);
  }
  function c(f) {
    return f === 96 ? (e.consume(f), i++, c) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (a.type = "codeTextData", u(f));
  }
}
class lE {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const a = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && xr(this.left, r), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), xr(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), xr(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        xr(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        xr(this.left, n.reverse());
      }
  }
}
function xr(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Uy(e) {
  const t = {};
  let n = -1, r, i, a, o, s, l, u;
  const c = new lE(e);
  for (; ++n < c.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = c.get(n), n && r[1].type === "chunkFlow" && c.get(n - 1)[1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, a = 0, a < l.length && l[a][1].type === "lineEndingBlank" && (a += 2), a < l.length && l[a][1].type === "content"))
      for (; ++a < l.length && l[a][1].type !== "content"; )
        l[a][1].type === "chunkText" && (l[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, uE(c, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (a = n, i = void 0; a--; )
        if (o = c.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (c.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...c.get(i)[1].start
      }, s = c.slice(i, n), s.unshift(r), c.splice(i, n - i + 1, s));
    }
  }
  return Ke(e, 0, Number.POSITIVE_INFINITY, c.slice(0)), !u;
}
function uE(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const a = [];
  let o = n._tokenizer;
  o || (o = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const s = o.events, l = [], u = {};
  let c, f, d = -1, h = n, p = 0, m = 0;
  const y = [m];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    a.push(i), h._tokenizer || (c = r.sliceStream(h), h.next || c.push(null), f && o.defineSkip(h.start), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(c), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), f = h, h = h.next;
  }
  for (h = n; ++d < s.length; )
    // Find a void token that includes a break.
    s[d][0] === "exit" && s[d - 1][0] === "enter" && s[d][1].type === s[d - 1][1].type && s[d][1].start.line !== s[d][1].end.line && (m = d + 1, y.push(m), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (o.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : y.pop(), d = y.length; d--; ) {
    const g = s.slice(y[d], y[d + 1]), w = a.pop();
    l.push([w, w + g.length - 1]), e.splice(w, 2, g);
  }
  for (l.reverse(), d = -1; ++d < l.length; )
    u[p + l[d][0]] = p + l[d][1], p += l[d][1] - l[d][0] - 1;
  return u;
}
const cE = {
  resolve: dE,
  tokenize: hE
}, fE = {
  partial: !0,
  tokenize: pE
};
function dE(e) {
  return Uy(e), e;
}
function hE(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? a(s) : H(s) ? e.check(fE, o, a)(s) : (e.consume(s), i);
  }
  function a(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function o(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function pE(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), ee(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || H(o))
      return n(o);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function Hy(e, t, n, r, i, a, o, s, l) {
  const u = l || Number.POSITIVE_INFINITY;
  let c = 0;
  return f;
  function f(g) {
    return g === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(g), e.exit(a), d) : g === null || g === 32 || g === 41 || mo(g) ? n(g) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), m(g));
  }
  function d(g) {
    return g === 62 ? (e.enter(a), e.consume(g), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), h(g));
  }
  function h(g) {
    return g === 62 ? (e.exit("chunkString"), e.exit(s), d(g)) : g === null || g === 60 || H(g) ? n(g) : (e.consume(g), g === 92 ? p : h);
  }
  function p(g) {
    return g === 60 || g === 62 || g === 92 ? (e.consume(g), h) : h(g);
  }
  function m(g) {
    return !c && (g === null || g === 41 || ae(g)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(g)) : c < u && g === 40 ? (e.consume(g), c++, m) : g === 41 ? (e.consume(g), c--, m) : g === null || g === 32 || g === 40 || mo(g) ? n(g) : (e.consume(g), g === 92 ? y : m);
  }
  function y(g) {
    return g === 40 || g === 41 || g === 92 ? (e.consume(g), m) : m(g);
  }
}
function Gy(e, t, n, r, i, a) {
  const o = this;
  let s = 0, l;
  return u;
  function u(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(a), c;
  }
  function c(h) {
    return s > 999 || h === null || h === 91 || h === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(h) : h === 93 ? (e.exit(a), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : H(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), f(h));
  }
  function f(h) {
    return h === null || h === 91 || h === 93 || H(h) || s++ > 999 ? (e.exit("chunkString"), c(h)) : (e.consume(h), l || (l = !Z(h)), h === 92 ? d : f);
  }
  function d(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), s++, f) : f(h);
  }
}
function qy(e, t, n, r, i, a) {
  let o;
  return s;
  function s(d) {
    return d === 34 || d === 39 || d === 40 ? (e.enter(r), e.enter(i), e.consume(d), e.exit(i), o = d === 40 ? 41 : d, l) : n(d);
  }
  function l(d) {
    return d === o ? (e.enter(i), e.consume(d), e.exit(i), e.exit(r), t) : (e.enter(a), u(d));
  }
  function u(d) {
    return d === o ? (e.exit(a), l(o)) : d === null ? n(d) : H(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), ee(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(d));
  }
  function c(d) {
    return d === o || d === null || H(d) ? (e.exit("chunkString"), u(d)) : (e.consume(d), d === 92 ? f : c);
  }
  function f(d) {
    return d === o || d === 92 ? (e.consume(d), c) : c(d);
  }
}
function Or(e, t) {
  let n;
  return r;
  function r(i) {
    return H(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : Z(i) ? ee(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const mE = {
  name: "definition",
  tokenize: yE
}, gE = {
  partial: !0,
  tokenize: wE
};
function yE(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(h) {
    return e.enter("definition"), o(h);
  }
  function o(h) {
    return Gy.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function s(h) {
    return i = at(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), l) : n(h);
  }
  function l(h) {
    return ae(h) ? Or(e, u)(h) : u(h);
  }
  function u(h) {
    return Hy(
      e,
      c,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function c(h) {
    return e.attempt(gE, f, f)(h);
  }
  function f(h) {
    return Z(h) ? ee(e, d, "whitespace")(h) : d(h);
  }
  function d(h) {
    return h === null || H(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function wE(e, t, n) {
  return r;
  function r(s) {
    return ae(s) ? Or(e, i)(s) : n(s);
  }
  function i(s) {
    return qy(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(s);
  }
  function a(s) {
    return Z(s) ? ee(e, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || H(s) ? t(s) : n(s);
  }
}
const vE = {
  name: "hardBreakEscape",
  tokenize: bE
};
function bE(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return H(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const xE = {
  name: "headingAtx",
  resolve: kE,
  tokenize: CE
};
function kE(e, t) {
  let n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Ke(e, r, n - r + 1, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]])), e;
}
function CE(e, t, n) {
  let r = 0;
  return i;
  function i(c) {
    return e.enter("atxHeading"), a(c);
  }
  function a(c) {
    return e.enter("atxHeadingSequence"), o(c);
  }
  function o(c) {
    return c === 35 && r++ < 6 ? (e.consume(c), o) : c === null || ae(c) ? (e.exit("atxHeadingSequence"), s(c)) : n(c);
  }
  function s(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), l(c)) : c === null || H(c) ? (e.exit("atxHeading"), t(c)) : Z(c) ? ee(e, s, "whitespace")(c) : (e.enter("atxHeadingText"), u(c));
  }
  function l(c) {
    return c === 35 ? (e.consume(c), l) : (e.exit("atxHeadingSequence"), s(c));
  }
  function u(c) {
    return c === null || c === 35 || ae(c) ? (e.exit("atxHeadingText"), s(c)) : (e.consume(c), u);
  }
}
const SE = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ld = ["pre", "script", "style", "textarea"], AE = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: PE,
  tokenize: IE
}, TE = {
  partial: !0,
  tokenize: ME
}, EE = {
  partial: !0,
  tokenize: RE
};
function PE(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function IE(e, t, n) {
  const r = this;
  let i, a, o, s, l;
  return u;
  function u(T) {
    return c(T);
  }
  function c(T) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(T), f;
  }
  function f(T) {
    return T === 33 ? (e.consume(T), d) : T === 47 ? (e.consume(T), a = !0, m) : T === 63 ? (e.consume(T), i = 3, r.interrupt ? t : S) : Oe(T) ? (e.consume(T), o = String.fromCharCode(T), y) : n(T);
  }
  function d(T) {
    return T === 45 ? (e.consume(T), i = 2, h) : T === 91 ? (e.consume(T), i = 5, s = 0, p) : Oe(T) ? (e.consume(T), i = 4, r.interrupt ? t : S) : n(T);
  }
  function h(T) {
    return T === 45 ? (e.consume(T), r.interrupt ? t : S) : n(T);
  }
  function p(T) {
    const Ne = "CDATA[";
    return T === Ne.charCodeAt(s++) ? (e.consume(T), s === Ne.length ? r.interrupt ? t : M : p) : n(T);
  }
  function m(T) {
    return Oe(T) ? (e.consume(T), o = String.fromCharCode(T), y) : n(T);
  }
  function y(T) {
    if (T === null || T === 47 || T === 62 || ae(T)) {
      const Ne = T === 47, Xe = o.toLowerCase();
      return !Ne && !a && Ld.includes(Xe) ? (i = 1, r.interrupt ? t(T) : M(T)) : SE.includes(o.toLowerCase()) ? (i = 6, Ne ? (e.consume(T), g) : r.interrupt ? t(T) : M(T)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(T) : a ? w(T) : v(T));
    }
    return T === 45 || Me(T) ? (e.consume(T), o += String.fromCharCode(T), y) : n(T);
  }
  function g(T) {
    return T === 62 ? (e.consume(T), r.interrupt ? t : M) : n(T);
  }
  function w(T) {
    return Z(T) ? (e.consume(T), w) : E(T);
  }
  function v(T) {
    return T === 47 ? (e.consume(T), E) : T === 58 || T === 95 || Oe(T) ? (e.consume(T), k) : Z(T) ? (e.consume(T), v) : E(T);
  }
  function k(T) {
    return T === 45 || T === 46 || T === 58 || T === 95 || Me(T) ? (e.consume(T), k) : x(T);
  }
  function x(T) {
    return T === 61 ? (e.consume(T), C) : Z(T) ? (e.consume(T), x) : v(T);
  }
  function C(T) {
    return T === null || T === 60 || T === 61 || T === 62 || T === 96 ? n(T) : T === 34 || T === 39 ? (e.consume(T), l = T, P) : Z(T) ? (e.consume(T), C) : I(T);
  }
  function P(T) {
    return T === l ? (e.consume(T), l = null, N) : T === null || H(T) ? n(T) : (e.consume(T), P);
  }
  function I(T) {
    return T === null || T === 34 || T === 39 || T === 47 || T === 60 || T === 61 || T === 62 || T === 96 || ae(T) ? x(T) : (e.consume(T), I);
  }
  function N(T) {
    return T === 47 || T === 62 || Z(T) ? v(T) : n(T);
  }
  function E(T) {
    return T === 62 ? (e.consume(T), L) : n(T);
  }
  function L(T) {
    return T === null || H(T) ? M(T) : Z(T) ? (e.consume(T), L) : n(T);
  }
  function M(T) {
    return T === 45 && i === 2 ? (e.consume(T), G) : T === 60 && i === 1 ? (e.consume(T), $) : T === 62 && i === 4 ? (e.consume(T), ne) : T === 63 && i === 3 ? (e.consume(T), S) : T === 93 && i === 5 ? (e.consume(T), U) : H(T) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(TE, _e, _)(T)) : T === null || H(T) ? (e.exit("htmlFlowData"), _(T)) : (e.consume(T), M);
  }
  function _(T) {
    return e.check(EE, D, _e)(T);
  }
  function D(T) {
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), j;
  }
  function j(T) {
    return T === null || H(T) ? _(T) : (e.enter("htmlFlowData"), M(T));
  }
  function G(T) {
    return T === 45 ? (e.consume(T), S) : M(T);
  }
  function $(T) {
    return T === 47 ? (e.consume(T), o = "", V) : M(T);
  }
  function V(T) {
    if (T === 62) {
      const Ne = o.toLowerCase();
      return Ld.includes(Ne) ? (e.consume(T), ne) : M(T);
    }
    return Oe(T) && o.length < 8 ? (e.consume(T), o += String.fromCharCode(T), V) : M(T);
  }
  function U(T) {
    return T === 93 ? (e.consume(T), S) : M(T);
  }
  function S(T) {
    return T === 62 ? (e.consume(T), ne) : T === 45 && i === 2 ? (e.consume(T), S) : M(T);
  }
  function ne(T) {
    return T === null || H(T) ? (e.exit("htmlFlowData"), _e(T)) : (e.consume(T), ne);
  }
  function _e(T) {
    return e.exit("htmlFlow"), t(T);
  }
}
function RE(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return H(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : n(o);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function ME(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(si, t, n);
  }
}
const DE = {
  name: "htmlText",
  tokenize: LE
};
function LE(e, t, n) {
  const r = this;
  let i, a, o;
  return s;
  function s(S) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(S), l;
  }
  function l(S) {
    return S === 33 ? (e.consume(S), u) : S === 47 ? (e.consume(S), x) : S === 63 ? (e.consume(S), v) : Oe(S) ? (e.consume(S), I) : n(S);
  }
  function u(S) {
    return S === 45 ? (e.consume(S), c) : S === 91 ? (e.consume(S), a = 0, p) : Oe(S) ? (e.consume(S), w) : n(S);
  }
  function c(S) {
    return S === 45 ? (e.consume(S), h) : n(S);
  }
  function f(S) {
    return S === null ? n(S) : S === 45 ? (e.consume(S), d) : H(S) ? (o = f, $(S)) : (e.consume(S), f);
  }
  function d(S) {
    return S === 45 ? (e.consume(S), h) : f(S);
  }
  function h(S) {
    return S === 62 ? G(S) : S === 45 ? d(S) : f(S);
  }
  function p(S) {
    const ne = "CDATA[";
    return S === ne.charCodeAt(a++) ? (e.consume(S), a === ne.length ? m : p) : n(S);
  }
  function m(S) {
    return S === null ? n(S) : S === 93 ? (e.consume(S), y) : H(S) ? (o = m, $(S)) : (e.consume(S), m);
  }
  function y(S) {
    return S === 93 ? (e.consume(S), g) : m(S);
  }
  function g(S) {
    return S === 62 ? G(S) : S === 93 ? (e.consume(S), g) : m(S);
  }
  function w(S) {
    return S === null || S === 62 ? G(S) : H(S) ? (o = w, $(S)) : (e.consume(S), w);
  }
  function v(S) {
    return S === null ? n(S) : S === 63 ? (e.consume(S), k) : H(S) ? (o = v, $(S)) : (e.consume(S), v);
  }
  function k(S) {
    return S === 62 ? G(S) : v(S);
  }
  function x(S) {
    return Oe(S) ? (e.consume(S), C) : n(S);
  }
  function C(S) {
    return S === 45 || Me(S) ? (e.consume(S), C) : P(S);
  }
  function P(S) {
    return H(S) ? (o = P, $(S)) : Z(S) ? (e.consume(S), P) : G(S);
  }
  function I(S) {
    return S === 45 || Me(S) ? (e.consume(S), I) : S === 47 || S === 62 || ae(S) ? N(S) : n(S);
  }
  function N(S) {
    return S === 47 ? (e.consume(S), G) : S === 58 || S === 95 || Oe(S) ? (e.consume(S), E) : H(S) ? (o = N, $(S)) : Z(S) ? (e.consume(S), N) : G(S);
  }
  function E(S) {
    return S === 45 || S === 46 || S === 58 || S === 95 || Me(S) ? (e.consume(S), E) : L(S);
  }
  function L(S) {
    return S === 61 ? (e.consume(S), M) : H(S) ? (o = L, $(S)) : Z(S) ? (e.consume(S), L) : N(S);
  }
  function M(S) {
    return S === null || S === 60 || S === 61 || S === 62 || S === 96 ? n(S) : S === 34 || S === 39 ? (e.consume(S), i = S, _) : H(S) ? (o = M, $(S)) : Z(S) ? (e.consume(S), M) : (e.consume(S), D);
  }
  function _(S) {
    return S === i ? (e.consume(S), i = void 0, j) : S === null ? n(S) : H(S) ? (o = _, $(S)) : (e.consume(S), _);
  }
  function D(S) {
    return S === null || S === 34 || S === 39 || S === 60 || S === 61 || S === 96 ? n(S) : S === 47 || S === 62 || ae(S) ? N(S) : (e.consume(S), D);
  }
  function j(S) {
    return S === 47 || S === 62 || ae(S) ? N(S) : n(S);
  }
  function G(S) {
    return S === 62 ? (e.consume(S), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(S);
  }
  function $(S) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), V;
  }
  function V(S) {
    return Z(S) ? ee(e, U, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(S) : U(S);
  }
  function U(S) {
    return e.enter("htmlTextData"), o(S);
  }
}
const Au = {
  name: "labelEnd",
  resolveAll: _E,
  resolveTo: zE,
  tokenize: VE
}, NE = {
  tokenize: $E
}, OE = {
  tokenize: jE
}, FE = {
  tokenize: BE
};
function _E(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && Ke(e, 0, e.length, n), e;
}
function zE(e, t) {
  let n = e.length, r = 0, i, a, o, s;
  for (; n--; )
    if (i = e[n][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = n);
  const l = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, u = {
    type: "label",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, c = {
    type: "labelText",
    start: {
      ...e[a + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return s = [["enter", l, t], ["enter", u, t]], s = Qe(s, e.slice(a + 1, a + r + 3)), s = Qe(s, [["enter", c, t]]), s = Qe(s, Bo(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), t)), s = Qe(s, [["exit", c, t], e[o - 2], e[o - 1], ["exit", u, t]]), s = Qe(s, e.slice(o + 1)), s = Qe(s, [["exit", l, t]]), Ke(e, a, e.length, s), e;
}
function VE(e, t, n) {
  const r = this;
  let i = r.events.length, a, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return s;
  function s(d) {
    return a ? a._inactive ? f(d) : (o = r.parser.defined.includes(at(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(d), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(d);
  }
  function l(d) {
    return d === 40 ? e.attempt(NE, c, o ? c : f)(d) : d === 91 ? e.attempt(OE, c, o ? u : f)(d) : o ? c(d) : f(d);
  }
  function u(d) {
    return e.attempt(FE, c, f)(d);
  }
  function c(d) {
    return t(d);
  }
  function f(d) {
    return a._balanced = !0, n(d);
  }
}
function $E(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return ae(f) ? Or(e, a)(f) : a(f);
  }
  function a(f) {
    return f === 41 ? c(f) : Hy(e, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function o(f) {
    return ae(f) ? Or(e, l)(f) : c(f);
  }
  function s(f) {
    return n(f);
  }
  function l(f) {
    return f === 34 || f === 39 || f === 40 ? qy(e, u, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : c(f);
  }
  function u(f) {
    return ae(f) ? Or(e, c)(f) : c(f);
  }
  function c(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function jE(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return Gy.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(s);
  }
  function a(s) {
    return r.parser.defined.includes(at(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(s) : n(s);
  }
  function o(s) {
    return n(s);
  }
}
function BE(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const WE = {
  name: "labelStartImage",
  resolveAll: Au.resolveAll,
  tokenize: UE
};
function UE(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), a;
  }
  function a(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), o) : n(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const HE = {
  name: "labelStartLink",
  resolveAll: Au.resolveAll,
  tokenize: GE
};
function GE(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const Ma = {
  name: "lineEnding",
  tokenize: qE
};
function qE(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), ee(e, t, "linePrefix");
  }
}
const Ji = {
  name: "thematicBreak",
  tokenize: KE
};
function KE(e, t, n) {
  let r = 0, i;
  return a;
  function a(u) {
    return e.enter("thematicBreak"), o(u);
  }
  function o(u) {
    return i = u, s(u);
  }
  function s(u) {
    return u === i ? (e.enter("thematicBreakSequence"), l(u)) : r >= 3 && (u === null || H(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), r++, l) : (e.exit("thematicBreakSequence"), Z(u) ? ee(e, s, "whitespace")(u) : s(u));
  }
}
const ze = {
  continuation: {
    tokenize: JE
  },
  exit: eP,
  name: "list",
  tokenize: ZE
}, YE = {
  partial: !0,
  tokenize: tP
}, XE = {
  partial: !0,
  tokenize: QE
};
function ZE(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return s;
  function s(h) {
    const p = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (p === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : qs(h)) {
      if (r.containerState.type || (r.containerState.type = p, e.enter(p, {
        _container: !0
      })), p === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(Ji, n, u)(h) : u(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(h);
    }
    return n(h);
  }
  function l(h) {
    return qs(h) && ++o < 10 ? (e.consume(h), l) : (!r.interrupt || o < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), u(h)) : n(h);
  }
  function u(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      si,
      // Can’t be empty when interrupting.
      r.interrupt ? n : c,
      e.attempt(YE, d, f)
    );
  }
  function c(h) {
    return r.containerState.initialBlankLine = !0, a++, d(h);
  }
  function f(h) {
    return Z(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), d) : n(h);
  }
  function d(h) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function JE(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(si, i, a);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, ee(e, t, "listItemIndent", r.containerState.size + 1)(s);
  }
  function a(s) {
    return r.containerState.furtherBlankLines || !Z(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(XE, t, o)(s));
  }
  function o(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, ee(e, e.attempt(ze, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s);
  }
}
function QE(e, t, n) {
  const r = this;
  return ee(e, i, "listItemIndent", r.containerState.size + 1);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(a) : n(a);
  }
}
function eP(e) {
  e.exit(this.containerState.type);
}
function tP(e, t, n) {
  const r = this;
  return ee(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return !Z(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const Nd = {
  name: "setextUnderline",
  resolveTo: nP,
  tokenize: rP
};
function nP(e, t) {
  let n = e.length, r, i, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[a][1].end
  }) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function rP(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(u) {
    let c = r.events.length, f;
    for (; c--; )
      if (r.events[c][1].type !== "lineEnding" && r.events[c][1].type !== "linePrefix" && r.events[c][1].type !== "content") {
        f = r.events[c][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), i = u, o(u)) : n(u);
  }
  function o(u) {
    return e.enter("setextHeadingLineSequence"), s(u);
  }
  function s(u) {
    return u === i ? (e.consume(u), s) : (e.exit("setextHeadingLineSequence"), Z(u) ? ee(e, l, "lineSuffix")(u) : l(u));
  }
  function l(u) {
    return u === null || H(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const iP = {
  tokenize: oP
};
function oP(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    si,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, ee(e, e.attempt(this.parser.constructs.flow, i, e.attempt(cE, i)), "linePrefix"))
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const aP = {
  resolveAll: Yy()
}, sP = Ky("string"), lP = Ky("text");
function Ky(e) {
  return {
    resolveAll: Yy(e === "text" ? uP : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], a = n.attempt(i, o, s);
    return o;
    function o(c) {
      return u(c) ? a(c) : s(c);
    }
    function s(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), l;
    }
    function l(c) {
      return u(c) ? (n.exit("data"), a(c)) : (n.consume(c), l);
    }
    function u(c) {
      if (c === null)
        return !0;
      const f = i[c];
      let d = -1;
      if (f)
        for (; ++d < f.length; ) {
          const h = f[d];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Yy(e) {
  return t;
  function t(n, r) {
    let i = -1, a;
    for (; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function uP(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let a = i.length, o = -1, s = 0, l;
      for (; a--; ) {
        const u = i[a];
        if (typeof u == "string") {
          for (o = u.length; u.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o) break;
          o = -1;
        } else if (u === -2)
          l = !0, s++;
        else if (u !== -1) {
          a++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (s = 0), s) {
        const u = {
          type: n === e.length || l || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: a ? o : r.start._bufferIndex + o,
            _index: r.start._index + a,
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...u.start
        }, r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(n, 0, ["enter", u, t], ["exit", u, t]), n += 2);
      }
      n++;
    }
  return e;
}
const cP = {
  42: ze,
  43: ze,
  45: ze,
  48: ze,
  49: ze,
  50: ze,
  51: ze,
  52: ze,
  53: ze,
  54: ze,
  55: ze,
  56: ze,
  57: ze,
  62: jy
}, fP = {
  91: mE
}, dP = {
  [-2]: Ra,
  [-1]: Ra,
  32: Ra
}, hP = {
  35: xE,
  42: Ji,
  45: [Nd, Ji],
  60: AE,
  61: Nd,
  95: Ji,
  96: Dd,
  126: Dd
}, pP = {
  38: Wy,
  92: By
}, mP = {
  [-5]: Ma,
  [-4]: Ma,
  [-3]: Ma,
  33: WE,
  38: Wy,
  42: Ks,
  60: [HT, DE],
  91: HE,
  92: [vE, By],
  93: Au,
  95: Ks,
  96: iE
}, gP = {
  null: [Ks, aP]
}, yP = {
  null: [42, 95]
}, wP = {
  null: []
}, vP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: yP,
  contentInitial: fP,
  disable: wP,
  document: cP,
  flow: hP,
  flowInitial: dP,
  insideSpan: gP,
  string: pP,
  text: mP
}, Symbol.toStringTag, { value: "Module" }));
function bP(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, a = [];
  let o = [], s = [];
  const l = {
    attempt: P(x),
    check: P(C),
    consume: w,
    enter: v,
    exit: k,
    interrupt: P(C, {
      interrupt: !0
    })
  }, u = {
    code: null,
    containerState: {},
    defineSkip: m,
    events: [],
    now: p,
    parser: e,
    previous: null,
    sliceSerialize: d,
    sliceStream: h,
    write: f
  };
  let c = t.tokenize.call(u, l);
  return t.resolveAll && a.push(t), u;
  function f(L) {
    return o = Qe(o, L), y(), o[o.length - 1] !== null ? [] : (I(t, 0), u.events = Bo(a, u.events, u), u.events);
  }
  function d(L, M) {
    return kP(h(L), M);
  }
  function h(L) {
    return xP(o, L);
  }
  function p() {
    const {
      _bufferIndex: L,
      _index: M,
      line: _,
      column: D,
      offset: j
    } = r;
    return {
      _bufferIndex: L,
      _index: M,
      line: _,
      column: D,
      offset: j
    };
  }
  function m(L) {
    i[L.line] = L.column, E();
  }
  function y() {
    let L;
    for (; r._index < o.length; ) {
      const M = o[r._index];
      if (typeof M == "string")
        for (L = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === L && r._bufferIndex < M.length; )
          g(M.charCodeAt(r._bufferIndex));
      else
        g(M);
    }
  }
  function g(L) {
    c = c(L);
  }
  function w(L) {
    H(L) ? (r.line++, r.column = 1, r.offset += L === -3 ? 2 : 1, E()) : L !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = L;
  }
  function v(L, M) {
    const _ = M || {};
    return _.type = L, _.start = p(), u.events.push(["enter", _, u]), s.push(_), _;
  }
  function k(L) {
    const M = s.pop();
    return M.end = p(), u.events.push(["exit", M, u]), M;
  }
  function x(L, M) {
    I(L, M.from);
  }
  function C(L, M) {
    M.restore();
  }
  function P(L, M) {
    return _;
    function _(D, j, G) {
      let $, V, U, S;
      return Array.isArray(D) ? (
        /* c8 ignore next 1 */
        _e(D)
      ) : "tokenize" in D ? (
        // Looks like a construct.
        _e([
          /** @type {Construct} */
          D
        ])
      ) : ne(D);
      function ne(de) {
        return ke;
        function ke(be) {
          const pe = be !== null && de[be], Ie = be !== null && de.null, ht = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(pe) ? pe : pe ? [pe] : [],
            ...Array.isArray(Ie) ? Ie : Ie ? [Ie] : []
          ];
          return _e(ht)(be);
        }
      }
      function _e(de) {
        return $ = de, V = 0, de.length === 0 ? G : T(de[V]);
      }
      function T(de) {
        return ke;
        function ke(be) {
          return S = N(), U = de, de.partial || (u.currentConstruct = de), de.name && u.parser.constructs.disable.null.includes(de.name) ? Xe() : de.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            M ? Object.assign(Object.create(u), M) : u,
            l,
            Ne,
            Xe
          )(be);
        }
      }
      function Ne(de) {
        return L(U, S), j;
      }
      function Xe(de) {
        return S.restore(), ++V < $.length ? T($[V]) : G;
      }
    }
  }
  function I(L, M) {
    L.resolveAll && !a.includes(L) && a.push(L), L.resolve && Ke(u.events, M, u.events.length - M, L.resolve(u.events.slice(M), u)), L.resolveTo && (u.events = L.resolveTo(u.events, u));
  }
  function N() {
    const L = p(), M = u.previous, _ = u.currentConstruct, D = u.events.length, j = Array.from(s);
    return {
      from: D,
      restore: G
    };
    function G() {
      r = L, u.previous = M, u.currentConstruct = _, u.events.length = D, s = j, E();
    }
  }
  function E() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function xP(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex;
  let o;
  if (n === i)
    o = [e[n].slice(r, a)];
  else {
    if (o = e.slice(n, i), r > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(r) : o.shift();
    }
    a > 0 && o.push(e[i].slice(0, a));
  }
  return o;
}
function kP(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const a = e[n];
    let o;
    if (typeof a == "string")
      o = a;
    else switch (a) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(a);
    }
    i = a === -2, r.push(o);
  }
  return r.join("");
}
function CP(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Vy([vP, ...(e || {}).extensions || []])
    ),
    content: i(zT),
    defined: [],
    document: i($T),
    flow: i(iP),
    lazy: {},
    string: i(sP),
    text: i(lP)
  };
  return r;
  function i(a) {
    return o;
    function o(s) {
      return bP(r, a, s);
    }
  }
}
function SP(e) {
  for (; !Uy(e); )
    ;
  return e;
}
const Od = /[\0\t\n\r]/g;
function AP() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(a, o, s) {
    const l = [];
    let u, c, f, d, h;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), f = 0, t = "", n && (a.charCodeAt(0) === 65279 && f++, n = void 0); f < a.length; ) {
      if (Od.lastIndex = f, u = Od.exec(a), d = u && u.index !== void 0 ? u.index : a.length, h = a.charCodeAt(d), !u) {
        t = a.slice(f);
        break;
      }
      if (h === 10 && f === d && r)
        l.push(-3), r = void 0;
      else
        switch (r && (l.push(-5), r = void 0), f < d && (l.push(a.slice(f, d)), e += d - f), h) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (c = Math.ceil(e / 4) * 4, l.push(-2); e++ < c; ) l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = d + 1;
    }
    return s && (r && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
const TP = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function EP(e) {
  return e.replace(TP, PP);
}
function PP(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), a = i === 120 || i === 88;
    return $y(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return Su(n) || e;
}
const Xy = {}.hasOwnProperty;
function IP(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), RP(n)(SP(CP(n).document().write(AP()(e, t, !0))));
}
function RP(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(dn),
      autolinkProtocol: N,
      autolinkEmail: N,
      atxHeading: a(fi),
      blockQuote: a(Ie),
      characterEscape: N,
      characterReference: N,
      codeFenced: a(ht),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a(ht, o),
      codeText: a(ui, o),
      codeTextData: N,
      data: N,
      codeFlowValue: N,
      definition: a(fn),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(ci),
      hardBreakEscape: a(di),
      hardBreakTrailing: a(di),
      htmlFlow: a(hi, o),
      htmlFlowData: N,
      htmlText: a(hi, o),
      htmlTextData: N,
      image: a(qo),
      label: o,
      link: a(dn),
      listItem: a(D1),
      listItemValue: d,
      listOrdered: a(Fu, f),
      listUnordered: a(Fu),
      paragraph: a(L1),
      reference: T,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(fi),
      strong: a(N1),
      thematicBreak: a(F1)
    },
    exit: {
      atxHeading: l(),
      atxHeadingSequence: x,
      autolink: l(),
      autolinkEmail: pe,
      autolinkProtocol: be,
      blockQuote: l(),
      characterEscapeValue: E,
      characterReferenceMarkerHexadecimal: Xe,
      characterReferenceMarkerNumeric: Xe,
      characterReferenceValue: de,
      characterReference: ke,
      codeFenced: l(y),
      codeFencedFence: m,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: p,
      codeFlowValue: E,
      codeIndented: l(g),
      codeText: l(j),
      codeTextData: E,
      data: E,
      definition: l(),
      definitionDestinationString: k,
      definitionLabelString: w,
      definitionTitleString: v,
      emphasis: l(),
      hardBreakEscape: l(M),
      hardBreakTrailing: l(M),
      htmlFlow: l(_),
      htmlFlowData: E,
      htmlText: l(D),
      htmlTextData: E,
      image: l($),
      label: U,
      labelText: V,
      lineEnding: L,
      link: l(G),
      listItem: l(),
      listOrdered: l(),
      listUnordered: l(),
      paragraph: l(),
      referenceString: Ne,
      resourceDestinationString: S,
      resourceTitleString: ne,
      resource: _e,
      setextHeading: l(I),
      setextHeadingLineSequence: P,
      setextHeadingText: C,
      strong: l(),
      thematicBreak: l()
    }
  };
  Zy(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(R) {
    let z = {
      type: "root",
      children: []
    };
    const K = {
      stack: [z],
      tokenStack: [],
      config: t,
      enter: s,
      exit: u,
      buffer: o,
      resume: c,
      data: n
    }, J = [];
    let ie = -1;
    for (; ++ie < R.length; )
      if (R[ie][1].type === "listOrdered" || R[ie][1].type === "listUnordered")
        if (R[ie][0] === "enter")
          J.push(ie);
        else {
          const nt = J.pop();
          ie = i(R, nt, ie);
        }
    for (ie = -1; ++ie < R.length; ) {
      const nt = t[R[ie][0]];
      Xy.call(nt, R[ie][1].type) && nt[R[ie][1].type].call(Object.assign({
        sliceSerialize: R[ie][2].sliceSerialize
      }, K), R[ie][1]);
    }
    if (K.tokenStack.length > 0) {
      const nt = K.tokenStack[K.tokenStack.length - 1];
      (nt[1] || Fd).call(K, void 0, nt[0]);
    }
    for (z.position = {
      start: qt(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: qt(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, ie = -1; ++ie < t.transforms.length; )
      z = t.transforms[ie](z) || z;
    return z;
  }
  function i(R, z, K) {
    let J = z - 1, ie = -1, nt = !1, hn, Et, pr, mr;
    for (; ++J <= K; ) {
      const We = R[J];
      switch (We[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          We[0] === "enter" ? ie++ : ie--, mr = void 0;
          break;
        }
        case "lineEndingBlank": {
          We[0] === "enter" && (hn && !mr && !ie && !pr && (pr = J), mr = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          mr = void 0;
      }
      if (!ie && We[0] === "enter" && We[1].type === "listItemPrefix" || ie === -1 && We[0] === "exit" && (We[1].type === "listUnordered" || We[1].type === "listOrdered")) {
        if (hn) {
          let Rn = J;
          for (Et = void 0; Rn--; ) {
            const Pt = R[Rn];
            if (Pt[1].type === "lineEnding" || Pt[1].type === "lineEndingBlank") {
              if (Pt[0] === "exit") continue;
              Et && (R[Et][1].type = "lineEndingBlank", nt = !0), Pt[1].type = "lineEnding", Et = Rn;
            } else if (!(Pt[1].type === "linePrefix" || Pt[1].type === "blockQuotePrefix" || Pt[1].type === "blockQuotePrefixWhitespace" || Pt[1].type === "blockQuoteMarker" || Pt[1].type === "listItemIndent")) break;
          }
          pr && (!Et || pr < Et) && (hn._spread = !0), hn.end = Object.assign({}, Et ? R[Et][1].start : We[1].end), R.splice(Et || J, 0, ["exit", hn, We[2]]), J++, K++;
        }
        if (We[1].type === "listItemPrefix") {
          const Rn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, We[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          hn = Rn, R.splice(J, 0, ["enter", Rn, We[2]]), J++, K++, pr = void 0, mr = !0;
        }
      }
    }
    return R[z][1]._spread = nt, K;
  }
  function a(R, z) {
    return K;
    function K(J) {
      s.call(this, R(J), J), z && z.call(this, J);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(R, z, K) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([z, K || void 0]), R.position = {
      start: qt(z.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function l(R) {
    return z;
    function z(K) {
      R && R.call(this, K), u.call(this, K);
    }
  }
  function u(R, z) {
    const K = this.stack.pop(), J = this.tokenStack.pop();
    if (J)
      J[0].type !== R.type && (z ? z.call(this, R, J[0]) : (J[1] || Fd).call(this, R, J[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + Nr({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    K.position.end = qt(R.end);
  }
  function c() {
    return Cu(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function d(R) {
    if (this.data.expectingFirstListItemValue) {
      const z = this.stack[this.stack.length - 2];
      z.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.lang = R;
  }
  function p() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.meta = R;
  }
  function m() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function y() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function g() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function w(R) {
    const z = this.resume(), K = this.stack[this.stack.length - 1];
    K.label = z, K.identifier = at(this.sliceSerialize(R)).toLowerCase();
  }
  function v() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function k() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function x(R) {
    const z = this.stack[this.stack.length - 1];
    if (!z.depth) {
      const K = this.sliceSerialize(R).length;
      z.depth = K;
    }
  }
  function C() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function P(R) {
    const z = this.stack[this.stack.length - 1];
    z.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function I() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function N(R) {
    const K = this.stack[this.stack.length - 1].children;
    let J = K[K.length - 1];
    (!J || J.type !== "text") && (J = O1(), J.position = {
      start: qt(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, K.push(J)), this.stack.push(J);
  }
  function E(R) {
    const z = this.stack.pop();
    z.value += this.sliceSerialize(R), z.position.end = qt(R.end);
  }
  function L(R) {
    const z = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const K = z.children[z.children.length - 1];
      K.position.end = qt(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(z.type) && (N.call(this, R), E.call(this, R));
  }
  function M() {
    this.data.atHardBreak = !0;
  }
  function _() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function D() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function j() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = R;
  }
  function G() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function $() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = z, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function V(R) {
    const z = this.sliceSerialize(R), K = this.stack[this.stack.length - 2];
    K.label = EP(z), K.identifier = at(z).toLowerCase();
  }
  function U() {
    const R = this.stack[this.stack.length - 1], z = this.resume(), K = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, K.type === "link") {
      const J = R.children;
      K.children = J;
    } else
      K.alt = z;
  }
  function S() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = R;
  }
  function ne() {
    const R = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = R;
  }
  function _e() {
    this.data.inReference = void 0;
  }
  function T() {
    this.data.referenceType = "collapsed";
  }
  function Ne(R) {
    const z = this.resume(), K = this.stack[this.stack.length - 1];
    K.label = z, K.identifier = at(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function Xe(R) {
    this.data.characterReferenceType = R.type;
  }
  function de(R) {
    const z = this.sliceSerialize(R), K = this.data.characterReferenceType;
    let J;
    K ? (J = $y(z, K === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : J = Su(z);
    const ie = this.stack[this.stack.length - 1];
    ie.value += J;
  }
  function ke(R) {
    const z = this.stack.pop();
    z.position.end = qt(R.end);
  }
  function be(R) {
    E.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = this.sliceSerialize(R);
  }
  function pe(R) {
    E.call(this, R);
    const z = this.stack[this.stack.length - 1];
    z.url = "mailto:" + this.sliceSerialize(R);
  }
  function Ie() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ht() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function ui() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function fn() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ci() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function fi() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function di() {
    return {
      type: "break"
    };
  }
  function hi() {
    return {
      type: "html",
      value: ""
    };
  }
  function qo() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function dn() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Fu(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function D1(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function L1() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function N1() {
    return {
      type: "strong",
      children: []
    };
  }
  function O1() {
    return {
      type: "text",
      value: ""
    };
  }
  function F1() {
    return {
      type: "thematicBreak"
    };
  }
}
function qt(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Zy(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Zy(e, r) : MP(e, r);
  }
}
function MP(e, t) {
  let n;
  for (n in t)
    if (Xy.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Fd(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Nr({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Nr({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Nr({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function DP(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return IP(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function LP(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function NP(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function OP(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function FP(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function _P(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function zP(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = hr(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let o, s = e.footnoteCounts.get(r);
  s === void 0 ? (s = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, s += 1, e.footnoteCounts.set(r, s);
  const l = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, l);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return e.patch(t, u), e.applyData(t, u);
}
function VP(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function $P(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Jy(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function jP(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Jy(e, t);
  const i = { src: hr(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function BP(e, t) {
  const n = { src: hr(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function WP(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function UP(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Jy(e, t);
  const i = { href: hr(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function HP(e, t) {
  const n = { href: hr(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function GP(e, t, n) {
  const r = e.all(t), i = n ? qP(n) : Qy(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const c = r[0];
    let f;
    c && c.type === "element" && c.tagName === "p" ? f = c : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const c = r[s];
    (i || s !== 0 || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` }), c.type === "element" && c.tagName === "p" && !i ? o.push(...c.children) : o.push(c);
  }
  const l = r[r.length - 1];
  l && (i || l.type !== "element" || l.tagName !== "p") && o.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, u), e.applyData(t, u);
}
function qP(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Qy(n[r]);
  }
  return t;
}
function Qy(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function KP(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function YP(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function XP(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function ZP(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function JP(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = vu(t.children[1]), l = Dy(t.children[t.children.length - 1]);
    s && l && (o.position = { start: s, end: l }), i.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function QP(e, t, n) {
  const r = n ? n.children : void 0, a = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, s = o ? o.length : t.children.length;
  let l = -1;
  const u = [];
  for (; ++l < s; ) {
    const f = t.children[l], d = {}, h = o ? o[l] : void 0;
    h && (d.align = h);
    let p = { type: "element", tagName: a, properties: d, children: [] };
    f && (p.children = e.all(f), e.patch(f, p), p = e.applyData(f, p)), u.push(p);
  }
  const c = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, c), e.applyData(t, c);
}
function e7(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const _d = 9, zd = 32;
function t7(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const a = [];
  for (; r; )
    a.push(
      Vd(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return a.push(Vd(t.slice(i), i > 0, !1)), a.join("");
}
function Vd(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let a = e.codePointAt(r);
    for (; a === _d || a === zd; )
      r++, a = e.codePointAt(r);
  }
  if (n) {
    let a = e.codePointAt(i - 1);
    for (; a === _d || a === zd; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function n7(e, t) {
  const n = { type: "text", value: t7(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function r7(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const i7 = {
  blockquote: LP,
  break: NP,
  code: OP,
  delete: FP,
  emphasis: _P,
  footnoteReference: zP,
  heading: VP,
  html: $P,
  imageReference: jP,
  image: BP,
  inlineCode: WP,
  linkReference: UP,
  link: HP,
  listItem: GP,
  list: KP,
  paragraph: YP,
  // @ts-expect-error: root is different, but hard to type.
  root: XP,
  strong: ZP,
  table: JP,
  tableCell: e7,
  tableRow: QP,
  text: n7,
  thematicBreak: r7,
  toml: Ei,
  yaml: Ei,
  definition: Ei,
  footnoteDefinition: Ei
};
function Ei() {
}
const e1 = -1, Wo = 0, Fr = 1, go = 2, Tu = 3, Eu = 4, Pu = 5, Iu = 6, t1 = 7, n1 = 8, $d = typeof self == "object" ? self : globalThis, o7 = (e, t) => {
  const n = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, o] = t[i];
    switch (a) {
      case Wo:
      case e1:
        return n(o, i);
      case Fr: {
        const s = n([], i);
        for (const l of o)
          s.push(r(l));
        return s;
      }
      case go: {
        const s = n({}, i);
        for (const [l, u] of o)
          s[r(l)] = r(u);
        return s;
      }
      case Tu:
        return n(new Date(o), i);
      case Eu: {
        const { source: s, flags: l } = o;
        return n(new RegExp(s, l), i);
      }
      case Pu: {
        const s = n(/* @__PURE__ */ new Map(), i);
        for (const [l, u] of o)
          s.set(r(l), r(u));
        return s;
      }
      case Iu: {
        const s = n(/* @__PURE__ */ new Set(), i);
        for (const l of o)
          s.add(r(l));
        return s;
      }
      case t1: {
        const { name: s, message: l } = o;
        return n(new $d[s](l), i);
      }
      case n1:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: s } = new Uint8Array(o);
        return n(new DataView(s), o);
      }
    }
    return n(new $d[a](o), i);
  };
  return r;
}, jd = (e) => o7(/* @__PURE__ */ new Map(), e)(0), _n = "", { toString: a7 } = {}, { keys: s7 } = Object, kr = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [Wo, t];
  const n = a7.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Fr, _n];
    case "Object":
      return [go, _n];
    case "Date":
      return [Tu, _n];
    case "RegExp":
      return [Eu, _n];
    case "Map":
      return [Pu, _n];
    case "Set":
      return [Iu, _n];
    case "DataView":
      return [Fr, n];
  }
  return n.includes("Array") ? [Fr, n] : n.includes("Error") ? [t1, n] : [go, n];
}, Pi = ([e, t]) => e === Wo && (t === "function" || t === "symbol"), l7 = (e, t, n, r) => {
  const i = (o, s) => {
    const l = r.push(o) - 1;
    return n.set(s, l), l;
  }, a = (o) => {
    if (n.has(o))
      return n.get(o);
    let [s, l] = kr(o);
    switch (s) {
      case Wo: {
        let c = o;
        switch (l) {
          case "bigint":
            s = n1, c = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + l);
            c = null;
            break;
          case "undefined":
            return i([e1], o);
        }
        return i([s, c], o);
      }
      case Fr: {
        if (l) {
          let d = o;
          return l === "DataView" ? d = new Uint8Array(o.buffer) : l === "ArrayBuffer" && (d = new Uint8Array(o)), i([l, [...d]], o);
        }
        const c = [], f = i([s, c], o);
        for (const d of o)
          c.push(a(d));
        return f;
      }
      case go: {
        if (l)
          switch (l) {
            case "BigInt":
              return i([l, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([l, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return a(o.toJSON());
        const c = [], f = i([s, c], o);
        for (const d of s7(o))
          (e || !Pi(kr(o[d]))) && c.push([a(d), a(o[d])]);
        return f;
      }
      case Tu:
        return i([s, o.toISOString()], o);
      case Eu: {
        const { source: c, flags: f } = o;
        return i([s, { source: c, flags: f }], o);
      }
      case Pu: {
        const c = [], f = i([s, c], o);
        for (const [d, h] of o)
          (e || !(Pi(kr(d)) || Pi(kr(h)))) && c.push([a(d), a(h)]);
        return f;
      }
      case Iu: {
        const c = [], f = i([s, c], o);
        for (const d of o)
          (e || !Pi(kr(d))) && c.push(a(d));
        return f;
      }
    }
    const { message: u } = o;
    return i([s, { name: l, message: u }], o);
  };
  return a;
}, Bd = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return l7(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, kn = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? jd(Bd(e, t)) : structuredClone(e)
) : (e, t) => jd(Bd(e, t));
function u7(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function c7(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function f7(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || u7, r = e.options.footnoteBackLabel || c7, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let l = -1;
  for (; ++l < e.footnoteOrder.length; ) {
    const u = e.footnoteById.get(
      e.footnoteOrder[l]
    );
    if (!u)
      continue;
    const c = e.all(u), f = String(u.identifier).toUpperCase(), d = hr(f.toLowerCase());
    let h = 0;
    const p = [], m = e.footnoteCounts.get(f);
    for (; m !== void 0 && ++h <= m; ) {
      p.length > 0 && p.push({ type: "text", value: " " });
      let w = typeof n == "string" ? n : n(l, h);
      typeof w == "string" && (w = { type: "text", value: w }), p.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + d + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(l, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(w) ? w : [w]
      });
    }
    const y = c[c.length - 1];
    if (y && y.type === "element" && y.tagName === "p") {
      const w = y.children[y.children.length - 1];
      w && w.type === "text" ? w.value += " " : y.children.push({ type: "text", value: " " }), y.children.push(...p);
    } else
      c.push(...p);
    const g = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + d },
      children: e.wrap(c, !0)
    };
    e.patch(u, g), s.push(g);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...kn(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Uo = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return m7;
    if (typeof e == "function")
      return Ho(e);
    if (typeof e == "object")
      return Array.isArray(e) ? d7(e) : h7(e);
    if (typeof e == "string")
      return p7(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function d7(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Uo(e[n]);
  return Ho(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, i)) return !0;
    return !1;
  }
}
function h7(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Ho(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let a;
    for (a in e)
      if (i[a] !== t[a]) return !1;
    return !0;
  }
}
function p7(e) {
  return Ho(t);
  function t(n) {
    return n && n.type === e;
  }
}
function Ho(e) {
  return t;
  function t(n, r, i) {
    return !!(g7(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function m7() {
  return !0;
}
function g7(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const r1 = [], y7 = !0, Ys = !1, w7 = "skip";
function i1(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const a = Uo(i), o = r ? -1 : 1;
  s(e, void 0, [])();
  function s(l, u, c) {
    const f = (
      /** @type {Record<string, unknown>} */
      l && typeof l == "object" ? l : {}
    );
    if (typeof f.type == "string") {
      const h = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(d, "name", {
        value: "node (" + (l.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return d;
    function d() {
      let h = r1, p, m, y;
      if ((!t || a(l, u, c[c.length - 1] || void 0)) && (h = v7(n(l, c)), h[0] === Ys))
        return h;
      if ("children" in l && l.children) {
        const g = (
          /** @type {UnistParent} */
          l
        );
        if (g.children && h[0] !== w7)
          for (m = (r ? g.children.length : -1) + o, y = c.concat(g); m > -1 && m < g.children.length; ) {
            const w = g.children[m];
            if (p = s(w, m, y)(), p[0] === Ys)
              return p;
            m = typeof p[1] == "number" ? p[1] : m + o;
          }
      }
      return h;
    }
  }
}
function v7(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [y7, e] : e == null ? r1 : [e];
}
function Go(e, t, n, r) {
  let i, a, o;
  typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), i1(e, a, s, i);
  function s(l, u) {
    const c = u[u.length - 1], f = c ? c.children.indexOf(l) : void 0;
    return o(l, f, c);
  }
}
const Xs = {}.hasOwnProperty, b7 = {};
function x7(e, t) {
  const n = t || b7, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...i7, ...n.handlers }, s = {
    all: u,
    applyData: C7,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: l,
    options: n,
    patch: k7,
    wrap: A7
  };
  return Go(e, function(c) {
    if (c.type === "definition" || c.type === "footnoteDefinition") {
      const f = c.type === "definition" ? r : i, d = String(c.identifier).toUpperCase();
      f.has(d) || f.set(d, c);
    }
  }), s;
  function l(c, f) {
    const d = c.type, h = s.handlers[d];
    if (Xs.call(s.handlers, d) && h)
      return h(s, c, f);
    if (s.options.passThrough && s.options.passThrough.includes(d)) {
      if ("children" in c) {
        const { children: m, ...y } = c, g = kn(y);
        return g.children = s.all(c), g;
      }
      return kn(c);
    }
    return (s.options.unknownHandler || S7)(s, c, f);
  }
  function u(c) {
    const f = [];
    if ("children" in c) {
      const d = c.children;
      let h = -1;
      for (; ++h < d.length; ) {
        const p = s.one(d[h], c);
        if (p) {
          if (h && d[h - 1].type === "break" && (!Array.isArray(p) && p.type === "text" && (p.value = Wd(p.value)), !Array.isArray(p) && p.type === "element")) {
            const m = p.children[0];
            m && m.type === "text" && (m.value = Wd(m.value));
          }
          Array.isArray(p) ? f.push(...p) : f.push(p);
        }
      }
    }
    return f;
  }
}
function k7(e, t) {
  e.position && (t.position = cT(e));
}
function C7(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && a && Object.assign(n.properties, kn(a)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function S7(e, t) {
  const n = t.data || {}, r = "value" in t && !(Xs.call(n, "hProperties") || Xs.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function A7(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Wd(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Ud(e, t) {
  const n = x7(e, t), r = n.one(e, void 0), i = f7(n), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function T7(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      Ud(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      Ud(n, { file: r, ...e || t })
    );
  };
}
function Hd(e) {
  if (e)
    throw e;
}
var Da, Gd;
function E7() {
  if (Gd) return Da;
  Gd = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, i = function(u) {
    return typeof Array.isArray == "function" ? Array.isArray(u) : t.call(u) === "[object Array]";
  }, a = function(u) {
    if (!u || t.call(u) !== "[object Object]")
      return !1;
    var c = e.call(u, "constructor"), f = u.constructor && u.constructor.prototype && e.call(u.constructor.prototype, "isPrototypeOf");
    if (u.constructor && !c && !f)
      return !1;
    var d;
    for (d in u)
      ;
    return typeof d > "u" || e.call(u, d);
  }, o = function(u, c) {
    n && c.name === "__proto__" ? n(u, c.name, {
      enumerable: !0,
      configurable: !0,
      value: c.newValue,
      writable: !0
    }) : u[c.name] = c.newValue;
  }, s = function(u, c) {
    if (c === "__proto__")
      if (e.call(u, c)) {
        if (r)
          return r(u, c).value;
      } else return;
    return u[c];
  };
  return Da = function l() {
    var u, c, f, d, h, p, m = arguments[0], y = 1, g = arguments.length, w = !1;
    for (typeof m == "boolean" && (w = m, m = arguments[1] || {}, y = 2), (m == null || typeof m != "object" && typeof m != "function") && (m = {}); y < g; ++y)
      if (u = arguments[y], u != null)
        for (c in u)
          f = s(m, c), d = s(u, c), m !== d && (w && d && (a(d) || (h = i(d))) ? (h ? (h = !1, p = f && i(f) ? f : []) : p = f && a(f) ? f : {}, o(m, { name: c, newValue: l(w, p, d) })) : typeof d < "u" && o(m, { name: c, newValue: d }));
    return m;
  }, Da;
}
var P7 = E7();
const La = /* @__PURE__ */ pl(P7);
function Zs(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function I7() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let a = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...i);
    function s(l, ...u) {
      const c = e[++a];
      let f = -1;
      if (l) {
        o(l);
        return;
      }
      for (; ++f < i.length; )
        (u[f] === null || u[f] === void 0) && (u[f] = i[f]);
      i = u, c ? R7(c, s)(...u) : o(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function R7(e, t) {
  let n;
  return r;
  function r(...o) {
    const s = e.length > o.length;
    let l;
    s && o.push(i);
    try {
      l = e.apply(this, o);
    } catch (u) {
      const c = (
        /** @type {Error} */
        u
      );
      if (s && n)
        throw c;
      return i(c);
    }
    s || (l && l.then && typeof l.then == "function" ? l.then(a, i) : l instanceof Error ? i(l) : a(l));
  }
  function i(o, ...s) {
    n || (n = !0, t(o, ...s));
  }
  function a(o) {
    i(null, o);
  }
}
const pt = { basename: M7, dirname: D7, extname: L7, join: N7, sep: "/" };
function M7(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  li(e);
  let n = 0, r = -1, i = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          n = i + 1;
          break;
        }
      } else r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, s = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        n = i + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function D7(e) {
  if (li(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function L7(e) {
  li(e);
  let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
  for (; t--; ) {
    const s = e.codePointAt(t);
    if (s === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), s === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function N7(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    li(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : O7(n);
}
function O7(e) {
  li(e);
  const t = e.codePointAt(0) === 47;
  let n = F7(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function F7(e, t) {
  let n = "", r = 0, i = -1, a = 0, o = -1, s, l;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      s = e.codePointAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (l = n.lastIndexOf("/"), l !== n.length - 1) {
              l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = o, a = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
      i = o, a = 0;
    } else s === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function li(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const _7 = { cwd: z7 };
function z7() {
  return "/";
}
function Js(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function V7(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Js(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return $7(e);
}
function $7(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const Na = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class o1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Js(t) ? n = { path: t } : typeof t == "string" || j7(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : _7.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < Na.length; ) {
      const a = Na[r];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let i;
    for (i in n)
      Na.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? pt.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Fa(t, "basename"), Oa(t, "basename"), this.path = pt.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? pt.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    qd(this.basename, "dirname"), this.path = pt.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? pt.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (Oa(t, "extname"), qd(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = pt.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Js(t) && (t = V7(t)), Fa(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? pt.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Fa(t, "stem"), Oa(t, "stem"), this.path = pt.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Le(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function Oa(e, t) {
  if (e && e.includes(pt.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + pt.sep + "`"
    );
}
function Fa(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function qd(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function j7(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const B7 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, r), a;
  })
), W7 = {}.hasOwnProperty;
class Ru extends B7 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = I7();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Ru()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(La(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (Va("data", this.frozen), this.namespace[t] = n, this) : W7.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (Va("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Ii(t), r = this.parser || this.Parser;
    return _a("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), _a("process", this.parser || this.Parser), za("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(a, o) {
      const s = Ii(t), l = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(s)
      );
      r.run(l, s, function(c, f, d) {
        if (c || !f || !d)
          return u(c);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), p = r.stringify(h, d);
        G7(p) ? d.value = p : d.result = p, u(
          c,
          /** @type {VFileWithOutput<CompileResult>} */
          d
        );
      });
      function u(c, f) {
        c || !f ? o(c) : a ? a(f) : n(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), _a("processSync", this.parser || this.Parser), za("processSync", this.compiler || this.Compiler), this.process(t, i), Yd("processSync", "process", n), r;
    function i(a, o) {
      n = !0, Hd(a), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    Kd(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = Ii(n);
      i.run(t, l, u);
      function u(c, f, d) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || t
        );
        c ? s(c) : o ? o(h) : r(void 0, h, d);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, a), Yd("runSync", "run", r), i;
    function a(o, s) {
      Hd(o), i = s, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = Ii(n), i = this.compiler || this.Compiler;
    return za("stringify", i), Kd(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (Va("use", this.frozen), t != null) if (typeof t == "function")
      l(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? s(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(u) {
      if (typeof u == "function")
        l(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [c, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          l(c, f);
        } else
          o(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function o(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(u.plugins), u.settings && (i.settings = La(!0, i.settings, u.settings));
    }
    function s(u) {
      let c = -1;
      if (u != null) if (Array.isArray(u))
        for (; ++c < u.length; ) {
          const f = u[c];
          a(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function l(u, c) {
      let f = -1, d = -1;
      for (; ++f < r.length; )
        if (r[f][0] === u) {
          d = f;
          break;
        }
      if (d === -1)
        r.push([u, ...c]);
      else if (c.length > 0) {
        let [h, ...p] = c;
        const m = r[d][1];
        Zs(m) && Zs(h) && (h = La(!0, m, h)), r[d] = [u, h, ...p];
      }
    }
  }
}
const U7 = new Ru().freeze();
function _a(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function za(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Va(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Kd(e) {
  if (!Zs(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Yd(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Ii(e) {
  return H7(e) ? e : new o1(e);
}
function H7(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function G7(e) {
  return typeof e == "string" || q7(e);
}
function q7(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const K7 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Xd = [], Zd = { allowDangerousHtml: !0 }, Y7 = /^(https?|ircs?|mailto|xmpp)$/i, X7 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Z7(e) {
  const t = J7(e), n = Q7(e);
  return e9(t.runSync(t.parse(n), n), e);
}
function J7(e) {
  const t = e.rehypePlugins || Xd, n = e.remarkPlugins || Xd, r = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Zd } : Zd;
  return U7().use(DP).use(n).use(T7, r).use(t);
}
function Q7(e) {
  const t = e.children || "", n = new o1();
  return typeof t == "string" && (n.value = t), n;
}
function e9(e, t) {
  const n = t.allowedElements, r = t.allowElement, i = t.components, a = t.disallowedElements, o = t.skipHtml, s = t.unwrapDisallowed, l = t.urlTransform || t9;
  for (const c of X7)
    Object.hasOwn(t, c.from) && ("" + c.from + (c.to ? "use `" + c.to + "` instead" : "remove it") + K7 + c.id, void 0);
  return t.className && (e = {
    type: "element",
    tagName: "div",
    properties: { className: t.className },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      e.type === "root" ? e.children : [e]
    )
  }), Go(e, u), mT(e, {
    Fragment: tt,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: i,
    ignoreInvalidStyle: !0,
    jsx: b,
    jsxs: B,
    passKeys: !0,
    passNode: !0
  });
  function u(c, f, d) {
    if (c.type === "raw" && d && typeof f == "number")
      return o ? d.children.splice(f, 1) : d.children[f] = { type: "text", value: c.value }, f;
    if (c.type === "element") {
      let h;
      for (h in Ia)
        if (Object.hasOwn(Ia, h) && Object.hasOwn(c.properties, h)) {
          const p = c.properties[h], m = Ia[h];
          (m === null || m.includes(c.tagName)) && (c.properties[h] = l(String(p || ""), h, c));
        }
    }
    if (c.type === "element") {
      let h = n ? !n.includes(c.tagName) : a ? a.includes(c.tagName) : !1;
      if (!h && r && typeof f == "number" && (h = !r(c, f, d)), h && d && typeof f == "number")
        return s && c.children ? d.children.splice(f, 1, ...c.children) : d.children.splice(f, 1), f;
    }
  }
}
function t9(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    Y7.test(e.slice(0, t)) ? e : ""
  );
}
const a1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends TestFunction>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & Predicate<Condition, Element>) &
   *   (<Condition extends string>(test: Condition) => (element: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element & {tagName: Condition}) &
   *   ((test?: null | undefined) => (element?: unknown, index?: number | null | undefined, parent?: Parents | null | undefined, context?: unknown) => element is Element) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test | null | undefined} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return i9;
    if (typeof e == "string")
      return r9(e);
    if (typeof e == "object")
      return n9(e);
    if (typeof e == "function")
      return Mu(e);
    throw new Error("Expected function, string, or array as `test`");
  })
);
function n9(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = a1(e[n]);
  return Mu(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, i)) return !0;
    return !1;
  }
}
function r9(e) {
  return Mu(t);
  function t(n) {
    return n.tagName === e;
  }
}
function Mu(e) {
  return t;
  function t(n, r, i) {
    return !!(o9(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function i9(e) {
  return !!(e && typeof e == "object" && "type" in e && e.type === "element" && "tagName" in e && typeof e.tagName == "string");
}
function o9(e) {
  return e !== null && typeof e == "object" && "type" in e && "tagName" in e;
}
const a9 = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/, s9 = /^[a-zA-Z]:\\/;
function l9(e) {
  if (typeof e != "string")
    throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
  return s9.test(e) ? !1 : a9.test(e);
}
const u9 = ["http", "https"], c9 = ["nofollow"], f9 = {};
function d9(e) {
  const t = e || f9, n = t.protocols || u9, r = a1(t.test);
  return function(i) {
    Go(i, "element", function(a, o, s) {
      if (a.tagName === "a" && typeof a.properties.href == "string" && r(a, o, s)) {
        const l = a.properties.href;
        if (l9(l) ? n.includes(l.slice(0, l.indexOf(":"))) : l.startsWith("//")) {
          const u = Cr(t.content, a), c = u && !Array.isArray(u) ? [u] : u, f = Cr(t.rel, a) || c9, d = typeof f == "string" ? nT(f) : f, h = Cr(t.target, a), p = Cr(t.properties, a);
          if (p && Object.assign(a.properties, kn(p)), d.length > 0 && (a.properties.rel = [...d]), h && (a.properties.target = h), c) {
            const m = Cr(t.contentProperties, a) || {};
            a.children.push({
              type: "element",
              tagName: "span",
              properties: kn(m),
              children: kn(c)
            });
          }
        }
      }
    });
  };
}
function Cr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Jd(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function h9(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function p9(e, t, n) {
  const i = Uo((n || {}).ignore || []), a = m9(t);
  let o = -1;
  for (; ++o < a.length; )
    i1(e, "text", s);
  function s(u, c) {
    let f = -1, d;
    for (; ++f < c.length; ) {
      const h = c[f], p = d ? d.children : void 0;
      if (i(
        h,
        p ? p.indexOf(h) : void 0,
        d
      ))
        return;
      d = h;
    }
    if (d)
      return l(u, c);
  }
  function l(u, c) {
    const f = c[c.length - 1], d = a[o][0], h = a[o][1];
    let p = 0;
    const y = f.children.indexOf(u);
    let g = !1, w = [];
    d.lastIndex = 0;
    let v = d.exec(u.value);
    for (; v; ) {
      const k = v.index, x = {
        index: v.index,
        input: v.input,
        stack: [...c, u]
      };
      let C = h(...v, x);
      if (typeof C == "string" && (C = C.length > 0 ? { type: "text", value: C } : void 0), C === !1 ? d.lastIndex = k + 1 : (p !== k && w.push({
        type: "text",
        value: u.value.slice(p, k)
      }), Array.isArray(C) ? w.push(...C) : C && w.push(C), p = k + v[0].length, g = !0), !d.global)
        break;
      v = d.exec(u.value);
    }
    return g ? (p < u.value.length && w.push({ type: "text", value: u.value.slice(p) }), f.children.splice(y, 1, ...w)) : w = [u], y + w.length;
  }
}
function m9(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    t.push([g9(i[0]), y9(i[1])]);
  }
  return t;
}
function g9(e) {
  return typeof e == "string" ? new RegExp(h9(e), "g") : e;
}
function y9(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const $a = "phrasing", ja = ["autolink", "link", "image", "label"];
function w9() {
  return {
    transforms: [A9],
    enter: {
      literalAutolink: b9,
      literalAutolinkEmail: Ba,
      literalAutolinkHttp: Ba,
      literalAutolinkWww: Ba
    },
    exit: {
      literalAutolink: S9,
      literalAutolinkEmail: C9,
      literalAutolinkHttp: x9,
      literalAutolinkWww: k9
    }
  };
}
function v9() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: $a,
        notInConstruct: ja
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: $a,
        notInConstruct: ja
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: $a,
        notInConstruct: ja
      }
    ]
  };
}
function b9(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Ba(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function x9(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function k9(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function C9(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function S9(e) {
  this.exit(e);
}
function A9(e) {
  p9(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, T9],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), E9]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function T9(e, t, n, r, i) {
  let a = "";
  if (!s1(i) || (/^w/i.test(t) && (n = t + n, t = "", a = "http://"), !P9(n)))
    return !1;
  const o = I9(n + r);
  if (!o[0]) return !1;
  const s = {
    type: "link",
    title: null,
    url: a + t + o[0],
    children: [{ type: "text", value: t + o[0] }]
  };
  return o[1] ? [s, { type: "text", value: o[1] }] : s;
}
function E9(e, t, n, r) {
  return (
    // Not an expected previous character.
    !s1(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function P9(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function I9(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = Jd(e, "(");
  let a = Jd(e, ")");
  for (; r !== -1 && i > a; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), a++;
  return [e, n];
}
function s1(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || En(n) || jo(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
l1.peek = z9;
function R9() {
  this.buffer();
}
function M9(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function D9() {
  this.buffer();
}
function L9(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function N9(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = at(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function O9(e) {
  this.exit(e);
}
function F9(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = at(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function _9(e) {
  this.exit(e);
}
function z9() {
  return "[";
}
function l1(e, t, n, r) {
  const i = n.createTracker(r);
  let a = i.move("[^");
  const o = n.enter("footnoteReference"), s = n.enter("reference");
  return a += i.move(
    n.safe(n.associationId(e), { after: "]", before: a })
  ), s(), o(), a += i.move("]"), a;
}
function V9() {
  return {
    enter: {
      gfmFootnoteCallString: R9,
      gfmFootnoteCall: M9,
      gfmFootnoteDefinitionLabelString: D9,
      gfmFootnoteDefinition: L9
    },
    exit: {
      gfmFootnoteCallString: N9,
      gfmFootnoteCall: O9,
      gfmFootnoteDefinitionLabelString: F9,
      gfmFootnoteDefinition: _9
    }
  };
}
function $9(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: l1 },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(r, i, a, o) {
    const s = a.createTracker(o);
    let l = s.move("[^");
    const u = a.enter("footnoteDefinition"), c = a.enter("label");
    return l += s.move(
      a.safe(a.associationId(r), { before: l, after: "]" })
    ), c(), l += s.move("]:"), r.children && r.children.length > 0 && (s.shift(4), l += s.move(
      (t ? `
` : " ") + a.indentLines(
        a.containerFlow(r, s.current()),
        t ? u1 : j9
      )
    )), u(), l;
  }
}
function j9(e, t, n) {
  return t === 0 ? e : u1(e, t, n);
}
function u1(e, t, n) {
  return (n ? "" : "    ") + e;
}
const B9 = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
c1.peek = q9;
function W9() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: H9 },
    exit: { strikethrough: G9 }
  };
}
function U9() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: B9
      }
    ],
    handlers: { delete: c1 }
  };
}
function H9(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function G9(e) {
  this.exit(e);
}
function c1(e, t, n, r) {
  const i = n.createTracker(r), a = n.enter("strikethrough");
  let o = i.move("~~");
  return o += n.containerPhrasing(e, {
    ...i.current(),
    before: o,
    after: "~"
  }), o += i.move("~~"), a(), o;
}
function q9() {
  return "~";
}
function K9(e) {
  return e.length;
}
function Y9(e, t) {
  const n = t || {}, r = (n.align || []).concat(), i = n.stringLength || K9, a = [], o = [], s = [], l = [];
  let u = 0, c = -1;
  for (; ++c < e.length; ) {
    const m = [], y = [];
    let g = -1;
    for (e[c].length > u && (u = e[c].length); ++g < e[c].length; ) {
      const w = X9(e[c][g]);
      if (n.alignDelimiters !== !1) {
        const v = i(w);
        y[g] = v, (l[g] === void 0 || v > l[g]) && (l[g] = v);
      }
      m.push(w);
    }
    o[c] = m, s[c] = y;
  }
  let f = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++f < u; )
      a[f] = Qd(r[f]);
  else {
    const m = Qd(r);
    for (; ++f < u; )
      a[f] = m;
  }
  f = -1;
  const d = [], h = [];
  for (; ++f < u; ) {
    const m = a[f];
    let y = "", g = "";
    m === 99 ? (y = ":", g = ":") : m === 108 ? y = ":" : m === 114 && (g = ":");
    let w = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      l[f] - y.length - g.length
    );
    const v = y + "-".repeat(w) + g;
    n.alignDelimiters !== !1 && (w = y.length + w + g.length, w > l[f] && (l[f] = w), h[f] = w), d[f] = v;
  }
  o.splice(1, 0, d), s.splice(1, 0, h), c = -1;
  const p = [];
  for (; ++c < o.length; ) {
    const m = o[c], y = s[c];
    f = -1;
    const g = [];
    for (; ++f < u; ) {
      const w = m[f] || "";
      let v = "", k = "";
      if (n.alignDelimiters !== !1) {
        const x = l[f] - (y[f] || 0), C = a[f];
        C === 114 ? v = " ".repeat(x) : C === 99 ? x % 2 ? (v = " ".repeat(x / 2 + 0.5), k = " ".repeat(x / 2 - 0.5)) : (v = " ".repeat(x / 2), k = v) : k = " ".repeat(x);
      }
      n.delimiterStart !== !1 && !f && g.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && w === "") && (n.delimiterStart !== !1 || f) && g.push(" "), n.alignDelimiters !== !1 && g.push(v), g.push(w), n.alignDelimiters !== !1 && g.push(k), n.padding !== !1 && g.push(" "), (n.delimiterEnd !== !1 || f !== u - 1) && g.push("|");
    }
    p.push(
      n.delimiterEnd === !1 ? g.join("").replace(/ +$/, "") : g.join("")
    );
  }
  return p.join(`
`);
}
function X9(e) {
  return e == null ? "" : String(e);
}
function Qd(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function Z9(e, t, n, r) {
  const i = n.enter("blockquote"), a = n.createTracker(r);
  a.move("> "), a.shift(2);
  const o = n.indentLines(
    n.containerFlow(e, a.current()),
    J9
  );
  return i(), o;
}
function J9(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function Q9(e, t) {
  return eh(e, t.inConstruct, !0) && !eh(e, t.notInConstruct, !1);
}
function eh(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function th(e, t, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length; )
    if (n.unsafe[i].character === `
` && Q9(n.stack, n.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function e8(e, t) {
  const n = String(e);
  let r = n.indexOf(t), i = r, a = 0, o = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++a > o && (o = a) : a = 1, i = r + t.length, r = n.indexOf(t, i);
  return o;
}
function t8(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function n8(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function r8(e, t, n, r) {
  const i = n8(n), a = e.value || "", o = i === "`" ? "GraveAccent" : "Tilde";
  if (t8(e, n)) {
    const f = n.enter("codeIndented"), d = n.indentLines(a, i8);
    return f(), d;
  }
  const s = n.createTracker(r), l = i.repeat(Math.max(e8(a, i) + 1, 3)), u = n.enter("codeFenced");
  let c = s.move(l);
  if (e.lang) {
    const f = n.enter(`codeFencedLang${o}`);
    c += s.move(
      n.safe(e.lang, {
        before: c,
        after: " ",
        encode: ["`"],
        ...s.current()
      })
    ), f();
  }
  if (e.lang && e.meta) {
    const f = n.enter(`codeFencedMeta${o}`);
    c += s.move(" "), c += s.move(
      n.safe(e.meta, {
        before: c,
        after: `
`,
        encode: ["`"],
        ...s.current()
      })
    ), f();
  }
  return c += s.move(`
`), a && (c += s.move(a + `
`)), c += s.move(l), u(), c;
}
function i8(e, t, n) {
  return (n ? "" : "    ") + e;
}
function Du(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function o8(e, t, n, r) {
  const i = Du(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
  let s = n.enter("label");
  const l = n.createTracker(r);
  let u = l.move("[");
  return u += l.move(
    n.safe(n.associationId(e), {
      before: u,
      after: "]",
      ...l.current()
    })
  ), u += l.move("]: "), s(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (s = n.enter("destinationLiteral"), u += l.move("<"), u += l.move(
    n.safe(e.url, { before: u, after: ">", ...l.current() })
  ), u += l.move(">")) : (s = n.enter("destinationRaw"), u += l.move(
    n.safe(e.url, {
      before: u,
      after: e.title ? " " : `
`,
      ...l.current()
    })
  )), s(), e.title && (s = n.enter(`title${a}`), u += l.move(" " + i), u += l.move(
    n.safe(e.title, {
      before: u,
      after: i,
      ...l.current()
    })
  ), u += l.move(i), s()), o(), u;
}
function a8(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function Kr(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function yo(e, t, n) {
  const r = ir(e), i = ir(t);
  return r === void 0 ? i === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : r === 1 ? i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
f1.peek = s8;
function f1(e, t, n, r) {
  const i = a8(n), a = n.enter("emphasis"), o = n.createTracker(r), s = o.move(i);
  let l = o.move(
    n.containerPhrasing(e, {
      after: i,
      before: s,
      ...o.current()
    })
  );
  const u = l.charCodeAt(0), c = yo(
    r.before.charCodeAt(r.before.length - 1),
    u,
    i
  );
  c.inside && (l = Kr(u) + l.slice(1));
  const f = l.charCodeAt(l.length - 1), d = yo(r.after.charCodeAt(0), f, i);
  d.inside && (l = l.slice(0, -1) + Kr(f));
  const h = o.move(i);
  return a(), n.attentionEncodeSurroundingInfo = {
    after: d.outside,
    before: c.outside
  }, s + l + h;
}
function s8(e, t, n) {
  return n.options.emphasis || "*";
}
function l8(e, t) {
  let n = !1;
  return Go(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, Ys;
  }), !!((!e.depth || e.depth < 3) && Cu(e) && (t.options.setext || n));
}
function u8(e, t, n, r) {
  const i = Math.max(Math.min(6, e.depth || 1), 1), a = n.createTracker(r);
  if (l8(e, n)) {
    const c = n.enter("headingSetext"), f = n.enter("phrasing"), d = n.containerPhrasing(e, {
      ...a.current(),
      before: `
`,
      after: `
`
    });
    return f(), c(), d + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      d.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(d.lastIndexOf("\r"), d.lastIndexOf(`
`)) + 1)
    );
  }
  const o = "#".repeat(i), s = n.enter("headingAtx"), l = n.enter("phrasing");
  a.move(o + " ");
  let u = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...a.current()
  });
  return /^[\t ]/.test(u) && (u = Kr(u.charCodeAt(0)) + u.slice(1)), u = u ? o + " " + u : o, n.options.closeAtx && (u += " " + o), l(), s(), u;
}
d1.peek = c8;
function d1(e) {
  return e.value || "";
}
function c8() {
  return "<";
}
h1.peek = f8;
function h1(e, t, n, r) {
  const i = Du(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
  let s = n.enter("label");
  const l = n.createTracker(r);
  let u = l.move("![");
  return u += l.move(
    n.safe(e.alt, { before: u, after: "]", ...l.current() })
  ), u += l.move("]("), s(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (s = n.enter("destinationLiteral"), u += l.move("<"), u += l.move(
    n.safe(e.url, { before: u, after: ">", ...l.current() })
  ), u += l.move(">")) : (s = n.enter("destinationRaw"), u += l.move(
    n.safe(e.url, {
      before: u,
      after: e.title ? " " : ")",
      ...l.current()
    })
  )), s(), e.title && (s = n.enter(`title${a}`), u += l.move(" " + i), u += l.move(
    n.safe(e.title, {
      before: u,
      after: i,
      ...l.current()
    })
  ), u += l.move(i), s()), u += l.move(")"), o(), u;
}
function f8() {
  return "!";
}
p1.peek = d8;
function p1(e, t, n, r) {
  const i = e.referenceType, a = n.enter("imageReference");
  let o = n.enter("label");
  const s = n.createTracker(r);
  let l = s.move("![");
  const u = n.safe(e.alt, {
    before: l,
    after: "]",
    ...s.current()
  });
  l += s.move(u + "]["), o();
  const c = n.stack;
  n.stack = [], o = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: l,
    after: "]",
    ...s.current()
  });
  return o(), n.stack = c, a(), i === "full" || !u || u !== f ? l += s.move(f + "]") : i === "shortcut" ? l = l.slice(0, -1) : l += s.move("]"), l;
}
function d8() {
  return "!";
}
m1.peek = h8;
function m1(e, t, n) {
  let r = e.value || "", i = "`", a = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++a < n.unsafe.length; ) {
    const o = n.unsafe[a], s = n.compilePattern(o);
    let l;
    if (o.atBreak)
      for (; l = s.exec(r); ) {
        let u = l.index;
        r.charCodeAt(u) === 10 && r.charCodeAt(u - 1) === 13 && u--, r = r.slice(0, u) + " " + r.slice(l.index + 1);
      }
  }
  return i + r + i;
}
function h8() {
  return "`";
}
function g1(e, t) {
  const n = Cu(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
y1.peek = p8;
function y1(e, t, n, r) {
  const i = Du(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.createTracker(r);
  let s, l;
  if (g1(e, n)) {
    const c = n.stack;
    n.stack = [], s = n.enter("autolink");
    let f = o.move("<");
    return f += o.move(
      n.containerPhrasing(e, {
        before: f,
        after: ">",
        ...o.current()
      })
    ), f += o.move(">"), s(), n.stack = c, f;
  }
  s = n.enter("link"), l = n.enter("label");
  let u = o.move("[");
  return u += o.move(
    n.containerPhrasing(e, {
      before: u,
      after: "](",
      ...o.current()
    })
  ), u += o.move("]("), l(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), u += o.move("<"), u += o.move(
    n.safe(e.url, { before: u, after: ">", ...o.current() })
  ), u += o.move(">")) : (l = n.enter("destinationRaw"), u += o.move(
    n.safe(e.url, {
      before: u,
      after: e.title ? " " : ")",
      ...o.current()
    })
  )), l(), e.title && (l = n.enter(`title${a}`), u += o.move(" " + i), u += o.move(
    n.safe(e.title, {
      before: u,
      after: i,
      ...o.current()
    })
  ), u += o.move(i), l()), u += o.move(")"), s(), u;
}
function p8(e, t, n) {
  return g1(e, n) ? "<" : "[";
}
w1.peek = m8;
function w1(e, t, n, r) {
  const i = e.referenceType, a = n.enter("linkReference");
  let o = n.enter("label");
  const s = n.createTracker(r);
  let l = s.move("[");
  const u = n.containerPhrasing(e, {
    before: l,
    after: "]",
    ...s.current()
  });
  l += s.move(u + "]["), o();
  const c = n.stack;
  n.stack = [], o = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: l,
    after: "]",
    ...s.current()
  });
  return o(), n.stack = c, a(), i === "full" || !u || u !== f ? l += s.move(f + "]") : i === "shortcut" ? l = l.slice(0, -1) : l += s.move("]"), l;
}
function m8() {
  return "[";
}
function Lu(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function g8(e) {
  const t = Lu(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function y8(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function v1(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function w8(e, t, n, r) {
  const i = n.enter("list"), a = n.bulletCurrent;
  let o = e.ordered ? y8(n) : Lu(n);
  const s = e.ordered ? o === "." ? ")" : "." : g8(n);
  let l = t && n.bulletLastUsed ? o === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const c = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (o === "*" || o === "-") && // Empty first list item:
      c && (!c.children || !c.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (l = !0), v1(n) === o && c
    ) {
      let f = -1;
      for (; ++f < e.children.length; ) {
        const d = e.children[f];
        if (d && d.type === "listItem" && d.children && d.children[0] && d.children[0].type === "thematicBreak") {
          l = !0;
          break;
        }
      }
    }
  }
  l && (o = s), n.bulletCurrent = o;
  const u = n.containerFlow(e, r);
  return n.bulletLastUsed = o, n.bulletCurrent = a, i(), u;
}
function v8(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function b8(e, t, n, r) {
  const i = v8(n);
  let a = n.bulletCurrent || Lu(n);
  t && t.type === "list" && t.ordered && (a = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + a);
  let o = a.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
  const s = n.createTracker(r);
  s.move(a + " ".repeat(o - a.length)), s.shift(o);
  const l = n.enter("listItem"), u = n.indentLines(
    n.containerFlow(e, s.current()),
    c
  );
  return l(), u;
  function c(f, d, h) {
    return d ? (h ? "" : " ".repeat(o)) + f : (h ? a : a + " ".repeat(o - a.length)) + f;
  }
}
function x8(e, t, n, r) {
  const i = n.enter("paragraph"), a = n.enter("phrasing"), o = n.containerPhrasing(e, r);
  return a(), i(), o;
}
const k8 = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  Uo([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function C8(e, t, n, r) {
  return (e.children.some(function(o) {
    return k8(o);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function S8(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
b1.peek = A8;
function b1(e, t, n, r) {
  const i = S8(n), a = n.enter("strong"), o = n.createTracker(r), s = o.move(i + i);
  let l = o.move(
    n.containerPhrasing(e, {
      after: i,
      before: s,
      ...o.current()
    })
  );
  const u = l.charCodeAt(0), c = yo(
    r.before.charCodeAt(r.before.length - 1),
    u,
    i
  );
  c.inside && (l = Kr(u) + l.slice(1));
  const f = l.charCodeAt(l.length - 1), d = yo(r.after.charCodeAt(0), f, i);
  d.inside && (l = l.slice(0, -1) + Kr(f));
  const h = o.move(i + i);
  return a(), n.attentionEncodeSurroundingInfo = {
    after: d.outside,
    before: c.outside
  }, s + l + h;
}
function A8(e, t, n) {
  return n.options.strong || "*";
}
function T8(e, t, n, r) {
  return n.safe(e.value, r);
}
function E8(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function P8(e, t, n) {
  const r = (v1(n) + (n.options.ruleSpaces ? " " : "")).repeat(E8(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const x1 = {
  blockquote: Z9,
  break: th,
  code: r8,
  definition: o8,
  emphasis: f1,
  hardBreak: th,
  heading: u8,
  html: d1,
  image: h1,
  imageReference: p1,
  inlineCode: m1,
  link: y1,
  linkReference: w1,
  list: w8,
  listItem: b8,
  paragraph: x8,
  root: C8,
  strong: b1,
  text: T8,
  thematicBreak: P8
};
function I8() {
  return {
    enter: {
      table: R8,
      tableData: nh,
      tableHeader: nh,
      tableRow: D8
    },
    exit: {
      codeText: L8,
      table: M8,
      tableData: Wa,
      tableHeader: Wa,
      tableRow: Wa
    }
  };
}
function R8(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function M8(e) {
  this.exit(e), this.data.inTable = void 0;
}
function D8(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Wa(e) {
  this.exit(e);
}
function nh(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function L8(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, N8));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function N8(e, t) {
  return t === "|" ? t : e;
}
function O8(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, a = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: d,
      table: o,
      tableCell: l,
      tableRow: s
    }
  };
  function o(h, p, m, y) {
    return u(c(h, m, y), h.align);
  }
  function s(h, p, m, y) {
    const g = f(h, m, y), w = u([g]);
    return w.slice(0, w.indexOf(`
`));
  }
  function l(h, p, m, y) {
    const g = m.enter("tableCell"), w = m.enter("phrasing"), v = m.containerPhrasing(h, {
      ...y,
      before: a,
      after: a
    });
    return w(), g(), v;
  }
  function u(h, p) {
    return Y9(h, {
      align: p,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function c(h, p, m) {
    const y = h.children;
    let g = -1;
    const w = [], v = p.enter("table");
    for (; ++g < y.length; )
      w[g] = f(y[g], p, m);
    return v(), w;
  }
  function f(h, p, m) {
    const y = h.children;
    let g = -1;
    const w = [], v = p.enter("tableRow");
    for (; ++g < y.length; )
      w[g] = l(y[g], h, p, m);
    return v(), w;
  }
  function d(h, p, m) {
    let y = x1.inlineCode(h, p, m);
    return m.stack.includes("tableCell") && (y = y.replace(/\|/g, "\\$&")), y;
  }
}
function F8() {
  return {
    exit: {
      taskListCheckValueChecked: rh,
      taskListCheckValueUnchecked: rh,
      paragraph: z8
    }
  };
}
function _8() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: V8 }
  };
}
function rh(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function z8(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let a = -1, o;
      for (; ++a < i.length; ) {
        const s = i[a];
        if (s.type === "paragraph") {
          o = s;
          break;
        }
      }
      o === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function V8(e, t, n, r) {
  const i = e.children[0], a = typeof e.checked == "boolean" && i && i.type === "paragraph", o = "[" + (e.checked ? "x" : " ") + "] ", s = n.createTracker(r);
  a && s.move(o);
  let l = x1.listItem(e, t, n, {
    ...r,
    ...s.current()
  });
  return a && (l = l.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, u)), l;
  function u(c) {
    return c + o;
  }
}
function $8() {
  return [
    w9(),
    V9(),
    W9(),
    I8(),
    F8()
  ];
}
function j8(e) {
  return {
    extensions: [
      v9(),
      $9(e),
      U9(),
      O8(e),
      _8()
    ]
  };
}
const B8 = {
  tokenize: K8,
  partial: !0
}, k1 = {
  tokenize: Y8,
  partial: !0
}, C1 = {
  tokenize: X8,
  partial: !0
}, S1 = {
  tokenize: Z8,
  partial: !0
}, W8 = {
  tokenize: J8,
  partial: !0
}, A1 = {
  name: "wwwAutolink",
  tokenize: G8,
  previous: E1
}, T1 = {
  name: "protocolAutolink",
  tokenize: q8,
  previous: P1
}, Ut = {
  name: "emailAutolink",
  tokenize: H8,
  previous: I1
}, Tt = {};
function U8() {
  return {
    text: Tt
  };
}
let mn = 48;
for (; mn < 123; )
  Tt[mn] = Ut, mn++, mn === 58 ? mn = 65 : mn === 91 && (mn = 97);
Tt[43] = Ut;
Tt[45] = Ut;
Tt[46] = Ut;
Tt[95] = Ut;
Tt[72] = [Ut, T1];
Tt[104] = [Ut, T1];
Tt[87] = [Ut, A1];
Tt[119] = [Ut, A1];
function H8(e, t, n) {
  const r = this;
  let i, a;
  return o;
  function o(f) {
    return !Qs(f) || !I1.call(r, r.previous) || Nu(r.events) ? n(f) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), s(f));
  }
  function s(f) {
    return Qs(f) ? (e.consume(f), s) : f === 64 ? (e.consume(f), l) : n(f);
  }
  function l(f) {
    return f === 46 ? e.check(W8, c, u)(f) : f === 45 || f === 95 || Me(f) ? (a = !0, e.consume(f), l) : c(f);
  }
  function u(f) {
    return e.consume(f), i = !0, l;
  }
  function c(f) {
    return a && i && Oe(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(f)) : n(f);
  }
}
function G8(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o !== 87 && o !== 119 || !E1.call(r, r.previous) || Nu(r.events) ? n(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(B8, e.attempt(k1, e.attempt(C1, a), n), n)(o));
  }
  function a(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(o);
  }
}
function q8(e, t, n) {
  const r = this;
  let i = "", a = !1;
  return o;
  function o(f) {
    return (f === 72 || f === 104) && P1.call(r, r.previous) && !Nu(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(f), e.consume(f), s) : n(f);
  }
  function s(f) {
    if (Oe(f) && i.length < 5)
      return i += String.fromCodePoint(f), e.consume(f), s;
    if (f === 58) {
      const d = i.toLowerCase();
      if (d === "http" || d === "https")
        return e.consume(f), l;
    }
    return n(f);
  }
  function l(f) {
    return f === 47 ? (e.consume(f), a ? u : (a = !0, l)) : n(f);
  }
  function u(f) {
    return f === null || mo(f) || ae(f) || En(f) || jo(f) ? n(f) : e.attempt(k1, e.attempt(C1, c), n)(f);
  }
  function c(f) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(f);
  }
}
function K8(e, t, n) {
  let r = 0;
  return i;
  function i(o) {
    return (o === 87 || o === 119) && r < 3 ? (r++, e.consume(o), i) : o === 46 && r === 3 ? (e.consume(o), a) : n(o);
  }
  function a(o) {
    return o === null ? n(o) : t(o);
  }
}
function Y8(e, t, n) {
  let r, i, a;
  return o;
  function o(u) {
    return u === 46 || u === 95 ? e.check(S1, l, s)(u) : u === null || ae(u) || En(u) || u !== 45 && jo(u) ? l(u) : (a = !0, e.consume(u), o);
  }
  function s(u) {
    return u === 95 ? r = !0 : (i = r, r = void 0), e.consume(u), o;
  }
  function l(u) {
    return i || r || !a ? n(u) : t(u);
  }
}
function X8(e, t) {
  let n = 0, r = 0;
  return i;
  function i(o) {
    return o === 40 ? (n++, e.consume(o), i) : o === 41 && r < n ? a(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(S1, t, a)(o) : o === null || ae(o) || En(o) ? t(o) : (e.consume(o), i);
  }
  function a(o) {
    return o === 41 && r++, e.consume(o), i;
  }
}
function Z8(e, t, n) {
  return r;
  function r(s) {
    return s === 33 || s === 34 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 63 || s === 95 || s === 126 ? (e.consume(s), r) : s === 38 ? (e.consume(s), a) : s === 93 ? (e.consume(s), i) : (
      // `<` is an end.
      s === 60 || // So is whitespace.
      s === null || ae(s) || En(s) ? t(s) : n(s)
    );
  }
  function i(s) {
    return s === null || s === 40 || s === 91 || ae(s) || En(s) ? t(s) : r(s);
  }
  function a(s) {
    return Oe(s) ? o(s) : n(s);
  }
  function o(s) {
    return s === 59 ? (e.consume(s), r) : Oe(s) ? (e.consume(s), o) : n(s);
  }
}
function J8(e, t, n) {
  return r;
  function r(a) {
    return e.consume(a), i;
  }
  function i(a) {
    return Me(a) ? n(a) : t(a);
  }
}
function E1(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || ae(e);
}
function P1(e) {
  return !Oe(e);
}
function I1(e) {
  return !(e === 47 || Qs(e));
}
function Qs(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Me(e);
}
function Nu(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const Q8 = {
  tokenize: sI,
  partial: !0
};
function eI() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: iI,
        continuation: {
          tokenize: oI
        },
        exit: aI
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: rI
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: tI,
        resolveTo: nI
      }
    }
  };
}
function tI(e, t, n) {
  const r = this;
  let i = r.events.length;
  const a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o;
  for (; i--; ) {
    const l = r.events[i][1];
    if (l.type === "labelImage") {
      o = l;
      break;
    }
    if (l.type === "gfmFootnoteCall" || l.type === "labelLink" || l.type === "label" || l.type === "image" || l.type === "link")
      break;
  }
  return s;
  function s(l) {
    if (!o || !o._balanced)
      return n(l);
    const u = at(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }));
    return u.codePointAt(0) !== 94 || !a.includes(u.slice(1)) ? n(l) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(l), e.exit("gfmFootnoteCallLabelMarker"), t(l));
  }
}
function nI(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const a = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, a.start),
    end: Object.assign({}, a.end)
  }, s = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", i, t],
    ["exit", i, t],
    // Everything in between.
    ["enter", a, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", a, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...s), e;
}
function rI(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a = 0, o;
  return s;
  function s(f) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), l;
  }
  function l(f) {
    return f !== 94 ? n(f) : (e.enter("gfmFootnoteCallMarker"), e.consume(f), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", u);
  }
  function u(f) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      f === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      f === null || f === 91 || ae(f)
    )
      return n(f);
    if (f === 93) {
      e.exit("chunkString");
      const d = e.exit("gfmFootnoteCallString");
      return i.includes(at(r.sliceSerialize(d))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(f);
    }
    return ae(f) || (o = !0), a++, e.consume(f), f === 92 ? c : u;
  }
  function c(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), a++, u) : u(f);
  }
}
function iI(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a, o = 0, s;
  return l;
  function l(p) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(p), e.exit("gfmFootnoteDefinitionLabelMarker"), u;
  }
  function u(p) {
    return p === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(p), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", c) : n(p);
  }
  function c(p) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      p === 93 && !s || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      p === null || p === 91 || ae(p)
    )
      return n(p);
    if (p === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteDefinitionLabelString");
      return a = at(r.sliceSerialize(m)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(p), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), d;
    }
    return ae(p) || (s = !0), o++, e.consume(p), p === 92 ? f : c;
  }
  function f(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, c) : c(p);
  }
  function d(p) {
    return p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), i.includes(a) || i.push(a), ee(e, h, "gfmFootnoteDefinitionWhitespace")) : n(p);
  }
  function h(p) {
    return t(p);
  }
}
function oI(e, t, n) {
  return e.check(si, t, e.attempt(Q8, t, n));
}
function aI(e) {
  e.exit("gfmFootnoteDefinition");
}
function sI(e, t, n) {
  const r = this;
  return ee(e, i, "gfmFootnoteDefinitionIndent", 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? t(a) : n(a);
  }
}
function lI(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: a,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(o, s) {
    let l = -1;
    for (; ++l < o.length; )
      if (o[l][0] === "enter" && o[l][1].type === "strikethroughSequenceTemporary" && o[l][1]._close) {
        let u = l;
        for (; u--; )
          if (o[u][0] === "exit" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._open && // If the sizes are the same:
          o[l][1].end.offset - o[l][1].start.offset === o[u][1].end.offset - o[u][1].start.offset) {
            o[l][1].type = "strikethroughSequence", o[u][1].type = "strikethroughSequence";
            const c = {
              type: "strikethrough",
              start: Object.assign({}, o[u][1].start),
              end: Object.assign({}, o[l][1].end)
            }, f = {
              type: "strikethroughText",
              start: Object.assign({}, o[u][1].end),
              end: Object.assign({}, o[l][1].start)
            }, d = [["enter", c, s], ["enter", o[u][1], s], ["exit", o[u][1], s], ["enter", f, s]], h = s.parser.constructs.insideSpan.null;
            h && Ke(d, d.length, 0, Bo(h, o.slice(u + 1, l), s)), Ke(d, d.length, 0, [["exit", f, s], ["enter", o[l][1], s], ["exit", o[l][1], s], ["exit", c, s]]), Ke(o, u - 1, l - u + 3, d), l = u + d.length - 2;
            break;
          }
      }
    for (l = -1; ++l < o.length; )
      o[l][1].type === "strikethroughSequenceTemporary" && (o[l][1].type = "data");
    return o;
  }
  function a(o, s, l) {
    const u = this.previous, c = this.events;
    let f = 0;
    return d;
    function d(p) {
      return u === 126 && c[c.length - 1][1].type !== "characterEscape" ? l(p) : (o.enter("strikethroughSequenceTemporary"), h(p));
    }
    function h(p) {
      const m = ir(u);
      if (p === 126)
        return f > 1 ? l(p) : (o.consume(p), f++, h);
      if (f < 2 && !n) return l(p);
      const y = o.exit("strikethroughSequenceTemporary"), g = ir(p);
      return y._open = !g || g === 2 && !!m, y._close = !m || m === 2 && !!g, s(p);
    }
  }
}
class uI {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    cI(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(a, o) {
      return a[0] - o[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push(t.slice()), t.length = 0;
    let i = r.pop();
    for (; i; ) {
      for (const a of i)
        t.push(a);
      i = r.pop();
    }
    this.map.length = 0;
  }
}
function cI(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function fI(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const a = r.length - 1;
          r[a] = r[a] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function dI() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: hI,
        resolveAll: pI
      }
    }
  };
}
function hI(e, t, n) {
  const r = this;
  let i = 0, a = 0, o;
  return s;
  function s(E) {
    let L = r.events.length - 1;
    for (; L > -1; ) {
      const D = r.events[L][1].type;
      if (D === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      D === "linePrefix") L--;
      else break;
    }
    const M = L > -1 ? r.events[L][1].type : null, _ = M === "tableHead" || M === "tableRow" ? C : l;
    return _ === C && r.parser.lazy[r.now().line] ? n(E) : _(E);
  }
  function l(E) {
    return e.enter("tableHead"), e.enter("tableRow"), u(E);
  }
  function u(E) {
    return E === 124 || (o = !0, a += 1), c(E);
  }
  function c(E) {
    return E === null ? n(E) : H(E) ? a > 1 ? (a = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), h) : n(E) : Z(E) ? ee(e, c, "whitespace")(E) : (a += 1, o && (o = !1, i += 1), E === 124 ? (e.enter("tableCellDivider"), e.consume(E), e.exit("tableCellDivider"), o = !0, c) : (e.enter("data"), f(E)));
  }
  function f(E) {
    return E === null || E === 124 || ae(E) ? (e.exit("data"), c(E)) : (e.consume(E), E === 92 ? d : f);
  }
  function d(E) {
    return E === 92 || E === 124 ? (e.consume(E), f) : f(E);
  }
  function h(E) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(E) : (e.enter("tableDelimiterRow"), o = !1, Z(E) ? ee(e, p, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(E) : p(E));
  }
  function p(E) {
    return E === 45 || E === 58 ? y(E) : E === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(E), e.exit("tableCellDivider"), m) : x(E);
  }
  function m(E) {
    return Z(E) ? ee(e, y, "whitespace")(E) : y(E);
  }
  function y(E) {
    return E === 58 ? (a += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(E), e.exit("tableDelimiterMarker"), g) : E === 45 ? (a += 1, g(E)) : E === null || H(E) ? k(E) : x(E);
  }
  function g(E) {
    return E === 45 ? (e.enter("tableDelimiterFiller"), w(E)) : x(E);
  }
  function w(E) {
    return E === 45 ? (e.consume(E), w) : E === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(E), e.exit("tableDelimiterMarker"), v) : (e.exit("tableDelimiterFiller"), v(E));
  }
  function v(E) {
    return Z(E) ? ee(e, k, "whitespace")(E) : k(E);
  }
  function k(E) {
    return E === 124 ? p(E) : E === null || H(E) ? !o || i !== a ? x(E) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(E)) : x(E);
  }
  function x(E) {
    return n(E);
  }
  function C(E) {
    return e.enter("tableRow"), P(E);
  }
  function P(E) {
    return E === 124 ? (e.enter("tableCellDivider"), e.consume(E), e.exit("tableCellDivider"), P) : E === null || H(E) ? (e.exit("tableRow"), t(E)) : Z(E) ? ee(e, P, "whitespace")(E) : (e.enter("data"), I(E));
  }
  function I(E) {
    return E === null || E === 124 || ae(E) ? (e.exit("data"), P(E)) : (e.consume(E), E === 92 ? N : I);
  }
  function N(E) {
    return E === 92 || E === 124 ? (e.consume(E), I) : I(E);
  }
}
function pI(e, t) {
  let n = -1, r = !0, i = 0, a = [0, 0, 0, 0], o = [0, 0, 0, 0], s = !1, l = 0, u, c, f;
  const d = new uI();
  for (; ++n < e.length; ) {
    const h = e[n], p = h[1];
    h[0] === "enter" ? p.type === "tableHead" ? (s = !1, l !== 0 && (ih(d, t, l, u, c), c = void 0, l = 0), u = {
      type: "table",
      start: Object.assign({}, p.start),
      // Note: correct end is set later.
      end: Object.assign({}, p.end)
    }, d.add(n, 0, [["enter", u, t]])) : p.type === "tableRow" || p.type === "tableDelimiterRow" ? (r = !0, f = void 0, a = [0, 0, 0, 0], o = [0, n + 1, 0, 0], s && (s = !1, c = {
      type: "tableBody",
      start: Object.assign({}, p.start),
      // Note: correct end is set later.
      end: Object.assign({}, p.end)
    }, d.add(n, 0, [["enter", c, t]])), i = p.type === "tableDelimiterRow" ? 2 : c ? 3 : 1) : i && (p.type === "data" || p.type === "tableDelimiterMarker" || p.type === "tableDelimiterFiller") ? (r = !1, o[2] === 0 && (a[1] !== 0 && (o[0] = o[1], f = Ri(d, t, a, i, void 0, f), a = [0, 0, 0, 0]), o[2] = n)) : p.type === "tableCellDivider" && (r ? r = !1 : (a[1] !== 0 && (o[0] = o[1], f = Ri(d, t, a, i, void 0, f)), a = o, o = [a[1], n, 0, 0])) : p.type === "tableHead" ? (s = !0, l = n) : p.type === "tableRow" || p.type === "tableDelimiterRow" ? (l = n, a[1] !== 0 ? (o[0] = o[1], f = Ri(d, t, a, i, n, f)) : o[1] !== 0 && (f = Ri(d, t, o, i, n, f)), i = 0) : i && (p.type === "data" || p.type === "tableDelimiterMarker" || p.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (l !== 0 && ih(d, t, l, u, c), d.consume(t.events), n = -1; ++n < t.events.length; ) {
    const h = t.events[n];
    h[0] === "enter" && h[1].type === "table" && (h[1]._align = fI(t.events, n));
  }
  return e;
}
function Ri(e, t, n, r, i, a) {
  const o = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (a.end = Object.assign({}, zn(t.events, n[0])), e.add(n[0], 0, [["exit", a, t]]));
  const l = zn(t.events, n[1]);
  if (a = {
    type: o,
    start: Object.assign({}, l),
    // Note: correct end is set later.
    end: Object.assign({}, l)
  }, e.add(n[1], 0, [["enter", a, t]]), n[2] !== 0) {
    const u = zn(t.events, n[2]), c = zn(t.events, n[3]), f = {
      type: s,
      start: Object.assign({}, u),
      end: Object.assign({}, c)
    };
    if (e.add(n[2], 0, [["enter", f, t]]), r !== 2) {
      const d = t.events[n[2]], h = t.events[n[3]];
      if (d[1].end = Object.assign({}, h[1].end), d[1].type = "chunkText", d[1].contentType = "text", n[3] > n[2] + 1) {
        const p = n[2] + 1, m = n[3] - n[2] - 1;
        e.add(p, m, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", f, t]]);
  }
  return i !== void 0 && (a.end = Object.assign({}, zn(t.events, i)), e.add(i, 0, [["exit", a, t]]), a = void 0), a;
}
function ih(e, t, n, r, i) {
  const a = [], o = zn(t.events, n);
  i && (i.end = Object.assign({}, o), a.push(["exit", i, t])), r.end = Object.assign({}, o), a.push(["exit", r, t]), e.add(n + 1, 0, a);
}
function zn(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const mI = {
  name: "tasklistCheck",
  tokenize: yI
};
function gI() {
  return {
    text: {
      91: mI
    }
  };
}
function yI(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(l) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), a)
    );
  }
  function a(l) {
    return ae(l) ? (e.enter("taskListCheckValueUnchecked"), e.consume(l), e.exit("taskListCheckValueUnchecked"), o) : l === 88 || l === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(l), e.exit("taskListCheckValueChecked"), o) : n(l);
  }
  function o(l) {
    return l === 93 ? (e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), s) : n(l);
  }
  function s(l) {
    return H(l) ? t(l) : Z(l) ? e.check({
      tokenize: wI
    }, t, n)(l) : n(l);
  }
}
function wI(e, t, n) {
  return ee(e, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : t(i);
  }
}
function vI(e) {
  return Vy([
    U8(),
    eI(),
    lI(e),
    dI(),
    gI()
  ]);
}
const bI = {};
function xI(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), n = e || bI, r = t.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), a = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), o = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(vI(n)), a.push($8()), o.push(j8(n));
}
const Ae = (e, t) => function(r) {
  const { node: i, ...a } = r, o = [
    "svg",
    "path",
    "g",
    "circle",
    "rect",
    "line",
    "polygon",
    "polyline",
    "text"
  ].includes(e);
  return ch(e, o ? a : { className: t, ...a });
}, kI = {
  h1: Ae("h1", "wgt-text-2xl wgt-font-semibold"),
  h2: Ae("h2", "wgt-font-semibold wgt-text-xl"),
  h3: Ae("h3", "wgt-font-semibold wgt-text-lg"),
  h4: Ae("h4", "wgt-font-semibold wgt-text-base"),
  h5: Ae("h5", "wgt-font-medium"),
  strong: Ae("strong", "wgt-font-semibold"),
  a: Ae("a", "wgt-text-brand wgt-underline wgt-underline-offset-2"),
  blockquote: Ae(
    "blockquote",
    "wgt-border-l-2 wgt-border-primary wgt-pl-4"
  ),
  code: ({ children: e, ...t }) => /* @__PURE__ */ b(
    "code",
    {
      className: te(
        "wgt-font-mono [:not(pre)>&]:wgt-rounded-md [:not(pre)>&]:wgt-bg-background/50 [:not(pre)>&]:wgt-px-1 [:not(pre)>&]:wgt-py-0.5"
      ),
      ...t,
      children: e
    }
  ),
  pre: ({ children: e }) => e,
  ol: Ae("ol", "wgt-list-decimal wgt-space-y-2 wgt-pl-6"),
  ul: Ae("ul", "wgt-list-disc wgt-space-y-2 wgt-pl-6"),
  li: Ae("li", "wgt-my-1.5"),
  table: Ae(
    "table",
    "wgt-w-full wgt-border-collapse wgt-overflow-y-auto wgt-rounded-md wgt-border wgt-border-foreground/20"
  ),
  th: Ae(
    "th",
    "wgt-border wgt-border-foreground/20 wgt-px-4 wgt-py-2 wgt-text-left wgt-font-bold [&[align=center]]:wgt-text-center [&[align=right]]:wgt-text-right"
  ),
  td: Ae(
    "td",
    "wgt-border wgt-border-foreground/20 wgt-px-4 wgt-py-2 wgt-text-left [&[align=center]]:wgt-text-center [&[align=right]]:wgt-text-right"
  ),
  tr: Ae("tr", "wgt-m-0 wgt-border-t wgt-p-0 even:wgt-bg-muted"),
  p: Ae("p", "wgt-whitespace-pre-wrap"),
  hr: Ae("hr", "wgt-border-foreground/20")
}, oh = ({ children: e }) => /* @__PURE__ */ b(
  Z7,
  {
    remarkPlugins: [xI],
    rehypePlugins: [[d9, { target: "_blank" }]],
    components: kI,
    className: "wgt-space-y-3 wgt-text-base sm:wgt-text-sm",
    children: e
  }
), CI = (e, t, n = 5) => {
  const [r, i] = oe("");
  return De(() => {
    if (!t) {
      i(e);
      return;
    }
    if (r.length === e.length)
      return;
    const a = setTimeout(() => {
      i(e.slice(0, r.length + 1));
    }, n);
    return () => clearTimeout(a);
  }, [e, r, t, n]), r;
}, ah = Eo(
  "wgt-group/message wgt-relative wgt-break-words wgt-rounded-lg wgt-p-3 wgt-text-sm sm:wgt-max-w-full",
  {
    variants: {
      isUser: {
        true: "wgt-bg-chat-bubble-user wgt-text-chat-bubble-user-foreground wgt-border",
        false: "wgt-bg-chat-bubble-bot wgt-text-chat-bubble-bot-foreground"
      },
      animation: {
        none: "",
        slide: "wgt-duration-300 wgt-animate-in wgt-fade-in-0",
        scale: "wgt-duration-300 wgt-animate-in wgt-fade-in-0 wgt-zoom-in-75",
        fade: "wgt-duration-500 wgt-animate-in wgt-fade-in-0"
      }
    },
    compoundVariants: [
      { isUser: !0, animation: "slide", class: "wgt-slide-in-from-right" },
      { isUser: !1, animation: "slide", class: "wgt-slide-in-from-left" },
      { isUser: !0, animation: "scale", class: "wgt-origin-bottom-right" },
      { isUser: !1, animation: "scale", class: "wgt-origin-bottom-left" }
    ]
  }
), SI = ({
  role: e,
  content: t,
  createdAt: n,
  showTimeStamp: r = !1,
  animation: i = "scale",
  actions: a,
  className: o,
  dislikeReason: s,
  shouldAnimate: l
}) => {
  var v, k, x;
  const { options: u } = ct(), { branding: c } = u, f = e === "user", d = /__UNIQUE_DELIMITER__/gi, p = t.length ? t.replace(d, `&nbsp; 
`) : t, m = (v = c.icons) == null ? void 0 : v.user, y = (k = c.icons) == null ? void 0 : k.bot, g = CI(
    p,
    !!l
  ), w = (x = new Date(n)) == null ? void 0 : x.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit"
  });
  return /* @__PURE__ */ B(
    "div",
    {
      style: { scrollbarWidth: "thin" },
      className: te(
        "wgt-relative wgt-flex wgt-flex-col wgt-overflow-x-auto",
        f ? "wgt-items-end" : "wgt-items-start"
      ),
      children: [
        f ? /* @__PURE__ */ B("div", { className: "wgt-flex wgt-w-fit wgt-flex-col wgt-px-4", children: [
          /* @__PURE__ */ B("div", { className: "wgt-flex wgt-items-end wgt-gap-1", children: [
            /* @__PURE__ */ b(
              "div",
              {
                className: te(
                  ah({ isUser: f, animation: i }),
                  o
                ),
                children: /* @__PURE__ */ b(oh, { children: g })
              }
            ),
            (m == null ? void 0 : m.icon) ?? /* @__PURE__ */ b(
              "div",
              {
                className: te(
                  "wgt-flex wgt-min-h-6 wgt-min-w-6 wgt-items-center wgt-justify-center wgt-rounded-full wgt-border wgt-bg-chat-bubble-user-icon wgt-text-[10px] wgt-font-bold wgt-text-chat-bubble-user-icon-foreground wgt-shadow-sm",
                  m == null ? void 0 : m.className
                ),
                children: /* @__PURE__ */ b(ve, { icon: t0, className: "wgt-h-3 wgt-w-3" })
              }
            )
          ] }),
          r && n ? /* @__PURE__ */ b(
            "time",
            {
              dateTime: new Date(n).toISOString(),
              className: te(
                "wgt-mt-1 wgt-block wgt-w-full wgt-px-1 wgt-text-start wgt-text-xs wgt-opacity-50",
                i !== "none" && "wgt-duration-500 wgt-animate-in wgt-fade-in-0"
              ),
              children: w
            }
          ) : null
        ] }) : /* @__PURE__ */ B("div", { className: "wgt-flex wgt-flex-col wgt-items-end wgt-gap-1 wgt-px-4", children: [
          /* @__PURE__ */ B("div", { className: "wgt-flex wgt-items-end wgt-gap-1", children: [
            (y == null ? void 0 : y.icon) ?? /* @__PURE__ */ b(
              "div",
              {
                className: te(
                  "wgt-flex wgt-min-h-6 wgt-min-w-6 wgt-items-center wgt-justify-center wgt-rounded-full wgt-border wgt-bg-background",
                  y == null ? void 0 : y.className
                ),
                children: /* @__PURE__ */ b(rr, { className: "wgt-h-4 wgt-w-4 wgt-fill-chat-bubble-bot-icon-foreground wgt-shadow-sm" })
              }
            ),
            /* @__PURE__ */ b(
              "div",
              {
                className: te(
                  ah({ isUser: f, animation: i }),
                  o
                ),
                children: /* @__PURE__ */ b(oh, { children: g })
              }
            )
          ] }),
          /* @__PURE__ */ B("div", { className: "wgt-mt-1 wgt-flex wgt-w-full wgt-justify-between wgt-pl-8 wgt-pr-1", children: [
            /* @__PURE__ */ b("div", { className: "wgt-flex wgt-w-full", children: a }),
            r && n ? /* @__PURE__ */ b(
              "time",
              {
                dateTime: new Date(n).toISOString(),
                className: te(
                  "wgt-block wgt-w-full wgt-text-end wgt-text-xs wgt-opacity-50",
                  i !== "none" && "wgt-duration-500 wgt-animate-in wgt-fade-in-0"
                ),
                children: w
              }
            ) : null
          ] })
        ] }),
        /* @__PURE__ */ b("div", { className: "wgt-absolute wgt-bottom-8 wgt-left-2 wgt-rounded-lg", children: s })
      ]
    }
  );
}, Ua = () => /* @__PURE__ */ b("div", { className: "wgt-h-[0.2rem] wgt-w-[0.2rem] wgt-rounded-full wgt-bg-gray-400" }), AI = () => /* @__PURE__ */ B("div", { className: "wgt-mb-1 wgt-flex wgt-items-center wgt-gap-1", children: [
  /* @__PURE__ */ b("div", { className: "wgt-animate-bounce-extreme-2way wgt-duration-700", children: /* @__PURE__ */ b(Ua, {}) }),
  /* @__PURE__ */ b("div", { className: "wgt-animate-bounce-extreme-2way wgt-delay-100 wgt-duration-700", children: /* @__PURE__ */ b(Ua, {}) }),
  /* @__PURE__ */ b("div", { className: "wgt-animate-bounce-extreme-2way wgt-delay-200 wgt-duration-700", children: /* @__PURE__ */ b(Ua, {}) })
] }), TI = ({ loadingStatus: e }) => /* @__PURE__ */ B("div", { className: "wgt-flex wgt-w-fit wgt-items-end wgt-gap-1 wgt-rounded-md wgt-bg-muted wgt-px-3 wgt-py-3 wgt-text-sm", children: [
  e && /* @__PURE__ */ b("div", { className: "wgt-flex wgt-text-muted-foreground", children: /* @__PURE__ */ b(eu, { mode: "wait", children: /* @__PURE__ */ b(
    cu.div,
    {
      initial: { y: "100%", opacity: 0 },
      animate: { y: "0%", opacity: 1 },
      exit: { y: "-100%", opacity: 0 },
      transition: { duration: 0.1, ease: "easeInOut" },
      children: e
    },
    e
  ) }) }),
  /* @__PURE__ */ b(AI, {})
] });
function EI({
  messages: e,
  showTimeStamps: t = !0,
  messageOptions: n,
  agentLoadingStatus: r
}) {
  return /* @__PURE__ */ B("div", { className: "wgt-space-y-5 wgt-overflow-visible", children: [
    e.map((i, a) => {
      const o = typeof n == "function" ? n(i) : n, s = (/* @__PURE__ */ new Date()).getTime() - new Date(i.createdAt).getTime() < 3e4, l = i.role === "assistant" && a === e.length - 1 && s;
      return /* @__PURE__ */ b(
        SI,
        {
          showTimeStamp: t,
          ...i,
          ...o,
          shouldAnimate: l
        },
        a
      );
    }),
    r && /* @__PURE__ */ b("div", { className: "wgt-px-4", children: /* @__PURE__ */ b(TI, { loadingStatus: r }) })
  ] });
}
const R1 = ({ className: e }) => /* @__PURE__ */ b(
  ve,
  {
    icon: n0,
    className: te("wgt-h-4 wgt-w-4 wgt-animate-spin", e)
  }
), PI = () => {
  var i;
  const { options: e } = ct(), { branding: t } = e, n = (i = t.icons) == null ? void 0 : i.session, r = (n == null ? void 0 : n.icon) ?? /* @__PURE__ */ b("div", { className: n == null ? void 0 : n.className, children: /* @__PURE__ */ b(rr, { className: "wgt-h-7 wgt-w-7 wgt-fill-foreground" }) });
  return /* @__PURE__ */ b(
    "div",
    {
      className: te(
        "wgt-flex wgt-items-center wgt-justify-center wgt-gap-3 wgt-text-sm",
        {
          "wgt-h-full": e.mode === "page-mobile"
        }
      ),
      children: /* @__PURE__ */ B("div", { className: "wgt-flex wgt-flex-col wgt-items-center wgt-justify-center wgt-gap-2", children: [
        r,
        /* @__PURE__ */ b("h1", { className: "wgt-text-lg wgt-font-medium", children: "Starting your session" }),
        /* @__PURE__ */ b(R1, { className: "wgt-mt-4 wgt-h-7 wgt-w-7" })
      ] })
    }
  );
}, II = async ({
  sessionId: e,
  apiKey: t,
  displayMode: n,
  recaptchaToken: r,
  apiBaseUrl: i,
  environment: a
}) => {
  const o = {
    "Content-Type": "application/json",
    "Client-Web-Api-Key": t,
    "Recaptcha-Token": r
  };
  n === "page-mobile" && (o["X-Client-Type"] = "page-mobile");
  const s = await fetch(`${i}/chat/v1/suggestions`, {
    method: "POST",
    body: JSON.stringify({ sessionId: e, environment: a }),
    headers: o
  });
  if (!s.ok) {
    const l = await s.json().catch(() => null);
    throw new Error(
      (l == null ? void 0 : l.message) || "Something went wrong! Please refresh or try again later."
    );
  }
  return s.json();
}, sh = ({ onClick: e, children: t }) => /* @__PURE__ */ b(
  "div",
  {
    onClick: e,
    className: "wgt-inline-flex wgt-min-h-10 wgt-animate-appear wgt-cursor-pointer wgt-items-center wgt-justify-center wgt-gap-2 wgt-text-wrap wgt-rounded-md wgt-border wgt-border-border wgt-px-4 wgt-py-2 wgt-text-sm wgt-font-normal hover:wgt-bg-muted",
    children: /* @__PURE__ */ b("p", { children: t })
  }
), RI = ({
  heading: e,
  handleSubmit: t
}) => {
  var x;
  const { executeRecaptcha: n } = vo(), { options: r, session: i } = ct(), [a, o] = oe([]), [s, l] = oe(!0), {
    mode: u,
    api: { key: c, baseUrl: f },
    branding: d,
    environment: h
  } = r, p = u === "page-mobile", { sessionId: m } = i, y = (x = d.icons) == null ? void 0 : x.session, g = u === "page-mobile" ? /* @__PURE__ */ b("div", { className: "wgt-rounded-full wgt-bg-brand wgt-p-2.5", children: /* @__PURE__ */ b(rr, { className: "wgt-h-6 wgt-w-6 wgt-fill-brand-foreground" }) }) : /* @__PURE__ */ b("div", { className: y == null ? void 0 : y.className, children: /* @__PURE__ */ b(rr, { className: "wgt-h-7 wgt-w-7 wgt-fill-foreground" }) }), w = (y == null ? void 0 : y.icon) ?? g;
  De(() => {
    (async () => {
      try {
        l(!0);
        let P = "";
        if (n && !p && (P = await n("get_prompt_suggestions")), !P && !p)
          return;
        const I = await II({
          sessionId: m,
          apiKey: c,
          recaptchaToken: P,
          displayMode: u,
          apiBaseUrl: f,
          environment: h
        });
        o(I);
      } catch {
        o([]);
      } finally {
        l(!1);
      }
    })();
  }, [
    c,
    u,
    n,
    p,
    m,
    f,
    h
  ]);
  const v = () => {
    var C;
    (C = d.predefinedPrompt) != null && C.prompt && t(void 0, {
      id: "some-random-temp-id",
      role: "user",
      content: d.predefinedPrompt.prompt,
      createdAt: /* @__PURE__ */ new Date(),
      liked: !1,
      disliked: !1
    });
  }, k = (C) => {
    t(void 0, {
      id: "some-random-temp-id",
      role: "user",
      content: C,
      createdAt: /* @__PURE__ */ new Date(),
      liked: !1,
      disliked: !1
    });
  };
  return /* @__PURE__ */ B(
    "div",
    {
      className: te(
        p ? "wgt-py-4" : "wgt-py-10",
        "wgt-mx-5 wgt-flex wgt-flex-col wgt-justify-between"
      ),
      children: [
        /* @__PURE__ */ b("div", { className: "wgt-mb-4 wgt-flex wgt-items-center wgt-justify-center", children: w }),
        /* @__PURE__ */ B("div", { className: "wgt-space-y-10", children: [
          /* @__PURE__ */ B("div", { className: "wgt-space-y-5", children: [
            /* @__PURE__ */ b("div", { className: "wgt-flex wgt-flex-col wgt-text-center", children: /* @__PURE__ */ b("h2", { className: "wgt-animate-appear wgt-text-2xl wgt-font-semibold", children: e }) }),
            s ? /* @__PURE__ */ b("div", { className: "wgt-flex wgt-items-center wgt-justify-center", children: /* @__PURE__ */ b(R1, { className: "wgt-h-7 wgt-w-7" }) }) : /* @__PURE__ */ b("div", { className: "wgt-flex wgt-flex-col wgt-items-center wgt-gap-4 wgt-px-3 wgt-text-sm", children: a.map((C, P) => /* @__PURE__ */ b(
              sh,
              {
                onClick: () => k(C),
                children: C
              },
              `${C}${P}`
            )) })
          ] }),
          d.predefinedPrompt && !s ? /* @__PURE__ */ B("div", { className: "wgt-space-y-4", children: [
            /* @__PURE__ */ b("div", { className: "wgt-flex wgt-flex-col wgt-space-y-4 wgt-text-center", children: /* @__PURE__ */ b("h3", { className: "wgt-text-base wgt-font-bold", children: "Not sure where to start?" }) }),
            /* @__PURE__ */ b("div", { className: "wgt-flex wgt-flex-col wgt-items-center wgt-gap-4 wgt-px-3 wgt-text-sm", children: /* @__PURE__ */ b(
              sh,
              {
                onClick: v,
                children: d.predefinedPrompt.title
              },
              d.predefinedPrompt.title
            ) })
          ] }) : null
        ] })
      ]
    }
  );
}, M1 = ({ chatApi: e, messageOptions: t }) => {
  const {
    messages: n,
    handleSubmit: r,
    isSessionLoading: i,
    error: a,
    agentLoadingStatus: o
  } = e, s = n.length === 0;
  return i ? /* @__PURE__ */ b(PI, {}) : /* @__PURE__ */ B(tt, { children: [
    s && /* @__PURE__ */ b("div", { className: "wgt-flex wgt-h-full wgt-flex-col wgt-items-center wgt-overflow-auto", children: /* @__PURE__ */ b(
      RI,
      {
        heading: "How can I help you today?",
        handleSubmit: r
      }
    ) }),
    n.length > 0 && /* @__PURE__ */ b(VA, { messages: n, className: "wgt-flex-1", children: /* @__PURE__ */ B("section", { className: "wgt-py-4", children: [
      /* @__PURE__ */ b(
        EI,
        {
          messages: n,
          messageOptions: t,
          agentLoadingStatus: o
        }
      ),
      a ? /* @__PURE__ */ b("div", { className: "wgt-px-4", children: /* @__PURE__ */ b("div", { className: "wgt-text-sm wgt-text-destructive", children: a }) }) : null
    ] }) }),
    /* @__PURE__ */ b(
      o2,
      {
        containerStyle: {
          position: "relative",
          top: 0,
          left: 20,
          bottom: 20,
          right: 20
        }
      }
    )
  ] });
}, MI = "ag-chat-has-accepted-terms", DI = ({
  chatInput: e,
  maximized: t,
  setMaximized: n,
  chatApi: r,
  messageOptions: i,
  onToggleOpen: a
}) => {
  var x, C, P, I, N;
  const [o, s] = OA(
    MI,
    !1
  ), { session: l, options: u } = ct(), { branding: c } = u, f = (x = c.icons) == null ? void 0 : x.newChat, d = (C = c.icons) == null ? void 0 : C.maximise, h = (P = c.icons) == null ? void 0 : P.minimise, p = (I = c.icons) == null ? void 0 : I.headerClose, m = () => s(!0), y = (f == null ? void 0 : f.icon) ?? /* @__PURE__ */ b("div", { className: f == null ? void 0 : f.className, children: /* @__PURE__ */ b(ve, { icon: r0, className: "wgt-h-5 wgt-w-5" }) }), g = (d == null ? void 0 : d.icon) ?? /* @__PURE__ */ b("div", { className: d == null ? void 0 : d.className, children: /* @__PURE__ */ b(
    ve,
    {
      icon: s0,
      className: "wgt-h-5 wgt-w-5"
    }
  ) }), w = (h == null ? void 0 : h.icon) ?? /* @__PURE__ */ b("div", { className: h == null ? void 0 : h.className, children: /* @__PURE__ */ b(ve, { icon: a0, className: "wgt-h-5 wgt-w-5" }) }), v = (p == null ? void 0 : p.icon) ?? /* @__PURE__ */ b("div", { className: p == null ? void 0 : p.className, children: /* @__PURE__ */ b(ve, { icon: ph, className: "wgt-h-5 wgt-w-5" }) }), k = (E) => typeof E == "string" ? /* @__PURE__ */ b("span", { className: "wgt-text-sm wgt-underline", children: E }) : E;
  return /* @__PURE__ */ B(
    "div",
    {
      className: te(
        "wgt-flex wgt-h-[100svh] wgt-flex-col wgt-transition-all wgt-duration-300 wgt-ease-in-out sm:wgt-h-[calc(100svh-10rem)] sm:wgt-max-h-[50rem]",
        {
          "wgt-justify-between": o,
          "sm:wgt-h-[calc(100vh-8rem)]": t,
          "sm:wgt-max-h-[560px]": !t
        }
      ),
      children: [
        /* @__PURE__ */ B("header", { className: "wgt-flex wgt-justify-between wgt-border-b-header wgt-bg-header wgt-px-4 wgt-py-5 wgt-text-header-foreground sm:wgt-rounded-t-xl", children: [
          /* @__PURE__ */ b("div", { className: "wgt-flex wgt-items-center wgt-gap-3", children: /* @__PURE__ */ B(Cy, { className: "wgt-relative wgt-flex wgt-items-center wgt-space-x-2 wgt-font-normal", children: [
            /* @__PURE__ */ b("p", { className: "wgt-font-medium", children: ((N = c.strings) == null ? void 0 : N.header) ?? c.name }),
            c.beta && /* @__PURE__ */ b(
              "span",
              {
                className: te("wgt-rounded wgt-border wgt-p-0.5 wgt-text-2xs"),
                children: "beta"
              }
            )
          ] }) }),
          /* @__PURE__ */ B("div", { className: "wgt-flex wgt-items-center wgt-justify-center wgt-gap-3", children: [
            /* @__PURE__ */ b(Lt, { delayDuration: 25, children: /* @__PURE__ */ B(Nt, { children: [
              /* @__PURE__ */ b(
                Ot,
                {
                  asChild: !0,
                  onClick: () => {
                    l.resetSession();
                  },
                  className: "wgt-flex wgt-cursor-pointer",
                  children: k(y)
                }
              ),
              /* @__PURE__ */ b(bt, { children: "New chat" })
            ] }) }),
            d != null && d.disabled ? null : /* @__PURE__ */ b(Lt, { delayDuration: 25, children: /* @__PURE__ */ B(Nt, { children: [
              /* @__PURE__ */ b(
                Ot,
                {
                  asChild: !0,
                  onClick: () => n((E) => !E),
                  className: "wgt-hidden wgt-cursor-pointer sm:wgt-flex",
                  children: k(t ? w : g)
                }
              ),
              /* @__PURE__ */ b(bt, { children: t ? "Minimise" : "Expand" })
            ] }) }),
            /* @__PURE__ */ b(Lt, { delayDuration: 25, children: /* @__PURE__ */ B(Nt, { children: [
              /* @__PURE__ */ b(
                Ot,
                {
                  asChild: !0,
                  className: "wgt-flex wgt-cursor-pointer sm:wgt-hidden",
                  onClick: a,
                  children: k(v)
                }
              ),
              /* @__PURE__ */ b(bt, { children: "Close" })
            ] }) })
          ] })
        ] }),
        o ? /* @__PURE__ */ B(tt, { children: [
          /* @__PURE__ */ b(M1, { chatApi: r, messageOptions: i }),
          /* @__PURE__ */ b("footer", { children: e })
        ] }) : /* @__PURE__ */ b("div", { className: "wgt-flex-1 wgt-overflow-auto", children: /* @__PURE__ */ b(FA, { onAccept: m }) })
      ]
    }
  );
}, Ou = Pn(
  ({ children: e, handleSubmit: t, className: n }, r) => /* @__PURE__ */ b("form", { ref: r, onSubmit: (a) => {
    t(a);
  }, className: n, children: e })
);
Ou.displayName = "ChatForm";
const LI = ({
  chatApi: e,
  messageOptions: t
}) => {
  var E, L, M, _;
  const { dialogOpenInternal: n, setDialogOpenInternal: r, options: i } = ct(), { mode: a, dialog: o, branding: s } = i, {
    input: l,
    handleInputChange: u,
    handleSubmit: c,
    isLoading: f,
    isSessionLoading: d,
    stop: h,
    info: p,
    agentLoadingStatus: m
  } = e, [y, g] = oe(!1), [w, v] = oe(!1), k = (E = i.branding.icons) == null ? void 0 : E.trigger, x = (L = i.branding.icons) == null ? void 0 : L.close, C = ge(null);
  De(() => {
    const D = setTimeout(() => v(!0), 3e3), j = setTimeout(() => v(!1), 8e3);
    return () => {
      clearTimeout(D), clearTimeout(j);
    };
  }, []);
  const P = (k == null ? void 0 : k.icon) ?? /* @__PURE__ */ b(
    "div",
    {
      className: te(
        "wgt-flex wgt-items-center wgt-justify-center",
        k == null ? void 0 : k.className
      ),
      children: /* @__PURE__ */ b(rr, { className: "wgt-h-3/5 wgt-w-3/5 wgt-fill-trigger-foreground" })
    }
  ), I = (x == null ? void 0 : x.icon) ?? /* @__PURE__ */ b(
    "div",
    {
      className: te(
        "wgt-flex wgt-items-center wgt-justify-center",
        x == null ? void 0 : x.className
      ),
      children: /* @__PURE__ */ b(ve, { icon: LC, className: "wgt-mx-auto wgt-h-6" })
    }
  ), N = () => {
    r((D) => {
      var G;
      const j = !D;
      return a === "dialog" && ((G = o == null ? void 0 : o.onTriggerClick) == null || G.call(o, j)), j;
    });
  };
  return /* @__PURE__ */ b(
    "div",
    {
      ref: C,
      className: "ag-wgt-root wgt-relative",
      "data-theme": s.theme,
      children: /* @__PURE__ */ B(LA, { modal: !1, open: n, children: [
        /* @__PURE__ */ b(Lt, { children: /* @__PURE__ */ B(Nt, { open: w, children: [
          /* @__PURE__ */ b(Ot, { asChild: !0, children: /* @__PURE__ */ b(
            "button",
            {
              className: "wgt-fixed wgt-bottom-3 wgt-right-1 wgt-z-[1100] wgt-flex wgt-h-14 wgt-w-14 wgt-scale-95 wgt-cursor-pointer wgt-items-center wgt-justify-center wgt-rounded-full wgt-bg-trigger wgt-font-base wgt-text-trigger-foreground wgt-shadow-lg wgt-shadow-primary/50 wgt-duration-200 wgt-ease-in hover:wgt-scale-100 dark:wgt-shadow-none sm:wgt-right-3",
              onClick: N,
              children: n ? I : P
            }
          ) }),
          /* @__PURE__ */ b(bt, { side: "left", variant: "trigger", children: ((M = s.strings) == null ? void 0 : M.triggerTooltip) ?? "Ask me anything!" })
        ] }) }),
        C.current && /* @__PURE__ */ b(
          ky,
          {
            position: "br-20",
            hideOverlay: !0,
            className: "wgt-bottom-0 wgt-right-0 wgt-z-[1200] wgt-h-full wgt-gap-0 wgt-border-none wgt-font-base wgt-text-foreground wgt-shadow-2xl dark:wgt-border-border sm:wgt-bottom-20 sm:wgt-right-3 sm:wgt-h-auto sm:wgt-rounded-lg sm:dark:wgt-border sm:dark:wgt-border-solid",
            size: y ? "3xl" : "default",
            onPointerDownOutside: (D) => D.preventDefault(),
            "aria-describedby": void 0,
            container: C.current,
            children: /* @__PURE__ */ b(
              DI,
              {
                maximized: y,
                setMaximized: g,
                chatInput: /* @__PURE__ */ B(tt, { children: [
                  /* @__PURE__ */ b(
                    Ou,
                    {
                      className: "wgt-mx-4",
                      isPending: f || !!m,
                      handleSubmit: c,
                      children: /* @__PURE__ */ B(tt, { children: [
                        p && /* @__PURE__ */ b("div", { className: "wgt-my-1 wgt-text-sm wgt-text-destructive", children: p }),
                        /* @__PURE__ */ b(
                          du,
                          {
                            value: l,
                            onChange: u,
                            stop: h,
                            isGenerating: f,
                            disabled: d,
                            placeholder: (_ = s.strings) == null ? void 0 : _.inputPlaceholder
                          }
                        )
                      ] })
                    }
                  ),
                  /* @__PURE__ */ b(hu, { className: "wgt-py-4 wgt-text-muted-foreground" })
                ] }),
                chatApi: e,
                messageOptions: t,
                onToggleOpen: N
              }
            )
          }
        )
      ] })
    }
  );
}, NI = ({
  children: e,
  chatInput: t
}) => {
  var a, o;
  const { options: n } = ct(), { page: r, branding: i } = n;
  return /* @__PURE__ */ b(
    "div",
    {
      style: {
        width: (a = r == null ? void 0 : r.size) == null ? void 0 : a.width,
        height: ((o = r == null ? void 0 : r.size) == null ? void 0 : o.height) ?? "84dvh"
      },
      className: "ag-wgt-root",
      "data-theme": i.theme,
      children: /* @__PURE__ */ B(
        "div",
        {
          className: te(
            "wgt-bg-background wgt-font-base wgt-text-base wgt-text-foreground",
            "wgt-flex wgt-flex-col wgt-justify-between wgt-transition-all wgt-duration-300 wgt-ease-in-out",
            "wgt-relative wgt-h-full wgt-w-full"
          ),
          children: [
            e,
            /* @__PURE__ */ b("footer", { children: t })
          ]
        }
      )
    }
  );
}, OI = ({
  chatApi: e,
  messageOptions: t
}) => {
  var d;
  const { options: n } = ct(), { branding: r } = n, {
    input: i,
    handleInputChange: a,
    handleSubmit: o,
    isLoading: s,
    isSessionLoading: l,
    stop: u,
    info: c,
    agentLoadingStatus: f
  } = e;
  return /* @__PURE__ */ b(
    NI,
    {
      chatInput: /* @__PURE__ */ B(tt, { children: [
        /* @__PURE__ */ b(
          Ou,
          {
            className: "wgt-mx-4",
            isPending: s || !!f,
            handleSubmit: o,
            children: /* @__PURE__ */ B(tt, { children: [
              c && /* @__PURE__ */ b("div", { className: "wgt-my-1 wgt-text-sm wgt-text-destructive", children: c }),
              /* @__PURE__ */ b(
                du,
                {
                  value: i,
                  onChange: a,
                  stop: u,
                  isGenerating: s,
                  disabled: l,
                  placeholder: (d = r.strings) == null ? void 0 : d.inputPlaceholder
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ b(hu, { className: "wgt-py-4 wgt-text-muted-foreground" })
      ] }),
      children: /* @__PURE__ */ b(M1, { chatApi: e, messageOptions: t })
    }
  );
}, FI = () => {
  const { executeRecaptcha: e } = vo(), { options: t, session: n } = ct(), {
    mode: r,
    api: { key: i, baseUrl: a }
  } = t, { sessionId: o } = n, s = r === "page-mobile", [l, u] = oe({}), [c, f] = oe(null), d = x3(), { messages: h, handleSubmit: p, updateMessage: m } = d, y = Ee(
    async (w, v) => {
      try {
        let k = v === "thumbs-up", x = v === "thumbs-down";
        w.liked && k && (k = !1), w.disliked && x && (x = !1), k && (x = !1), x && (k = !1), u((I) => ({
          ...I,
          [w.id]: k ? "thumbs-up" : x ? "thumbs-down" : null
        }));
        let C = "";
        if (e && !s && (C = await e("rate_message")), !C && !s)
          return;
        const P = await wp({
          sessionId: o,
          apiKey: i,
          messageId: w.id,
          displayMode: r,
          liked: k,
          disliked: x,
          recaptchaToken: C,
          apiBaseUrl: a
        });
        m(P);
      } catch {
        u((k) => ({
          ...k,
          [w.id]: w.liked ? "thumbs-up" : w.disliked ? "thumbs-down" : null
        }));
      }
    },
    [
      i,
      r,
      e,
      s,
      o,
      m,
      a
    ]
  ), g = Ee(
    (w) => {
      const v = c === w.id;
      return {
        actions: /* @__PURE__ */ B("div", { className: "wgt-flex wgt-gap-3 sm:wgt-gap-2", children: [
          /* @__PURE__ */ b(
            RC,
            {
              content: w.content,
              className: te(s && "[&_svg]:wgt-size-4")
            }
          ),
          /* @__PURE__ */ b(Lt, { children: /* @__PURE__ */ B(Nt, { children: [
            /* @__PURE__ */ b(Ot, { asChild: !0, children: /* @__PURE__ */ b(
              ot,
              {
                size: "icon",
                variant: "ghost",
                className: te(
                  "wgt-h-fit wgt-w-fit",
                  s && "[&_svg]:wgt-size-4",
                  l[w.id] === "thumbs-up" || w.liked ? "wgt-text-green-600 hover:wgt-text-green-600" : "wgt-opacity-50 hover:wgt-opacity-100"
                ),
                onClick: () => y(w, "thumbs-up"),
                children: /* @__PURE__ */ b(ve, { icon: Q1 })
              }
            ) }),
            /* @__PURE__ */ b(bt, { children: "Like" })
          ] }) }),
          /* @__PURE__ */ b(Lt, { children: /* @__PURE__ */ B(Nt, { children: [
            /* @__PURE__ */ b(Ot, { asChild: !0, children: /* @__PURE__ */ b(
              ot,
              {
                size: "icon",
                variant: "ghost",
                className: te(
                  "wgt-h-fit wgt-w-fit",
                  s && "[&_svg]:wgt-size-4",
                  l[w.id] === "thumbs-down" || w.disliked ? "wgt-text-destructive hover:wgt-text-destructive" : "wgt-opacity-50 hover:wgt-opacity-100"
                ),
                onClick: () => {
                  const k = l[w.id] === "thumbs-down" || w.disliked;
                  f(k ? null : w.id), y(w, "thumbs-down");
                },
                children: /* @__PURE__ */ b(ve, { icon: J1 })
              }
            ) }),
            /* @__PURE__ */ b(bt, { children: "Dislike" })
          ] }) }),
          /* @__PURE__ */ b(
            MC,
            {
              handleSubmit: p,
              messages: h,
              currentMessage: w,
              className: te(
                s && "[&_svg]:wgt-size-4",
                "wgt-h-fit wgt-w-fit wgt-opacity-50 hover:wgt-opacity-100"
              )
            }
          )
        ] }),
        dislikeReason: v ? /* @__PURE__ */ b(
          m2,
          {
            message: w,
            updateMessage: m,
            onClose: () => f(null)
          }
        ) : null
      };
    },
    [
      c,
      p,
      s,
      h,
      y,
      l,
      m
    ]
  );
  return /* @__PURE__ */ b(tt, { children: r === "page-mobile" ? /* @__PURE__ */ b(OI, { chatApi: d, messageOptions: g }) : /* @__PURE__ */ b(LI, { chatApi: d, messageOptions: g }) });
}, _I = ({
  options: e,
  children: t
}) => {
  var c;
  const n = "ag-chat-widget-session", r = (c = e.dialog) == null ? void 0 : c.open, [i, a, o] = NA(
    n,
    ""
  ), [s, l] = oe(!!r);
  De(() => {
    l(!!r);
  }, [r]);
  const u = () => {
    o(), a("");
  };
  return /* @__PURE__ */ b(
    Mp.Provider,
    {
      value: {
        options: e,
        session: { sessionId: i, setSessionId: a, resetSession: u },
        dialogOpenInternal: s,
        setDialogOpenInternal: l
      },
      children: t
    }
  );
}, GI = (e) => /* @__PURE__ */ b(U1, { reCaptchaKey: e.reCaptchaKey, children: /* @__PURE__ */ b(_I, { options: e.options, children: /* @__PURE__ */ b(FI, {}) }) });
export {
  GI as ChatWidget
};
